import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ISODate: string;
  Naive24HourTime: string;
  ISODateTime: string;
  MobileNumber: string;
};

export type Query = {
  __typename?: 'Query';
  account?: Maybe<Account>;
  activityPaginated?: Maybe<ActivityPaginated>;
  address?: Maybe<AddressInfo>;
  availablePushNotificationTypes: Array<PushNotificationTypeDetails>;
  /**
   * Returns a non nullable list of nullable bookmarkable union types.
   * The order of these bookmarks align with the `items` input given.
   * If an element of the `codes` is malformed, the index of the
   * response will be null and can be ignored.
   *
   * The type prefix should align with a GraphQL type, the ID and the
   * tenant slug. This query can only support one tenant at a time.
   * If `codes` contains bookmarks across multiple tenants it will
   * be treated as a bad request. If the tenant header is provided,
   * and the input entries do not define their own `tenant` field,
   * the tenant defined in the header will implicitly be used.
   *
   * When profile bookmark inputs are provided, it is possible that
   * the `DiscoverProfile` response will return `null`. This indicates
   * that the profile has been marked as private. It is also possible
   * for a different profile to be returned when the bookmarked profile
   * was claimed. This can be confirmed by comparing the ID provided
   * with the bookmark versus the one that was returned as part of the
   * response.
   *
   * The response will only respond with 50 bookmarkable entities. Any
   * attempt to provide more than 50 codes is treated as a bad request.
   */
  bookmarks?: Maybe<Array<Maybe<Bookmarkable>>>;
  configuration: Configuration;
  /**
   * Returns the dependent's profile details. Users must be authenticated
   * to use this query and the ID provided must be a valid dependent that
   * the account holder supervises.
   */
  dependantProfile?: Maybe<Profile>;
  discoverCompetitions: Array<DiscoverCompetition>;
  discoverDiscount?: Maybe<Discount>;
  discoverFixtureByRound: DiscoverRoundFixture;
  discoverGame?: Maybe<DiscoverGame>;
  discoverGrade?: Maybe<DiscoverGrade>;
  discoverGradeFixture: Array<DiscoverRound>;
  discoverMilestone?: Maybe<DiscoverMilestone>;
  /**
   * Return a milestones for a profile given a list of game counts.
   * Limit field is optional and will return the highest milestones with maximum limit count.
   */
  discoverMilestones?: Maybe<Array<DiscoverMilestone>>;
  discoverOrganisation?: Maybe<DiscoverOrganisation>;
  discoverOrganisationPosts?: Maybe<DiscoverOrganisationPosts>;
  discoverOrganisations: DiscoverOrganisationResults;
  discoverPost?: Maybe<DiscoverPost>;
  discoverSeason?: Maybe<DiscoverSeason>;
  discoverSeasonRegistration: DiscoverRegistration;
  discoverSocialTeamRegistration: DiscoverSocialTeamRegistration;
  discoverTeam?: Maybe<DiscoverTeam>;
  discoverTeamFixture: Array<DiscoverRound>;
  discoverTeams: Array<DiscoverTeam>;
  /**
   * Find profiles that would be classed as duplicates based of user
   * submitted information. This is primarily used to find dependants
   * that exist in our systems, but have changed their details that the
   * existing criteria defined in the `Profile.duplicateProfiles` no longer
   * works. Dependant searches are scoped by the authenticated user;
   * that is that the authenticated user making the query _must_ be
   * the account holder.
   *
   * Users must be authenticated to make this GraphQL mutation.
   */
  duplicateProfiles?: Maybe<Array<DuplicateProfile>>;
  gameSheetDownload?: Maybe<GameSheetDownloadResponse>;
  /** Return the award configuration, votes and player lineup for a team in a game */
  gameTeamAward?: Maybe<GameTeamAwardResponse>;
  /**
   * Validate if the provided lineup is valid.
   *
   * This is currently used when adding additional players to a lineup.
   */
  gameTeamLineupValidate?: Maybe<Array<GameTeamLineupValidateResult>>;
  /** Get statistics for a given grade based on given sorting and pagination parameters */
  gradePlayerStatistics?: Maybe<GradePlayerStatistics>;
  /** Get list of teams from grade statistics for a given grade */
  gradePlayerStatisticsTeamList?: Maybe<Array<StatisticsTeam>>;
  /** Get an incident by ID */
  incident?: Maybe<Incident>;
  invoiceList: InvoiceList;
  /**
   * Get the game availability for all participants related to the logged in profile
   * @deprecated use myProfilesGameAvailability instead
   */
  myPlayersGameAvailability?: Maybe<MyPlayersGameAvailabilityResponse>;
  /** Get the game availability for all profiles related to the logged in account */
  myProfilesGameAvailability?: Maybe<MyProfilesGameAvailabilityResponse>;
  myTeamsGame?: Maybe<MyTeamsGame>;
  myTeamsGamePaymentRequest?: Maybe<MyTeamsGamePaymentRequestResponse>;
  /** Get a list of participants in an organisation and season */
  myTeamsParticipants?: Maybe<MyTeamsParticipantList>;
  myTeamsTeam?: Maybe<MyTeamsTeam>;
  /** Placeholder query with null response that is used as a template for queries that are not implemented yet */
  nullResponse?: Maybe<NullResponse>;
  organisationRegistrations: Array<DiscoverRegistration>;
  participant: Participant;
  /** Get a payment request product by its ID */
  paymentRequestProduct?: Maybe<Product>;
  /**
   * Returns the authenticated user's profile details. The ID argument is
   * never referred to in the server implementation. This exists only to
   * ensure that this change is a non-breaking.
   */
  profile?: Maybe<Profile>;
  profilePhotoVerificationUploadURL: SignedUrl;
  profileSearch?: Maybe<ProfileSearchResult>;
  profileTenantHistory: ProfileTenantDetails;
  publicProfile?: Maybe<DiscoverProfile>;
  publicProfileStatistics?: Maybe<PublicProfileStatistics>;
  /**
   * Get a list of teams for a given profile allocated as a player.
   * The max number of teams per profile has been capped to 50 teams.
   * Returns null if:
   * 1. Profile is not visible
   */
  publicProfileTeams?: Maybe<Array<DiscoverTeam>>;
  pushNotificationSettings: PushNotificationUserSettings;
  /**
   * The query allows asserting the registration related input by running all required policies and
   * return a hash key that will be used to submit the order, the hash key will be valid for a limited time
   * and needs to be used by the order submit mutation.
   */
  registrationAssert: AssertHash;
  registrationCheck?: Maybe<RegistrationCheckResult>;
  registrationSettings?: Maybe<RegistrationSettings>;
  searchAddresses: Array<Scalars['String']>;
  seasonRegistrationCart: CartPayload;
  seasonRegistrations: Array<DiscoverRegistration>;
  /** Get a shop cart for a given ID */
  shopCart?: Maybe<ShopCart>;
  /**
   * Get a product by its ID
   * organisation code parameter has been added later to support easy merch products retrieval
   * hence to avoid breaking changes, it is optional
   */
  shopProduct?: Maybe<Product>;
  /**
   * Get a list of products available/visible in the shop for a given organisation
   * The result is a shallow products list, excluding the product variants and custom fields
   */
  shopProducts?: Maybe<Array<ShallowProduct>>;
  socialTeamRegistration?: Maybe<SocialTeamRegistration>;
  socialTeamRegistrationCart: CartPayload;
  sponsorBanner: SponsorBanner;
  tenantConfiguration?: Maybe<TenantConfiguration>;
  /**
   * Finds upcoming team events for a set of bookmarks. These bookmarks must all be teams,
   * all other bookmark types will be ignored. While a majority of these team events will
   * be games, they also represent byes and scenarios where the team may not have been
   * allocated.
   *
   * See the UpcomingTeamEventTimeline documentation regarding the contents of the timeline.
   *
   * A tenant header must be provided.
   */
  upcomingTeamEvents?: Maybe<UpcomingTeamEventTimeline>;
  /**
   * Finds team events for a set of bookmarks from a specific start date. These bookmarks
   * must all be teams, all other bookmark types will be ignored.
   * If the number of events exceed the limit of the response, it will cut off on a specific
   * date which is available as the lastDate field, and the hasMoreAfterLastDate flag will be
   * TRUE. Pagination is based on dates, and not any exact number of events.
   */
  upcomingTeamEventsPaginated?: Maybe<UpcomingTeamEventsPaginated>;
};


export type QueryActivityPaginatedArgs = {
  input: ActivityPaginatedInput;
};


export type QueryAddressArgs = {
  filter: Scalars['String'];
};


export type QueryAvailablePushNotificationTypesArgs = {
  version: Scalars['String'];
};


export type QueryBookmarksArgs = {
  items: Array<BookmarkItemInput>;
};


export type QueryDependantProfileArgs = {
  id: Scalars['ID'];
};


export type QueryDiscoverCompetitionsArgs = {
  organisationID: Scalars['ID'];
};


export type QueryDiscoverDiscountArgs = {
  input: DiscoverDiscountInput;
};


export type QueryDiscoverFixtureByRoundArgs = {
  roundID: Scalars['ID'];
};


export type QueryDiscoverGameArgs = {
  gameID: Scalars['ID'];
};


export type QueryDiscoverGradeArgs = {
  gradeID: Scalars['ID'];
};


export type QueryDiscoverGradeFixtureArgs = {
  filter?: InputMaybe<DiscoverGradeFixtureFilter>;
  gradeID: Scalars['ID'];
};


export type QueryDiscoverMilestoneArgs = {
  input: DiscoverMilestoneInput;
};


export type QueryDiscoverMilestonesArgs = {
  input: DiscoverMilestonesInput;
};


export type QueryDiscoverOrganisationArgs = {
  code: Scalars['String'];
};


export type QueryDiscoverOrganisationPostsArgs = {
  input: DiscoverOrganisationPostsInput;
};


export type QueryDiscoverOrganisationsArgs = {
  filter: DiscoverOrganisationsFilter;
};


export type QueryDiscoverPostArgs = {
  postID: Scalars['ID'];
};


export type QueryDiscoverSeasonArgs = {
  seasonID: Scalars['String'];
};


export type QueryDiscoverSeasonRegistrationArgs = {
  registrationID: Scalars['String'];
};


export type QueryDiscoverSocialTeamRegistrationArgs = {
  registrationID: Scalars['ID'];
};


export type QueryDiscoverTeamArgs = {
  teamID: Scalars['ID'];
};


export type QueryDiscoverTeamFixtureArgs = {
  teamID: Scalars['ID'];
};


export type QueryDiscoverTeamsArgs = {
  filter: DiscoverTeamsFilter;
};


export type QueryDuplicateProfilesArgs = {
  searchParameters: DuplicateProfileSearchInput;
};


export type QueryGameSheetDownloadArgs = {
  stateID: Scalars['ID'];
};


export type QueryGameTeamAwardArgs = {
  input: GameTeamAwardFilter;
};


export type QueryGameTeamLineupValidateArgs = {
  input: GameTeamLineupValidateInput;
};


export type QueryGradePlayerStatisticsArgs = {
  filter?: InputMaybe<GradePlayerStatisticsFilter>;
  gradeID: Scalars['ID'];
};


export type QueryGradePlayerStatisticsTeamListArgs = {
  gradeID: Scalars['ID'];
};


export type QueryIncidentArgs = {
  id: Scalars['ID'];
};


export type QueryInvoiceListArgs = {
  filter?: InputMaybe<InvoicePaginatedFilter>;
};


export type QueryMyPlayersGameAvailabilityArgs = {
  input?: InputMaybe<MyPlayersGameAvailabilityInput>;
};


export type QueryMyProfilesGameAvailabilityArgs = {
  input?: InputMaybe<MyProfilesGameAvailabilityInput>;
};


export type QueryMyTeamsGameArgs = {
  input: MyTeamsGameInput;
};


export type QueryMyTeamsGamePaymentRequestArgs = {
  input: MyTeamsGamePaymentRequest;
};


export type QueryMyTeamsParticipantsArgs = {
  filter: MyTeamsParticipantsFilter;
};


export type QueryMyTeamsTeamArgs = {
  input: MyTeamsTeamInput;
};


export type QueryNullResponseArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type QueryOrganisationRegistrationsArgs = {
  code: Scalars['ID'];
};


export type QueryParticipantArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentRequestProductArgs = {
  id: Scalars['ID'];
};


export type QueryProfileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryProfilePhotoVerificationUploadUrlArgs = {
  dependantProfileID?: InputMaybe<Scalars['ID']>;
};


export type QueryProfileSearchArgs = {
  fullName: Scalars['String'];
};


export type QueryProfileTenantHistoryArgs = {
  id: Scalars['ID'];
};


export type QueryPublicProfileArgs = {
  profileID: Scalars['ID'];
};


export type QueryPublicProfileStatisticsArgs = {
  profileID: Scalars['ID'];
};


export type QueryPublicProfileTeamsArgs = {
  profileID: Scalars['ID'];
};


export type QueryPushNotificationSettingsArgs = {
  appId: Scalars['String'];
};


export type QueryRegistrationAssertArgs = {
  input: RegistrationAssertInput;
};


export type QueryRegistrationCheckArgs = {
  input: RegistrationCheckInput;
};


export type QueryRegistrationSettingsArgs = {
  code: Scalars['String'];
};


export type QuerySearchAddressesArgs = {
  filter: SearchAddressesFilter;
};


export type QuerySeasonRegistrationCartArgs = {
  args: SeasonRegistrationCartArgs;
};


export type QuerySeasonRegistrationsArgs = {
  seasonID: Scalars['ID'];
};


export type QueryShopCartArgs = {
  input: ShopCartArgs;
};


export type QueryShopProductArgs = {
  id: Scalars['ID'];
  organisationCode?: InputMaybe<Scalars['String']>;
};


export type QueryShopProductsArgs = {
  filter?: InputMaybe<ShopProductsFilter>;
  organisationCode: Scalars['String'];
};


export type QuerySocialTeamRegistrationArgs = {
  code: Scalars['String'];
};


export type QuerySocialTeamRegistrationCartArgs = {
  args: SocialTeamRegistrationCartArgs;
};


export type QuerySponsorBannerArgs = {
  args?: InputMaybe<SponsorBannerInputArgs>;
};


export type QueryUpcomingTeamEventsArgs = {
  items: Array<BookmarkItemInput>;
};


export type QueryUpcomingTeamEventsPaginatedArgs = {
  input: UpcomingTeamEventsPaginatedInput;
};

export type Account = {
  __typename?: 'Account';
  id: Scalars['ID'];
  identityID: Scalars['String'];
  identityProvider: IdentityProvider;
  profile?: Maybe<Profile>;
};

export enum IdentityProvider {
  CognitoUserPool = 'COGNITO_USER_POOL'
}

export type Profile = {
  __typename?: 'Profile';
  address?: Maybe<Address>;
  childSafety?: Maybe<Array<FieldSet>>;
  coachingAccreditation?: Maybe<CoachingAccreditation>;
  concussionIncidents?: Maybe<Array<Incident>>;
  countryOfBirth?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['ISODate']>;
  dependants?: Maybe<Array<Profile>>;
  disabilities?: Maybe<Array<TenantField>>;
  /** @deprecated use hasDisability and disabilities */
  disability?: Maybe<TenantField>;
  disabilityHelp?: Maybe<Scalars['String']>;
  /**
   * Returns a list of profiles that are possible duplicates of this one.
   * The matching criteria is as follows:
   *
   * - The last name MUST be an exact match
   * - The first name MUST be an exact match OR be an alternative name
   * - The gender MUST be an exact match
   * - The date of birth MUST be an exact match
   *
   * > Alternative names are commonly known aliases for a given name. For example,
   * > `Catherine` can be an alias to `Cat`.
   *
   * This can be used in two different flows; in a registration or direct
   * flow. Registration flows should provide the `registrationCode` argument
   * which is used to verify whether duplicate profiles have existing registrations
   * with the organisation for given registration.
   *
   * For example, if `registrationCode` `alice` is provided and is organised by
   * organisation `bob`, then duplicate profiles must have a previous registration
   * with organisation `bob`.
   *
   * Direct flows can provide a first name, last name, gender and/or a date of birth.
   * Direct flows are used outside an registration context and the `registrationCode`
   * should not be supplied in these circumstances. When these are supplied, these
   * values are used to as part of the matching criteria instead.
   *
   * A request that mixes these arguments would result in a bad request.
   *
   * Use the `Query.duplicateProfiles` for direct flows.
   */
  duplicateProfiles?: Maybe<Array<DuplicateProfile>>;
  email?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<EmergencyContact>;
  /**
   * Used to store links to external accounts
   * For example, it can store the link to someones Cricket ID account
   */
  externalAccounts: Array<ExternalAccount>;
  firstName: Scalars['String'];
  gender?: Maybe<TenantField>;
  genderSelfDescribe?: Maybe<Scalars['String']>;
  guardian1CountryOfBirth?: Maybe<Scalars['String']>;
  guardian2CountryOfBirth?: Maybe<Scalars['String']>;
  guardianBornOverseas?: Maybe<TenantField>;
  guardians?: Maybe<Array<PossibleGuardian>>;
  hasDisability?: Maybe<TenantField>;
  homeNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  indigenousDescent?: Maybe<TenantField>;
  /**
   * Resolves to the last known interacted organisations that the profile is associated with.
   * This interaction is determined by their tenant. For example, this could reflect the
   * organisation associated with the profile's last known registration and/or their latest
   * club affiliation.
   */
  lastInteractedOrganisations?: Maybe<Array<DiscoverOrganisation>>;
  lastName: Scalars['String'];
  memberships: Array<Membership>;
  migratedEmail?: Maybe<Scalars['String']>;
  mobileNumber?: Maybe<Mobile>;
  /**
   * List of teams that the profile has participated in. Can be filtered by
   * season status (e.g. to hide teams in completed seasons)
   */
  myTeamsList?: Maybe<MyTeamsList>;
  otherDisability?: Maybe<Scalars['String']>;
  preferredName?: Maybe<Scalars['String']>;
  profilePhotoVerificationURL?: Maybe<SignedUrl>;
  profileQuestions?: Maybe<Array<FieldSet>>;
  registrationHistory?: Maybe<Array<RegistrationHistory>>;
  socialTeams: Array<TeamOrigin>;
  transferRequests: Array<TransferRequest>;
  visible: Scalars['Boolean'];
  wwc?: Maybe<Wwc>;
};


export type ProfileDependantsArgs = {
  tenantFilter?: InputMaybe<Array<Scalars['String']>>;
};


export type ProfileDuplicateProfilesArgs = {
  registrationCode?: InputMaybe<Scalars['String']>;
  searchParameters?: InputMaybe<DuplicateProfileSearchInput>;
};


export type ProfileMyTeamsListArgs = {
  filter?: InputMaybe<MyTeamsListFilter>;
};


export type ProfileRegistrationHistoryArgs = {
  organisationID?: InputMaybe<Scalars['ID']>;
};


export type ProfileSocialTeamsArgs = {
  organisationID?: InputMaybe<Scalars['ID']>;
};


export type ProfileTransferRequestsArgs = {
  filter?: InputMaybe<TransferRequestsFilter>;
};

export type Address = {
  __typename?: 'Address';
  country: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  line1: Scalars['String'];
  longitude?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  state: Scalars['String'];
  suburb: Scalars['String'];
};

export type FieldSet = {
  __typename?: 'FieldSet';
  fields?: Maybe<Array<Field>>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type Field = {
  hidden?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type CoachingAccreditation = Node & {
  __typename?: 'CoachingAccreditation';
  id: Scalars['ID'];
  level: TenantField;
};

export type Node = {
  id: Scalars['ID'];
};

export type TenantField = {
  __typename?: 'TenantField';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type Incident = {
  __typename?: 'Incident';
  category?: Maybe<IncidentCategory>;
  createdAt?: Maybe<Scalars['ISODate']>;
  /** Applied to GAME incident only */
  game?: Maybe<MyTeamsGame>;
  id: Scalars['ID'];
  /** Applied to NON_GAME incident only */
  incidentDate?: Maybe<Scalars['ISODate']>;
  note?: Maybe<Scalars['String']>;
  outcome?: Maybe<Outcome>;
  /** Applied to NON_GAME incident only */
  owningOrganisation?: Maybe<DiscoverOrganisation>;
  /** Applied to GAME incident only */
  participant?: Maybe<Participant>;
  /** Applied to NON_GAME incident only */
  profile?: Maybe<MyTeamsProfile>;
  /** Applied to NON_GAME incident only */
  seasonName?: Maybe<Scalars['String']>;
  status?: Maybe<IncidentStatus>;
  /** Applied to GAME incident only */
  team?: Maybe<MyTeamsPossibleTeam>;
  type?: Maybe<IncidentType>;
  updatedAt?: Maybe<Scalars['ISODate']>;
};

export enum IncidentCategory {
  Concussion = 'CONCUSSION'
}

export type MyTeamsGame = Node & {
  __typename?: 'MyTeamsGame';
  allocation?: Maybe<DiscoverAllocation>;
  /**
   * Availability can be accessed if the account has at least one profile that is participating
   * in this game
   * @deprecated use myProfilesGameAvailability instead
   */
  availability?: Maybe<GameAvailability>;
  away?: Maybe<MyTeamsPossibleTeam>;
  clubScoringAccess?: Maybe<GameClubScoringAccess>;
  /** @deprecated use dates */
  date?: Maybe<Scalars['ISODate']>;
  dates?: Maybe<Array<Scalars['ISODate']>>;
  /**
   * Returns the lineup without checking the access to the opposition lineup
   * when tenant is cricket and the grade setting `Club access type` is set to `Their own team`
   */
  gameTeams?: Maybe<MyTeamsGameTeams>;
  gameType?: Maybe<GameType>;
  /** Incidents can be viewed by team managers */
  hasIncidentAccess?: Maybe<Scalars['Boolean']>;
  hasManagementAccess?: Maybe<Scalars['Boolean']>;
  hasOvertime?: Maybe<Scalars['Boolean']>;
  home?: Maybe<MyTeamsPossibleTeam>;
  id: Scalars['ID'];
  managementAuthorisation?: Maybe<GameManagementAuthorisation>;
  /** @deprecated use clubScoringAccess */
  managementTimeWindowInHours?: Maybe<Scalars['Int']>;
  result?: Maybe<GameResult>;
  round?: Maybe<MyTeamsRound>;
  startDateTime?: Maybe<Scalars['ISODateTime']>;
  statistics?: Maybe<MyTeamsGameStatistics>;
  status?: Maybe<GameStatus>;
  teams?: Maybe<MyTeamsGameTeams>;
};

export type DiscoverAllocation = {
  __typename?: 'DiscoverAllocation';
  court: DiscoverCourt;
  dateTimeList?: Maybe<Array<DateTime>>;
  /** @deprecated use dateTimeList.time */
  time: Scalars['Naive24HourTime'];
  timezone: Scalars['String'];
};

export type DiscoverCourt = {
  __typename?: 'DiscoverCourt';
  abbreviatedName: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  venue: DiscoverVenue;
};

export type DiscoverVenue = {
  __typename?: 'DiscoverVenue';
  abbreviatedName: Scalars['String'];
  address: Scalars['String'];
  country: Scalars['String'];
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  postcode: Scalars['String'];
  state: Scalars['String'];
  suburb: Scalars['String'];
};

export type DateTime = {
  __typename?: 'DateTime';
  date: Scalars['ISODate'];
  time: Scalars['Naive24HourTime'];
};

/**
 * Only the team that the account holder has at least one profile participating in will return
 * its team availability information for the game
 */
export type GameAvailability = {
  __typename?: 'GameAvailability';
  away?: Maybe<GameTeamAvailability>;
  home?: Maybe<GameTeamAvailability>;
};

export type GameTeamAvailability = {
  __typename?: 'GameTeamAvailability';
  /** Get the game availability status for my profiles in this game team */
  myPlayers?: Maybe<Array<GamePlayerAvailability>>;
  /**
   * Player count information will be available to all authenticated users that have access
   * to this game teams availability.
   */
  playerCount?: Maybe<GameTeamAvailabilityPlayerCount>;
  /**
   * Only users that have management authorisation are able to see the list of player availabilities
   * This field will only take into account the main profiles management access
   */
  players?: Maybe<Array<GamePlayerAvailability>>;
};

export type GamePlayerAvailability = {
  __typename?: 'GamePlayerAvailability';
  participant?: Maybe<MyTeamsParticipant>;
  status?: Maybe<AvailabilityStatus>;
};

export type MyTeamsParticipant = Node & {
  __typename?: 'MyTeamsParticipant';
  gamesPlayed?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  /** @deprecated use MyTeamsGamePlayerStatistics.ineligibilityStatus */
  ineligibilityStatus?: Maybe<Array<IneligibilityStatus>>;
  isSuspended?: Maybe<Scalars['Boolean']>;
  permit?: Maybe<Permit>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  /** This is the player points in the season context, not game context */
  playerPoints?: Maybe<Scalars['Int']>;
  profile?: Maybe<MyTeamsProfile>;
  teams?: Maybe<Array<MyTeamsTeam>>;
  totalStatistics?: Maybe<Array<Statistic>>;
};


export type MyTeamsParticipantIneligibilityStatusArgs = {
  input?: InputMaybe<IneligibilityStatusInput>;
};

export type IneligibilityStatusInput = {
  gameID?: InputMaybe<Scalars['ID']>;
  teamID?: InputMaybe<Scalars['ID']>;
};

export type IneligibilityStatus = {
  __typename?: 'IneligibilityStatus';
  message?: Maybe<Scalars['String']>;
  value?: Maybe<IneligibilityStatusType>;
};

export enum IneligibilityStatusType {
  AgeAndGenderRestrictions = 'AGE_AND_GENDER_RESTRICTIONS',
  Concussion = 'CONCUSSION',
  FinalsIneligible = 'FINALS_INELIGIBLE',
  InactivePermit = 'INACTIVE_PERMIT',
  NoPlayerPoints = 'NO_PLAYER_POINTS',
  Suspended = 'SUSPENDED'
}

export type Permit = Node & {
  __typename?: 'Permit';
  createdAt?: Maybe<Scalars['ISODateTime']>;
  destinationClub?: Maybe<DiscoverOrganisation>;
  destinationSeason?: Maybe<DiscoverSeason>;
  fromDate: Scalars['ISODate'];
  id: Scalars['ID'];
  registrationLink?: Maybe<Scalars['String']>;
  requestedBy?: Maybe<PermitRequestedByRole>;
  sourceAffiliation?: Maybe<Affiliation>;
  status: PermitStatus;
  toDate: Scalars['ISODate'];
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export type DiscoverOrganisation = {
  __typename?: 'DiscoverOrganisation';
  address?: Maybe<Address>;
  contactNumber: Scalars['String'];
  contacts: Array<DiscoverOrganisationContact>;
  email: Scalars['String'];
  id: Scalars['String'];
  /** Indicates if the organisation is the top level tenant org (e.g. Basketball Victoria, AFL, etc) */
  isTenantOrganisation?: Maybe<Scalars['Boolean']>;
  logo?: Maybe<Image>;
  name: Scalars['String'];
  registeredCompetitions: Array<DiscoverCompetition>;
  /** Whether the organisation has marked their shop to be visible */
  shopVisible?: Maybe<Scalars['Boolean']>;
  telCountryCode: Scalars['String'];
  tenant?: Maybe<TenantOrganisation>;
  /** @deprecated Field no longer supported */
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  type: OrganisationType;
  websiteUrl?: Maybe<Scalars['String']>;
};

export type DiscoverOrganisationContact = Node & {
  __typename?: 'DiscoverOrganisationContact';
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  position: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  sizes: Array<ImageSource>;
};


export type ImageSizesArgs = {
  dimensions?: InputMaybe<Array<ImageDimensionInput>>;
};

export type ImageDimensionInput = {
  height?: InputMaybe<Scalars['Int']>;
  width: Scalars['Int'];
};

export type ImageSource = {
  __typename?: 'ImageSource';
  dimensions: ImageDimension;
  url: Scalars['String'];
};

export type ImageDimension = {
  __typename?: 'ImageDimension';
  height: Scalars['Int'];
  width: Scalars['Int'];
};

export type DiscoverCompetition = {
  __typename?: 'DiscoverCompetition';
  format?: Maybe<TenantField>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
  seasons: Array<DiscoverSeason>;
  type: CompetitionType;
};


export type DiscoverCompetitionSeasonsArgs = {
  organisationID?: InputMaybe<Scalars['ID']>;
};

export type DiscoverSeason = Node & {
  __typename?: 'DiscoverSeason';
  ageGroups?: Maybe<Array<SeasonAgeGroup>>;
  ageRestrictionRange?: Maybe<AgeRestrictionRange>;
  availableRegistrations: Array<DiscoverRegistration>;
  competition: DiscoverCompetition;
  endDate: Scalars['ISODate'];
  grades: Array<DiscoverGrade>;
  id: Scalars['ID'];
  name: Scalars['String'];
  startDate: Scalars['ISODate'];
  status: DiscoverSeasonStatus;
};

export type SeasonAgeGroup = {
  __typename?: 'SeasonAgeGroup';
  ageGroup?: Maybe<AgeGroup>;
  equalToOrOlderThan?: Maybe<YearsMonthsDays>;
  maxDOB?: Maybe<Scalars['ISODate']>;
  minDOB?: Maybe<Scalars['ISODate']>;
  youngerThan?: Maybe<YearsMonthsDays>;
};

export type AgeGroup = {
  __typename?: 'AgeGroup';
  name: Scalars['String'];
  shortName?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type YearsMonthsDays = {
  __typename?: 'YearsMonthsDays';
  days?: Maybe<Scalars['Int']>;
  months?: Maybe<Scalars['Int']>;
  years?: Maybe<Scalars['Int']>;
};

export type AgeRestrictionRange = {
  __typename?: 'AgeRestrictionRange';
  dobFromDate: Scalars['ISODate'];
  dobToDate: Scalars['ISODate'];
};

export type DiscoverRegistration = {
  __typename?: 'DiscoverRegistration';
  additionalInfo?: Maybe<Scalars['String']>;
  ageGroupRestrictions?: Maybe<Array<AgeGroupRestriction>>;
  /** @deprecated use registrationAgeRestriction */
  ageRestriction?: Maybe<IntRange>;
  customFields: Array<CustomFields>;
  daySessions?: Maybe<Array<DaySession>>;
  /** Determines whether an org has setup deferred fees for this registration */
  deferredFees?: Maybe<Scalars['Boolean']>;
  deferredFeesDueDate?: Maybe<Scalars['ISODate']>;
  depositAmount?: Maybe<Scalars['Int']>;
  endDate: TimeZoneDateTime;
  fieldEntries?: Maybe<RegistrationFields>;
  gender?: Maybe<GradeGender>;
  groups: Array<Group>;
  hostOrganisation: DiscoverOrganisation;
  id: Scalars['ID'];
  marketingOptInText?: Maybe<Scalars['String']>;
  organisation: DiscoverOrganisation;
  organisationTermsAndConditions?: Maybe<Array<OrganisationTermsAndConditions>>;
  playingSurface?: Maybe<PlayingSurface>;
  pricingInfo?: Maybe<Scalars['String']>;
  /**
   * Find products that are assigned to a registration. Certain products
   * can only be purchasable and/or mandatory based on the registrant's
   * role. For example, a product may be purchasable by a player, but not
   * by a coach.
   *
   * Providing no value is equivalant to providing all possible roles.
   * This is primarily in place to ensure backwards compatability.
   */
  products?: Maybe<Array<Product>>;
  questions: Array<RegistrationQuestion>;
  registrationAgeRestriction?: Maybe<AgeRestriction>;
  registrationCode: Scalars['String'];
  registrationUserTypes: Array<RegistrationUserType>;
  season: CompetitionProgramSeason;
  sessionCount?: Maybe<Scalars['Int']>;
  startDate: TimeZoneDateTime;
  /** @deprecated use organisationTermsAndConditions */
  termsAndConditions: Array<TermsAndConditions>;
  type: SeasonRegistrationType;
  visible?: Maybe<Scalars['Boolean']>;
};


export type DiscoverRegistrationCustomFieldsArgs = {
  role?: InputMaybe<CustomFieldApplicableRole>;
};


export type DiscoverRegistrationProductsArgs = {
  role?: InputMaybe<SeasonRegistrationUserType>;
};

export type AgeGroupRestriction = {
  __typename?: 'AgeGroupRestriction';
  ageGroup?: Maybe<AgeGroup>;
  registrationInfo?: Maybe<Scalars['String']>;
};

export type IntRange = {
  __typename?: 'IntRange';
  max: Scalars['Int'];
  min: Scalars['Int'];
};

export enum CustomFieldApplicableRole {
  BenchPersonnel = 'BENCH_PERSONNEL',
  Coach = 'COACH',
  MedicalOfficer = 'MEDICAL_OFFICER',
  Official = 'OFFICIAL',
  Player = 'PLAYER',
  Statistician = 'STATISTICIAN',
  TableOfficial = 'TABLE_OFFICIAL',
  TeamManager = 'TEAM_MANAGER',
  Volunteer = 'VOLUNTEER'
}

export type CustomFields = DropdownCustomField | TextCustomField;

export type DropdownCustomField = CustomField & {
  __typename?: 'DropdownCustomField';
  dropdownOptions: Array<DropdownOption>;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
  required?: Maybe<Scalars['Boolean']>;
};

export type CustomField = {
  id: Scalars['ID'];
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
};

export type DropdownOption = {
  __typename?: 'DropdownOption';
  customField?: Maybe<CustomFields>;
  hasData: Scalars['Boolean'];
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type TextCustomField = CustomField & {
  __typename?: 'TextCustomField';
  id: Scalars['ID'];
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
  required?: Maybe<Scalars['Boolean']>;
};

export type DaySession = {
  __typename?: 'DaySession';
  day: DayOfTheWeek;
  endTime?: Maybe<Scalars['Naive24HourTime']>;
  startTime?: Maybe<Scalars['Naive24HourTime']>;
};

export enum DayOfTheWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type TimeZoneDateTime = {
  __typename?: 'TimeZoneDateTime';
  date: Scalars['ISODate'];
  time: Scalars['Naive24HourTime'];
  timezone: Scalars['String'];
};

export type RegistrationFields = {
  __typename?: 'RegistrationFields';
  childSafety?: Maybe<FieldSet>;
  profileQuestions?: Maybe<FieldSet>;
};

export enum GradeGender {
  Boys = 'BOYS',
  Girls = 'GIRLS',
  Mens = 'MENS',
  Mixed = 'MIXED',
  Unspecified = 'UNSPECIFIED',
  Womens = 'WOMENS'
}

export type Group = Node & {
  __typename?: 'Group';
  /** @deprecated use daySessions */
  days: Array<DayOfTheWeek>;
  daySessions?: Maybe<Array<DaySession>>;
  gender?: Maybe<GradeGender>;
  id: Scalars['ID'];
  name: Scalars['String'];
  playingSurface?: Maybe<PlayingSurface>;
  /** @deprecated use userTypesMeta */
  registrationUserTypes?: Maybe<Array<RegistrationUserType>>;
  sessionCount?: Maybe<Scalars['Int']>;
  /** @deprecated use daySessions */
  sessionEndTime?: Maybe<Scalars['Naive24HourTime']>;
  /** @deprecated use daySessions */
  sessionStartTime?: Maybe<Scalars['Naive24HourTime']>;
  startDate?: Maybe<Scalars['ISODate']>;
  userTypesMeta?: Maybe<Array<GroupUserTypeMeta>>;
};

export type PlayingSurface = {
  __typename?: 'PlayingSurface';
  id: Scalars['ID'];
  name: Scalars['String'];
  venue: Venue;
};

export type Venue = Node & {
  __typename?: 'Venue';
  abbreviatedName: Scalars['String'];
  address: Scalars['String'];
  contactName?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  courtCount: Scalars['Int'];
  courts: Array<Court>;
  email?: Maybe<Scalars['String']>;
  hasCafeOnSite?: Maybe<Scalars['Boolean']>;
  hasCarPark?: Maybe<Scalars['Boolean']>;
  hasDisabledAccess?: Maybe<Scalars['Boolean']>;
  hasFirstAid?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  state: Scalars['String'];
  suburb: Scalars['String'];
  timezone: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type Court = {
  __typename?: 'Court';
  abbreviatedName: Scalars['String'];
  games?: Maybe<Array<DiscoverGame>>;
  hasAdjustableRingHeight: Scalars['Boolean'];
  hasScoreboard: Scalars['Boolean'];
  hasShotClock: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  surfaceType?: Maybe<TenantField>;
  venue: Venue;
};


export type CourtGamesArgs = {
  filter?: InputMaybe<Array<Scalars['ISODate']>>;
};

export type DiscoverGame = {
  __typename?: 'DiscoverGame';
  alias?: Maybe<Scalars['String']>;
  allocation?: Maybe<DiscoverAllocation>;
  away: DiscoverPossibleTeam;
  /** @deprecated use dates */
  date: Scalars['ISODate'];
  dates?: Maybe<Array<Scalars['ISODate']>>;
  /**
   * Display game formation for this game in the game centre
   * If this field is empty, render regular lineup list
   */
  formation?: Maybe<GameFormation>;
  gameType?: Maybe<GameType>;
  grade?: Maybe<DiscoverGrade>;
  home: DiscoverPossibleTeam;
  id: Scalars['ID'];
  isStale?: Maybe<Scalars['Boolean']>;
  pool?: Maybe<Pool>;
  publishLineup?: Maybe<Scalars['Boolean']>;
  result?: Maybe<GameResult>;
  round: DiscoverRound;
  statistics?: Maybe<DiscoverGameStatistics>;
  status: GameStatus;
};

export type DiscoverPossibleTeam = DiscoverTeam | ProvisionalTeam;

export type DiscoverTeam = {
  __typename?: 'DiscoverTeam';
  ageGroup: TenantField;
  gender: TenantField;
  grade?: Maybe<DiscoverGrade>;
  id: Scalars['ID'];
  logo?: Maybe<Image>;
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
  playerPointsCap?: Maybe<Scalars['Int']>;
  pool?: Maybe<Pool>;
  preferredGrade?: Maybe<Scalars['String']>;
  registeredDate?: Maybe<Scalars['ISODate']>;
  season: DiscoverSeason;
};

export type DiscoverGrade = {
  __typename?: 'DiscoverGrade';
  age?: Maybe<TenantField>;
  bestPlayers?: Maybe<BestPlayersConfiguration>;
  day?: Maybe<TenantField>;
  /** @deprecated use gameStatisticsConfiguration */
  gameEvents: GameEvents;
  /**
   * This field is introduced as a replacement for gameEvents. The word 'event' is a bit misleading as some statistics
   * recorded against a game can classify as an event (eg. 1_POINT_SCORE) and others can classify as a total
   * (eg. TOTAL_FOULS).
   */
  gameStatisticsConfiguration?: Maybe<GameStatisticsConfiguration>;
  /** @deprecated use gameTypes */
  gameType?: Maybe<GameType>;
  gameTypes?: Maybe<Array<GameType>>;
  gender?: Maybe<TenantField>;
  hasFinals: Scalars['Boolean'];
  hasPeriodScores?: Maybe<Scalars['Boolean']>;
  hideScores: Scalars['Boolean'];
  id: Scalars['String'];
  ladder: Array<LadderPool>;
  ladderType?: Maybe<LadderTemplate>;
  lineupRemainsWhenGameStarted?: Maybe<Scalars['Boolean']>;
  maxPlayers?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  overallLadder?: Maybe<OverallLadder>;
  overallLadderFields?: Maybe<Array<LadderField>>;
  overallLadderRankingFields?: Maybe<Array<LadderField>>;
  periods: Array<Period>;
  periodScoresDisplayType?: Maybe<TenantField>;
  playerPoints?: Maybe<PlayerPointsConfiguration>;
  rounds: Array<DiscoverRound>;
  season: DiscoverSeason;
  type?: Maybe<GradeType>;
};


export type DiscoverGradeLadderArgs = {
  filter?: InputMaybe<GradeLadderFilter>;
};

export type BestPlayersConfiguration = {
  __typename?: 'BestPlayersConfiguration';
  max?: Maybe<Scalars['Int']>;
};

export type GameEvents = {
  __typename?: 'GameEvents';
  participantEvents: Array<GameEventConfiguration>;
  periodEvents: Array<GameEventConfiguration>;
  teamEvents: Array<GameEventConfiguration>;
};

export type GameEventConfiguration = {
  __typename?: 'GameEventConfiguration';
  advanced?: Maybe<Scalars['Boolean']>;
  applicableTo: Array<GameActor>;
  label: Scalars['String'];
  pointValue?: Maybe<Scalars['Int']>;
  shortName: Scalars['String'];
  type: GameStatisticType;
  value: Scalars['String'];
};

export enum GameActor {
  AssistantCoach = 'ASSISTANT_COACH',
  Coach = 'COACH',
  Player = 'PLAYER',
  Team = 'TEAM'
}

export enum GameStatisticType {
  Batting = 'BATTING',
  Bowling = 'BOWLING',
  Card = 'CARD',
  Extras = 'EXTRAS',
  FallOfWicket = 'FALL_OF_WICKET',
  Fielding = 'FIELDING',
  Foul = 'FOUL',
  NonScore = 'NON_SCORE',
  Score = 'SCORE'
}

export type GameStatisticsConfiguration = {
  __typename?: 'GameStatisticsConfiguration';
  /**
   * A list of all statistics applicable to a game in this grade. An optional filter allows a subset of statistics to be
   * returned based on whether they are an event statistic or a total statistic.
   */
  gameStatistics?: Maybe<Array<GameStatisticConfiguration>>;
};


export type GameStatisticsConfigurationGameStatisticsArgs = {
  filter?: InputMaybe<GameStatisticsFilter>;
};

export type GameStatisticsFilter = {
  classification?: InputMaybe<GameStatisticClassification>;
};

export enum GameStatisticClassification {
  Event = 'EVENT',
  Total = 'TOTAL'
}

export type GameStatisticConfiguration = {
  __typename?: 'GameStatisticConfiguration';
  applicableTo?: Maybe<Array<GameActor>>;
  glossary?: Maybe<GameStatisticGlossary>;
  max?: Maybe<Scalars['Int']>;
  pointValue?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<GameStatisticType>;
  value?: Maybe<Scalars['String']>;
};

export type GameStatisticGlossary = {
  __typename?: 'GameStatisticGlossary';
  default?: Maybe<GameStatisticGlossaryField>;
  scoring?: Maybe<GameStatisticGlossaryField>;
};

export type GameStatisticGlossaryField = {
  __typename?: 'GameStatisticGlossaryField';
  /**
   * If the statistic is shown as a button, this is what the label should be.
   * For example, in netball, this will be Goal, but in AFL, it will be "1"
   */
  labelName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type GameType = {
  __typename?: 'GameType';
  clockType?: Maybe<ClockType>;
  emergencyPlayersSettings?: Maybe<EmergencyPlayersSettings>;
  eScoringSettings?: Maybe<EScoringSettings>;
  hasManualBonusPoints?: Maybe<Scalars['Boolean']>;
  hasSuperOver?: Maybe<Scalars['Boolean']>;
  ladderFields?: Maybe<Array<LadderField>>;
  ladderRankingFields?: Maybe<Array<LadderField>>;
  ladderType?: Maybe<LadderTemplate>;
  lineupLimits?: Maybe<LineupLimits>;
  manualBonusPoints?: Maybe<Array<Scalars['Float']>>;
  maxBattersPerInnings?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  overs?: Maybe<Scalars['Int']>;
  overtime?: Maybe<Overtime>;
  periodLength?: Maybe<Scalars['Int']>;
  playerPositionsSettings?: Maybe<PlayerPositionsSettings>;
  value?: Maybe<Scalars['String']>;
};

/** Whether the clock counts up or down for users scoring games electronically */
export enum ClockType {
  CountDown = 'COUNT_DOWN',
  CountUp = 'COUNT_UP'
}

export type EmergencyPlayersSettings = {
  __typename?: 'EmergencyPlayersSettings';
  enabled?: Maybe<Scalars['Boolean']>;
  includeInLineupLimit?: Maybe<Scalars['Boolean']>;
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type EScoringSettings = {
  __typename?: 'EScoringSettings';
  dismissalsPerBatter?: Maybe<Scalars['Int']>;
  legalBallsPerOver?: Maybe<Scalars['Int']>;
};

export type LadderField = {
  __typename?: 'LadderField';
  dataType?: Maybe<LadderDataType>;
  decimals?: Maybe<Scalars['Int']>;
  displayOrder?: Maybe<Scalars['Int']>;
  extendedToolTip?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  /** Only applicable in the scope of Grade/Game Type default settings and Game Type/Grade settings. 3 to 5 ladder fields will have this populated. */
  sortOrder?: Maybe<Scalars['Int']>;
  toolTip?: Maybe<Scalars['String']>;
  truncateTrailingZeros?: Maybe<Scalars['Boolean']>;
  type?: Maybe<LadderFieldType>;
};

export enum LadderDataType {
  Float = 'FLOAT',
  Int = 'INT'
}

export enum LadderFieldType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export enum LadderTemplate {
  MatchRatio = 'MATCH_RATIO',
  PointsAverage = 'POINTS_AVERAGE',
  TotalCompetitionPoints = 'TOTAL_COMPETITION_POINTS'
}

export type LineupLimits = {
  __typename?: 'LineupLimits';
  coaches?: Maybe<MinMax>;
  players?: Maybe<MinMax>;
};

export type MinMax = {
  __typename?: 'MinMax';
  max?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Int']>;
};

export type Overtime = {
  __typename?: 'Overtime';
  periodLength?: Maybe<Scalars['Int']>;
};

export type PlayerPositionsSettings = {
  __typename?: 'PlayerPositionsSettings';
  /** Enable or disable player positions */
  enabled?: Maybe<Scalars['Boolean']>;
  /** When set to true, each player in a game team line up must have a player position */
  enforcePositions?: Maybe<Scalars['Boolean']>;
  /**
   * When set to true, players that have an in-game position set via e-scoring will
   * be displayed in public game centre lineups.
   */
  isInGamePositionsLineupVisible?: Maybe<Scalars['Boolean']>;
};

export type GradeLadderFilter = {
  teamID?: InputMaybe<Scalars['ID']>;
};

export type LadderPool = {
  __typename?: 'LadderPool';
  gameTypeValue?: Maybe<Scalars['String']>;
  generatedFrom: DiscoverRound;
  pool?: Maybe<Pool>;
  standings: Array<LadderStanding>;
};

export type DiscoverRound = {
  __typename?: 'DiscoverRound';
  abbreviatedName: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  byes?: Maybe<Array<DiscoverTeam>>;
  current: Scalars['Boolean'];
  fixture: DiscoverRoundFixture;
  games: Array<DiscoverGame>;
  grade: DiscoverGrade;
  id: Scalars['ID'];
  isFinalsRound: Scalars['Boolean'];
  isStale?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  number: Scalars['Int'];
  /** @deprecated use provisionalDates */
  provisionalDate?: Maybe<Scalars['ISODate']>;
  provisionalDates?: Maybe<Array<Scalars['ISODate']>>;
};

export type DiscoverRoundFixture = {
  __typename?: 'DiscoverRoundFixture';
  byes: Array<DiscoverTeam>;
  games: Array<DiscoverGame>;
};

export type Pool = {
  __typename?: 'Pool';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type LadderStanding = {
  __typename?: 'LadderStanding';
  adjustments: Scalars['Float'];
  /** A calculation that is a ratio of the number of points scored by the team versus the number of points scored by their opponents + number of points scored by the team */
  alternatePercentage?: Maybe<Scalars['Float']>;
  bonusPoints?: Maybe<Scalars['Float']>;
  byes: Scalars['Int'];
  competitionPoints: Scalars['Float'];
  disqualifications: Scalars['Int'];
  drawn: Scalars['Int'];
  forfeits: Scalars['Int'];
  lossFirstInnings?: Maybe<Scalars['Int']>;
  lossOutright?: Maybe<Scalars['Int']>;
  lost: Scalars['Int'];
  matchRatio?: Maybe<Scalars['Float']>;
  netRunRate?: Maybe<Scalars['Float']>;
  noResults?: Maybe<Scalars['Int']>;
  oversBowled?: Maybe<Scalars['Float']>;
  oversFaced?: Maybe<Scalars['Float']>;
  percentage: Scalars['Float'];
  played: Scalars['Int'];
  pointsAgainst: Scalars['Int'];
  pointsAverage?: Maybe<Scalars['Float']>;
  pointsDifference?: Maybe<Scalars['Int']>;
  pointsFor: Scalars['Int'];
  quotient?: Maybe<Scalars['Float']>;
  runsAgainst?: Maybe<Scalars['Int']>;
  runsFor?: Maybe<Scalars['Int']>;
  team: DiscoverTeam;
  ties?: Maybe<Scalars['Int']>;
  wicketsLost?: Maybe<Scalars['Int']>;
  wicketsTaken?: Maybe<Scalars['Int']>;
  winFirstInnings?: Maybe<Scalars['Int']>;
  winOutright?: Maybe<Scalars['Int']>;
  won: Scalars['Int'];
};

export type OverallLadder = {
  __typename?: 'OverallLadder';
  ladderType?: Maybe<OverallLadderTemplate>;
};

export enum OverallLadderTemplate {
  PointsAverage = 'POINTS_AVERAGE',
  TotalCompetitionPoints = 'TOTAL_COMPETITION_POINTS'
}

export type Period = {
  __typename?: 'Period';
  label: Scalars['String'];
  shortName: Scalars['String'];
  value: PeriodValue;
};

export enum PeriodValue {
  FirstHalf = 'FIRST_HALF',
  FirstInnings = 'FIRST_INNINGS',
  FirstQtr = 'FIRST_QTR',
  FourthQtr = 'FOURTH_QTR',
  Overtime = 'OVERTIME',
  SecondHalf = 'SECOND_HALF',
  SecondInnings = 'SECOND_INNINGS',
  SecondQtr = 'SECOND_QTR',
  ThirdQtr = 'THIRD_QTR'
}

export type PlayerPointsConfiguration = {
  __typename?: 'PlayerPointsConfiguration';
  enforceTeamTotalCap?: Maybe<Scalars['Boolean']>;
  publicVisible?: Maybe<Scalars['Boolean']>;
  teamPlayerPointsCap?: Maybe<Scalars['Int']>;
};

export enum GradeType {
  Bye = 'BYE',
  CupCompetition = 'CUP_COMPETITION',
  Friendlies = 'FRIENDLIES',
  Practice = 'PRACTICE',
  PreSeason = 'PRE_SEASON',
  Regular = 'REGULAR',
  School = 'SCHOOL'
}

export type ProvisionalTeam = {
  __typename?: 'ProvisionalTeam';
  name: Scalars['String'];
  pool?: Maybe<Pool>;
};

export type GameFormation = {
  __typename?: 'GameFormation';
  template?: Maybe<FormationTemplate>;
};

/**
 * Formation templates to be displayed in game centre that are unique
 * per sport/tenant and can be extended as needed
 */
export enum FormationTemplate {
  Afl = 'AFL'
}

export type GameResult = {
  __typename?: 'GameResult';
  away: GameTeamResult;
  home: GameTeamResult;
  outcome?: Maybe<TenantField>;
  winner?: Maybe<TenantField>;
};

export type GameTeamResult = {
  __typename?: 'GameTeamResult';
  gameOutcomeDescription?: Maybe<Scalars['String']>;
  outcome?: Maybe<TenantField>;
  periods?: Maybe<Array<GamePeriodStatistics>>;
  /** @deprecated use statistics */
  score?: Maybe<Scalars['Int']>;
  statistics?: Maybe<Array<Statistic>>;
};

export type GamePeriodStatistics = {
  __typename?: 'GamePeriodStatistics';
  closureStatus?: Maybe<ClosureStatus>;
  overtimeSequenceNo?: Maybe<Scalars['Int']>;
  period: Period;
  statistics: Array<Statistic>;
  teamEvents?: Maybe<Array<GameTeamPeriodEvent>>;
  type?: Maybe<PeriodType>;
};

export enum ClosureStatus {
  AllOut = 'ALL_OUT',
  CompulsoryClose = 'COMPULSORY_CLOSE',
  Declared = 'DECLARED',
  EndOfGame = 'END_OF_GAME',
  FollowOn = 'FOLLOW_ON',
  InProgress = 'IN_PROGRESS'
}

export type Statistic = {
  __typename?: 'Statistic';
  count?: Maybe<Scalars['Float']>;
  details?: Maybe<GameStatistic>;
  /** Time when a particular statistic entry was added, only relevant for football tenant for now */
  recordedTimeList?: Maybe<Array<StatisticRecordedTimeInfo>>;
  type: GameEventConfiguration;
};

export type GameStatistic = {
  __typename?: 'GameStatistic';
  max?: Maybe<Scalars['Int']>;
  required?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type StatisticRecordedTimeInfo = {
  __typename?: 'StatisticRecordedTimeInfo';
  /** Optional free-text field to capture additional information. */
  description?: Maybe<Scalars['String']>;
  minute?: Maybe<Scalars['Int']>;
  /**
   * In the case of a foul, this field will map to a list of options against the
   * tenant, eg. for Football there is a different list of options for a red or
   * yellow card.
   */
  offenceType?: Maybe<Scalars['String']>;
  stoppage?: Maybe<Scalars['Int']>;
};

export type GameTeamPeriodEvent = {
  __typename?: 'GameTeamPeriodEvent';
  playerID?: Maybe<Scalars['String']>;
  sequenceNo?: Maybe<Scalars['Int']>;
  statistic?: Maybe<Statistic>;
};

export enum PeriodType {
  Halves = 'HALVES',
  Innings = 'INNINGS',
  Quarters = 'QUARTERS',
  SuperOver = 'SUPER_OVER'
}

export type DiscoverGameStatistics = {
  __typename?: 'DiscoverGameStatistics';
  away: DiscoverGameTeamStatistics;
  home: DiscoverGameTeamStatistics;
  shared?: Maybe<Array<SharedPeriodStatistics>>;
};

export type DiscoverGameTeamStatistics = {
  __typename?: 'DiscoverGameTeamStatistics';
  bestPlayers?: Maybe<Array<DiscoverBestPlayer>>;
  coinTossWinningResult?: Maybe<CoinToss>;
  emergencyPlayers?: Maybe<Array<DiscoverEmergencyPlayer>>;
  periods: Array<GamePeriodStatistics>;
  players: Array<DiscoverPlayerStatistics>;
  statistics: Array<Statistic>;
};

export type DiscoverBestPlayer = {
  __typename?: 'DiscoverBestPlayer';
  participant?: Maybe<DiscoverPossibleParticipant>;
  ranking?: Maybe<Scalars['Int']>;
};

export type DiscoverPossibleParticipant = DiscoverAnonymousParticipant | DiscoverParticipant;

export type DiscoverAnonymousParticipant = {
  __typename?: 'DiscoverAnonymousParticipant';
  /**
   * If the FillInPlayer has come from outside the season and has a game permit, this will be true
   * It is used for things like the game permit tooltip
   */
  hasGamePermit?: Maybe<Scalars['Boolean']>;
  /**
   * This will be true if the player has a season permit. We don't return the season permit dates,
   * as we assume that if the FillInPlayer was added to the lineup, their season permit must be valid on the game date
   */
  hasSeasonPermit?: Maybe<Scalars['Boolean']>;
  /**
   * The "ID" for this participant. Note: This is deliberately generated on a request basis so the player
   * stays anonymous. This ID is mainly used to map to shared statistics
   */
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type DiscoverParticipant = {
  __typename?: 'DiscoverParticipant';
  /**
   * This will be true if the player has a season permit. We don't return the season permit dates,
   * as we assume that if the FillInPlayer was added to the lineup, their season permit must be valid on the game date
   */
  hasSeasonPermit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  profile?: Maybe<DiscoverProfile>;
  /** @deprecated not used */
  type?: Maybe<Scalars['String']>;
};

export type DiscoverProfile = {
  __typename?: 'DiscoverProfile';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  /**
   * Resolves to the last known interacted organisation that the profile is associated with.
   * This interaction is determined by their tenant. For example, this could reflect the
   * organisation associated with the profile's last known registration or their latest
   * club affiliation.
   *
   * This can return a nullable organisation as a tenant must be specified.
   */
  lastInteractedOrganisation?: Maybe<DiscoverOrganisation>;
  lastName: Scalars['String'];
};

export type CoinToss = {
  __typename?: 'CoinToss';
  preference?: Maybe<Scalars['String']>;
};

export type DiscoverEmergencyPlayer = {
  __typename?: 'DiscoverEmergencyPlayer';
  /** @deprecated use player */
  participant?: Maybe<DiscoverPossibleParticipant>;
  /** player distinguishes all possible types of emergency players in a game */
  player?: Maybe<DiscoverPossibleEmergencyPlayer>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  playerPoints?: Maybe<Scalars['Int']>;
};

export type DiscoverPossibleEmergencyPlayer = DiscoverAnonymousParticipant | DiscoverGamePermitFillInPlayer | DiscoverParticipant | DiscoverParticipantFillInPlayer;

export type DiscoverGamePermitFillInPlayer = {
  __typename?: 'DiscoverGamePermitFillInPlayer';
  id?: Maybe<Scalars['ID']>;
  profile?: Maybe<DiscoverProfile>;
};

export type DiscoverParticipantFillInPlayer = {
  __typename?: 'DiscoverParticipantFillInPlayer';
  /**
   * This will be true if the player has a season permit. We don't return the season permit dates,
   * as we assume that if the FillInPlayer was added to the lineup, their season permit must be valid on the game date
   */
  hasSeasonPermit?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  profile?: Maybe<DiscoverProfile>;
};

export type DiscoverPlayerStatistics = {
  __typename?: 'DiscoverPlayerStatistics';
  captain?: Maybe<Captain>;
  lineupOrder?: Maybe<Scalars['Int']>;
  /** @deprecated use player */
  participant: DiscoverPossibleParticipant;
  periods?: Maybe<Array<PlayerPeriod>>;
  periodStatistics?: Maybe<Array<PlayerPeriodStatistics>>;
  /** player distinguishes all possible types of players in a game */
  player?: Maybe<DiscoverPossiblePlayer>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  playerPoints?: Maybe<Scalars['Int']>;
  playerPosition?: Maybe<GamePlayerPosition>;
  statistics: Array<Statistic>;
};

export type Captain = {
  __typename?: 'Captain';
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** Non-cricket player statistics per period */
export type PlayerPeriod = {
  __typename?: 'PlayerPeriod';
  /**
   * Array of positions the player had during the current period (if in-game
   * positions is enabled). NOTE: this only tracks each unique position, ordered by
   * the tenant-config positions sort-order. For example, if a player in netball
   * was on the interchange, subbed into center, then changed to goal attack, this
   * would be returned as ["GA", "C", "INT"]
   */
  inGamePositions?: Maybe<Array<GamePlayerPosition>>;
  /**
   * If the game is in overtime, this will always start from 1 (even if there is
   * only 1 overtime period in the game).
   */
  overtimeSequenceNo?: Maybe<Scalars['Int']>;
  period?: Maybe<Period>;
};

export type GamePlayerPosition = {
  __typename?: 'GamePlayerPosition';
  label?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  /** Identifier for the player position type */
  positionType?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

/** Cricket player statistics per period */
export type PlayerPeriodStatistics = {
  __typename?: 'PlayerPeriodStatistics';
  displayOrder?: Maybe<Scalars['Int']>;
  period?: Maybe<Period>;
  /** @deprecated field not used anymore */
  sequenceNo?: Maybe<Scalars['Int']>;
  /**
   * PeriodValue along with Side determines the innings the player period stats were applied to.
   * For Eg: In Cricket,
   * A Player can have stats in both FIRST_INNINGS
   * If he bats in his team's FIRST_INNINGS and bowls in the other team's FIRST_INNINGS.
   * side property determines which period to apply the statistics on the graph.
   * side applicable to innings based games
   */
  side?: Maybe<Side>;
  statistics?: Maybe<Array<Statistic>>;
  status?: Maybe<PlayerPeriodStatusValue>;
  type?: Maybe<PeriodType>;
};

export enum Side {
  Away = 'AWAY',
  Home = 'HOME'
}

export enum PlayerPeriodStatusValue {
  DidNotBat = 'DID_NOT_BAT',
  NotOut = 'NOT_OUT',
  Out = 'OUT',
  RetiredNotOut = 'RETIRED_NOT_OUT',
  RetiredOut = 'RETIRED_OUT'
}

export type DiscoverPossiblePlayer = DiscoverAnonymousParticipant | DiscoverGamePermitFillInPlayer | DiscoverParticipant | DiscoverParticipantFillInPlayer | DiscoverRegularFillInPlayer;

export type DiscoverRegularFillInPlayer = {
  __typename?: 'DiscoverRegularFillInPlayer';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type SharedPeriodStatistics = {
  __typename?: 'SharedPeriodStatistics';
  dismissalType?: Maybe<DismissalTypeValue>;
  displayOrder?: Maybe<Scalars['Int']>;
  period?: Maybe<Period>;
  players?: Maybe<Array<PlayerSharedStatisticRole>>;
  /** @deprecated field not used anymore */
  sequenceNo?: Maybe<Scalars['Int']>;
  /** PeriodValue along with Side determines the innings the player period stats were applied to. */
  side?: Maybe<Side>;
  statistics?: Maybe<Array<Statistic>>;
  status?: Maybe<SharedPlayerPeriodStatus>;
  type?: Maybe<SharedPeriodType>;
};

export enum DismissalTypeValue {
  Bowled = 'BOWLED',
  Caught = 'CAUGHT',
  HitBallTwice = 'HIT_BALL_TWICE',
  HitWicket = 'HIT_WICKET',
  LegBeforeWicket = 'LEG_BEFORE_WICKET',
  ObstructingField = 'OBSTRUCTING_FIELD',
  RetiredOut = 'RETIRED_OUT',
  RunOut = 'RUN_OUT',
  RunOutPriorToBallDelivery = 'RUN_OUT_PRIOR_TO_BALL_DELIVERY',
  Stumped = 'STUMPED',
  TimedOut = 'TIMED_OUT'
}

export type PlayerSharedStatisticRole = {
  __typename?: 'PlayerSharedStatisticRole';
  playerID: Scalars['ID'];
  role?: Maybe<PlayerRoleInSharedStatistic>;
  teamID: Scalars['ID'];
};

export enum PlayerRoleInSharedStatistic {
  AssistantFielding = 'ASSISTANT_FIELDING',
  Batting = 'BATTING',
  Bowling = 'BOWLING',
  Fielding = 'FIELDING'
}

export enum SharedPlayerPeriodStatus {
  Out = 'OUT'
}

export enum SharedPeriodType {
  Innings = 'INNINGS',
  SuperOver = 'SUPER_OVER'
}

export type GameStatus = {
  __typename?: 'GameStatus';
  name: Scalars['String'];
  value: GameStatusType;
};

export enum GameStatusType {
  Abandoned = 'ABANDONED',
  Cancelled = 'CANCELLED',
  Final = 'FINAL',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Upcoming = 'UPCOMING'
}

export type RegistrationUserType = {
  __typename?: 'RegistrationUserType';
  displayName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  registrationLimit?: Maybe<RegistrationLimit>;
  value: SeasonRegistrationUserType;
};

export type RegistrationLimit = {
  __typename?: 'RegistrationLimit';
  limitReached?: Maybe<Scalars['Boolean']>;
};

export enum SeasonRegistrationUserType {
  BenchPersonnel = 'BENCH_PERSONNEL',
  Coach = 'COACH',
  MedicalOfficer = 'MEDICAL_OFFICER',
  Official = 'OFFICIAL',
  Player = 'PLAYER',
  Statistician = 'STATISTICIAN',
  TableOfficial = 'TABLE_OFFICIAL',
  TeamManager = 'TEAM_MANAGER',
  Volunteer = 'VOLUNTEER'
}

export type GroupUserTypeMeta = {
  __typename?: 'GroupUserTypeMeta';
  fee?: Maybe<Price>;
  name?: Maybe<Scalars['String']>;
  registrationLimit?: Maybe<RegistrationLimit>;
  value?: Maybe<SeasonRegistrationUserType>;
};

export type Price = {
  __typename?: 'Price';
  currency: Currency;
  label: Scalars['String'];
  net: Scalars['Int'];
};

export type Currency = {
  __typename?: 'Currency';
  code: Scalars['String'];
  symbol: Scalars['String'];
  symbolLocation: SymbolLocation;
};

export enum SymbolLocation {
  End = 'END',
  Start = 'START'
}

export type OrganisationTermsAndConditions = {
  __typename?: 'OrganisationTermsAndConditions';
  name: Scalars['String'];
  type: TermsAndConditionsType;
  value: Scalars['String'];
};

export enum TermsAndConditionsType {
  Text = 'TEXT',
  Url = 'URL'
}

export type Product = {
  __typename?: 'Product';
  /**
   * Determines whether this product can be purchasable during the registration
   * process.
   */
  active: Scalars['Boolean'];
  /**
   * Determines whether this product should be visible on the organisation's
   * shop. Defaults to `false` when not provided.
   */
  activeShop?: Maybe<Scalars['Boolean']>;
  /**
   * Categories associated with the product. For example, a shirt product
   * may have the 'Size' and 'Colour' categories.
   */
  categories: Array<ProductCategory>;
  /**
   * Custom fields associated with the product and attribute options.
   * Empty if no custom fields associated with the product or attribute options.
   */
  customFields: Array<ProductCustomField>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  images: Array<Image>;
  /**
   * The maximum available product quantity for purchase during the registration
   * across all the variants available.
   * @deprecated use registrationSettings
   */
  maxQuantity?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  productType: ProductType;
  /**
   * Since the product type is now used by both registration and shop, this field would only contain
   * the registration related settings for the product. Thus the product type can be used by both
   * registration and shop.
   */
  registrationSettings?: Maybe<ProductRegistrationSettings>;
  /** @deprecated use registrationSettings */
  required?: Maybe<Scalars['Boolean']>;
  /** Generic property to display any product related metadata such validFrom or validTo */
  settings?: Maybe<ProductSettings>;
  variants: Array<ProductVariant>;
};

/**
 * An attribute/category that belongs to a given product. For example,
 * 'Size' is a valid category/attribute for a product to have.
 */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['ID'];
  /** The name of the category. For example, 'Size'. */
  name: Scalars['String'];
  /**
   * The number of options for the given category. Using size example,
   * this could be options such as 'Small', 'Medium', 'Large'.
   */
  options: Array<ProductCategoryOption>;
};

/**
 * The product category option. Usually context bound to a given product
 * category.
 */
export type ProductCategoryOption = {
  __typename?: 'ProductCategoryOption';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ProductCustomField = {
  __typename?: 'ProductCustomField';
  dropdownOptions?: Maybe<Array<ProductDropdownOption>>;
  id: Scalars['ID'];
  option?: Maybe<ProductCustomFieldOption>;
  question: Scalars['String'];
  type: CustomFieldType;
  visible: Scalars['Boolean'];
};

export type ProductDropdownOption = {
  __typename?: 'ProductDropdownOption';
  id: Scalars['ID'];
  label: Scalars['String'];
};

export type ProductCustomFieldOption = {
  __typename?: 'ProductCustomFieldOption';
  category: ProductCategory;
  option: ProductCategoryOption;
};

export enum CustomFieldType {
  DropDown = 'DROP_DOWN',
  Text = 'TEXT'
}

export enum ProductType {
  Fundraiser = 'FUNDRAISER',
  Merchandise = 'MERCHANDISE',
  /** @deprecated use MERCHANDISE */
  MultiVariant = 'MULTI_VARIANT',
  PaymentRequest = 'PAYMENT_REQUEST',
  /** @deprecated use MERCHANDISE */
  SingleVariant = 'SINGLE_VARIANT',
  SocialMembership = 'SOCIAL_MEMBERSHIP'
}

export type ProductRegistrationSettings = {
  __typename?: 'ProductRegistrationSettings';
  /**
   * The maximum available product quantity for purchase during the registration
   * across all the variants available.
   */
  maxQuantity?: Maybe<Scalars['Int']>;
  required: Scalars['Boolean'];
};

export type ProductSettings = {
  __typename?: 'ProductSettings';
  validFrom?: Maybe<DateTime>;
  validTo?: Maybe<DateTime>;
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  amount: Price;
  available: Scalars['Boolean'];
  /**
   * The nullable set of category/attribute pairs that define the given variant product.
   * For example, given a product that has the 'Size' and 'Colour' categories,
   * this variant product may be defined as a 'Small Red Shirt', or a 'Large Green
   * Shirt'.
   *
   * This value is possibly null as single products that do not have these categories
   * set do not provide category pairs.
   */
  categoryPairs?: Maybe<Array<ProductVariantPair>>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  sortOrder: Scalars['Int'];
};

/** A type that is comprised of a category and option. */
export type ProductVariantPair = {
  __typename?: 'ProductVariantPair';
  category: ProductCategory;
  id: Scalars['ID'];
  option: ProductCategoryOption;
};

export type RegistrationQuestion = Node & {
  __typename?: 'RegistrationQuestion';
  id: Scalars['ID'];
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  question: Scalars['String'];
};

export type AgeRestriction = {
  __typename?: 'AgeRestriction';
  asAtDate: Scalars['ISODate'];
  range: IntRange;
};

export type CompetitionProgramSeason = DiscoverSeason | ProgramSeason;

export type ProgramSeason = Node & {
  __typename?: 'ProgramSeason';
  endDate: Scalars['ISODate'];
  id: Scalars['ID'];
  name: Scalars['String'];
  program: Program;
  startDate: Scalars['ISODate'];
  type: SeasonType;
};

export type Program = Node & {
  __typename?: 'Program';
  alias?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  format?: Maybe<TenantField>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum SeasonType {
  Autumn = 'AUTUMN',
  Spring = 'SPRING',
  Summer = 'SUMMER',
  Winter = 'WINTER',
  YearLong = 'YEAR_LONG'
}

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  name: Scalars['String'];
  url: Scalars['String'];
};

export enum SeasonRegistrationType {
  ParticipantProgram = 'PARTICIPANT_PROGRAM',
  ParticipantToAssociation = 'PARTICIPANT_TO_ASSOCIATION',
  ParticipantToClub = 'PARTICIPANT_TO_CLUB',
  ParticipantToClubTeam = 'PARTICIPANT_TO_CLUB_TEAM',
  ParticipantToTeam = 'PARTICIPANT_TO_TEAM',
  SocialTeamToSeason = 'SOCIAL_TEAM_TO_SEASON'
}

export type DiscoverSeasonStatus = {
  __typename?: 'DiscoverSeasonStatus';
  name: Scalars['String'];
  value: DiscoverSeasonStatusType;
};

export enum DiscoverSeasonStatusType {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Upcoming = 'UPCOMING'
}

export enum CompetitionType {
  Domestic = 'DOMESTIC',
  HomeAndAway = 'HOME_AND_AWAY',
  Tournament = 'TOURNAMENT'
}

export type TenantOrganisation = Node & {
  __typename?: 'TenantOrganisation';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export enum OrganisationType {
  AdministrativeBody = 'ADMINISTRATIVE_BODY',
  Association = 'ASSOCIATION',
  Club = 'CLUB'
}

export enum PermitRequestedByRole {
  Admin = 'ADMIN',
  Participant = 'PARTICIPANT'
}

export type Affiliation = Node & {
  __typename?: 'Affiliation';
  club: DiscoverOrganisation;
  id: Scalars['ID'];
};

export enum PermitStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

/**
 * Profile type with limited access between DiscoverProfile and Profile types.
 * To be used within by MyTeams types for team admins through public portal management
 */
export type MyTeamsProfile = {
  __typename?: 'MyTeamsProfile';
  accountManagedBy?: Maybe<MyTeamsProfile>;
  email?: Maybe<Scalars['String']>;
  emergencyContact?: Maybe<EmergencyContact>;
  firstName: Scalars['String'];
  guardians?: Maybe<Array<MyTeamsPossibleGuardian>>;
  homeNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mobileNumber?: Maybe<Mobile>;
  preferredName?: Maybe<Scalars['String']>;
};

export type EmergencyContact = Contact & Node & {
  __typename?: 'EmergencyContact';
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mobileNumber: Mobile;
  relation: Scalars['String'];
};

export type Contact = {
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber?: Maybe<Mobile>;
};

export type Mobile = {
  __typename?: 'Mobile';
  countryAlphaCode?: Maybe<Scalars['String']>;
  countryCode: TenantField;
  displayNumber: Scalars['String'];
  number: Scalars['String'];
};

export type MyTeamsPossibleGuardian = MyTeamsGuardian | MyTeamsProfile;

export type MyTeamsGuardian = {
  __typename?: 'MyTeamsGuardian';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobileNumber?: Maybe<Mobile>;
};

export type MyTeamsTeam = {
  __typename?: 'MyTeamsTeam';
  ageGroup: TenantField;
  assistantCoaches?: Maybe<Array<MyTeamsParticipant>>;
  coach?: Maybe<MyTeamsParticipant>;
  concussionIncidents?: Maybe<Array<Incident>>;
  gender: TenantField;
  grade?: Maybe<MyTeamsGrade>;
  /** Incidents can be viewed by team managers */
  hasIncidentAccess?: Maybe<Scalars['Boolean']>;
  hasManagementAccess?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  logo?: Maybe<Image>;
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
  organiser?: Maybe<MyTeamsProfile>;
  playerPointsCap?: Maybe<Scalars['Int']>;
  /** @deprecated use teamPlayers instead */
  players?: Maybe<Array<MyTeamsParticipant>>;
  pool?: Maybe<Pool>;
  preferredGrade?: Maybe<Scalars['String']>;
  registeredDate?: Maybe<Scalars['ISODate']>;
  /**
   * Social team registration code for direct access when querying this team type
   * Should have the same value as DiscoverSocialTeamRegistration.registrationCode
   */
  registrationCode?: Maybe<Scalars['String']>;
  season: DiscoverSeason;
  teamManagers?: Maybe<Array<MyTeamsParticipant>>;
  teamPlayers?: Maybe<Array<MyTeamsTeamPlayer>>;
};

export type MyTeamsGrade = {
  __typename?: 'MyTeamsGrade';
  age?: Maybe<TenantField>;
  bestPlayers?: Maybe<BestPlayersConfiguration>;
  day?: Maybe<TenantField>;
  /** @deprecated use gameStatisticsConfiguration */
  gameEvents: GameEvents;
  /**
   * This field is introduced as a replacement for gameEvents. The word 'event' is a bit misleading as some statistics
   * recorded against a game can classify as an event (eg. 1_POINT_SCORE) and others can classify as a total
   * (eg. TOTAL_FOULS).
   */
  gameStatisticsConfiguration?: Maybe<GameStatisticsConfiguration>;
  /** @deprecated use gameTypes */
  gameType?: Maybe<GameType>;
  gameTypes?: Maybe<Array<GameType>>;
  gender?: Maybe<TenantField>;
  hasFinals: Scalars['Boolean'];
  hasPeriodScores?: Maybe<Scalars['Boolean']>;
  hideScores: Scalars['Boolean'];
  id: Scalars['String'];
  ladder: Array<LadderPool>;
  ladderType?: Maybe<LadderTemplate>;
  lineupLimits?: Maybe<LineupLimits>;
  maxPlayers?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  overallLadder?: Maybe<OverallLadder>;
  overallLadderFields?: Maybe<Array<LadderField>>;
  overallLadderRankingFields?: Maybe<Array<LadderField>>;
  periods: Array<Period>;
  periodScoresDisplayType?: Maybe<TenantField>;
  playerPoints?: Maybe<PlayerPointsConfiguration>;
  rounds: Array<MyTeamsRound>;
  season: DiscoverSeason;
  type?: Maybe<GradeType>;
};


export type MyTeamsGradeLadderArgs = {
  filter?: InputMaybe<GradeLadderFilter>;
};

export type MyTeamsRound = {
  __typename?: 'MyTeamsRound';
  abbreviatedName: Scalars['String'];
  alias?: Maybe<Scalars['String']>;
  byes?: Maybe<Array<DiscoverTeam>>;
  current: Scalars['Boolean'];
  fixture: DiscoverRoundFixture;
  games: Array<DiscoverGame>;
  grade: MyTeamsGrade;
  id: Scalars['ID'];
  isFinalsRound: Scalars['Boolean'];
  isStale?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  number: Scalars['Int'];
  /** @deprecated use provisionalDates */
  provisionalDate?: Maybe<Scalars['ISODate']>;
  provisionalDates?: Maybe<Array<Scalars['ISODate']>>;
};

export type MyTeamsTeamPlayer = {
  __typename?: 'MyTeamsTeamPlayer';
  captain?: Maybe<Captain>;
  participant?: Maybe<MyTeamsParticipant>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
};

export enum AvailabilityStatus {
  Available = 'AVAILABLE',
  Unavailable = 'UNAVAILABLE'
}

export type GameTeamAvailabilityPlayerCount = {
  __typename?: 'GameTeamAvailabilityPlayerCount';
  available?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
  unavailable?: Maybe<Scalars['Int']>;
};

export type MyTeamsPossibleTeam = MyTeamsTeam | ProvisionalTeam;

export type GameClubScoringAccess = {
  __typename?: 'GameClubScoringAccess';
  /** End date time of club scoring access OR end date time from when temporary access was enabled */
  endDateTime?: Maybe<Scalars['ISODateTime']>;
  /** Temporary club scoring access enabled */
  temporaryAccessEnabled?: Maybe<Scalars['Boolean']>;
};

export type MyTeamsGameTeams = {
  __typename?: 'MyTeamsGameTeams';
  away?: Maybe<MyTeamsGameTeam>;
  home?: Maybe<MyTeamsGameTeam>;
};

export type MyTeamsGameTeam = {
  __typename?: 'MyTeamsGameTeam';
  lineup?: Maybe<MyTeamsGameTeamLineup>;
  previousRoundLineup?: Maybe<MyTeamsPreviousRoundGameTeamLineup>;
};

export type MyTeamsGameTeamLineup = {
  __typename?: 'MyTeamsGameTeamLineup';
  emergencyPlayers?: Maybe<Array<MyTeamsGameEmergencyPlayer>>;
  players?: Maybe<Array<MyTeamsGameTeamPlayer>>;
};

export type MyTeamsGameEmergencyPlayer = {
  __typename?: 'MyTeamsGameEmergencyPlayer';
  participant?: Maybe<MyTeamsPossibleEmergencyPlayer>;
  playerNumber?: Maybe<Scalars['String']>;
  playerPoints?: Maybe<Scalars['Int']>;
};

export type MyTeamsPossibleEmergencyPlayer = MyTeamsGamePermitFillInPlayer | MyTeamsParticipant | MyTeamsParticipantFillInPlayer;

export type MyTeamsGamePermitFillInPlayer = Node & {
  __typename?: 'MyTeamsGamePermitFillInPlayer';
  /** This is the MyTeamsFillInPlayer id */
  id: Scalars['ID'];
  profile?: Maybe<MyTeamsProfile>;
};

export type MyTeamsParticipantFillInPlayer = Node & {
  __typename?: 'MyTeamsParticipantFillInPlayer';
  /** This is the MyTeamsFillInPlayer id */
  id: Scalars['ID'];
  participant?: Maybe<MyTeamsParticipant>;
};

export type MyTeamsGameTeamPlayer = {
  __typename?: 'MyTeamsGameTeamPlayer';
  availabilityStatus?: Maybe<AvailabilityStatus>;
  captain?: Maybe<Captain>;
  ineligibilityStatus?: Maybe<Array<IneligibilityStatus>>;
  lineupOrder?: Maybe<Scalars['Int']>;
  participant?: Maybe<MyTeamsPossibleGamePlayer>;
  periods?: Maybe<Array<PlayerPeriod>>;
  periodStatistics?: Maybe<Array<PlayerPeriodStatistics>>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  playerPoints?: Maybe<Scalars['Int']>;
  playerPosition?: Maybe<GamePlayerPosition>;
  selected?: Maybe<Scalars['Boolean']>;
  statistics?: Maybe<Array<Statistic>>;
};

export type MyTeamsPossibleGamePlayer = MyTeamsGamePermitFillInPlayer | MyTeamsParticipant | MyTeamsParticipantFillInPlayer | MyTeamsRegularFillInPlayer;

export type MyTeamsRegularFillInPlayer = Node & {
  __typename?: 'MyTeamsRegularFillInPlayer';
  firstName?: Maybe<Scalars['String']>;
  /** This is the FillInPlayer id */
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type MyTeamsPreviousRoundGameTeamLineup = {
  __typename?: 'MyTeamsPreviousRoundGameTeamLineup';
  players?: Maybe<Array<MyTeamsPreviousRoundGameTeamPlayer>>;
};

export type MyTeamsPreviousRoundGameTeamPlayer = {
  __typename?: 'MyTeamsPreviousRoundGameTeamPlayer';
  captain?: Maybe<Captain>;
  lineupOrder?: Maybe<Scalars['Int']>;
  player?: Maybe<MyTeamsPossiblePreviousRoundPlayer>;
  playerNumber?: Maybe<Scalars['String']>;
  playerPoints?: Maybe<Scalars['Int']>;
  playerPosition?: Maybe<GamePlayerPosition>;
};

export type MyTeamsPossiblePreviousRoundPlayer = MyTeamsParticipant | MyTeamsParticipantFillInPlayer;

export type GameManagementAuthorisation = {
  __typename?: 'GameManagementAuthorisation';
  away?: Maybe<GameManagementTeamAuthorisation>;
  gameSheet?: Maybe<Scalars['Boolean']>;
  home?: Maybe<GameManagementTeamAuthorisation>;
  resultAndPeriodScores?: Maybe<ReadWrite>;
};

export type GameManagementTeamAuthorisation = {
  __typename?: 'GameManagementTeamAuthorisation';
  lineUp?: Maybe<ReadWrite>;
  stats?: Maybe<ReadWrite>;
};

export type ReadWrite = {
  __typename?: 'ReadWrite';
  read?: Maybe<Scalars['Boolean']>;
  write?: Maybe<Scalars['Boolean']>;
};

export type MyTeamsGameStatistics = {
  __typename?: 'MyTeamsGameStatistics';
  away?: Maybe<MyTeamsGameTeamStatistics>;
  home?: Maybe<MyTeamsGameTeamStatistics>;
  shared?: Maybe<Array<SharedPeriodStatistics>>;
};

export type MyTeamsGameTeamStatistics = {
  __typename?: 'MyTeamsGameTeamStatistics';
  bestPlayers?: Maybe<Array<MyTeamsBestPlayer>>;
  coaches?: Maybe<Array<MyTeamsGameCoachStatistics>>;
  coinTossWinningResult?: Maybe<CoinToss>;
  manualBonusPoints?: Maybe<Scalars['Float']>;
  periods?: Maybe<Array<GamePeriodStatistics>>;
  /** @deprecated use game.team.*.lineup.players */
  players?: Maybe<Array<MyTeamsGamePlayerStatistics>>;
  statistics?: Maybe<Array<Statistic>>;
  volunteers?: Maybe<Array<GameVolunteer>>;
};

export type MyTeamsBestPlayer = {
  __typename?: 'MyTeamsBestPlayer';
  /** @deprecated use player */
  participant?: Maybe<MyTeamsParticipant>;
  player?: Maybe<MyTeamsPossibleBestPlayer>;
  ranking?: Maybe<Scalars['Int']>;
};

export type MyTeamsPossibleBestPlayer = MyTeamsGamePermitFillInPlayer | MyTeamsParticipant | MyTeamsParticipantFillInPlayer;

export type MyTeamsGameCoachStatistics = {
  __typename?: 'MyTeamsGameCoachStatistics';
  order?: Maybe<Scalars['Int']>;
  participant?: Maybe<MyTeamsPossibleCoach>;
  role?: Maybe<CoachType>;
  selected?: Maybe<Scalars['Boolean']>;
  statistics?: Maybe<Array<Statistic>>;
};

export type MyTeamsPossibleCoach = MyTeamsFillInCoach | MyTeamsParticipant;

export type MyTeamsFillInCoach = Node & {
  __typename?: 'MyTeamsFillInCoach';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum CoachType {
  AssistantCoach = 'ASSISTANT_COACH',
  Coach = 'COACH'
}

export type MyTeamsGamePlayerStatistics = {
  __typename?: 'MyTeamsGamePlayerStatistics';
  ineligibilityStatus?: Maybe<Array<IneligibilityStatus>>;
  isEligible?: Maybe<Scalars['Boolean']>;
  participant?: Maybe<MyTeamsPossiblePlayer>;
  periodStatistics?: Maybe<Array<PlayerPeriodStatistics>>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  playerPoints?: Maybe<Scalars['Int']>;
  playerPosition?: Maybe<GamePlayerPosition>;
  selected?: Maybe<Scalars['Boolean']>;
  statistics?: Maybe<Array<Statistic>>;
};

export type MyTeamsPossiblePlayer = MyTeamsFillInPlayer | MyTeamsParticipant;

export type MyTeamsFillInPlayer = Node & {
  __typename?: 'MyTeamsFillInPlayer';
  /**
   * Can this FillInPlayer be removed from the lineup.
   * Currently any fill ins that are created from bench can be removed,
   * but any fill ins created with gamer permits or that are in the same season can't be
   */
  canRemoveFromLineup?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  /**
   * If the FillInPlayer has come from outside the season and has a game permit, this will be true
   * It is used for things like the game permit tooltip
   */
  hasGamePermit?: Maybe<Scalars['Boolean']>;
  /**
   * This will be true if the player has a season permit. We don't return the season permit dates,
   * as we assume that if the FillInPlayer was added to the lineup, their season permit must be valid on the game date
   */
  hasSeasonPermit?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isSuspended?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  playerType?: Maybe<GamePlayerType>;
};

export enum GamePlayerType {
  FillIn = 'FILL_IN',
  Participant = 'PARTICIPANT',
  Profile = 'PROFILE'
}

export type GameVolunteer = {
  __typename?: 'GameVolunteer';
  fullName?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  roleType?: Maybe<Scalars['String']>;
  roleTypeLabel?: Maybe<Scalars['String']>;
};

export type Outcome = {
  id: Scalars['ID'];
  incident?: Maybe<Incident>;
  note?: Maybe<Scalars['String']>;
};

export type Participant = Node & {
  __typename?: 'Participant';
  /** @deprecated use school and schoolYear */
  answers: Array<RegistrationAnswer>;
  cancelledAt?: Maybe<Scalars['ISODateTime']>;
  /** This property indicates the request to play options available for the registration */
  clubChangeOptions?: Maybe<Array<ClubChangeOption>>;
  coachingAccreditationLevel?: Maybe<Scalars['String']>;
  customFieldAnswers: Array<CustomFieldAnswer>;
  dateOfBirth: Scalars['ISODate'];
  displayName?: Maybe<Scalars['String']>;
  gender: Scalars['String'];
  id: Scalars['ID'];
  organisation: DiscoverOrganisation;
  permit?: Maybe<Permit>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  preferredGroup?: Maybe<Group>;
  profile?: Maybe<Profile>;
  registeredAt: Scalars['String'];
  school?: Maybe<Scalars['String']>;
  schoolData?: Maybe<School>;
  schoolYear?: Maybe<Scalars['String']>;
  seasonRegistration: DiscoverRegistration;
  status?: Maybe<ParticipantStatus>;
  teamName?: Maybe<Scalars['String']>;
  teams: Array<DiscoverTeam>;
  /** This property indicates (by its truthiness) whether or not a transfer request is required. If so, the properties of the type provide further detail. */
  transferRequired?: Maybe<ParticipantTransferRequired>;
  type: Scalars['String'];
  wwcExpiryDate?: Maybe<Scalars['ISODate']>;
  wwcNumber?: Maybe<Scalars['String']>;
  wwcStateOfIssue?: Maybe<Scalars['String']>;
};

export type RegistrationAnswer = {
  __typename?: 'RegistrationAnswer';
  answer: Scalars['String'];
  question: RegistrationQuestion;
};

export enum ClubChangeOption {
  Permit = 'PERMIT',
  Transfer = 'TRANSFER'
}

export type CustomFieldAnswer = DropdownCustomFieldAnswer | TextCustomFieldAnswer;

export type DropdownCustomFieldAnswer = {
  __typename?: 'DropdownCustomFieldAnswer';
  dropdownAnswer?: Maybe<DropdownOption>;
  question: DropdownCustomField;
};

export type TextCustomFieldAnswer = {
  __typename?: 'TextCustomFieldAnswer';
  answer?: Maybe<Scalars['String']>;
  question: TextCustomField;
};

export type School = {
  __typename?: 'School';
  name: Scalars['String'];
  postcode?: Maybe<Scalars['String']>;
  schoolID: Scalars['ID'];
  state?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export enum ParticipantStatus {
  Cancelled = 'CANCELLED',
  PendingActivation = 'PENDING_ACTIVATION',
  PendingRegistration = 'PENDING_REGISTRATION',
  Registered = 'REGISTERED'
}

/** If a transfer request is required, provides detail required by the FE to display appropriate text and useful information to the user */
export type ParticipantTransferRequired = {
  __typename?: 'ParticipantTransferRequired';
  exceptionPeriod?: Maybe<TransferExceptionPeriod>;
  /** @deprecated use pendingTransferRequest */
  hasPendingTransferRequest: Scalars['Boolean'];
  hasRegistrationInSameSeason: Scalars['Boolean'];
  /** Null if the user has no pending transfer request */
  pendingTransferRequest?: Maybe<TransferRequest>;
  transferDeniedReason?: Maybe<TransferDeniedReason>;
};

export type TransferExceptionPeriod = Node & {
  __typename?: 'TransferExceptionPeriod';
  id: Scalars['ID'];
};

export type TransferRequest = Node & {
  __typename?: 'TransferRequest';
  createdAt?: Maybe<Scalars['ISODateTime']>;
  destinationClub: DiscoverOrganisation;
  id: Scalars['ID'];
  registrationLink?: Maybe<Scalars['String']>;
  requestedBy?: Maybe<TransferRequestedByRole>;
  season?: Maybe<DiscoverSeason>;
  sourceAffiliation: Affiliation;
  status?: Maybe<TransferRequestStatus>;
  updatedAt?: Maybe<Scalars['ISODateTime']>;
};

export enum TransferRequestedByRole {
  Admin = 'ADMIN',
  Participant = 'PARTICIPANT'
}

export enum TransferRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum TransferDeniedReason {
  ClubAdminLedPreference = 'CLUB_ADMIN_LED_PREFERENCE',
  HasTransferRequestInProgress = 'HAS_TRANSFER_REQUEST_IN_PROGRESS'
}

export enum IncidentStatus {
  Closed = 'CLOSED',
  NeedsReview = 'NEEDS_REVIEW',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export enum IncidentType {
  Game = 'GAME',
  NonGame = 'NON_GAME'
}

export type DuplicateProfileSearchInput = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  isDependent?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export enum Gender {
  DifferentIdentity = 'DIFFERENT_IDENTITY',
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  /** @deprecated gender diversity */
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export type DuplicateProfile = {
  __typename?: 'DuplicateProfile';
  claimability: ClaimabilityStatus;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  isMigrated?: Maybe<Scalars['Boolean']>;
  isPrivate?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  lastRegisteredOrganisation?: Maybe<DiscoverOrganisation>;
  lastRegisteredRole?: Maybe<SeasonRegistrationUserType>;
  lastRegisteredSeason?: Maybe<DiscoverSeason>;
  mobileNumber?: Maybe<Scalars['String']>;
};

export enum ClaimabilityStatus {
  ManuallyVerified = 'MANUALLY_VERIFIED',
  SupportRequired = 'SUPPORT_REQUIRED',
  VerificationNotRequired = 'VERIFICATION_NOT_REQUIRED',
  VerificationRequired = 'VERIFICATION_REQUIRED'
}

export type ExternalAccount = {
  __typename?: 'ExternalAccount';
  externalAccountID: Scalars['String'];
  externalEmail?: Maybe<Scalars['String']>;
  tenantSlug: Scalars['String'];
};

export type PossibleGuardian = Guardian | Profile;

export type Guardian = Contact & Node & {
  __typename?: 'Guardian';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
  mobileNumber?: Maybe<Mobile>;
};

export type Membership = {
  __typename?: 'Membership';
  application: MembershipApplication;
  history: Array<UserMembership>;
  id: Scalars['ID'];
  /** The organisation that created this membership application */
  organisation?: Maybe<DiscoverOrganisation>;
};

export type MembershipApplication = {
  __typename?: 'MembershipApplication';
  active: Scalars['Boolean'];
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  payments?: Maybe<Array<MembershipApplicationPayment>>;
  /** @deprecated use payments of type TWELVE_MONTHS */
  playerAdvancedFees?: Maybe<Array<MembershipAdvancedFee>>;
  /** @deprecated use payments of type TWELVE_MONTHS */
  playerBaseFee?: Maybe<Price>;
  /** The registration role that this membership application is for */
  role?: Maybe<MembershipApplicationRoleType>;
};

export type MembershipApplicationPayment = {
  __typename?: 'MembershipApplicationPayment';
  active: Scalars['Boolean'];
  id: Scalars['ID'];
  playerAdvancedFees: Array<MembershipAdvancedFee>;
  playerBaseFee: Price;
  type: MembershipApplicationPaymentTypes;
};

export type MembershipAdvancedFee = {
  __typename?: 'MembershipAdvancedFee';
  amount: Price;
  applicationDescription: Scalars['String'];
  /** The role that the membership application applies to. e.g. 'Player', 'Team Manager' */
  applicationRole?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  maxAge: Scalars['Int'];
  minAge: Scalars['Int'];
  organisation: DiscoverOrganisation;
  payments: Array<MembershipAdvancedFeePayment>;
  quantity: Scalars['Int'];
  selectedPayment?: Maybe<MembershipAdvancedFeePayment>;
};

export type MembershipAdvancedFeePayment = {
  __typename?: 'MembershipAdvancedFeePayment';
  amount: Price;
  id: Scalars['ID'];
  playerAdvancedFees: Array<MembershipAdvancedFee>;
  playerBaseFee: Price;
  type: MembershipApplicationPaymentTypes;
};

export enum MembershipApplicationPaymentTypes {
  NineMonths = 'NINE_MONTHS',
  SixMonths = 'SIX_MONTHS',
  ThreeMonths = 'THREE_MONTHS',
  TwelveMonths = 'TWELVE_MONTHS'
}

export type MembershipApplicationRoleType = {
  __typename?: 'MembershipApplicationRoleType';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<MembershipApplicationRole>;
};

export enum MembershipApplicationRole {
  BenchPersonnel = 'BENCH_PERSONNEL',
  Coach = 'COACH',
  MedicalOfficer = 'MEDICAL_OFFICER',
  Official = 'OFFICIAL',
  Player = 'PLAYER',
  Statistician = 'STATISTICIAN',
  TableOfficial = 'TABLE_OFFICIAL',
  TeamManager = 'TEAM_MANAGER',
  Volunteer = 'VOLUNTEER'
}

export type UserMembership = {
  __typename?: 'UserMembership';
  expiryDate: Scalars['ISODate'];
  id: Scalars['ID'];
  purchaseDate: Scalars['ISODate'];
  source: MembershipSource;
  startDate: Scalars['ISODate'];
};

export enum MembershipSource {
  Migration = 'MIGRATION',
  Purchase = 'PURCHASE'
}

export type MyTeamsListFilter = {
  seasonStatus?: InputMaybe<Array<DiscoverSeasonStatusType>>;
};

export type MyTeamsList = {
  __typename?: 'MyTeamsList';
  meta?: Maybe<SearchResultMeta>;
  results?: Maybe<Array<DiscoverTeam>>;
};

export type SearchResultMeta = {
  __typename?: 'SearchResultMeta';
  page: Scalars['Int'];
  totalPages: Scalars['Int'];
  totalRecords: Scalars['Int'];
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  url: Scalars['String'];
};

export type RegistrationHistory = DiscoverTeam | Participant;

export type TeamOrigin = Node & {
  __typename?: 'TeamOrigin';
  id: Scalars['ID'];
  name: Scalars['String'];
  organiser?: Maybe<Profile>;
};

export type TransferRequestsFilter = {
  competitionID?: InputMaybe<Scalars['ID']>;
  destinationClubID?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<TransferRequestStatus>;
};

export type Wwc = {
  __typename?: 'WWC';
  expiryDate: Scalars['ISODate'];
  id: Scalars['ID'];
  number: Scalars['String'];
  stateOfIssue: Scalars['String'];
};

export type ActivityPaginatedInput = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
};

export type ActivityPaginated = {
  __typename?: 'ActivityPaginated';
  meta?: Maybe<SearchResultMeta>;
  results?: Maybe<Array<ActivityItem>>;
};

/** To be extended with new types in the activity feed as needed */
export type ActivityItem = DiscoverMilestone | DiscoverPost;

export type DiscoverMilestone = {
  __typename?: 'DiscoverMilestone';
  /** Date when the milestone was achieved */
  dateTime?: Maybe<Scalars['ISODate']>;
  /** Game for which the milestone was achieved */
  game?: Maybe<DiscoverGame>;
  gameCount?: Maybe<Scalars['Int']>;
  profile?: Maybe<DiscoverProfile>;
};

export type DiscoverPost = {
  __typename?: 'DiscoverPost';
  /** HTML format string */
  body?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<PostImage>;
  organisation?: Maybe<DiscoverOrganisation>;
  products?: Maybe<Array<Product>>;
  publishedDateTime?: Maybe<Scalars['ISODate']>;
  title?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['ISODateTime']>;
};

export type PostImage = {
  __typename?: 'PostImage';
  caption?: Maybe<Scalars['String']>;
  /** Width: 1200/Height: Auto */
  heroImageUrl?: Maybe<Scalars['String']>;
  /** Width: 312/Height: 312/crop:fill/Square & Centered */
  thumbnailUrl?: Maybe<Scalars['String']>;
  /** @deprecated use heroImageUrl/thumbnailUrl */
  url?: Maybe<Scalars['String']>;
};

export type AddressInfo = {
  __typename?: 'AddressInfo';
  postcode: Scalars['String'];
  state: Scalars['String'];
  streetLine: Scalars['String'];
  suburb: Scalars['String'];
};

export type PushNotificationTypeDetails = {
  __typename?: 'PushNotificationTypeDetails';
  description: Scalars['String'];
  notificationType: PushNotificationType;
  title: Scalars['String'];
};

export enum PushNotificationType {
  ClubRegFormOpened = 'CLUB_REG_FORM_OPENED',
  GameAllocationChanged = 'GAME_ALLOCATION_CHANGED',
  GameCancelled = 'GAME_CANCELLED',
  GameGoingLive = 'GAME_GOING_LIVE',
  PostPublished = 'POST_PUBLISHED'
}

export type BookmarkItemInput = {
  id: Scalars['String'];
  tenant?: InputMaybe<Scalars['String']>;
  type: BookmarkType;
};

export enum BookmarkType {
  Grade = 'GRADE',
  Organisation = 'ORGANISATION',
  Profile = 'PROFILE',
  Team = 'TEAM'
}

export type Bookmarkable = DiscoverGrade | DiscoverOrganisation | DiscoverProfile | DiscoverTeam;

/**
 * Configuration type that is global across the PlayHQ platform. This information
 * includes the overarching sporting organisations, known as tenants, and their
 * corresponding sport that they govern.
 */
export type Configuration = {
  __typename?: 'Configuration';
  /** Returns ExternalAccountLinking configuration for all tenants. */
  externalAccountLinking?: Maybe<Array<ExternalAccountLinkingWithTenant>>;
  /**
   * The sports that the tenants govern over. The `name` is the human readable
   * representation and should be displayed to the user. The `value` is the
   * computed name, and should be used as GraphQL input when the query or mutation
   * requires it.
   */
  sports: Array<TenantField>;
  /**
   * Returns information about the countries we support for registration.
   * Includes mobile country code.
   */
  supportedCountries?: Maybe<Array<SupportedCountry>>;
  /**
   * The tenants name details. The `name` subfield is the human readable name
   * and should be displayed to the user, while the `value` is the computed
   * name, mainly used for scoping. Requests that require such scoping should
   * provide it in the header when the request is made.
   */
  tenants: Array<TenantField>;
};

export type ExternalAccountLinkingWithTenant = {
  __typename?: 'ExternalAccountLinkingWithTenant';
  config?: Maybe<ExternalAccountLinking>;
  tenantSlug?: Maybe<Scalars['String']>;
};

export type ExternalAccountLinking = {
  __typename?: 'ExternalAccountLinking';
  /** Should we allow the participant unlink their external account themselves */
  allowParticipantToUnlink?: Maybe<Scalars['Boolean']>;
  /** The URL of the OIDC/OAuth2 provider */
  authUri?: Maybe<Scalars['String']>;
  /** Layup application identifier as registered with the OIDC/OAuth2 provider */
  clientID?: Maybe<Scalars['String']>;
  /** The display friendly name, eg CricketiD */
  displayName?: Maybe<Scalars['String']>;
  /**
   * If external account linking is enabled, the FE should show the linking tile during
   * the registration flow
   */
  enabled: Scalars['Boolean'];
  /** The homepage for the external linking, eg https://id.cricket.com.au */
  externalURL?: Maybe<Scalars['String']>;
  /** URL pointing to an image that is the logo for the external account linking. EG the AFLID logo */
  logoURL?: Maybe<Scalars['String']>;
  /** The description/text used on the profile page to explain to the user how the linking works for the tenant */
  profilePageInfoText?: Maybe<Scalars['String']>;
  /** The layup redirect URI to receive a response from the OIDC/OAuth2 provider */
  redirectUri?: Maybe<Scalars['String']>;
  /**
   * In the registration flow, when the user signs in with an external account,
   * should we attempt to link the accounts for SSO as well.
   */
  shouldLinkSSOInRegistrationFlow?: Maybe<Scalars['Boolean']>;
};

export type SupportedCountry = {
  __typename?: 'SupportedCountry';
  /**
   * alpha2Code for the country. eg AU
   * https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
   */
  alpha2Code: Scalars['String'];
  /** country calling code for the mobile, eg +61 */
  mobileCountryCode: Scalars['String'];
  /** Full name of the country, eg Australia */
  name: Scalars['String'];
};

export type DiscoverDiscountInput = {
  registrationCode: Scalars['String'];
  seasonCode: Scalars['String'];
};

export type Discount = Node & {
  __typename?: 'Discount';
  amount: Scalars['Int'];
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
};

export type DiscoverGradeFixtureFilter = {
  finals?: InputMaybe<Scalars['Boolean']>;
  poolID?: InputMaybe<Scalars['ID']>;
};

export type DiscoverMilestoneInput = {
  gameCount: Scalars['Int'];
  profileID: Scalars['ID'];
};

export type DiscoverMilestonesInput = {
  limit?: InputMaybe<Scalars['Int']>;
  profileID: Scalars['ID'];
};

export type DiscoverOrganisationPostsInput = {
  limit: Scalars['Int'];
  /** Organisation routing code */
  organisationID: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
};

export type DiscoverOrganisationPosts = {
  __typename?: 'DiscoverOrganisationPosts';
  meta?: Maybe<SearchResultMeta>;
  results?: Maybe<Array<DiscoverPost>>;
};

export type DiscoverOrganisationsFilter = {
  limit: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<OrganisationType>;
};

export type DiscoverOrganisationResults = {
  __typename?: 'DiscoverOrganisationResults';
  meta: SearchResultMeta;
  results: Array<DiscoverOrganisation>;
};

export type DiscoverSocialTeamRegistration = {
  __typename?: 'DiscoverSocialTeamRegistration';
  additionalInfo?: Maybe<Scalars['String']>;
  customFields: Array<CustomFields>;
  endDate: TimeZoneDateTime;
  grades: Array<DiscoverGrade>;
  id: Scalars['ID'];
  organisationTermsAndConditions: Array<OrganisationTermsAndConditions>;
  pricingInfo?: Maybe<Scalars['String']>;
  products?: Maybe<Array<Product>>;
  registrationCode: Scalars['String'];
  season: DiscoverSeason;
  startDate: TimeZoneDateTime;
  /** @deprecated use organisationTermsAndConditions */
  termsAndConditions: Array<TermsAndConditions>;
  visible?: Maybe<Scalars['Boolean']>;
};


export type DiscoverSocialTeamRegistrationGradesArgs = {
  day?: InputMaybe<DayOfTheWeek>;
  gender?: InputMaybe<GradeGender>;
};

export type DiscoverTeamsFilter = {
  organisationID?: InputMaybe<Scalars['ID']>;
  seasonID: Scalars['ID'];
};

export type GameSheetDownloadResponse = {
  __typename?: 'GameSheetDownloadResponse';
  document?: Maybe<Document>;
  stateID?: Maybe<Scalars['ID']>;
  status?: Maybe<GameSheetDownloadStatus>;
};

export type Document = {
  __typename?: 'Document';
  url: Scalars['String'];
};

export enum GameSheetDownloadStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type GameTeamAwardFilter = {
  gameID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  teamID: Scalars['ID'];
};

export type GameTeamAwardResponse = {
  __typename?: 'GameTeamAwardResponse';
  award?: Maybe<GameTeamAward>;
  players?: Maybe<Array<GameTeamAwardPlayer>>;
};

export type GameTeamAward = {
  __typename?: 'GameTeamAward';
  configuration?: Maybe<TeamAwardConfiguration>;
  isOpen?: Maybe<Scalars['Boolean']>;
  voteSlips?: Maybe<Array<GameTeamAwardVoteSlip>>;
};

export type TeamAwardConfiguration = {
  __typename?: 'TeamAwardConfiguration';
  awardName?: Maybe<Scalars['String']>;
  highestVote?: Maybe<Scalars['Int']>;
  totalVoters?: Maybe<Scalars['Int']>;
};

export type GameTeamAwardVoteSlip = {
  __typename?: 'GameTeamAwardVoteSlip';
  voterName?: Maybe<Scalars['String']>;
  voterNumber?: Maybe<Scalars['Int']>;
};

export type GameTeamAwardPlayer = {
  __typename?: 'GameTeamAwardPlayer';
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  playerNumber?: Maybe<Scalars['String']>;
};

export type GameTeamLineupValidateInput = {
  gameID: Scalars['ID'];
  lineup: GameTeamLineupValidateLineupInput;
  profileID?: InputMaybe<Scalars['ID']>;
  side: Side;
  teamContextID: Scalars['ID'];
};

/** Based on the GameTeamStatisticsInput type */
export type GameTeamLineupValidateLineupInput = {
  fillInPlayers?: InputMaybe<Array<GameTeamPlayerValidateInput>>;
  players?: InputMaybe<Array<GameTeamPlayerValidateInput>>;
};

export type GameTeamPlayerValidateInput = {
  /**
   * ID related to the entity. It could be
   * 1. A Participant ID
   * 2. A Fill In Player
   * 3. A Profile ID
   *
   * What this is depends on type
   */
  id: Scalars['ID'];
  /** The order of the player in the lineup */
  lineupOrder?: InputMaybe<Scalars['Int']>;
  /** Is this player currently selected in the lineup */
  selected?: InputMaybe<Scalars['Boolean']>;
  /** The player type that should be used/created. */
  type?: InputMaybe<GamePlayerType>;
};

export type GameTeamLineupValidateResult = {
  __typename?: 'GameTeamLineupValidateResult';
  /** This is the ID that was passed into the input in one of the arrays */
  entityID: Scalars['ID'];
  errors?: Maybe<Array<GameTeamLineupValidateError>>;
};

export type GameTeamLineupValidateError = {
  __typename?: 'GameTeamLineupValidateError';
  /** User friendly message for the error */
  message?: Maybe<Scalars['String']>;
  /**
   * The type of the error message. This should be used if the consumer of the API needs to
   * do some specific functionality based on the error returned.
   * If this isn't the case, return OTHER
   */
  value?: Maybe<GameTeamLineupErrorType>;
};

export enum GameTeamLineupErrorType {
  Other = 'OTHER'
}

export type GradePlayerStatisticsFilter = {
  pagination?: InputMaybe<ListPagination>;
  /** Array sort to support tiered sorting (eg. primary/secondary/tertiary sorting) */
  sort?: InputMaybe<Array<ListSort>>;
  teamIDs?: InputMaybe<Array<Scalars['ID']>>;
};

export type ListPagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type ListSort = {
  /** e.g. 'NAME', 'TEAM', 'TOTAL_SCORE', '1_POINT_SCORE' */
  column?: InputMaybe<Scalars['String']>;
  /** e.g. 'ASC' | 'DESC' */
  direction?: InputMaybe<ListSortDirection>;
};

export enum ListSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type GradePlayerStatistics = {
  __typename?: 'GradePlayerStatistics';
  meta?: Maybe<SearchResultMeta>;
  results?: Maybe<Array<GradePlayerStatisticsResult>>;
};

export type GradePlayerStatisticsResult = {
  __typename?: 'GradePlayerStatisticsResult';
  profile?: Maybe<StatisticsProfile>;
  ranking?: Maybe<Scalars['Int']>;
  statistics?: Maybe<Array<Statistic>>;
  team?: Maybe<StatisticsTeam>;
};

export type StatisticsProfile = {
  __typename?: 'StatisticsProfile';
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type StatisticsTeam = {
  __typename?: 'StatisticsTeam';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type InvoicePaginatedFilter = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type InvoiceList = {
  __typename?: 'InvoiceList';
  meta?: Maybe<SearchResultMeta>;
  results: Array<Invoice>;
};

export type Invoice = {
  __typename?: 'Invoice';
  createdAt?: Maybe<Scalars['ISODate']>;
  id: Scalars['ID'];
  orderID?: Maybe<Scalars['String']>;
  total?: Maybe<Price>;
};

export type MyPlayersGameAvailabilityInput = {
  /** Game routing code */
  gameID: Scalars['ID'];
};

export type MyPlayersGameAvailabilityResponse = {
  __typename?: 'MyPlayersGameAvailabilityResponse';
  away?: Maybe<Array<GamePlayerAvailability>>;
  home?: Maybe<Array<GamePlayerAvailability>>;
};

export type MyProfilesGameAvailabilityInput = {
  /** Game routing code */
  gameID: Scalars['ID'];
};

export type MyProfilesGameAvailabilityResponse = {
  __typename?: 'MyProfilesGameAvailabilityResponse';
  away?: Maybe<GameTeamAvailability>;
  home?: Maybe<GameTeamAvailability>;
};

export type MyTeamsGameInput = {
  gameID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  teamContextID?: InputMaybe<Scalars['ID']>;
};

export type MyTeamsGamePaymentRequest = {
  gameID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  side: Side;
  teamID: Scalars['ID'];
};

export type MyTeamsGamePaymentRequestResponse = {
  __typename?: 'MyTeamsGamePaymentRequestResponse';
  organisationID?: Maybe<Scalars['ID']>;
  organisationName?: Maybe<Scalars['ID']>;
  paymentRequestID?: Maybe<Scalars['ID']>;
  status?: Maybe<PaymentRequestStatus>;
};

export enum PaymentRequestStatus {
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type MyTeamsParticipantsFilter = {
  firstName?: InputMaybe<Scalars['String']>;
  gameID?: InputMaybe<Scalars['ID']>;
  lastName: Scalars['String'];
  organisationID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  seasonID: Scalars['ID'];
  teamContextID?: InputMaybe<Scalars['ID']>;
  teamID?: InputMaybe<Scalars['ID']>;
  type: SeasonRegistrationUserType;
};

export type MyTeamsParticipantList = {
  __typename?: 'MyTeamsParticipantList';
  meta?: Maybe<SearchResultMeta>;
  result?: Maybe<Array<MyTeamsParticipant>>;
};

export type MyTeamsTeamInput = {
  profileID?: InputMaybe<Scalars['ID']>;
  teamID?: InputMaybe<Scalars['ID']>;
};

export type NullResponse = {
  __typename?: 'NullResponse';
  /** Placeholder field with null response that is used as a template for fields that are not implemented yet */
  nullField?: Maybe<Scalars['String']>;
};

export type ProfileSearchResult = {
  __typename?: 'ProfileSearchResult';
  result?: Maybe<Array<DiscoverProfile>>;
};

/**
 * Tenant fields return tenant name and slug
 * e.g. { name: "Basketball VIC", value: "basketball-victoria" }
 */
export type ProfileTenantDetails = {
  __typename?: 'ProfileTenantDetails';
  coachingAccreditation: Array<TenantField>;
  concussionIncidents?: Maybe<Array<TenantField>>;
  memberships: Array<TenantField>;
  myTeams: Array<TenantField>;
  registrationHistory: Array<TenantField>;
};

export type PublicProfileStatistics = {
  __typename?: 'PublicProfileStatistics';
  careerStatistics?: Maybe<CareerStatistics>;
  seasonStatistics?: Maybe<Array<SeasonStatistics>>;
};

export type CareerStatistics = {
  __typename?: 'CareerStatistics';
  clubStatistics?: Maybe<Array<ClubStatistics>>;
  totalStatistics?: Maybe<Array<Statistic>>;
};

export type ClubStatistics = {
  __typename?: 'ClubStatistics';
  club?: Maybe<DiscoverOrganisation>;
  id: Scalars['ID'];
  statistics?: Maybe<Array<Statistic>>;
};

export type SeasonStatistics = {
  __typename?: 'SeasonStatistics';
  name: Scalars['String'];
  player: DiscoverAnonymousParticipant;
  statistics?: Maybe<Array<SeasonStatisticsRegistrations>>;
};

export type SeasonStatisticsRegistrations = {
  __typename?: 'SeasonStatisticsRegistrations';
  club?: Maybe<DiscoverOrganisation>;
  role: SeasonRegistrationUserType;
  season: DiscoverSeason;
  teamStatistics?: Maybe<Array<TeamStatistics>>;
  totalStatistics?: Maybe<Array<Statistic>>;
};

export type TeamStatistics = {
  __typename?: 'TeamStatistics';
  gradeStatistics?: Maybe<Array<GradeStatistics>>;
  team?: Maybe<DiscoverPossibleTeam>;
  totalStatistics?: Maybe<Array<Statistic>>;
};

export type GradeStatistics = {
  __typename?: 'GradeStatistics';
  gameStatistics?: Maybe<Array<SeasonGameStatistics>>;
  grade: DiscoverGrade;
  totalStatistics?: Maybe<Array<Statistic>>;
};

export type SeasonGameStatistics = {
  __typename?: 'SeasonGameStatistics';
  game: DiscoverGame;
  statistics?: Maybe<Array<Statistic>>;
};

export type PushNotificationUserSettings = {
  __typename?: 'PushNotificationUserSettings';
  disabledPushNotificationTypes: Array<PushNotificationType>;
};

export type RegistrationAssertInput = {
  registration?: InputMaybe<OrderRegistrationInput>;
};

export type OrderRegistrationInput = {
  participantID?: InputMaybe<Scalars['ID']>;
  registrationCode: Scalars['ID'];
  teamID?: InputMaybe<Scalars['ID']>;
};

/**
 * Time dependent hash which must be passed with timestamp to assert the freshness of the hash key.
 * Rebound ensures validity of the has based on the hash key value and timestampIso of when the hash key was generated.
 */
export type AssertHash = {
  __typename?: 'AssertHash';
  hashKey?: Maybe<Scalars['String']>;
  /** timestampIso is the time when the hash key was generated. */
  timestampIso?: Maybe<Scalars['ISODateTime']>;
};

export type RegistrationCheckInput = {
  activityID: Scalars['ID'];
  destinationOrganisationID: Scalars['ID'];
  filter?: InputMaybe<RegistrationCheckFilter>;
  participantID?: InputMaybe<Scalars['ID']>;
  profileID: Scalars['ID'];
  registrationCode: Scalars['String'];
  role: SeasonRegistrationUserType;
};

export type RegistrationCheckFilter = {
  registrationCheckType?: InputMaybe<RegistrationCheckType>;
};

export enum RegistrationCheckType {
  Approved = 'APPROVED',
  Pending = 'PENDING'
}

/** Some fields only apply to competitions and will be null for programs */
export type RegistrationCheckResult = {
  __typename?: 'RegistrationCheckResult';
  alreadyRegisteredToRole?: Maybe<Scalars['Boolean']>;
  approvedParticipantID?: Maybe<Scalars['ID']>;
  hasAffiliationChangedSinceParticipantCreation?: Maybe<Scalars['Boolean']>;
  permitRequest?: Maybe<Permit>;
  transferRequest?: Maybe<TransferRequest>;
};

export type RegistrationSettings = DiscoverRegistration | DiscoverSocialTeamRegistration;

export type SearchAddressesFilter = {
  query: Scalars['String'];
};

export type SeasonRegistrationCartArgs = {
  charities?: InputMaybe<Array<CharityInput>>;
  checkoutSessionID?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  dateOfBirth?: InputMaybe<Scalars['ISODate']>;
  deferredFees?: InputMaybe<Scalars['Boolean']>;
  externalVouchers?: InputMaybe<Array<ExternalVoucherInput>>;
  gender?: InputMaybe<Gender>;
  participantID: Scalars['ID'];
  /** ! Looks like this field is not use. Check if can be removed. */
  products?: InputMaybe<Array<ProductCartInput>>;
  /**
   * The following three fields can be deprecated or even removed once FE changes to stop providing them have been merged into layup, as the
   * BE now pulls them from the database using the participantID
   */
  role?: InputMaybe<SeasonRegistrationUserType>;
  selectedAdvancedFeeIDs?: InputMaybe<Array<Scalars['ID']>>;
  selectedMembershipIDs?: InputMaybe<Array<Scalars['ID']>>;
  voucherCodes: Array<Scalars['String']>;
};

export type CharityInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type ExternalVoucherInput = {
  aboriginalOrTorresStraightIslander?: InputMaybe<Scalars['Boolean']>;
  alternativeMainLanguageSpokenAtHome?: InputMaybe<Scalars['String']>;
  amount?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
  costToRegisterForActivity?: InputMaybe<Scalars['Int']>;
  /**
   * SA government voucher not gonna use this field, but keeping it as FE hid the field as requested
   * by the product owner (in case the field is needed again in the future)
   */
  culturalLinguisticDiversity?: InputMaybe<Scalars['Boolean']>;
  /** SA Government Questions */
  englishMainLanguageSpokenAtHome?: InputMaybe<Scalars['Boolean']>;
  identifiedDisability?: InputMaybe<Scalars['Boolean']>;
  identifier?: InputMaybe<Scalars['String']>;
  isExistingMember?: InputMaybe<Scalars['Boolean']>;
  schemeID: Scalars['ID'];
};

export type ProductCartInput = {
  customFieldAnswers: Array<CustomFieldAnswerInput>;
  productID: Scalars['ID'];
  productVariantID: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type CustomFieldAnswerInput = {
  answer: Scalars['String'];
  id: Scalars['ID'];
};

export type CartPayload = {
  __typename?: 'CartPayload';
  cart: Cart;
  checkoutSession?: Maybe<CheckoutSession>;
  errors: Array<UserError>;
};

export type Cart = {
  __typename?: 'Cart';
  availableCharities?: Maybe<Array<Charity>>;
  availableExternalVouchers?: Maybe<Array<ExternalVoucher>>;
  feesAmount: Price;
  items: Array<CartItem>;
  productsAmount: Price;
  totals: CartTotals;
};

export type Charity = {
  __typename?: 'Charity';
  charityIdentifier?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  learnMoreUrl?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<DonationOption>>;
};

export type DonationOption = {
  __typename?: 'DonationOption';
  amount?: Maybe<Price>;
};

export type ExternalVoucher = {
  __typename?: 'ExternalVoucher';
  scheme: VoucherScheme;
};

export type VoucherScheme = {
  __typename?: 'VoucherScheme';
  externalOwner: Scalars['String'];
  hasAmount: Scalars['Boolean'];
  id: Scalars['ID'];
  maxAmount?: Maybe<Scalars['Int']>;
  minAmount?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type CartItem = {
  __typename?: 'CartItem';
  discount?: Maybe<CartDiscount>;
  fee: CartFee;
  voucher?: Maybe<CartVoucher>;
};

export type CartDiscount = {
  __typename?: 'CartDiscount';
  amount: Price;
  id: Scalars['ID'];
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
};

export type CartFee = MembershipAdvancedFee | MerchandiseFee | ParticipantFee | TeamFee;

export type MerchandiseFee = {
  __typename?: 'MerchandiseFee';
  amount: Price;
  /**
   * Category pairs returned null for registration related merchandise fees
   *
   * The nullable set of category/attribute pairs that define the given variant product.
   * For example, given a product that has the 'Size' and 'Colour' categories,
   * this variant product may be defined as a 'Small Red Shirt', or a 'Large Green
   * Shirt'.
   *
   * Unlike ProductVariantPair which provide all available categories in ProductVariant, this field
   * only returns selected categories that are relevant to the item in the cart.
   */
  categoryPairs?: Maybe<Array<CategoryPair>>;
  customFieldAnswers?: Maybe<Array<MerchandiseFeeCustomFieldResponse>>;
  description?: Maybe<Scalars['String']>;
  fulfilmentMethod: FulfilmentMethod;
  fulfilmentProvider?: Maybe<Scalars['String']>;
  /** Images returned null for registration related merchandise fees */
  images?: Maybe<Array<Image>>;
  organisation: DiscoverOrganisation;
  productID: Scalars['ID'];
  productType: ProductType;
  productVariantID: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type CategoryPair = {
  __typename?: 'CategoryPair';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** A merchandise fee custom field response provided by the registrant. */
export type MerchandiseFeeCustomFieldResponse = {
  __typename?: 'MerchandiseFeeCustomFieldResponse';
  answer: Scalars['String'];
  customField: ProductCustomField;
};

export enum FulfilmentMethod {
  Delivery = 'DELIVERY',
  NotRequired = 'NOT_REQUIRED',
  Pickup = 'PICKUP'
}

export type ParticipantFee = Node & {
  __typename?: 'ParticipantFee';
  amount: Price;
  amountDeferred?: Maybe<Price>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * options is the list of new advancedFees,
   * for ageAndGenderFee and GroupFee, this list will only have 1 entry
   * variantFees can have one or more
   */
  options?: Maybe<Array<ParticipantFeeOption>>;
  organisation: DiscoverOrganisation;
  quantity: Scalars['Int'];
  /** The selected advanced fee when variant fees are applicable to the cart */
  selectedOption?: Maybe<ParticipantFeeOption>;
};

export type ParticipantFeeOption = {
  __typename?: 'ParticipantFeeOption';
  amount?: Maybe<Price>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type TeamFee = Node & {
  __typename?: 'TeamFee';
  amount: Price;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  organisation: DiscoverOrganisation;
  quantity: Scalars['Int'];
};

export type CartVoucher = {
  __typename?: 'CartVoucher';
  amount: Price;
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  organisation: DiscoverOrganisation;
};

export type CartTotals = {
  __typename?: 'CartTotals';
  deferredServiceFeeAmount?: Maybe<Price>;
  deferredSubtotalAmount?: Maybe<Price>;
  externalVouchers?: Maybe<Array<CartExternalVoucher>>;
  promotionalVouchers?: Maybe<Array<CartPromotionalVoucher>>;
  selectedCharities?: Maybe<Array<SelectedCharity>>;
  serviceFeeAmount?: Maybe<Price>;
  shippingFeeAmount?: Maybe<Price>;
  subTotalAmount?: Maybe<Price>;
  totalAmount?: Maybe<Price>;
  vouchers?: Maybe<Array<CartVoucher>>;
};

export type CartExternalVoucher = {
  __typename?: 'CartExternalVoucher';
  aboriginalOrTorresStraightIslander?: Maybe<Scalars['Boolean']>;
  alternativeMainLanguageSpokenAtHome?: Maybe<Scalars['String']>;
  amount: Price;
  code: Scalars['String'];
  costToRegisterForActivity?: Maybe<Scalars['Int']>;
  /**
   * SA government voucher not gonna use this field, but keeping it as FE hid the field as requested
   * by the product owner (in case the field is needed again in the future)
   * @deprecated use englishMainLanguageSpokenAtHome and alternativeMainLanguageSpokenAtHome instead
   */
  culturalLinguisticDiversity?: Maybe<Scalars['Boolean']>;
  englishMainLanguageSpokenAtHome?: Maybe<Scalars['Boolean']>;
  identifiedDisability?: Maybe<Scalars['Boolean']>;
  identifier?: Maybe<Scalars['String']>;
  isExistingMember?: Maybe<Scalars['Boolean']>;
  organisations: Array<DiscoverOrganisation>;
  scheme: VoucherScheme;
};

export type CartPromotionalVoucher = {
  __typename?: 'CartPromotionalVoucher';
  amount: Price;
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organisations: Array<DiscoverOrganisation>;
};

export type SelectedCharity = {
  __typename?: 'SelectedCharity';
  amount?: Maybe<Price>;
  id: Scalars['ID'];
};

export type CheckoutSession = Gr4vyCheckoutSession | Gr4vyEmbedCheckoutSession | StripeCheckoutSession;

export type Gr4vyCheckoutSession = {
  __typename?: 'Gr4vyCheckoutSession';
  browser?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['ISODateTime']>;
  id: Scalars['String'];
};

export type Gr4vyEmbedCheckoutSession = {
  __typename?: 'Gr4vyEmbedCheckoutSession';
  embedToken?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['ISODateTime']>;
  id: Scalars['String'];
};

export type StripeCheckoutSession = {
  __typename?: 'StripeCheckoutSession';
  id?: Maybe<Scalars['String']>;
};

export type UserError = {
  __typename?: 'UserError';
  field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message: Scalars['String'];
};

export type ShopCartArgs = {
  checkoutSessionID?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ShopCart = {
  __typename?: 'ShopCart';
  availableCharities?: Maybe<Array<Charity>>;
  checkoutSession?: Maybe<CheckoutSession>;
  id: Scalars['ID'];
  items?: Maybe<Array<CartItem>>;
  productsAmount?: Maybe<Price>;
  totals?: Maybe<CartTotals>;
};

export type ShopProductsFilter = {
  types?: InputMaybe<Array<ProductType>>;
};

export type ShallowProduct = {
  __typename?: 'ShallowProduct';
  fulfilment?: Maybe<Fulfilment>;
  id: Scalars['ID'];
  images?: Maybe<Array<Image>>;
  maxPrice?: Maybe<Price>;
  minPrice?: Maybe<Price>;
  name?: Maybe<Scalars['String']>;
  productType?: Maybe<ProductType>;
};

export type Fulfilment = {
  __typename?: 'Fulfilment';
  method?: Maybe<FulfilmentMethod>;
  provider?: Maybe<Scalars['String']>;
};

export type SocialTeamRegistration = Node & {
  __typename?: 'SocialTeamRegistration';
  additionalInfo?: Maybe<Scalars['String']>;
  endDate: TimeZoneDateTime;
  fee: TeamFee;
  grades: Array<DiscoverGrade>;
  id: Scalars['ID'];
  pricingInfo?: Maybe<Scalars['String']>;
  registrationCode: Scalars['String'];
  season: DiscoverSeason;
  showOrganisationTermsAndConditions: Scalars['Boolean'];
  startDate: TimeZoneDateTime;
  teams: Array<DiscoverTeam>;
  /** @deprecated Field no longer supported */
  termsAndConditions: Array<TermsAndConditions>;
  visible: Scalars['Boolean'];
};


export type SocialTeamRegistrationGradesArgs = {
  day?: InputMaybe<DayOfTheWeek>;
  gender?: InputMaybe<GradeGender>;
};

export type SocialTeamRegistrationCartArgs = {
  checkoutSessionID?: InputMaybe<Scalars['String']>;
  code: Scalars['String'];
  voucherCodes: Array<Scalars['String']>;
};

export type SponsorBannerInputArgs = {
  organisationID?: InputMaybe<Scalars['String']>;
  screen: OutswingScreen;
};

export enum OutswingScreen {
  Activity = 'ACTIVITY',
  Favourites = 'FAVOURITES',
  GameCentre = 'GAME_CENTRE',
  Grade = 'GRADE',
  Home = 'HOME',
  Profile = 'PROFILE',
  Search = 'SEARCH',
  Team = 'TEAM'
}

export type SponsorBanner = {
  __typename?: 'SponsorBanner';
  imageUrl?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
  screen: OutswingScreen;
};

export type TenantConfiguration = {
  __typename?: 'TenantConfiguration';
  availableTaxType: Array<TaxOption>;
  basicGenders: Array<TenantField>;
  canGenerateGameSheets?: Maybe<Scalars['Boolean']>;
  captainOptions?: Maybe<Array<Captain>>;
  /** Defines whether the claim profiles step for profile matching is mandatory or not */
  claimProfilesIsMandatory: Scalars['Boolean'];
  coinTossPreferences?: Maybe<Array<TenantField>>;
  competition: CompetitionConfiguration;
  contactRoles: Array<TenantField>;
  /** Full list of valid countries. Used for things like country of birth. */
  countries: Array<TenantField>;
  /** @deprecated Use supportedCountries on Configuration */
  countryCodes: Array<TenantField>;
  discloseOptions: Array<TenantField>;
  /** Returns information about the external account linking for the tenant sending the request */
  externalAccountLinking?: Maybe<ExternalAccountLinking>;
  externalAppUrls?: Maybe<Array<UrlTenantField>>;
  externalStatisticsUrls?: Maybe<Array<UrlTenantField>>;
  /** @deprecated use gameOutcomeOverride from GameTypeConfig */
  gameOutcomeOverride: Array<TenantField>;
  gameTypes?: Maybe<Array<GameTypeConfig>>;
  /** The list of all play grade types available to use while creating a grade for the current tenant */
  gradeTypes?: Maybe<Array<GradeTypeConfig>>;
  hasVolunteerRoles: Scalars['Boolean'];
  label?: Maybe<Scalars['String']>;
  localisation?: Maybe<TenantLocalisation>;
  /**
   * The list of all milestone game counts achievable by a profile
   * e.g. 1, 50, 100, 150, 200
   */
  milestoneGameCounts?: Maybe<Array<Scalars['Int']>>;
  /**
   * Provides options for, eg. for Football we have an additional dropdown against
   * a Card statistic such as "R1 - Serious foul play".
   */
  offenceTypeOptions?: Maybe<Array<OffenceTypeOption>>;
  organisation: OrganisationConfiguration;
  outswingConfiguration?: Maybe<OutswingConfiguration>;
  overtimeType: Array<TenantField>;
  periodType: Array<TenantField>;
  playerDismissalTypes?: Maybe<Array<DismissalType>>;
  /** Defines whether player numbers are disabled and UI should be hidden */
  playerNumberDisabled?: Maybe<Scalars['Boolean']>;
  playerPeriodStatuses?: Maybe<Array<PlayerPeriodStatus>>;
  playerPositions?: Maybe<Array<PlayerPositionOption>>;
  scoresheetOrientation: Array<TenantField>;
  seasonRegistration: SeasonRegistrationConfiguration;
  /** Show or hide a duck icon for cricket dismissals in game centre batting table */
  showDuckIconInBattingTable?: Maybe<Scalars['Boolean']>;
  /** Show or hide player position in lineup list in game centre */
  showPlayerPositionsInLineup?: Maybe<Scalars['Boolean']>;
  sport?: Maybe<SportConfiguration>;
  /**
   * Defines what stats type of statistics a sport has.
   * For example, types of fouls and scores.
   */
  statistics?: Maybe<TenantStatistics>;
  stripePublicKey?: Maybe<Scalars['String']>;
  /** @deprecated This is not a tenant specific value, so is resolved on Configuration Instead */
  supportedCountries?: Maybe<Array<SupportedCountry>>;
  timezones: Array<TenantField>;
  transfers: TenantTransferSettings;
  venue: VenueConfiguration;
  volunteerRoles?: Maybe<Array<VolunteerRoleField>>;
};

export type TaxOption = {
  __typename?: 'TaxOption';
  name: Scalars['String'];
  value: TaxStatus;
};

export enum TaxStatus {
  AusGst = 'AUS_GST',
  NoTax = 'NO_TAX'
}

export type CompetitionConfiguration = {
  __typename?: 'CompetitionConfiguration';
  ageGroups: Array<TenantField>;
  genders: Array<TenantField>;
  roundFrequency: Array<TenantField>;
};

export type UrlTenantField = {
  __typename?: 'UrlTenantField';
  name: Scalars['String'];
  url: Scalars['String'];
  value: Scalars['String'];
};

export type GameTypeConfig = {
  __typename?: 'GameTypeConfig';
  closureStatusOptions?: Maybe<Array<ClosureStatusOption>>;
  gameOutcomeOverride?: Maybe<Array<TenantField>>;
  gameType: TenantField;
  gameTypeFeatures?: Maybe<GameTypeFeatures>;
  isDefault?: Maybe<Scalars['Boolean']>;
  manualBonusPointsOptions?: Maybe<Array<Scalars['String']>>;
  possibleGameOutcomesMap?: Maybe<Array<PossibleGameOutcomeMap>>;
};

export type ClosureStatusOption = {
  __typename?: 'ClosureStatusOption';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<ClosureStatus>;
};

export type GameTypeFeatures = {
  __typename?: 'GameTypeFeatures';
  /** Enables editing statistics for individual player per game, currently introduced for football tenant only */
  editIndividualPlayerStatistics?: Maybe<Scalars['Boolean']>;
  lineupOrderingEnabled?: Maybe<Scalars['Boolean']>;
};

export type PossibleGameOutcomeMap = {
  __typename?: 'PossibleGameOutcomeMap';
  labelLoss?: Maybe<Scalars['String']>;
  labelWin?: Maybe<Scalars['String']>;
  loss?: Maybe<Scalars['String']>;
  win?: Maybe<Scalars['String']>;
};

export type GradeTypeConfig = {
  __typename?: 'GradeTypeConfig';
  description?: Maybe<Scalars['String']>;
  features?: Maybe<GradeTypeFeatures>;
  fixtureType?: Maybe<FixtureType>;
  /** Used to distinguish regular grade and all other "all play" grades */
  isAllPlay?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<GradeType>;
};

export type GradeTypeFeatures = {
  __typename?: 'GradeTypeFeatures';
  hasCareerStats?: Maybe<Scalars['Boolean']>;
  hasFinals?: Maybe<Scalars['Boolean']>;
  hasFixture?: Maybe<Scalars['Boolean']>;
  hasGameStats?: Maybe<Scalars['Boolean']>;
  hasLadder?: Maybe<Scalars['Boolean']>;
  hasRounds?: Maybe<Scalars['Boolean']>;
  hasSeasonStats?: Maybe<Scalars['Boolean']>;
  hasTeamToGradeAllocation?: Maybe<Scalars['Boolean']>;
};

export enum FixtureType {
  Knockout = 'KNOCKOUT',
  RoundRobin = 'ROUND_ROBIN'
}

export type TenantLocalisation = {
  __typename?: 'TenantLocalisation';
  country: Scalars['String'];
  currency: Currency;
  locale: Scalars['String'];
  states?: Maybe<Array<CountryState>>;
};

export type CountryState = {
  __typename?: 'CountryState';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type OffenceTypeOption = {
  __typename?: 'OffenceTypeOption';
  /**
   * What statistic values the offence type is applicable to, so the list can be
   * filtered to show only the relevant options for the card-type, eg.
   * ["YELLOW_CARD"] or ["RED_CARD"]
   */
  applicableTo?: Maybe<Array<Scalars['String']>>;
  /**
   * A longer form description of the offence type, the dropdown should display
   * this against each option as a label when open, eg. "Serious foul play"
   */
  description?: Maybe<Scalars['String']>;
  /**
   * In this context the value will act as both the label and value, eg. the
   * dropdown should display "R1" as the selected option.
   */
  value: Scalars['String'];
};

export type OrganisationConfiguration = {
  __typename?: 'OrganisationConfiguration';
  types: Array<TenantField>;
};

export type OutswingConfiguration = {
  __typename?: 'OutswingConfiguration';
  /** @deprecated use sponsorBanners Query */
  banners?: Maybe<Array<SponsorBanner>>;
  minimumVersion?: Maybe<Version>;
  /** Name of mobile app */
  name?: Maybe<Scalars['String']>;
  unsupportedVersions?: Maybe<Array<Version>>;
  /** Marketing and app store URLs */
  urls?: Maybe<OutswingUrls>;
  /** Internal identifier of the app (e.g. playafl, myhoops, netballhq) */
  value?: Maybe<Scalars['String']>;
  version?: Maybe<Version>;
};

export type Version = {
  __typename?: 'Version';
  effectiveDate: Scalars['ISODate'];
  major: Scalars['Int'];
  minor: Scalars['Int'];
  patch: Scalars['Int'];
};

export type OutswingUrls = {
  __typename?: 'OutswingUrls';
  /** Apple app store download link */
  appleAppStore?: Maybe<Scalars['String']>;
  /** Google play store download link */
  googlePlayStore?: Maybe<Scalars['String']>;
  /** Information page of the app hosted on playhq.com */
  info?: Maybe<Scalars['String']>;
};

export type DismissalType = {
  __typename?: 'DismissalType';
  applicableTo?: Maybe<Array<DismissalPlayerRole>>;
  name?: Maybe<Scalars['String']>;
  statisticTypes?: Maybe<Array<DismissalStatisticType>>;
  value?: Maybe<DismissalTypeValue>;
};

export enum DismissalPlayerRole {
  AssistantFielder = 'ASSISTANT_FIELDER',
  Bowler = 'BOWLER',
  Fielder = 'FIELDER',
  NonStrikeBatter = 'NON_STRIKE_BATTER',
  StrikeBatter = 'STRIKE_BATTER'
}

export enum DismissalStatisticType {
  NoBall = 'NO_BALL',
  Wide = 'WIDE'
}

export type PlayerPeriodStatus = {
  __typename?: 'PlayerPeriodStatus';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<PlayerPeriodStatusValue>;
};

export type PlayerPositionOption = {
  __typename?: 'PlayerPositionOption';
  label?: Maybe<Scalars['String']>;
  /**
   * Maximum players that can be allocated to this position per lineup
   * If value is null, there is no limit
   */
  lineupMax?: Maybe<Scalars['Int']>;
  /** Identifier for the player position type */
  positionType?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
};

export type SeasonRegistrationConfiguration = {
  __typename?: 'SeasonRegistrationConfiguration';
  /** @deprecated use coachingAccreditationConfig */
  coachAccreditation: Array<TenantField>;
  coachingAccreditationConfig?: Maybe<CoachingAccreditationConfiguration>;
  disabilities: Array<TenantField>;
  indigenousDescent: Array<TenantField>;
  photoVerification?: Maybe<RegistrationPhotoVerificationConfiguration>;
};

export type CoachingAccreditationConfiguration = {
  __typename?: 'CoachingAccreditationConfiguration';
  accreditations?: Maybe<Array<TenantField>>;
  selfSubmit?: Maybe<Scalars['Boolean']>;
};

export type RegistrationPhotoVerificationConfiguration = {
  __typename?: 'RegistrationPhotoVerificationConfiguration';
  enabled?: Maybe<Scalars['Boolean']>;
  requiredMinimumAge?: Maybe<Scalars['Int']>;
  roles?: Maybe<Array<SeasonRegistrationUserType>>;
};

export type SportConfiguration = {
  __typename?: 'SportConfiguration';
  /** @deprecated use participantEvents in grade gameEvents */
  gameEvents: Array<GameEventConfiguration>;
  name: Scalars['String'];
};

export type TenantStatistics = {
  __typename?: 'TenantStatistics';
  careerStatisticsMeta?: Maybe<Array<StatisticsMeta>>;
  enabled: Scalars['Boolean'];
  publicGradeStatisticsMeta?: Maybe<Array<StatisticsMeta>>;
  seasonStatisticsMeta?: Maybe<Array<StatisticsMeta>>;
};

export type StatisticsMeta = {
  __typename?: 'StatisticsMeta';
  /** Default sorting order used in offence list page */
  defaultDescendingSort?: Maybe<Scalars['Boolean']>;
  /** This property allows to check if stat is shown in offence lists (e.g. Red/Yellow cards for football) */
  inOffenceList?: Maybe<Scalars['Boolean']>;
  isDisplayable: Scalars['Boolean'];
  name: Scalars['String'];
  /** Controls the visibility of the offence list column in public portal */
  offenceListPublicVisible?: Maybe<Scalars['Boolean']>;
  shortName: Scalars['String'];
  value: Scalars['String'];
};

export type TenantTransferSettings = {
  __typename?: 'TenantTransferSettings';
  transferSettingsOwner: TransferSettingsOwner;
};

export enum TransferSettingsOwner {
  Competition = 'COMPETITION',
  Tenant = 'TENANT'
}

export type VenueConfiguration = {
  __typename?: 'VenueConfiguration';
  surfaceType: Array<TenantField>;
};

export type VolunteerRoleField = {
  __typename?: 'VolunteerRoleField';
  label: Scalars['String'];
  number: Scalars['Int'];
  roleType: Scalars['String'];
};

/**
 * An upcoming team event timeline has two categories outlined in their field documentation.
 * Every `[UpcomingTeamEvent!]` is ordered by their date in ascending order. Byes dates are
 * determined by their round's provisional date. Due to how rounds only store the date,
 * these entries will be ordered before games.
 */
export type UpcomingTeamEventTimeline = {
  __typename?: 'UpcomingTeamEventTimeline';
  /**
   * Events have occurred recently (no more than 1 day ago), and events that are upcoming next
   * week are found here. Most events will be allocated games of any status and some byes.
   * Byes are represented as `DiscoverRound`.
   *
   * Bookmarked entries that would result in duplicated entries are removed. Duplication is
   * determined by the type of event and the team. For example, if a user follows two teams
   * that would play against one another, the game would be duplicated.
   * Byes act differently as their identity is compounded by their round ID and the team.
   * If the user follows multiple teams that share a bye (i.e., these teams are having byes
   * on the same round), a record for each team will be given.
   */
  recentAndNextWeekEvents: Array<UpcomingTeamEvent>;
  /**
   * Upcoming events outside the week range specified above will reside in this type. Every
   * bookmarked team should have one element in this list. Games may be allocated or unallocated.
   * View the `UpcomingTeamEventItem` union type documentation for more details.
   */
  upcomingEvents: Array<UpcomingTeamEvent>;
};

export type UpcomingTeamEvent = {
  __typename?: 'UpcomingTeamEvent';
  event: UpcomingTeamEventItem;
  team: DiscoverTeam;
};

/**
 * An upcoming team event can be comprised of different events expressed in this union
 * type. The type return is based from the following rules:
 *
 * DiscoverGame is used when:
 *
 * - When the team is playing in an allocated game
 * - When the team is playing in an unallocated game. The `allocation` field resolver
 *   should return `null` in this case.
 *
 * DiscoverRound is used when:
 *
 * - If the team has a bye
 *
 * EmptyTeamEvent is used when the conditions met in the its type documentation are found.
 */
export type UpcomingTeamEventItem = DiscoverGame | DiscoverRound | EmptyTeamEvent;

/**
 * Represent an team event that acts like a terminator, i.e., the last event for a team
 * in the timeline. This event can represent the following:
 *
 * - A team is in an event that exceeds round visibility.
 * - A team is not allocated to a grade
 * - A team is allocated to a grade with no fixture.
 */
export type EmptyTeamEvent = {
  __typename?: 'EmptyTeamEvent';
  reason?: Maybe<EmptyTeamEventReason>;
};

export enum EmptyTeamEventReason {
  HiddenByRoundVisibility = 'HIDDEN_BY_ROUND_VISIBILITY',
  NoFixtureAvailable = 'NO_FIXTURE_AVAILABLE',
  NoUpcomingGames = 'NO_UPCOMING_GAMES'
}

export type UpcomingTeamEventsPaginatedInput = {
  fromDate: Scalars['ISODate'];
  items: Array<BookmarkItemInput>;
};

export type UpcomingTeamEventsPaginated = {
  __typename?: 'UpcomingTeamEventsPaginated';
  meta?: Maybe<UpcomingTeamEventsPaginatedMeta>;
  results?: Maybe<Array<UpcomingTeamEvent>>;
};

export type UpcomingTeamEventsPaginatedMeta = {
  __typename?: 'UpcomingTeamEventsPaginatedMeta';
  fromDate?: Maybe<Scalars['ISODate']>;
  hasMoreAfterLastDate?: Maybe<Scalars['Boolean']>;
  /** The cut off date of the results determined by the response result limit, to be used when `hasMoreAfterLastDate` field is true */
  lastDate?: Maybe<Scalars['ISODate']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  accountConfirm: AccountConfirmation;
  accountUpdate: Account;
  addressUpdate: Address;
  checkoutSessionCreate: CheckoutSession;
  childSafetyUpdate?: Maybe<FieldSet>;
  claimVerify: ProfileMerge;
  coachingAccreditationUpdate: CoachingAccreditation;
  /** Team manager reviews and confirms incident clearance */
  confirmIncidentClearance?: Maybe<Incident>;
  /** Unsubscribes an email from notifications for a tenant */
  emailNotificationUnsubscribe: EmailNotificationUnsubscribe;
  emergencyContactUpdate?: Maybe<EmergencyContact>;
  /**
   * Update game availability status for a participant. Participants generally do not have access to full game and team information
   * due to privacy reasons, so the response fields should be public facing (besides participant details)
   */
  gameAvailabilityUpdate?: Maybe<GameAvailabilityUpdateResponse>;
  /** Flag the game webhook as confirmed by the external source (such as a referee). */
  gameManageConfirmResults?: Maybe<Scalars['Boolean']>;
  /**
   * Pass in a signed base64-encoded token from an integration partner (such as
   * Refbook), and if valid return a long-lived JWT auth token with scoped manage
   * access, as well as the gameID from the token.
   */
  gameManageJWTGenerate?: Maybe<GameManageJwtGenerateResponse>;
  gameSheetGenerate?: Maybe<GameSheetGenerateResponse>;
  /** Update club award votes for players in a team in a game */
  gameTeamAwardVotesUpdate?: Maybe<GameTeamAward>;
  guardianCreate: Guardian;
  guardianDelete: Guardian;
  guardianUpdate: Guardian;
  /** Create an identity verification session to receive a return URL for the user to complete the identity verification process */
  identityVerificationSessionCreate: Scalars['String'];
  /** Creates an incident */
  incidentCreate?: Maybe<Incident>;
  /** Deletes an incident */
  incidentDelete?: Maybe<Incident>;
  /** Updates an incident */
  incidentUpdate?: Maybe<Incident>;
  invoiceDownload?: Maybe<Document>;
  linkExternalAccount: ExternalAccount;
  myTeamsGameFillInPlayerUpdate?: Maybe<MyTeamsGameUpdateResponse>;
  myTeamsGamePaymentRequestCreate?: Maybe<MyTeamsGamePaymentRequestCreateResponse>;
  myTeamsGamePlayerUpdate?: Maybe<MyTeamsGameUpdateResponse>;
  myTeamsGameTeamUpdate?: Maybe<MyTeamsGameUpdateResponse>;
  myTeamsGameUpdate?: Maybe<MyTeamsGameUpdateResponse>;
  /**
   * For Gr4vy embed, transactions are authorized and not captured by their embedded form before
   * orderSubmit is called. At the point they are authorized we have the ability to set an external
   * identifier which we want to be the order ID, so we need to generate one.
   * It will be linked to the user that creates it for authorization purposes.
   */
  orderIdentifierGenerate: Scalars['String'];
  /**
   * Submits an order and charges the account specified by the token from the input arguments.
   * This mutation is a common for shop and registration orders, and to distinguish between the two
   * we use orderPurchaseScope.purchaseScope to determine the order type.
   */
  orderSubmit: Order;
  participantRegister?: Maybe<Participant>;
  permitRequestCreate?: Maybe<Permit>;
  postEmailUnsubscribe: PostEmailUnsubscribe;
  productsUpdateCart: Cart;
  productUpdateSocialTeamCart: Cart;
  profileClaim: ProfileMerge;
  profileEmailChange?: Maybe<Scalars['ID']>;
  profileEmailVerify?: Maybe<ProfileEmailChangeResult>;
  profileQuestionsUpdate?: Maybe<FieldSet>;
  profileUpdate?: Maybe<Profile>;
  registerPushNotificationTarget: PushNotificationTarget;
  savePushNotificationUserSettings: PushNotificationUserSettings;
  /** If input contains an ID, it will update the existing cart, otherwise it will create a new cart. */
  shopCartUpsert?: Maybe<ShopCart>;
  socialTeamRegistrationSubmit: DiscoverTeam;
  /** Submits incident clearance */
  submitIncidentClearance?: Maybe<Incident>;
  transferRequestCreate: TransferRequest;
  unlinkExternalAccount: ExternalAccount;
  unregisterPushNotificationTarget?: Maybe<Scalars['String']>;
  updatePendingParticipant?: Maybe<Scalars['Boolean']>;
  /**
   * Generate a verification code to be used for claim verification. An email
   * or SMS message will be sent to the designated individual who can authorise
   * the claim. This can be used in a registration or self initiated flow.
   *
   * Determining whether a claim is valid uses the same approach as the
   * `Profile.duplicateProfiles` field resolver. Users can provide overrides that
   * allow users to find profiles that do not match previously set values.
   *
   * Please view the documentation in the `ClaimProfileInput` regarding the intents
   * which can be captured by this mutation.
   */
  verificationCodeGenerate: ProfileMerge;
  wwcUpdate: Wwc;
};


export type MutationAccountConfirmArgs = {
  input: AccountConfirmInput;
};


export type MutationAccountUpdateArgs = {
  input: AccountUpdateInput;
};


export type MutationAddressUpdateArgs = {
  id: Scalars['ID'];
  input: AddressInput;
};


export type MutationCheckoutSessionCreateArgs = {
  input?: InputMaybe<CheckoutSessionCreateInput>;
};


export type MutationChildSafetyUpdateArgs = {
  input: FieldSetInput;
};


export type MutationClaimVerifyArgs = {
  input: ClaimVerifyInput;
};


export type MutationCoachingAccreditationUpdateArgs = {
  id: Scalars['ID'];
  input: CoachingAccreditationInput;
};


export type MutationConfirmIncidentClearanceArgs = {
  incidentID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
};


export type MutationEmailNotificationUnsubscribeArgs = {
  input: EmailNotificationUnsubscribeInput;
};


export type MutationEmergencyContactUpdateArgs = {
  id: Scalars['ID'];
  input: EmergencyContactInput;
};


export type MutationGameAvailabilityUpdateArgs = {
  input: GameAvailabilityUpdateInput;
};


export type MutationGameManageConfirmResultsArgs = {
  gameID: Scalars['ID'];
};


export type MutationGameManageJwtGenerateArgs = {
  token: Scalars['String'];
};


export type MutationGameSheetGenerateArgs = {
  input: GameSheetGenerateInput;
};


export type MutationGameTeamAwardVotesUpdateArgs = {
  input: GameTeamAwardVotesUpdateInput;
};


export type MutationGuardianCreateArgs = {
  input: GuardianInput;
  profileID: Scalars['ID'];
};


export type MutationGuardianDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationGuardianUpdateArgs = {
  id: Scalars['ID'];
  input: GuardianInput;
};


export type MutationIdentityVerificationSessionCreateArgs = {
  input?: InputMaybe<IdentityVerificationSessionCreateInput>;
};


export type MutationIncidentCreateArgs = {
  input: IncidentCreateInput;
};


export type MutationIncidentDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationIncidentUpdateArgs = {
  id: Scalars['ID'];
  input: IncidentUpdateInput;
};


export type MutationInvoiceDownloadArgs = {
  orderID: Scalars['String'];
};


export type MutationLinkExternalAccountArgs = {
  input: LinkExternalAccountInput;
};


export type MutationMyTeamsGameFillInPlayerUpdateArgs = {
  gameID: Scalars['ID'];
  input: MyTeamsGamePlayerUpdateInput;
};


export type MutationMyTeamsGamePaymentRequestCreateArgs = {
  input: MyTeamsGamePaymentRequestCreateInput;
};


export type MutationMyTeamsGamePlayerUpdateArgs = {
  gameID: Scalars['ID'];
  input: MyTeamsGamePlayerUpdateInput;
};


export type MutationMyTeamsGameTeamUpdateArgs = {
  gameID: Scalars['ID'];
  input: MyTeamsGameTeamUpdateInput;
  side: Side;
};


export type MutationMyTeamsGameUpdateArgs = {
  input: MyTeamsGameUpdateInput;
};


export type MutationOrderSubmitArgs = {
  input: OrderSubmitInput;
};


export type MutationParticipantRegisterArgs = {
  input: ParticipantRegisterInput;
};


export type MutationPermitRequestCreateArgs = {
  participantID: Scalars['ID'];
};


export type MutationPostEmailUnsubscribeArgs = {
  input: PostEmailUnsubscribeInput;
};


export type MutationProductsUpdateCartArgs = {
  input: SeasonRegistrationProductCartInput;
};


export type MutationProductUpdateSocialTeamCartArgs = {
  input: SocialTeamRegistrationProductCartInput;
};


export type MutationProfileClaimArgs = {
  input: ClaimProfileInput;
  overrides?: InputMaybe<ClaimProfileOverrides>;
};


export type MutationProfileEmailChangeArgs = {
  request: ProfileEmailChangeInput;
};


export type MutationProfileEmailVerifyArgs = {
  code: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationProfileQuestionsUpdateArgs = {
  input: Array<FormInput>;
  profileID: Scalars['ID'];
};


export type MutationProfileUpdateArgs = {
  id: Scalars['ID'];
  input: ProfileInput;
};


export type MutationRegisterPushNotificationTargetArgs = {
  targetInput: RegisterPushNotificationTargetInput;
};


export type MutationSavePushNotificationUserSettingsArgs = {
  input: SavePushNotificationUserSettingsInput;
};


export type MutationShopCartUpsertArgs = {
  input: ShopCartUpsertInput;
};


export type MutationSocialTeamRegistrationSubmitArgs = {
  input: SocialTeamCreateInput;
};


export type MutationSubmitIncidentClearanceArgs = {
  incidentID: Scalars['ID'];
  input?: InputMaybe<ConcussionClearanceInput>;
};


export type MutationTransferRequestCreateArgs = {
  participantID: Scalars['ID'];
};


export type MutationUnlinkExternalAccountArgs = {
  input: LinkExternalAccountInput;
};


export type MutationUnregisterPushNotificationTargetArgs = {
  appId: Scalars['String'];
};


export type MutationUpdatePendingParticipantArgs = {
  input: UpdatePendingParticipantInput;
};


export type MutationVerificationCodeGenerateArgs = {
  input: ClaimProfileInput;
  overrides?: InputMaybe<ClaimProfileOverrides>;
};


export type MutationWwcUpdateArgs = {
  id: Scalars['ID'];
  input: WwcInput;
};

export type AccountConfirmInput = {
  code: Scalars['String'];
  email: Scalars['String'];
};

export type AccountConfirmation = {
  __typename?: 'AccountConfirmation';
  success: Scalars['Boolean'];
};

export type AccountUpdateInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  mobileCountryAlphaCode: Scalars['String'];
  mobileCountryCode: Scalars['String'];
  mobileNumber: Scalars['MobileNumber'];
};

export type AddressInput = {
  country: Scalars['String'];
  latitude?: InputMaybe<Scalars['String']>;
  line1: Scalars['String'];
  line2?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  postcode: Scalars['String'];
  state: Scalars['String'];
  suburb: Scalars['String'];
};

export type CheckoutSessionCreateInput = {
  userAgent?: InputMaybe<Scalars['String']>;
};

export type FieldSetInput = {
  fields?: InputMaybe<Array<FormInput>>;
  name?: InputMaybe<Scalars['String']>;
};

export type FormInput = {
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type ClaimVerifyInput = {
  code: Scalars['String'];
  mergeID: Scalars['ID'];
};

export type ProfileMerge = {
  __typename?: 'ProfileMerge';
  id: Scalars['ID'];
  status: MergeStatus;
};

export enum MergeStatus {
  Claimed = 'CLAIMED',
  PendingVerification = 'PENDING_VERIFICATION'
}

export type CoachingAccreditationInput = {
  accreditation?: InputMaybe<Scalars['String']>;
  level?: InputMaybe<CoachingAccreditationType>;
};

export enum CoachingAccreditationType {
  Association = 'ASSOCIATION',
  Club = 'CLUB',
  Community = 'COMMUNITY',
  Master = 'MASTER',
  None = 'NONE',
  Performance = 'PERFORMANCE',
  Unsure = 'UNSURE'
}

export type EmailNotificationUnsubscribeInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type EmailNotificationUnsubscribe = {
  __typename?: 'EmailNotificationUnsubscribe';
  success?: Maybe<Scalars['Boolean']>;
};

export type EmergencyContactInput = {
  contact: ContactInput;
  relation: Scalars['String'];
};

export type ContactInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  mobileCountryAlphaCode: Scalars['String'];
  mobileCountryCode: Scalars['String'];
  mobileNumber: Scalars['MobileNumber'];
};

export type GameAvailabilityUpdateInput = {
  /** Game routing code */
  gameID: Scalars['ID'];
  /** Participant ID */
  participantID: Scalars['ID'];
  status: AvailabilityStatus;
  /** Team routing code */
  teamID: Scalars['ID'];
};

/**
 * Response to updating a participants game availability. Participants generally do
 * not have access to full game and team information due to privacy reasons, so the
 * response fields should be public facing (besides participant details)
 */
export type GameAvailabilityUpdateResponse = {
  __typename?: 'GameAvailabilityUpdateResponse';
  status?: Maybe<AvailabilityStatus>;
};

export type GameManageJwtGenerateResponse = {
  __typename?: 'GameManageJWTGenerateResponse';
  gameID?: Maybe<Scalars['ID']>;
  jwt?: Maybe<Scalars['String']>;
};

export type GameSheetGenerateInput = {
  gameID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  teamContextID?: InputMaybe<Scalars['ID']>;
};

export type GameSheetGenerateResponse = {
  __typename?: 'GameSheetGenerateResponse';
  stateID?: Maybe<Scalars['ID']>;
};

export type GameTeamAwardVotesUpdateInput = {
  gameID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  teamID: Scalars['ID'];
  voteSlip?: InputMaybe<GameTeamAwardVoteSlipInput>;
};

export type GameTeamAwardVoteSlipInput = {
  playerVotes?: InputMaybe<Array<GameTeamAwardPlayerVoteInput>>;
  voterName: Scalars['String'];
  voterNumber: Scalars['Int'];
};

export type GameTeamAwardPlayerVoteInput = {
  /** participant or fillInPlayer ID */
  playerID?: InputMaybe<Scalars['ID']>;
  voteCount?: InputMaybe<Scalars['Int']>;
};

export type GuardianInput = {
  address: AddressInput;
  contact: ContactInput;
};

export type IdentityVerificationSessionCreateInput = {
  returnUrl?: InputMaybe<Scalars['String']>;
};

export type IncidentCreateInput = {
  category?: InputMaybe<IncidentCategory>;
  /** Applied to GAME incident only */
  gameID?: InputMaybe<Scalars['ID']>;
  /** Applied to NON_GAME incident only */
  incidentDate?: InputMaybe<Scalars['ISODate']>;
  note?: InputMaybe<Scalars['String']>;
  /** Applied to NON_GAME incident only */
  owningOrganisationID?: InputMaybe<Scalars['ID']>;
  playerID?: InputMaybe<Scalars['ID']>;
  playerType?: InputMaybe<GamePlayerType>;
  /** Applied to NON_GAME incident only */
  seasonName?: InputMaybe<Scalars['String']>;
  /**
   * Applied to GAME incident only.
   * Also used for authorisation of Team Managers in playmaker.
   */
  teamID?: InputMaybe<Scalars['ID']>;
  type?: InputMaybe<IncidentType>;
};

export type IncidentUpdateInput = {
  incidentDate?: InputMaybe<Scalars['ISODate']>;
  note?: InputMaybe<Scalars['String']>;
  owningOrganisationID?: InputMaybe<Scalars['ID']>;
  seasonName?: InputMaybe<Scalars['String']>;
};

export type LinkExternalAccountInput = {
  externalAccountID: Scalars['String'];
};

export type MyTeamsGamePlayerUpdateInput = {
  input?: InputMaybe<GamePlayerStatisticsInput>;
  /**
   * Users view a MyTeamsGame in the context of a specific team.
   * READ/WRITE permissions will be based on that team.
   */
  teamContextID?: InputMaybe<Scalars['ID']>;
};

export type GamePlayerStatisticsInput = {
  captainValue?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  lineupOrder?: InputMaybe<Scalars['Int']>;
  periods?: InputMaybe<Array<PlayerPeriodInput>>;
  periodStatistics?: InputMaybe<Array<PlayerPeriodStatisticsInput>>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: InputMaybe<Scalars['String']>;
  playerPosition?: InputMaybe<GamePlayerPositionInput>;
  selected?: InputMaybe<Scalars['Boolean']>;
  statistics?: InputMaybe<Array<StatisticInput>>;
  type?: InputMaybe<GamePlayerType>;
};

/** Non-cricket player statistics per period */
export type PlayerPeriodInput = {
  /**
   * Array of positions the player had during the current period (if in-game
   * positions is enabled). NOTE: this only tracks each unique instance of a
   * position, so duplicates will be ignored, and the return value will be sorted
   * according to the tenant-config positions sort order.
   */
  inGamePositions?: InputMaybe<Array<Scalars['String']>>;
  /**
   * If the game is in overtime, this will always start from 1 (even if there is only
   * 1 overtime period in the game).
   */
  overtimeSequenceNo?: InputMaybe<Scalars['Int']>;
  periodValue?: InputMaybe<Scalars['String']>;
};

/** Cricket player statistics per period */
export type PlayerPeriodStatisticsInput = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  periodValue?: InputMaybe<Scalars['String']>;
  sequenceNo?: InputMaybe<Scalars['Int']>;
  /**
   * Side along with periodValue determines the innings the player period stats should be applied to.
   * For Eg: In Cricket,
   * A Player can have stats in both FIRST_INNINGS
   * If he bats in his team's FIRST_INNINGS and bowls in the other team's FIRST_INNINGS.
   * side property determines which period to apply the statistics on the graph.
   * side applicable to innings based games
   */
  side?: InputMaybe<Side>;
  statistics?: InputMaybe<Array<StatisticInput>>;
  status?: InputMaybe<PlayerPeriodStatusValue>;
  type?: InputMaybe<PeriodType>;
};

export type StatisticInput = {
  count?: InputMaybe<Scalars['Float']>;
  /** Time when a particular statistic entry was added, only relevant for football tenant for now */
  recordedTimeList?: InputMaybe<Array<StatisticRecordedTimeInfoInput>>;
  type: Scalars['String'];
};

export type StatisticRecordedTimeInfoInput = {
  /** Optional free-text field to capture additional information. */
  description?: InputMaybe<Scalars['String']>;
  minute?: InputMaybe<Scalars['Int']>;
  /**
   * In the case of a foul, this field will be selected from a list of options
   * against the tenant. If the options field is a non-empty array this field
   * should be mandatory, otherwise it is treated as optional.
   */
  offenceType?: InputMaybe<Scalars['String']>;
  stoppage?: InputMaybe<Scalars['Int']>;
};

export type GamePlayerPositionInput = {
  order?: InputMaybe<Scalars['Int']>;
  positionType: Scalars['String'];
};

export type MyTeamsGameUpdateResponse = {
  __typename?: 'MyTeamsGameUpdateResponse';
  discoverGame?: Maybe<DiscoverGame>;
  myTeamsGame?: Maybe<MyTeamsGame>;
};

export type MyTeamsGamePaymentRequestCreateInput = {
  gameID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
  side: Side;
  teamID: Scalars['ID'];
};

export type MyTeamsGamePaymentRequestCreateResponse = {
  __typename?: 'MyTeamsGamePaymentRequestCreateResponse';
  organisationID?: Maybe<Scalars['ID']>;
  organisationName?: Maybe<Scalars['ID']>;
  paymentRequestID?: Maybe<Scalars['ID']>;
};

export type MyTeamsGameTeamUpdateInput = {
  statistics?: InputMaybe<Array<StatisticInput>>;
  /**
   * Users view a MyTeamsGame in the context of a specific team.
   * READ/WRITE permissions will be based on that team.
   */
  teamContextID?: InputMaybe<Scalars['ID']>;
};

export type MyTeamsGameUpdateInput = {
  gameID: Scalars['ID'];
  overrideResult?: InputMaybe<Scalars['Boolean']>;
  profileID?: InputMaybe<Scalars['ID']>;
  result?: InputMaybe<GameResultInput>;
  statistics?: InputMaybe<GameStatisticsInput>;
  teamContextID?: InputMaybe<Scalars['ID']>;
};

export type GameResultInput = {
  away: GameTeamResultInput;
  home: GameTeamResultInput;
  inProgress?: InputMaybe<Scalars['Boolean']>;
  override?: InputMaybe<GameResultOverrideInput>;
  overrideOutcome?: InputMaybe<GameOutcomeOverrideType>;
};

export type GameTeamResultInput = {
  periodScores?: InputMaybe<Array<PeriodStatisticsInput>>;
  statistics: Array<StatisticInput>;
};

export type PeriodStatisticsInput = {
  closureStatus?: InputMaybe<ClosureStatus>;
  overtimeSequenceNo?: InputMaybe<Scalars['Int']>;
  period: Scalars['String'];
  statistics?: InputMaybe<Array<StatisticInput>>;
  teamEvents?: InputMaybe<Array<GameTeamPeriodEventInput>>;
  type?: InputMaybe<PeriodType>;
};

export type GameTeamPeriodEventInput = {
  playerID?: InputMaybe<Scalars['ID']>;
  sequenceNo?: InputMaybe<Scalars['Int']>;
  statistic?: InputMaybe<StatisticInput>;
};

export type GameResultOverrideInput = {
  away?: InputMaybe<Scalars['String']>;
  home?: InputMaybe<Scalars['String']>;
  outcome?: InputMaybe<GameOutcomeOverrideType>;
};

export enum GameOutcomeOverrideType {
  Abandoned = 'ABANDONED',
  AwayTeamWonByDisqualification = 'AWAY_TEAM_WON_BY_DISQUALIFICATION',
  AwayTeamWonByForfeit = 'AWAY_TEAM_WON_BY_FORFEIT',
  AwayTeamWonByPenaltyShootout = 'AWAY_TEAM_WON_BY_PENALTY_SHOOTOUT',
  Cancelled = 'CANCELLED',
  Dls = 'DLS',
  DoubleDisqualification = 'DOUBLE_DISQUALIFICATION',
  DoubleForfeit = 'DOUBLE_FORFEIT',
  HomeTeamWonByDisqualification = 'HOME_TEAM_WON_BY_DISQUALIFICATION',
  HomeTeamWonByForfeit = 'HOME_TEAM_WON_BY_FORFEIT',
  HomeTeamWonByPenaltyShootout = 'HOME_TEAM_WON_BY_PENALTY_SHOOTOUT'
}

export type GameStatisticsInput = {
  away?: InputMaybe<GameTeamStatisticsInput>;
  home?: InputMaybe<GameTeamStatisticsInput>;
  shared?: InputMaybe<Array<SharedPeriodStatisticsInput>>;
};

export type GameTeamStatisticsInput = {
  bestPlayers?: InputMaybe<Array<BestPlayerInput>>;
  coaches?: InputMaybe<Array<GameCoachStatisticsInput>>;
  coinTossWinningResult?: InputMaybe<CoinTossInput>;
  emergencyPlayers?: InputMaybe<Array<EmergencyPlayerInput>>;
  fillInCoaches?: InputMaybe<Array<GameCoachStatisticsInput>>;
  fillInPlayers?: InputMaybe<Array<GamePlayerStatisticsInput>>;
  manualBonusPoints?: InputMaybe<Scalars['Float']>;
  periods?: InputMaybe<Array<PeriodStatisticsInput>>;
  players?: InputMaybe<Array<GamePlayerStatisticsInput>>;
  statistics?: InputMaybe<Array<StatisticInput>>;
  volunteers?: InputMaybe<Array<GameVolunteerInput>>;
};

export type BestPlayerInput = {
  fillInPlayerID?: InputMaybe<Scalars['ID']>;
  participantID?: InputMaybe<Scalars['ID']>;
  ranking?: InputMaybe<Scalars['Int']>;
};

export type GameCoachStatisticsInput = {
  id: Scalars['ID'];
  order?: InputMaybe<Scalars['Int']>;
  role?: InputMaybe<CoachType>;
  selected?: InputMaybe<Scalars['Boolean']>;
  statistics?: InputMaybe<Array<StatisticInput>>;
};

export type CoinTossInput = {
  preference?: InputMaybe<CoinTossPreference>;
};

export enum CoinTossPreference {
  Bat = 'BAT',
  Bowl = 'BOWL'
}

export type EmergencyPlayerInput = {
  /**
   * ID related to the entity. It could be
   * 1. A Participant ID
   * 2. A Profile ID
   * What this is depends on type
   */
  playerID: Scalars['ID'];
  /** The player type that should be used. */
  type: EmergencyPlayerType;
};

export enum EmergencyPlayerType {
  GamePermitFillIn = 'GAME_PERMIT_FILL_IN',
  Participant = 'PARTICIPANT',
  ParticipantFillIn = 'PARTICIPANT_FILL_IN'
}

export type GameVolunteerInput = {
  fullName?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['Int']>;
  roleType?: InputMaybe<Scalars['String']>;
};

export type SharedPeriodStatisticsInput = {
  dismissalType?: InputMaybe<DismissalTypeValue>;
  displayOrder?: InputMaybe<Scalars['Int']>;
  periodValue?: InputMaybe<Scalars['String']>;
  players?: InputMaybe<Array<PlayerSharedStatisticRoleInput>>;
  status?: InputMaybe<SharedPlayerPeriodStatus>;
  type?: InputMaybe<SharedPeriodType>;
};

export type PlayerSharedStatisticRoleInput = {
  playerID: Scalars['ID'];
  role?: InputMaybe<PlayerRoleInSharedStatistic>;
  teamID: Scalars['ID'];
};

export type OrderSubmitInput = {
  billingAddress?: InputMaybe<BillingAddressInput>;
  /**
   * Charities need to be passed only for registration orders, purchase flow gets everything from the cart stored in dynamodb
   * Thus, if charities passed in the shop order, they will be ignored.
   */
  charities?: InputMaybe<Array<CharityInput>>;
  checkoutSession?: InputMaybe<CheckoutSessionInput>;
  deferredFees?: InputMaybe<Scalars['Boolean']>;
  externalVouchers?: InputMaybe<Array<ExternalVoucherInput>>;
  items: Array<OrderItem>;
  optedInToMarketing?: InputMaybe<Scalars['Boolean']>;
  orderPurchaseScope: PurchaseScopeInput;
  referringParticipantID?: InputMaybe<Scalars['ID']>;
  /**
   * ! If absent, we assume this is a shop order
   *
   * Also, this registration input will not be validated using registration policies. To skip registration policies
   * this registration input must be defined along with the registrationSkipPolicyChecks, as an indicator that the registration
   * input has been asserted prior to submitting the order.
   */
  registration?: InputMaybe<OrderRegistrationInput>;
  registrationSkipPolicyChecks?: InputMaybe<AssertHashInput>;
  selectedAdvancedFeeIDs?: InputMaybe<Array<Scalars['ID']>>;
  selectedMembershipIDs?: InputMaybe<Array<Scalars['ID']>>;
  sessionID?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<BillingAddressInput>;
  tenderAmount: Scalars['Int'];
  token?: InputMaybe<Scalars['String']>;
  voucherCodes: Array<Scalars['String']>;
};

export type BillingAddressInput = {
  address: Scalars['String'];
  country: Scalars['String'];
  postcode: Scalars['String'];
  state: Scalars['String'];
  suburb: Scalars['String'];
};

export type CheckoutSessionInput = {
  orderID?: InputMaybe<Scalars['String']>;
  sessionID: Scalars['String'];
  transactionID?: InputMaybe<Scalars['String']>;
};

export type OrderItem = {
  id: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type PurchaseScopeInput = {
  cartID?: InputMaybe<Scalars['String']>;
  /**
   * purchase scope allows distinguishing between registration, payment request, and shop orders
   * thus the field is required and is used in the core to determine the purchase scope
   */
  purchaseScope: PurchaseScope;
};

export enum PurchaseScope {
  PaymentRequest = 'PAYMENT_REQUEST',
  Registration = 'REGISTRATION',
  Shop = 'SHOP'
}

export type AssertHashInput = {
  hashKey?: InputMaybe<Scalars['String']>;
  /** timestampIso is the time when the hash key was generated. */
  timestampIso?: InputMaybe<Scalars['ISODateTime']>;
};

export type Order = Node & {
  __typename?: 'Order';
  amount: Price;
  id: Scalars['ID'];
  profile?: Maybe<Profile>;
  status?: Maybe<OrderStatus>;
};

export enum OrderStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  Pending = 'PENDING'
}

export type ParticipantRegisterInput = {
  answers?: InputMaybe<Array<RegistrationQuestionAnswerInput>>;
  childSafety?: InputMaybe<Array<FormInput>>;
  coachAccreditationValue?: InputMaybe<Scalars['String']>;
  coachingAccreditation?: InputMaybe<CoachingAccreditationType>;
  code: Scalars['String'];
  customFieldAnswers: Array<CustomFieldAnswerInput>;
  emergencyContact: EmergencyContactInput;
  groupID?: InputMaybe<Scalars['ID']>;
  guardians?: InputMaybe<Array<GuardianInput>>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: InputMaybe<Scalars['String']>;
  primaryProfileAddress?: InputMaybe<AddressInput>;
  profile: ParticipantProfileInput;
  profileQuestions?: InputMaybe<Array<FormInput>>;
  role: SeasonRegistrationUserType;
  school?: InputMaybe<SchoolInput>;
  schoolYear?: InputMaybe<Scalars['String']>;
  teamID?: InputMaybe<Scalars['ID']>;
  wwc?: InputMaybe<WwcParticipantInput>;
};

export type RegistrationQuestionAnswerInput = {
  answer: Scalars['String'];
  registrationQuestionID: Scalars['ID'];
};

export type ParticipantProfileInput = {
  address: AddressInput;
  countryOfBirth: Scalars['String'];
  dateOfBirth: Scalars['ISODate'];
  disabilities?: InputMaybe<Array<DisabilityTypes>>;
  disability?: InputMaybe<DisabilityType>;
  disabilityHelp?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  gender: Gender;
  genderSelfDescribe?: InputMaybe<Scalars['String']>;
  guardian1CountryOfBirth?: InputMaybe<Scalars['String']>;
  guardian2CountryOfBirth?: InputMaybe<Scalars['String']>;
  guardianBornOverseas?: InputMaybe<DiscloseOption>;
  hasDisability?: InputMaybe<DiscloseOption>;
  homeNumber?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  indigenousDescent?: InputMaybe<IndigenousDescent>;
  /** Profile visibility on public pages */
  isPublicVisible?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  mobileCountryAlphaCode?: InputMaybe<Scalars['String']>;
  mobileCountryCode?: InputMaybe<Scalars['String']>;
  mobileNumber?: InputMaybe<Scalars['MobileNumber']>;
  otherDisability?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  profileQuestionResponses?: InputMaybe<Array<ProfileResponseInput>>;
};

export enum DisabilityTypes {
  Adhd = 'ADHD',
  Autism = 'AUTISM',
  Blind = 'BLIND',
  CerebralPalsy = 'CEREBRAL_PALSY',
  Dcd = 'DCD',
  Deaf = 'DEAF',
  IntellectualDisability = 'INTELLECTUAL_DISABILITY',
  Other = 'OTHER',
  PhysicalDisability = 'PHYSICAL_DISABILITY'
}

export enum DisabilityType {
  Blind = 'BLIND',
  Deaf = 'DEAF',
  IntellectuallyImpaired = 'INTELLECTUALLY_IMPAIRED',
  None = 'NONE',
  PhysicalAmbulant = 'PHYSICAL_AMBULANT',
  PhysicalWheelchair = 'PHYSICAL_WHEELCHAIR'
}

export enum DiscloseOption {
  No = 'NO',
  NotSaying = 'NOT_SAYING',
  Yes = 'YES'
}

export enum IndigenousDescent {
  Aboriginal = 'ABORIGINAL',
  Both = 'BOTH',
  No = 'NO',
  NotSaying = 'NOT_SAYING',
  TorresStraightIslander = 'TORRES_STRAIGHT_ISLANDER'
}

export type ProfileResponseInput = {
  answer: Scalars['String'];
  questionID: Scalars['String'];
};

export type SchoolInput = {
  name: Scalars['String'];
  postcode?: InputMaybe<Scalars['String']>;
  schoolID?: InputMaybe<Scalars['ID']>;
  state?: InputMaybe<Scalars['String']>;
  suburb?: InputMaybe<Scalars['String']>;
};

export type WwcParticipantInput = {
  expiryDate: Scalars['ISODate'];
  number: Scalars['String'];
  stateOfIssue: Scalars['String'];
};

export type PostEmailUnsubscribeInput = {
  token?: InputMaybe<Scalars['String']>;
};

export type PostEmailUnsubscribe = {
  __typename?: 'PostEmailUnsubscribe';
  success?: Maybe<Scalars['Boolean']>;
};

export type SeasonRegistrationProductCartInput = {
  code: Scalars['String'];
  participantID: Scalars['ID'];
  products?: InputMaybe<Array<ProductCartInput>>;
};

export type SocialTeamRegistrationProductCartInput = {
  code: Scalars['String'];
  products?: InputMaybe<Array<ProductCartInput>>;
};

export type ClaimProfileInput = {
  claimProfileID: Scalars['ID'];
  id: Scalars['ID'];
  /**
   * This field is used only for self initiated profile claiming, specifically
   * for claiming profiles that should be classed as dependants under the account
   * holder who should be the same as the authenticated profile.
   *
   * This should be set to true when the following intent is expressed from the user:
   *
   * - The authenticated user (also known as the account holder thereafter) wants to
   *   claim a profile as a new dependent.
   * - The account holder knows the personal details of the dependent and submits them
   *   as override fields
   *
   * When this field is true, the `id` field of `ClaimProfileInput` should be the same
   * as the account holder's profile ID while the `claimProfileID` should be the disjointed
   * dependant profile ID.
   *
   * This field should not be provided and will be ignored if the `registrationCode`
   * is also supplied.
   */
  isClaimingNewDependant?: InputMaybe<Scalars['Boolean']>;
  method?: InputMaybe<ClaimMethod>;
  registrationCode?: InputMaybe<Scalars['String']>;
};

export enum ClaimMethod {
  Email = 'EMAIL',
  Mobile = 'MOBILE'
}

export type ClaimProfileOverrides = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type ProfileEmailChangeInput = {
  email: Scalars['String'];
};

export type ProfileEmailChangeResult = {
  __typename?: 'ProfileEmailChangeResult';
  id: Scalars['ID'];
  status?: Maybe<ProfileEmailStatus>;
};

export enum ProfileEmailStatus {
  Expired = 'EXPIRED',
  VerificationRequired = 'VERIFICATION_REQUIRED',
  Verified = 'VERIFIED'
}

export type ProfileInput = {
  countryOfBirth?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['ISODate']>;
  disabilities?: InputMaybe<Array<DisabilityTypes>>;
  disability?: InputMaybe<DisabilityType>;
  disabilityHelp?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  genderSelfDescribe?: InputMaybe<Scalars['String']>;
  guardian1CountryOfBirth?: InputMaybe<Scalars['String']>;
  guardian2CountryOfBirth?: InputMaybe<Scalars['String']>;
  guardianBornOverseas?: InputMaybe<DiscloseOption>;
  hasDisability?: InputMaybe<DiscloseOption>;
  homeNumber?: InputMaybe<Scalars['String']>;
  indigenousDescent?: InputMaybe<IndigenousDescent>;
  lastName?: InputMaybe<Scalars['String']>;
  mobileCountryAlphaCode?: InputMaybe<Scalars['String']>;
  mobileCountryCode?: InputMaybe<Scalars['String']>;
  mobileNumber?: InputMaybe<Scalars['MobileNumber']>;
  otherDisability?: InputMaybe<Scalars['String']>;
  preferredName?: InputMaybe<Scalars['String']>;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type RegisterPushNotificationTargetInput = {
  appId: Scalars['String'];
  appVariant: AppVariant;
  platform: Platform;
  token: Scalars['String'];
  version?: InputMaybe<Scalars['String']>;
};

export enum AppVariant {
  Afl = 'AFL',
  Basketball = 'BASKETBALL',
  Football = 'FOOTBALL',
  Netball = 'NETBALL'
}

export enum Platform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type PushNotificationTarget = {
  __typename?: 'PushNotificationTarget';
  appId: Scalars['String'];
  appVariant: AppVariant;
  platform: Platform;
  token: Scalars['String'];
  version?: Maybe<Scalars['String']>;
};

export type SavePushNotificationUserSettingsInput = {
  appId: Scalars['String'];
  pushNotificationSettings: PushNotificationUserSettingsInput;
};

export type PushNotificationUserSettingsInput = {
  disabledPushNotificationTypes: Array<PushNotificationType>;
};

/**
 * This is an upsert input which means if id is not provided it will create a new shop cart
 * Otherwise it will update the existing shop cart, with the given products. Hence id is not required
 */
export type ShopCartUpsertInput = {
  charities?: InputMaybe<Array<CharityInput>>;
  id?: InputMaybe<Scalars['ID']>;
  organisationCode: Scalars['String'];
  products?: InputMaybe<Array<ProductCartInput>>;
};

export type SocialTeamCreateInput = {
  code: Scalars['String'];
  customFieldAnswers: Array<CustomFieldAnswerInput>;
  gradeID: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  teamOriginID?: InputMaybe<Scalars['ID']>;
};

export type ConcussionClearanceInput = {
  doctor?: InputMaybe<Scalars['String']>;
  medicalFacilityAddress?: InputMaybe<Scalars['String']>;
  medicalFacilityContactNumber?: InputMaybe<Scalars['String']>;
  providerID?: InputMaybe<Scalars['String']>;
  returnDate?: InputMaybe<Scalars['ISODate']>;
};

export type UpdatePendingParticipantInput = {
  participantID?: InputMaybe<Scalars['ID']>;
  registrationReminderEligible?: InputMaybe<Scalars['Boolean']>;
};

export type WwcInput = {
  expiryDate: Scalars['ISODate'];
  number: Scalars['String'];
  stateOfIssue: Scalars['String'];
};

export type AccountCreateResult = {
  __typename?: 'AccountCreateResult';
  id: Scalars['ID'];
};

export enum BasicGender {
  All = 'ALL',
  DifferentIdentity = 'DIFFERENT_IDENTITY',
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  /** @deprecated gender diversity */
  Other = 'OTHER',
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum CheckoutSessionEntity {
  Participant = 'PARTICIPANT'
}

export type CompetitionFixture = {
  __typename?: 'CompetitionFixture';
  away: Scalars['String'];
  date: Scalars['String'];
  home: Scalars['String'];
};

export type ConcussionClearance = {
  __typename?: 'ConcussionClearance';
  doctor?: Maybe<Scalars['String']>;
  /** @deprecated use medicalFacilityAddress & medicalFacilityContactNumber */
  medicalFacility?: Maybe<Scalars['String']>;
  medicalFacilityAddress?: Maybe<Scalars['String']>;
  medicalFacilityContactNumber?: Maybe<Scalars['String']>;
  providerID?: Maybe<Scalars['String']>;
  returnDate?: Maybe<Scalars['ISODate']>;
};

export type ConcussionOutcome = Outcome & {
  __typename?: 'ConcussionOutcome';
  clearance?: Maybe<ConcussionClearance>;
  id: Scalars['ID'];
  incident?: Maybe<Incident>;
  note?: Maybe<Scalars['String']>;
};

export type ConditionalFields = {
  __typename?: 'ConditionalFields';
  fields?: Maybe<Array<Field>>;
  value?: Maybe<Scalars['String']>;
};

export enum CustomFieldApplicableRule {
  ClubAdminEditable = 'CLUB_ADMIN_EDITABLE',
  ParticipantToClubAnswerable = 'PARTICIPANT_TO_CLUB_ANSWERABLE',
  ParticipantToClubTeamAnswerable = 'PARTICIPANT_TO_CLUB_TEAM_ANSWERABLE',
  ParticipantToSeasonAnswerable = 'PARTICIPANT_TO_SEASON_ANSWERABLE',
  ParticipantToTeamAnswerable = 'PARTICIPANT_TO_TEAM_ANSWERABLE',
  TeamToSeasonAnswerable = 'TEAM_TO_SEASON_ANSWERABLE'
}

export type CustomFieldCreateInput = {
  applicableRoles: Array<CustomFieldApplicableRole>;
  applicableRules: Array<CustomFieldApplicableRule>;
  dropdownOptions?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  registrantCategories: Array<CustomFieldRegistrantCategory>;
  type: CustomFieldType;
};

export enum CustomFieldRegistrantCategory {
  Participant = 'PARTICIPANT',
  Team = 'TEAM'
}

export type CustomFieldReorderInput = {
  order: Scalars['Int'];
};

export type CustomFieldsFilter = {
  applicableRule?: InputMaybe<Array<CustomFieldApplicableRule>>;
  registrantCategories?: InputMaybe<Array<CustomFieldRegistrantCategory>>;
};

export type CustomFieldUpdateInput = {
  applicableRoles: Array<CustomFieldApplicableRole>;
  applicableRules: Array<CustomFieldApplicableRule>;
  dropdownOptions?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type DateTimeInput = {
  date: Scalars['ISODate'];
  time: Scalars['Naive24HourTime'];
};

export enum DiscountAmountType {
  Cents = 'CENTS',
  Percentage = 'PERCENTAGE'
}

export type DiscountCreateInput = {
  amount: Scalars['Int'];
  amountType: DiscountAmountType;
  discountType: DiscountType;
  enabled: Scalars['Boolean'];
  seasonID: Scalars['String'];
};

export enum DiscountType {
  FamilyMember = 'FAMILY_MEMBER'
}

export type DiscountUpdateInput = {
  amount: Scalars['Int'];
  amountType: DiscountAmountType;
  discountType: DiscountType;
  enabled: Scalars['Boolean'];
};

export type ExceptionDate = Node & {
  __typename?: 'ExceptionDate';
  fromDate: Scalars['ISODate'];
  id: Scalars['ID'];
  reason?: Maybe<Scalars['String']>;
  toDate: Scalars['ISODate'];
};

export type FieldAnswer = {
  field?: Maybe<Field>;
};

export type FieldInput = Field & {
  __typename?: 'FieldInput';
  hidden?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  required?: Maybe<Scalars['Boolean']>;
  type?: Maybe<FieldInputType>;
  value?: Maybe<Scalars['String']>;
};

export enum FieldInputType {
  Date = 'DATE',
  Text = 'TEXT'
}

export type FieldInputAnswer = FieldAnswer & {
  __typename?: 'FieldInputAnswer';
  answer: Scalars['String'];
  field?: Maybe<Field>;
};

export type FieldOption = {
  __typename?: 'FieldOption';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FieldSelect = Field & {
  __typename?: 'FieldSelect';
  conditionalFields?: Maybe<ConditionalFields>;
  hidden?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<FieldOption>>;
  required?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['String']>;
};

export type FieldSelectAnswer = FieldAnswer & {
  __typename?: 'FieldSelectAnswer';
  answer: FieldOption;
  field?: Maybe<Field>;
};

export type FillInCoach = {
  __typename?: 'FillInCoach';
  id: Scalars['ID'];
  name: Scalars['String'];
  role: CoachType;
};

export type FillInPlayer = {
  __typename?: 'FillInPlayer';
  id: Scalars['ID'];
  name: Scalars['String'];
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
};

export type FinalsTemplate = Node & {
  __typename?: 'FinalsTemplate';
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  numberOfRounds: Scalars['Int'];
  numberOfTeams: Scalars['Int'];
};

export type Fixture = {
  __typename?: 'Fixture';
  games?: Maybe<Array<Maybe<CompetitionFixture>>>;
  round: Scalars['String'];
};

export type GameCoachStatistics = {
  __typename?: 'GameCoachStatistics';
  order?: Maybe<Scalars['Int']>;
  participant: PossibleCoach;
  /** @deprecated use role */
  position: Scalars['String'];
  role?: Maybe<CoachType>;
  selected?: Maybe<Scalars['Boolean']>;
  statistics: Array<Statistic>;
};

export type PossibleCoach = FillInCoach | Participant;

export type GameDateAllocation = {
  __typename?: 'GameDateAllocation';
  date: Scalars['ISODate'];
  gamesUnallocated: Scalars['Int'];
  hasCourtConflict: Scalars['Boolean'];
};

export type GamePlayerStatistics = {
  __typename?: 'GamePlayerStatistics';
  participant: PossiblePlayer;
  periods?: Maybe<Array<PlayerPeriod>>;
  periodStatistics?: Maybe<Array<PlayerPeriodStatistics>>;
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: Maybe<Scalars['String']>;
  selected: Scalars['Boolean'];
  statistics: Array<Statistic>;
};

export type PossiblePlayer = FillInPlayer | Participant;

export type GamesSetResultsPayload = {
  __typename?: 'GamesSetResultsPayload';
  errors: Array<UserError>;
  games: Array<DiscoverGame>;
};

export type GradeReseedInput = {
  gradeID: Scalars['ID'];
  seed: Scalars['Int'];
  teamID: Scalars['ID'];
};

export type GradesFilter = {
  age?: InputMaybe<Scalars['String']>;
  day?: InputMaybe<DayOfTheWeek>;
  gender?: InputMaybe<GradeGender>;
  regradeable?: InputMaybe<Scalars['Boolean']>;
};

export enum IdentificationType {
  License = 'LICENSE',
  Passport = 'PASSPORT'
}

export enum ImageType {
  Jpg = 'jpg',
  Png = 'png'
}

export enum InvitationStatusValue {
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Redeemed = 'REDEEMED',
  Revoked = 'REVOKED'
}

export type MembershipFeeInput = {
  id: Scalars['ID'];
  organisationId: Scalars['ID'];
};

export enum MembershipType {
  Membership = 'MEMBERSHIP'
}

export type OrderNonceResult = {
  __typename?: 'OrderNonceResult';
  nonce: Scalars['String'];
};

export type OrganisationDeleteResult = Node & {
  __typename?: 'OrganisationDeleteResult';
  contactNumber: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  telCountryCode: Scalars['String'];
  type: OrganisationType;
};

export enum PeriodScoresDisplayType {
  ByPeriod = 'BY_PERIOD',
  EndOfPeriod = 'END_OF_PERIOD'
}

export enum PermitRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export enum ResultSource {
  Admin = 'ADMIN',
  LiveScoring = 'LIVE_SCORING'
}

export enum Role {
  ClubAdmin = 'CLUB_ADMIN',
  FullAccess = 'FULL_ACCESS',
  SuperAdmin = 'SUPER_ADMIN',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type RoundDate = {
  __typename?: 'RoundDate';
  date: Scalars['ISODate'];
  isExcluded: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RoundDates = {
  __typename?: 'RoundDates';
  dates?: Maybe<Array<RoundDate>>;
  firstDate: Scalars['String'];
  lastDate: Scalars['String'];
};

export enum RoundFrequency {
  Weekly = 'WEEKLY'
}

export enum SeasonInvitationStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type SeasonVenue = {
  __typename?: 'SeasonVenue';
  gamesAllocated: Scalars['Boolean'];
  venue: Venue;
};

export type SessionCreated = {
  __typename?: 'SessionCreated';
  token: Scalars['String'];
};

export type SessionFailed = {
  __typename?: 'SessionFailed';
  error: Scalars['String'];
};

export type SessionResult = SessionCreated | SessionFailed;

export type Slot = Node & {
  __typename?: 'Slot';
  allocation?: Maybe<SlotAllocation>;
  grade: DiscoverGrade;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SlotAllocation = {
  __typename?: 'SlotAllocation';
  court: Court;
  time: Scalars['Naive24HourTime'];
};

export type SlotGroup = {
  __typename?: 'SlotGroup';
  allocated: Scalars['Int'];
  day: TenantField;
  slots?: Maybe<Array<Slot>>;
  total: Scalars['Int'];
};

export type SocialTeamRegistrationInput = {
  additionalInfo?: InputMaybe<Scalars['String']>;
  endDate: TimeZoneDateTimeInput;
  fee: Scalars['Int'];
  gradeIDs: Array<Scalars['ID']>;
  pricingInfo?: InputMaybe<Scalars['String']>;
  showOrganisationTermsAndConditions: Scalars['Boolean'];
  startDate: TimeZoneDateTimeInput;
  visible?: InputMaybe<Scalars['Boolean']>;
};

export type TimeZoneDateTimeInput = {
  date: Scalars['ISODate'];
  time: Scalars['Naive24HourTime'];
  timezone: Scalars['String'];
};

export type SuspensionOutcome = Outcome & {
  __typename?: 'SuspensionOutcome';
  id: Scalars['ID'];
  incident?: Maybe<Incident>;
  note?: Maybe<Scalars['String']>;
};

export type SuspensionOutcomeInput = {
  endDate?: InputMaybe<Scalars['ISODate']>;
  gameCount?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['ISODate']>;
};

export type TeamEditInput = {
  ageGroup: Scalars['String'];
  gender: GradeGender;
  id: Scalars['ID'];
  name: Scalars['String'];
  teamIdentifier?: InputMaybe<Scalars['String']>;
};

export type TeamInput = {
  ageGroup: Scalars['String'];
  gender: GradeGender;
  name: Scalars['String'];
  organisationID: Scalars['ID'];
  seasonID: Scalars['ID'];
  teamIdentifier?: InputMaybe<Scalars['String']>;
};

export type TeamLimitStatus = {
  __typename?: 'TeamLimitStatus';
  limit?: Maybe<Scalars['Int']>;
  selected: Scalars['Int'];
};

export type TeamParticipantsAllocationInput = {
  participantIDs: Array<Scalars['ID']>;
  teamID: Scalars['ID'];
  type: SeasonRegistrationUserType;
};

export type TeamParticipantUnallocationInput = {
  participantID: Scalars['ID'];
  teamID: Scalars['ID'];
  type: SeasonRegistrationUserType;
};

export type TeamPlayerNumberInput = {
  participantID: Scalars['ID'];
  /**
   * Player number configuration is set in TenantConfiguration.playerNumberDisabled
   * Some tenants do not have player numbers and UI should be hidden
   */
  playerNumber?: InputMaybe<Scalars['String']>;
};

export type TeamsFilter = {
  allocated?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type TransactionsFilter = {
  fromDate?: InputMaybe<Scalars['ISODate']>;
  organisationID: Scalars['ID'];
  toDate?: InputMaybe<Scalars['ISODate']>;
};

export type VenueInput = {
  abbreviatedName: Scalars['String'];
  address: Scalars['String'];
  contactName?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['String']>;
  longitude?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postcode: Scalars['String'];
  state: Scalars['String'];
  suburb: Scalars['String'];
  timezone: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type VenueScheduleReportInput = {
  date: Scalars['ISODate'];
  organisationID: Scalars['ID'];
  venueID: Scalars['ID'];
};

export type Voucher = Node & {
  __typename?: 'Voucher';
  active: Scalars['Boolean'];
  amount: Price;
  code: Scalars['String'];
  id: Scalars['ID'];
  maxUsage: Scalars['Int'];
  name: Scalars['String'];
  totalUses: Scalars['Int'];
};

export type VoucherInput = {
  active: Scalars['Boolean'];
  amount: Scalars['Int'];
  maxUsage: Scalars['Int'];
  name: Scalars['String'];
};

export type SearchAddressesQueryVariables = Exact<{
  filter: SearchAddressesFilter;
}>;


export type SearchAddressesQuery = { __typename?: 'Query', searchAddresses: Array<string> };

export type AddressQueryVariables = Exact<{
  filter: Scalars['String'];
}>;


export type AddressQuery = { __typename?: 'Query', address?: { __typename?: 'AddressInfo', streetLine: string, suburb: string, state: string, postcode: string } | null };

export type AppBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type AppBannerQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', externalAppUrls?: Array<{ __typename?: 'UrlTenantField', name: string, value: string, url: string }> | null, outswingConfiguration?: { __typename?: 'OutswingConfiguration', value?: string | null } | null } | null };

export type AppFooterBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type AppFooterBannerQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', outswingConfiguration?: { __typename?: 'OutswingConfiguration', value?: string | null } | null } | null };

export type AppPromoBannerQueryVariables = Exact<{ [key: string]: never; }>;


export type AppPromoBannerQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', outswingConfiguration?: { __typename?: 'OutswingConfiguration', value?: string | null } | null } | null };

export type CheckoutSessionCreateMutationVariables = Exact<{
  input?: InputMaybe<CheckoutSessionCreateInput>;
}>;


export type CheckoutSessionCreateMutation = { __typename?: 'Mutation', checkoutSessionCreate: { __typename: 'Gr4vyCheckoutSession', id: string, expiryDate?: string | null, browser?: string | null } | { __typename: 'Gr4vyEmbedCheckoutSession', id: string, expiryDate?: string | null, embedToken?: string | null } | { __typename: 'StripeCheckoutSession' } };

export type GameViewQueryVariables = Exact<{
  gameId: Scalars['ID'];
  gameStatisticsFilter: GameStatisticsFilter;
}>;


export type GameViewQuery = { __typename?: 'Query', discoverGame?: { __typename?: 'DiscoverGame', id: string, alias?: string | null, date: string, dates?: Array<string> | null, publishLineup?: boolean | null, away: { __typename?: 'DiscoverTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, home: { __typename?: 'DiscoverTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', score?: number | null, gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', score?: number | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status: { __typename?: 'GameStatus', name: string, value: GameStatusType }, round: { __typename?: 'DiscoverRound', id: string, name: string, abbreviatedName: string, grade: { __typename?: 'DiscoverGrade', id: string, name: string, hideScores: boolean, hasPeriodScores?: boolean | null, lineupRemainsWhenGameStarted?: boolean | null, day?: { __typename?: 'TenantField', name: string, value: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } }, gameEvents: { __typename?: 'GameEvents', participantEvents: Array<{ __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }>, periodEvents: Array<{ __typename?: 'GameEventConfiguration', value: string }> }, periodScoresDisplayType?: { __typename?: 'TenantField', name: string, value: string } | null, periods: Array<{ __typename?: 'Period', shortName: string, value: PeriodValue }>, playerPoints?: { __typename?: 'PlayerPointsConfiguration', enforceTeamTotalCap?: boolean | null, teamPlayerPointsCap?: number | null, publicVisible?: boolean | null } | null, bestPlayers?: { __typename?: 'BestPlayersConfiguration', max?: number | null } | null, gameStatisticsConfiguration?: { __typename?: 'GameStatisticsConfiguration', gameStatistics?: Array<{ __typename?: 'GameStatisticConfiguration', type?: GameStatisticType | null, value?: string | null, pointValue?: number | null, applicableTo?: Array<GameActor> | null, required?: boolean | null, max?: number | null, glossary?: { __typename?: 'GameStatisticGlossary', default?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null, scoring?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null } | null }> | null } | null } }, allocation?: { __typename?: 'DiscoverAllocation', time: string, dateTimeList?: Array<{ __typename?: 'DateTime', date: string, time: string }> | null, court: { __typename?: 'DiscoverCourt', id: string, abbreviatedName: string, name: string, venue: { __typename?: 'DiscoverVenue', id: string, name: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string } } } | null, statistics?: { __typename?: 'DiscoverGameStatistics', home: { __typename?: 'DiscoverGameTeamStatistics', players: Array<{ __typename?: 'DiscoverPlayerStatistics', playerNumber?: string | null, playerPoints?: number | null, lineupOrder?: number | null, player?: { __typename?: 'DiscoverAnonymousParticipant', id?: string | null, name?: string | null, hasGamePermit?: boolean | null, hasSeasonPermit?: boolean | null } | { __typename?: 'DiscoverGamePermitFillInPlayer', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipant', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipantFillInPlayer', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverRegularFillInPlayer', id?: string | null, name?: string | null } | null, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null }> | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', positionType?: string | null, shortName?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, shortName?: string | null } | null }>, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null } }>, periods: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }>, emergencyPlayers?: Array<{ __typename?: 'DiscoverEmergencyPlayer', playerNumber?: string | null, playerPoints?: number | null, player?: { __typename?: 'DiscoverAnonymousParticipant', id?: string | null, name?: string | null, hasGamePermit?: boolean | null, hasSeasonPermit?: boolean | null } | { __typename?: 'DiscoverGamePermitFillInPlayer', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipant', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipantFillInPlayer', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, bestPlayers?: Array<{ __typename?: 'DiscoverBestPlayer', ranking?: number | null, participant?: { __typename?: 'DiscoverAnonymousParticipant', name?: string | null } | { __typename?: 'DiscoverParticipant', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null }, away: { __typename?: 'DiscoverGameTeamStatistics', players: Array<{ __typename?: 'DiscoverPlayerStatistics', playerNumber?: string | null, playerPoints?: number | null, lineupOrder?: number | null, player?: { __typename?: 'DiscoverAnonymousParticipant', id?: string | null, name?: string | null, hasGamePermit?: boolean | null, hasSeasonPermit?: boolean | null } | { __typename?: 'DiscoverGamePermitFillInPlayer', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipant', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipantFillInPlayer', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverRegularFillInPlayer', id?: string | null, name?: string | null } | null, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null }> | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', positionType?: string | null, shortName?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, shortName?: string | null } | null }>, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null } }>, periods: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }>, emergencyPlayers?: Array<{ __typename?: 'DiscoverEmergencyPlayer', playerNumber?: string | null, playerPoints?: number | null, player?: { __typename?: 'DiscoverAnonymousParticipant', id?: string | null, name?: string | null, hasGamePermit?: boolean | null, hasSeasonPermit?: boolean | null } | { __typename?: 'DiscoverGamePermitFillInPlayer', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipant', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipantFillInPlayer', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, bestPlayers?: Array<{ __typename?: 'DiscoverBestPlayer', ranking?: number | null, participant?: { __typename?: 'DiscoverAnonymousParticipant', name?: string | null } | { __typename?: 'DiscoverParticipant', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null }, shared?: Array<{ __typename?: 'SharedPeriodStatistics', type?: SharedPeriodType | null, status?: SharedPlayerPeriodStatus | null, side?: Side | null, dismissalType?: DismissalTypeValue | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, players?: Array<{ __typename?: 'PlayerSharedStatisticRole', playerID: string, teamID: string, role?: PlayerRoleInSharedStatistic | null }> | null }> | null } | null, gameType?: { __typename?: 'GameType', name?: string | null, value?: string | null, maxBattersPerInnings?: number | null, clockType?: ClockType | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null, emergencyPlayersSettings?: { __typename?: 'EmergencyPlayersSettings', enabled?: boolean | null } | null, playerPositionsSettings?: { __typename?: 'PlayerPositionsSettings', isInGamePositionsLineupVisible?: boolean | null } | null } | null, formation?: { __typename?: 'GameFormation', template?: FormationTemplate | null } | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, showPlayerPositionsInLineup?: boolean | null, showDuckIconInBattingTable?: boolean | null, statistics?: { __typename?: 'TenantStatistics', enabled: boolean } | null, periodType: Array<{ __typename?: 'TenantField', value: string }>, gameTypes?: Array<{ __typename?: 'GameTypeConfig', gameType: { __typename?: 'TenantField', value: string }, gameTypeFeatures?: { __typename?: 'GameTypeFeatures', lineupOrderingEnabled?: boolean | null } | null }> | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type GameViewGameTeamStatisticsFragmentFragment = { __typename?: 'DiscoverGameTeamStatistics', players: Array<{ __typename?: 'DiscoverPlayerStatistics', playerNumber?: string | null, playerPoints?: number | null, lineupOrder?: number | null, player?: { __typename?: 'DiscoverAnonymousParticipant', id?: string | null, name?: string | null, hasGamePermit?: boolean | null, hasSeasonPermit?: boolean | null } | { __typename?: 'DiscoverGamePermitFillInPlayer', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipant', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipantFillInPlayer', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverRegularFillInPlayer', id?: string | null, name?: string | null } | null, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null }> | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', positionType?: string | null, shortName?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, shortName?: string | null } | null }>, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null } }>, periods: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }>, emergencyPlayers?: Array<{ __typename?: 'DiscoverEmergencyPlayer', playerNumber?: string | null, playerPoints?: number | null, player?: { __typename?: 'DiscoverAnonymousParticipant', id?: string | null, name?: string | null, hasGamePermit?: boolean | null, hasSeasonPermit?: boolean | null } | { __typename?: 'DiscoverGamePermitFillInPlayer', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipant', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'DiscoverParticipantFillInPlayer', id?: string | null, hasSeasonPermit?: boolean | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, bestPlayers?: Array<{ __typename?: 'DiscoverBestPlayer', ranking?: number | null, participant?: { __typename?: 'DiscoverAnonymousParticipant', name?: string | null } | { __typename?: 'DiscoverParticipant', id?: string | null, profile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null };

export type OrderIdentifierGenerateMutationVariables = Exact<{ [key: string]: never; }>;


export type OrderIdentifierGenerateMutation = { __typename?: 'Mutation', orderIdentifierGenerate: string };

export type GradeAllRoundsQueryVariables = Exact<{
  gradeID: Scalars['ID'];
}>;


export type GradeAllRoundsQuery = { __typename?: 'Query', discoverGradeFixture: Array<{ __typename?: 'DiscoverRound', id: string, name: string, provisionalDates?: Array<string> | null, isFinalsRound: boolean, grade: { __typename?: 'DiscoverGrade', type?: GradeType | null, hideScores: boolean }, byes?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } }> | null, games: Array<{ __typename?: 'DiscoverGame', id: string, alias?: string | null, date: string, dates?: Array<string> | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, away: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, home: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status: { __typename?: 'GameStatus', name: string, value: GameStatusType }, allocation?: { __typename?: 'DiscoverAllocation', time: string, dateTimeList?: Array<{ __typename?: 'DateTime', date: string, time: string }> | null, court: { __typename?: 'DiscoverCourt', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, venue: { __typename?: 'DiscoverVenue', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string, country: string } } } | null, gameType?: { __typename?: 'GameType', name?: string | null, value?: string | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null } | null }> }>, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, gradeTypes?: Array<{ __typename?: 'GradeTypeConfig', value?: GradeType | null, isAllPlay?: boolean | null, features?: { __typename?: 'GradeTypeFeatures', hasRounds?: boolean | null, hasSeasonStats?: boolean | null, hasCareerStats?: boolean | null, hasGameStats?: boolean | null, hasFixture?: boolean | null, hasLadder?: boolean | null } | null }> | null } | null };

export type GradeRoundsQueryVariables = Exact<{
  gradeID: Scalars['ID'];
}>;


export type GradeRoundsQuery = { __typename?: 'Query', discoverGrade?: { __typename?: 'DiscoverGrade', id: string, name: string, type?: GradeType | null, hideScores: boolean, rounds: Array<{ __typename?: 'DiscoverRound', id: string, name: string, abbreviatedName: string, current: boolean, number: number, isFinalsRound: boolean, provisionalDates?: Array<string> | null }>, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, gradeTypes?: Array<{ __typename?: 'GradeTypeConfig', value?: GradeType | null, isAllPlay?: boolean | null, features?: { __typename?: 'GradeTypeFeatures', hasRounds?: boolean | null, hasSeasonStats?: boolean | null, hasCareerStats?: boolean | null, hasGameStats?: boolean | null, hasFixture?: boolean | null, hasLadder?: boolean | null } | null }> | null } | null };

export type DiscoverFixtureByRoundQueryVariables = Exact<{
  roundID: Scalars['ID'];
}>;


export type DiscoverFixtureByRoundQuery = { __typename?: 'Query', discoverFixtureByRound: { __typename?: 'DiscoverRoundFixture', byes: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } }>, games: Array<{ __typename?: 'DiscoverGame', id: string, alias?: string | null, date: string, dates?: Array<string> | null, isStale?: boolean | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, away: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, home: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status: { __typename?: 'GameStatus', name: string, value: GameStatusType }, allocation?: { __typename?: 'DiscoverAllocation', time: string, dateTimeList?: Array<{ __typename?: 'DateTime', date: string, time: string }> | null, court: { __typename?: 'DiscoverCourt', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, venue: { __typename?: 'DiscoverVenue', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string, country: string } } } | null, gameType?: { __typename?: 'GameType', name?: string | null, value?: string | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null } | null }> } };

export type GroupLabelFragment = { __typename?: 'Group', id: string, name: string, days: Array<DayOfTheWeek>, sessionCount?: number | null, gender?: GradeGender | null, startDate?: string | null, sessionStartTime?: string | null, sessionEndTime?: string | null, daySessions?: Array<{ __typename?: 'DaySession', day: DayOfTheWeek, startTime?: string | null, endTime?: string | null }> | null, playingSurface?: { __typename?: 'PlayingSurface', id: string, name: string, venue: { __typename?: 'Venue', id: string, name: string } } | null };

export type SearchRegisteredPlayerQueryVariables = Exact<{
  filter: MyTeamsParticipantsFilter;
}>;


export type SearchRegisteredPlayerQuery = { __typename?: 'Query', myTeamsParticipants?: { __typename?: 'MyTeamsParticipantList', result?: Array<{ __typename?: 'MyTeamsParticipant', id: string, playerPoints?: number | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, teams?: Array<{ __typename?: 'MyTeamsTeam', id: string, name: string }> | null }> | null } | null };

export type ValidateGameLineupQueryVariables = Exact<{
  input: GameTeamLineupValidateInput;
}>;


export type ValidateGameLineupQuery = { __typename?: 'Query', gameTeamLineupValidate?: Array<{ __typename?: 'GameTeamLineupValidateResult', entityID: string, errors?: Array<{ __typename?: 'GameTeamLineupValidateError', value?: GameTeamLineupErrorType | null, message?: string | null }> | null }> | null };

export type GameTeamAwardVotesUpdateMutationVariables = Exact<{
  input: GameTeamAwardVotesUpdateInput;
}>;


export type GameTeamAwardVotesUpdateMutation = { __typename?: 'Mutation', gameTeamAwardVotesUpdate?: { __typename?: 'GameTeamAward', isOpen?: boolean | null, configuration?: { __typename?: 'TeamAwardConfiguration', awardName?: string | null, highestVote?: number | null, totalVoters?: number | null } | null, voteSlips?: Array<{ __typename?: 'GameTeamAwardVoteSlip', voterName?: string | null, voterNumber?: number | null }> | null } | null };

export type MyTeamsGameManageQueryVariables = Exact<{
  gameId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
  teamContextId?: InputMaybe<Scalars['ID']>;
  gameStatisticsFilter: GameStatisticsFilter;
}>;


export type MyTeamsGameManageQuery = { __typename?: 'Query', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, date?: string | null, hasManagementAccess?: boolean | null, startDateTime?: string | null, hasOvertime?: boolean | null, away?: { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null } | null, home?: { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null } | null, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status?: { __typename?: 'GameStatus', name: string, value: GameStatusType } | null, round?: { __typename?: 'MyTeamsRound', id: string, name: string, abbreviatedName: string, grade: { __typename?: 'MyTeamsGrade', id: string, name: string, hideScores: boolean, hasPeriodScores?: boolean | null, day?: { __typename?: 'TenantField', name: string, value: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } }, gameEvents: { __typename?: 'GameEvents', participantEvents: Array<{ __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }>, periodEvents: Array<{ __typename?: 'GameEventConfiguration', label: string, shortName: string, value: string, pointValue?: number | null }>, teamEvents: Array<{ __typename?: 'GameEventConfiguration', label: string, value: string, pointValue?: number | null, shortName: string }> }, periodScoresDisplayType?: { __typename?: 'TenantField', name: string, value: string } | null, periods: Array<{ __typename?: 'Period', label: string, shortName: string, value: PeriodValue }>, playerPoints?: { __typename?: 'PlayerPointsConfiguration', enforceTeamTotalCap?: boolean | null, teamPlayerPointsCap?: number | null } | null, bestPlayers?: { __typename?: 'BestPlayersConfiguration', max?: number | null } | null, gameStatisticsConfiguration?: { __typename?: 'GameStatisticsConfiguration', gameStatistics?: Array<{ __typename?: 'GameStatisticConfiguration', type?: GameStatisticType | null, value?: string | null, pointValue?: number | null, applicableTo?: Array<GameActor> | null, required?: boolean | null, max?: number | null, glossary?: { __typename?: 'GameStatisticGlossary', default?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null, scoring?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null } | null }> | null } | null } } | null, allocation?: { __typename?: 'DiscoverAllocation', time: string, court: { __typename?: 'DiscoverCourt', id: string, abbreviatedName: string, name: string, venue: { __typename?: 'DiscoverVenue', id: string, name: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string } } } | null, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, shared?: Array<{ __typename?: 'SharedPeriodStatistics', type?: SharedPeriodType | null, status?: SharedPlayerPeriodStatus | null, side?: Side | null, dismissalType?: DismissalTypeValue | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, players?: Array<{ __typename?: 'PlayerSharedStatisticRole', playerID: string, teamID: string, role?: PlayerRoleInSharedStatistic | null }> | null }> | null } | null, managementAuthorisation?: { __typename?: 'GameManagementAuthorisation', gameSheet?: boolean | null, resultAndPeriodScores?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, home?: { __typename?: 'GameManagementTeamAuthorisation', lineUp?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, stats?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null } | null, away?: { __typename?: 'GameManagementTeamAuthorisation', lineUp?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, stats?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null } | null } | null, clubScoringAccess?: { __typename?: 'GameClubScoringAccess', temporaryAccessEnabled?: boolean | null, endDateTime?: string | null } | null, gameType?: { __typename?: 'GameType', value?: string | null, overs?: number | null, hasSuperOver?: boolean | null, maxBattersPerInnings?: number | null, hasManualBonusPoints?: boolean | null, manualBonusPoints?: Array<number> | null, periodLength?: number | null, playerPositionsSettings?: { __typename?: 'PlayerPositionsSettings', enabled?: boolean | null, enforcePositions?: boolean | null, isInGamePositionsLineupVisible?: boolean | null } | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null, emergencyPlayersSettings?: { __typename?: 'EmergencyPlayersSettings', enabled?: boolean | null, max?: number | null, min?: number | null, includeInLineupLimit?: boolean | null } | null, lineupLimits?: { __typename?: 'LineupLimits', players?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, coaches?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, hasVolunteerRoles: boolean, canGenerateGameSheets?: boolean | null, showDuckIconInBattingTable?: boolean | null, volunteerRoles?: Array<{ __typename?: 'VolunteerRoleField', label: string, number: number, roleType: string }> | null, playerPositions?: Array<{ __typename?: 'PlayerPositionOption', label?: string | null, shortName?: string | null, positionType?: string | null, lineupMax?: number | null }> | null, playerDismissalTypes?: Array<{ __typename?: 'DismissalType', name?: string | null, value?: DismissalTypeValue | null }> | null, gameTypes?: Array<{ __typename?: 'GameTypeConfig', gameType: { __typename?: 'TenantField', name: string, value: string }, closureStatusOptions?: Array<{ __typename?: 'ClosureStatusOption', name?: string | null, value?: ClosureStatus | null }> | null, gameOutcomeOverride?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null, possibleGameOutcomesMap?: Array<{ __typename?: 'PossibleGameOutcomeMap', win?: string | null, labelWin?: string | null, loss?: string | null, labelLoss?: string | null }> | null, gameTypeFeatures?: { __typename?: 'GameTypeFeatures', lineupOrderingEnabled?: boolean | null, editIndividualPlayerStatistics?: boolean | null } | null }> | null, captainOptions?: Array<{ __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null }> | null, offenceTypeOptions?: Array<{ __typename?: 'OffenceTypeOption', value: string, description?: string | null, applicableTo?: Array<string> | null }> | null, outswingConfiguration?: { __typename?: 'OutswingConfiguration', name?: string | null } | null } | null };

export type MyTeamsGamePlayerUpdateFragment = { __typename?: 'MyTeamsGame', id: string, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null };

export type GamePlayerUpdateMutationVariables = Exact<{
  gameID: Scalars['ID'];
  input: MyTeamsGamePlayerUpdateInput;
}>;


export type GamePlayerUpdateMutation = { __typename?: 'Mutation', myTeamsGamePlayerUpdate?: { __typename?: 'MyTeamsGameUpdateResponse', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null } | null } | null };

export type GameFillinPlayerUpdateMutationVariables = Exact<{
  gameID: Scalars['ID'];
  input: MyTeamsGamePlayerUpdateInput;
}>;


export type GameFillinPlayerUpdateMutation = { __typename?: 'Mutation', myTeamsGameFillInPlayerUpdate?: { __typename?: 'MyTeamsGameUpdateResponse', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null } | null } | null };

export type GameTeamUpdateMutationVariables = Exact<{
  gameID: Scalars['ID'];
  side: Side;
  input: MyTeamsGameTeamUpdateInput;
}>;


export type GameTeamUpdateMutation = { __typename?: 'Mutation', myTeamsGameTeamUpdate?: { __typename?: 'MyTeamsGameUpdateResponse', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null } | null } | null };

export type OrganisationPageWrapperQueryVariables = Exact<{
  orgCode: Scalars['String'];
}>;


export type OrganisationPageWrapperQuery = { __typename?: 'Query', discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type OrganisationPageWrapperNewsQueryVariables = Exact<{
  orgCode: Scalars['ID'];
}>;


export type OrganisationPageWrapperNewsQuery = { __typename?: 'Query', discoverOrganisationPosts?: { __typename?: 'DiscoverOrganisationPosts', meta?: { __typename?: 'SearchResultMeta', totalRecords: number } | null } | null };

export type ProfileQuestionsUpdateMutationVariables = Exact<{
  profileID: Scalars['ID'];
  input: Array<FormInput>;
}>;


export type ProfileQuestionsUpdateMutation = { __typename?: 'Mutation', profileQuestionsUpdate?: { __typename?: 'FieldSet', name?: string | null, label?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null };

export type ChildSafetyUpdateMutationVariables = Exact<{
  input: FieldSetInput;
}>;


export type ChildSafetyUpdateMutation = { __typename?: 'Mutation', childSafetyUpdate?: { __typename?: 'FieldSet', name?: string | null, label?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null };

export type CoachingAccreditationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CoachingAccreditationsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, coachingAccreditation?: { __typename?: 'CoachingAccreditation', id: string, level: { __typename?: 'TenantField', name: string, value: string } } | null, dependants?: Array<{ __typename?: 'Profile', id: string, coachingAccreditation?: { __typename?: 'CoachingAccreditation', id: string, level: { __typename?: 'TenantField', name: string, value: string } } | null }> | null } | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, seasonRegistration: { __typename?: 'SeasonRegistrationConfiguration', coachingAccreditationConfig?: { __typename?: 'CoachingAccreditationConfiguration', selfSubmit?: boolean | null, accreditations?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } | null } } | null };

export type CoachingAccreditationUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CoachingAccreditationInput;
}>;


export type CoachingAccreditationUpdateMutation = { __typename?: 'Mutation', coachingAccreditationUpdate: { __typename?: 'CoachingAccreditation', id: string, level: { __typename?: 'TenantField', name: string, value: string } } };

export type UnlinkExternalAccountMutationVariables = Exact<{
  input: LinkExternalAccountInput;
}>;


export type UnlinkExternalAccountMutation = { __typename?: 'Mutation', unlinkExternalAccount: { __typename?: 'ExternalAccount', tenantSlug: string, externalAccountID: string } };

export type ProfileDisabilityUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProfileInput;
}>;


export type ProfileDisabilityUpdateMutation = { __typename?: 'Mutation', profileUpdate?: { __typename?: 'Profile', id: string, otherDisability?: string | null, disabilityHelp?: string | null, hasDisability?: { __typename?: 'TenantField', name: string, value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } | null };

export type EmergencyContactUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: EmergencyContactInput;
}>;


export type EmergencyContactUpdateMutation = { __typename?: 'Mutation', emergencyContactUpdate?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } } | null };

export type GuardianDetailsFragment = { __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null };

export type GuardianCreateMutationVariables = Exact<{
  profileID: Scalars['ID'];
  input: GuardianInput;
}>;


export type GuardianCreateMutation = { __typename?: 'Mutation', guardianCreate: { __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } };

export type GuardianUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: GuardianInput;
}>;


export type GuardianUpdateMutation = { __typename?: 'Mutation', guardianUpdate: { __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } };

export type GuardianDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GuardianDeleteMutation = { __typename?: 'Mutation', guardianDelete: { __typename?: 'Guardian', id: string } };

export type ProfileUpdateMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProfileInput;
}>;


export type ProfileUpdateMutation = { __typename?: 'Mutation', profileUpdate?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | null };

export type ProfileAndAddressUpdateMutationVariables = Exact<{
  profileID: Scalars['ID'];
  profileInput: ProfileInput;
  addressID: Scalars['ID'];
  addressInput: AddressInput;
}>;


export type ProfileAndAddressUpdateMutation = { __typename?: 'Mutation', profileUpdate?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | null, addressUpdate: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } };

export type UpdatePrivacyMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ProfileInput;
}>;


export type UpdatePrivacyMutation = { __typename?: 'Mutation', profileUpdate?: { __typename?: 'Profile', id: string, visible: boolean } | null };

export type CurrentAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', number: string, countryCode: { __typename?: 'TenantField', value: string } } | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }> } | null } | null };

export type ShopCartFragmentFragment = { __typename?: 'ShopCart', id: string, items?: Array<{ __typename?: 'CartItem', fee: { __typename?: 'MembershipAdvancedFee' } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productID: string, productVariantID: string, productType: ProductType, fulfilmentMethod: FulfilmentMethod, fulfilmentProvider?: string | null, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, images?: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }> | null, categoryPairs?: Array<{ __typename?: 'CategoryPair', id: string, name?: string | null, value?: string | null }> | null, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee' } | { __typename?: 'TeamFee' } }> | null, availableCharities?: Array<{ __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }> | null, totals?: { __typename?: 'CartTotals', totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, selectedCharities?: Array<{ __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null } | null, productsAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null };

export type GetShopCartQueryVariables = Exact<{
  input: ShopCartArgs;
}>;


export type GetShopCartQuery = { __typename?: 'Query', shopCart?: { __typename?: 'ShopCart', id: string, items?: Array<{ __typename?: 'CartItem', fee: { __typename?: 'MembershipAdvancedFee' } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productID: string, productVariantID: string, productType: ProductType, fulfilmentMethod: FulfilmentMethod, fulfilmentProvider?: string | null, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, images?: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }> | null, categoryPairs?: Array<{ __typename?: 'CategoryPair', id: string, name?: string | null, value?: string | null }> | null, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee' } | { __typename?: 'TeamFee' } }> | null, availableCharities?: Array<{ __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }> | null, totals?: { __typename?: 'CartTotals', totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, selectedCharities?: Array<{ __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null } | null, productsAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null } | null };

export type IncidentFormSelectionsQueryVariables = Exact<{
  teamID: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
}>;


export type IncidentFormSelectionsQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, season: { __typename?: 'DiscoverSeason', id: string, name: string }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null, myTeamsTeam?: { __typename?: 'MyTeamsTeam', id: string, teamPlayers?: Array<{ __typename?: 'MyTeamsTeamPlayer', participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null }> | null } | null };

export type MyTeamsPreviousLineupQueryVariables = Exact<{
  gameId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
  teamContextId?: InputMaybe<Scalars['ID']>;
}>;


export type MyTeamsPreviousLineupQuery = { __typename?: 'Query', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', previousRoundLineup?: { __typename?: 'MyTeamsPreviousRoundGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsPreviousRoundGameTeamPlayer', playerPoints?: number | null, playerNumber?: string | null, lineupOrder?: number | null, player?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', previousRoundLineup?: { __typename?: 'MyTeamsPreviousRoundGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsPreviousRoundGameTeamPlayer', playerPoints?: number | null, playerNumber?: string | null, lineupOrder?: number | null, player?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null } | null } | null } | null } | null };

export type CountryCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryCodesQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, countryCodes: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type TextCustomFieldDetailsFragment = { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } };

export type DropdownCustomFieldDetailsFragment = { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } };

export type RecursiveDropdownCustomFieldsDetailsFragment = { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } };

export type ExternalAccountsFragmentFragment = { __typename?: 'Profile', externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }> };

export type GetLinkedExternalAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLinkedExternalAccountsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }> } | null } | null };

export type GetParticipantTypeQueryVariables = Exact<{
  participantID: Scalars['ID'];
}>;


export type GetParticipantTypeQuery = { __typename?: 'Query', participant: { __typename?: 'Participant', id: string, type: string } };

export type ProfilePersonalDetailsFragment = { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null };

export type ProfileDisabilityDetailsFragment = { __typename?: 'Profile', id: string, otherDisability?: string | null, disabilityHelp?: string | null, hasDisability?: { __typename?: 'TenantField', name: string, value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null };

export type ProfileOverviewFragment = { __typename?: 'Profile', visible: boolean, id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, otherDisability?: string | null, disabilityHelp?: string | null, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } } | null, guardians?: Array<{ __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null }> | null, dependants?: Array<{ __typename?: 'Profile', id: string, firstName: string, lastName: string, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null }> | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }>, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, hasDisability?: { __typename?: 'TenantField', name: string, value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null };

export type ProfileTenantConfigurationFragment = { __typename?: 'TenantConfiguration', seasonRegistration: { __typename?: 'SeasonRegistrationConfiguration', indigenousDescent: Array<{ __typename?: 'TenantField', name: string, value: string }>, disabilities: Array<{ __typename?: 'TenantField', name: string, value: string }> }, countries: Array<{ __typename?: 'TenantField', name: string, value: string }>, countryCodes: Array<{ __typename?: 'TenantField', name: string, value: string }>, discloseOptions: Array<{ __typename?: 'TenantField', name: string, value: string }> };

export type ProfileConfigurationFragment = { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null, externalAccountLinking?: Array<{ __typename?: 'ExternalAccountLinkingWithTenant', tenantSlug?: string | null, config?: { __typename?: 'ExternalAccountLinking', displayName?: string | null, profilePageInfoText?: string | null, logoURL?: string | null, externalURL?: string | null, allowParticipantToUnlink?: boolean | null, shouldLinkSSOInRegistrationFlow?: boolean | null } | null }> | null };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', visible: boolean, id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, otherDisability?: string | null, disabilityHelp?: string | null, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } } | null, guardians?: Array<{ __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null }> | null, dependants?: Array<{ __typename?: 'Profile', id: string, firstName: string, lastName: string, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null }> | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }>, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, hasDisability?: { __typename?: 'TenantField', name: string, value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', seasonRegistration: { __typename?: 'SeasonRegistrationConfiguration', indigenousDescent: Array<{ __typename?: 'TenantField', name: string, value: string }>, disabilities: Array<{ __typename?: 'TenantField', name: string, value: string }> }, countries: Array<{ __typename?: 'TenantField', name: string, value: string }>, countryCodes: Array<{ __typename?: 'TenantField', name: string, value: string }>, discloseOptions: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null, configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null, externalAccountLinking?: Array<{ __typename?: 'ExternalAccountLinkingWithTenant', tenantSlug?: string | null, config?: { __typename?: 'ExternalAccountLinking', displayName?: string | null, profilePageInfoText?: string | null, logoURL?: string | null, externalURL?: string | null, allowParticipantToUnlink?: boolean | null, shouldLinkSSOInRegistrationFlow?: boolean | null } | null }> | null } };

export type DependantProfileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DependantProfileQuery = { __typename?: 'Query', dependantProfile?: { __typename?: 'Profile', visible: boolean, id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, otherDisability?: string | null, disabilityHelp?: string | null, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } } | null, guardians?: Array<{ __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null }> | null, dependants?: Array<{ __typename?: 'Profile', id: string, firstName: string, lastName: string, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null }> | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }>, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, hasDisability?: { __typename?: 'TenantField', name: string, value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', seasonRegistration: { __typename?: 'SeasonRegistrationConfiguration', indigenousDescent: Array<{ __typename?: 'TenantField', name: string, value: string }>, disabilities: Array<{ __typename?: 'TenantField', name: string, value: string }> }, countries: Array<{ __typename?: 'TenantField', name: string, value: string }>, countryCodes: Array<{ __typename?: 'TenantField', name: string, value: string }>, discloseOptions: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null, configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null, externalAccountLinking?: Array<{ __typename?: 'ExternalAccountLinkingWithTenant', tenantSlug?: string | null, config?: { __typename?: 'ExternalAccountLinking', displayName?: string | null, profilePageInfoText?: string | null, logoURL?: string | null, externalURL?: string | null, allowParticipantToUnlink?: boolean | null, shouldLinkSSOInRegistrationFlow?: boolean | null } | null }> | null } };

export type RegistrationOrganisationDetailsFragment = { __typename?: 'DiscoverOrganisation', id: string, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> };

export type GetRegistrationQueryVariables = Exact<{
  code: Scalars['String'];
  role?: InputMaybe<SeasonRegistrationUserType>;
  skipTenantConfig: Scalars['Boolean'];
}>;


export type GetRegistrationQuery = { __typename?: 'Query', registrationSettings?: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, registrationCode: string, deferredFees?: boolean | null, deferredFeesDueDate?: string | null, visible?: boolean | null, startDate: { __typename?: 'TimeZoneDateTime', date: string, time: string, timezone: string }, endDate: { __typename?: 'TimeZoneDateTime', date: string, time: string, timezone: string }, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } } | { __typename?: 'ProgramSeason', id: string, name: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> }, products?: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number }, categoryPairs?: Array<{ __typename?: 'ProductVariantPair', id: string, category: { __typename?: 'ProductCategory', id: string, name: string }, option: { __typename?: 'ProductCategoryOption', id: string, name: string } }> | null }>, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, options: Array<{ __typename?: 'ProductCategoryOption', id: string, name: string }> }>, customFields: Array<{ __typename?: 'ProductCustomField', id: string, question: string, type: CustomFieldType, dropdownOptions?: Array<{ __typename?: 'ProductDropdownOption', id: string, label: string }> | null, option?: { __typename?: 'ProductCustomFieldOption', category: { __typename?: 'ProductCategory', id: string }, option: { __typename?: 'ProductCategoryOption', id: string } } | null }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }>, registrationSettings?: { __typename?: 'ProductRegistrationSettings', required: boolean, maxQuantity?: number | null } | null }> | null } | { __typename?: 'DiscoverSocialTeamRegistration', id: string, registrationCode: string, visible?: boolean | null, startDate: { __typename?: 'TimeZoneDateTime', date: string, time: string, timezone: string }, endDate: { __typename?: 'TimeZoneDateTime', date: string, time: string, timezone: string }, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } }, grades: Array<{ __typename?: 'DiscoverGrade', id: string, name: string }>, products?: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number }, categoryPairs?: Array<{ __typename?: 'ProductVariantPair', id: string, category: { __typename?: 'ProductCategory', id: string, name: string }, option: { __typename?: 'ProductCategoryOption', id: string, name: string } }> | null }>, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, options: Array<{ __typename?: 'ProductCategoryOption', id: string, name: string }> }>, customFields: Array<{ __typename?: 'ProductCustomField', id: string, question: string, type: CustomFieldType, dropdownOptions?: Array<{ __typename?: 'ProductDropdownOption', id: string, label: string }> | null, option?: { __typename?: 'ProductCustomFieldOption', category: { __typename?: 'ProductCategory', id: string }, option: { __typename?: 'ProductCategoryOption', id: string } } | null }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }>, registrationSettings?: { __typename?: 'ProductRegistrationSettings', required: boolean, maxQuantity?: number | null } | null }> | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, stripePublicKey?: string | null, sport?: { __typename?: 'SportConfiguration', name: string } | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }>, externalAccountLinking?: { __typename?: 'ExternalAccountLinking', enabled: boolean, authUri?: string | null, clientID?: string | null, redirectUri?: string | null, shouldLinkSSOInRegistrationFlow?: boolean | null } | null } | null };

export type TeamQueryVariables = Exact<{
  teamId: Scalars['ID'];
}>;


export type TeamQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string } | null };

type MyTeamsPossibleTeamFragment_MyTeamsTeam_Fragment = { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } };

type MyTeamsPossibleTeamFragment_ProvisionalTeam_Fragment = { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null };

export type MyTeamsPossibleTeamFragmentFragment = MyTeamsPossibleTeamFragment_MyTeamsTeam_Fragment | MyTeamsPossibleTeamFragment_ProvisionalTeam_Fragment;

export type MyTeamsGameTeamStatisticsFragmentFragment = { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null };

export type MyTeamsGameTeamFragmentFragment = { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null };

export type MyTeamsPreviousLineupFragmentFragment = { __typename?: 'MyTeamsGameTeam', previousRoundLineup?: { __typename?: 'MyTeamsPreviousRoundGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsPreviousRoundGameTeamPlayer', playerPoints?: number | null, playerNumber?: string | null, lineupOrder?: number | null, player?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null } | null };

export type MyTeamsGameDetailsFragmentFragment = { __typename?: 'MyTeamsGame', id: string, date?: string | null, hasManagementAccess?: boolean | null, startDateTime?: string | null, hasOvertime?: boolean | null, away?: { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null } | null, home?: { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null } | null, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status?: { __typename?: 'GameStatus', name: string, value: GameStatusType } | null, round?: { __typename?: 'MyTeamsRound', id: string, name: string, abbreviatedName: string, grade: { __typename?: 'MyTeamsGrade', id: string, name: string, hideScores: boolean, hasPeriodScores?: boolean | null, day?: { __typename?: 'TenantField', name: string, value: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } }, gameEvents: { __typename?: 'GameEvents', participantEvents: Array<{ __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }>, periodEvents: Array<{ __typename?: 'GameEventConfiguration', label: string, shortName: string, value: string, pointValue?: number | null }>, teamEvents: Array<{ __typename?: 'GameEventConfiguration', label: string, value: string, pointValue?: number | null, shortName: string }> }, periodScoresDisplayType?: { __typename?: 'TenantField', name: string, value: string } | null, periods: Array<{ __typename?: 'Period', label: string, shortName: string, value: PeriodValue }>, playerPoints?: { __typename?: 'PlayerPointsConfiguration', enforceTeamTotalCap?: boolean | null, teamPlayerPointsCap?: number | null } | null, bestPlayers?: { __typename?: 'BestPlayersConfiguration', max?: number | null } | null, gameStatisticsConfiguration?: { __typename?: 'GameStatisticsConfiguration', gameStatistics?: Array<{ __typename?: 'GameStatisticConfiguration', type?: GameStatisticType | null, value?: string | null, pointValue?: number | null, applicableTo?: Array<GameActor> | null, required?: boolean | null, max?: number | null, glossary?: { __typename?: 'GameStatisticGlossary', default?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null, scoring?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null } | null }> | null } | null } } | null, allocation?: { __typename?: 'DiscoverAllocation', time: string, court: { __typename?: 'DiscoverCourt', id: string, abbreviatedName: string, name: string, venue: { __typename?: 'DiscoverVenue', id: string, name: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string } } } | null, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, shared?: Array<{ __typename?: 'SharedPeriodStatistics', type?: SharedPeriodType | null, status?: SharedPlayerPeriodStatus | null, side?: Side | null, dismissalType?: DismissalTypeValue | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, players?: Array<{ __typename?: 'PlayerSharedStatisticRole', playerID: string, teamID: string, role?: PlayerRoleInSharedStatistic | null }> | null }> | null } | null, managementAuthorisation?: { __typename?: 'GameManagementAuthorisation', gameSheet?: boolean | null, resultAndPeriodScores?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, home?: { __typename?: 'GameManagementTeamAuthorisation', lineUp?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, stats?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null } | null, away?: { __typename?: 'GameManagementTeamAuthorisation', lineUp?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, stats?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null } | null } | null, clubScoringAccess?: { __typename?: 'GameClubScoringAccess', temporaryAccessEnabled?: boolean | null, endDateTime?: string | null } | null, gameType?: { __typename?: 'GameType', value?: string | null, overs?: number | null, hasSuperOver?: boolean | null, maxBattersPerInnings?: number | null, hasManualBonusPoints?: boolean | null, manualBonusPoints?: Array<number> | null, periodLength?: number | null, playerPositionsSettings?: { __typename?: 'PlayerPositionsSettings', enabled?: boolean | null, enforcePositions?: boolean | null, isInGamePositionsLineupVisible?: boolean | null } | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null, emergencyPlayersSettings?: { __typename?: 'EmergencyPlayersSettings', enabled?: boolean | null, max?: number | null, min?: number | null, includeInLineupLimit?: boolean | null } | null, lineupLimits?: { __typename?: 'LineupLimits', players?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, coaches?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null };

export type MyTeamsGameUpdateMutationVariables = Exact<{
  input: MyTeamsGameUpdateInput;
  gameStatisticsFilter: GameStatisticsFilter;
}>;


export type MyTeamsGameUpdateMutation = { __typename?: 'Mutation', myTeamsGameUpdate?: { __typename?: 'MyTeamsGameUpdateResponse', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, date?: string | null, hasManagementAccess?: boolean | null, startDateTime?: string | null, hasOvertime?: boolean | null, away?: { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null } | null, home?: { __typename?: 'MyTeamsTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null } | null, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status?: { __typename?: 'GameStatus', name: string, value: GameStatusType } | null, round?: { __typename?: 'MyTeamsRound', id: string, name: string, abbreviatedName: string, grade: { __typename?: 'MyTeamsGrade', id: string, name: string, hideScores: boolean, hasPeriodScores?: boolean | null, day?: { __typename?: 'TenantField', name: string, value: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } }, gameEvents: { __typename?: 'GameEvents', participantEvents: Array<{ __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }>, periodEvents: Array<{ __typename?: 'GameEventConfiguration', label: string, shortName: string, value: string, pointValue?: number | null }>, teamEvents: Array<{ __typename?: 'GameEventConfiguration', label: string, value: string, pointValue?: number | null, shortName: string }> }, periodScoresDisplayType?: { __typename?: 'TenantField', name: string, value: string } | null, periods: Array<{ __typename?: 'Period', label: string, shortName: string, value: PeriodValue }>, playerPoints?: { __typename?: 'PlayerPointsConfiguration', enforceTeamTotalCap?: boolean | null, teamPlayerPointsCap?: number | null } | null, bestPlayers?: { __typename?: 'BestPlayersConfiguration', max?: number | null } | null, gameStatisticsConfiguration?: { __typename?: 'GameStatisticsConfiguration', gameStatistics?: Array<{ __typename?: 'GameStatisticConfiguration', type?: GameStatisticType | null, value?: string | null, pointValue?: number | null, applicableTo?: Array<GameActor> | null, required?: boolean | null, max?: number | null, glossary?: { __typename?: 'GameStatisticGlossary', default?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null, scoring?: { __typename?: 'GameStatisticGlossaryField', name?: string | null, shortName?: string | null, message?: string | null, labelName?: string | null } | null } | null }> | null } | null } } | null, allocation?: { __typename?: 'DiscoverAllocation', time: string, court: { __typename?: 'DiscoverCourt', id: string, abbreviatedName: string, name: string, venue: { __typename?: 'DiscoverVenue', id: string, name: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string } } } | null, statistics?: { __typename?: 'MyTeamsGameStatistics', home?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeamStatistics', manualBonusPoints?: number | null, coaches?: Array<{ __typename?: 'MyTeamsGameCoachStatistics', role?: CoachType | null, selected?: boolean | null, order?: number | null, participant?: { __typename?: 'MyTeamsFillInCoach', id: string, name?: string | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null }> | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string, pointValue?: number | null }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', overtimeSequenceNo?: number | null, period: { __typename?: 'Period', value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }>, teamEvents?: Array<{ __typename?: 'GameTeamPeriodEvent', sequenceNo?: number | null, playerID?: string | null, statistic?: { __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } } | null }> | null }> | null, bestPlayers?: Array<{ __typename?: 'MyTeamsBestPlayer', ranking?: number | null, player?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null, volunteers?: Array<{ __typename?: 'GameVolunteer', fullName?: string | null, roleType?: string | null, roleTypeLabel?: string | null, number?: number | null }> | null, coinTossWinningResult?: { __typename?: 'CoinToss', preference?: string | null } | null } | null, shared?: Array<{ __typename?: 'SharedPeriodStatistics', type?: SharedPeriodType | null, status?: SharedPlayerPeriodStatus | null, side?: Side | null, dismissalType?: DismissalTypeValue | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, players?: Array<{ __typename?: 'PlayerSharedStatisticRole', playerID: string, teamID: string, role?: PlayerRoleInSharedStatistic | null }> | null }> | null } | null, managementAuthorisation?: { __typename?: 'GameManagementAuthorisation', gameSheet?: boolean | null, resultAndPeriodScores?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, home?: { __typename?: 'GameManagementTeamAuthorisation', lineUp?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, stats?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null } | null, away?: { __typename?: 'GameManagementTeamAuthorisation', lineUp?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null, stats?: { __typename?: 'ReadWrite', read?: boolean | null, write?: boolean | null } | null } | null } | null, clubScoringAccess?: { __typename?: 'GameClubScoringAccess', temporaryAccessEnabled?: boolean | null, endDateTime?: string | null } | null, gameType?: { __typename?: 'GameType', value?: string | null, overs?: number | null, hasSuperOver?: boolean | null, maxBattersPerInnings?: number | null, hasManualBonusPoints?: boolean | null, manualBonusPoints?: Array<number> | null, periodLength?: number | null, playerPositionsSettings?: { __typename?: 'PlayerPositionsSettings', enabled?: boolean | null, enforcePositions?: boolean | null, isInGamePositionsLineupVisible?: boolean | null } | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null, emergencyPlayersSettings?: { __typename?: 'EmergencyPlayersSettings', enabled?: boolean | null, max?: number | null, min?: number | null, includeInLineupLimit?: boolean | null } | null, lineupLimits?: { __typename?: 'LineupLimits', players?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null, coaches?: { __typename?: 'MinMax', min?: number | null, max?: number | null } | null } | null } | null, gameTeams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', playerNumber?: string | null, playerPoints?: number | null, selected?: boolean | null, availabilityStatus?: AvailabilityStatus | null, lineupOrder?: number | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer', id: string, firstName?: string | null, lastName?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string }, recordedTimeList?: Array<{ __typename?: 'StatisticRecordedTimeInfo', minute?: number | null, stoppage?: number | null, description?: string | null, offenceType?: string | null }> | null }> | null, periodStatistics?: Array<{ __typename?: 'PlayerPeriodStatistics', type?: PeriodType | null, status?: PlayerPeriodStatusValue | null, side?: Side | null, displayOrder?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', type: GameStatisticType, label: string, shortName: string, value: string, pointValue?: number | null, applicableTo: Array<GameActor>, advanced?: boolean | null }, details?: { __typename?: 'GameStatistic', value: string, required?: boolean | null, max?: number | null } | null }> | null }> | null, periods?: Array<{ __typename?: 'PlayerPeriod', overtimeSequenceNo?: number | null, period?: { __typename?: 'Period', label: string, shortName: string, value: PeriodValue } | null, inGamePositions?: Array<{ __typename?: 'GamePlayerPosition', shortName?: string | null, positionType?: string | null }> | null }> | null, ineligibilityStatus?: Array<{ __typename?: 'IneligibilityStatus', value?: IneligibilityStatusType | null, message?: string | null }> | null, playerPosition?: { __typename?: 'GamePlayerPosition', label?: string | null, shortName?: string | null, positionType?: string | null, order?: number | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, emergencyPlayers?: Array<{ __typename?: 'MyTeamsGameEmergencyPlayer', playerPoints?: number | null, playerNumber?: string | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | null }> | null } | null } | null } | null } | null } | null };

export type OrganisationDetailsFragment = { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> };

export type TenantContactRolesConfigurationFragment = { __typename?: 'TenantConfiguration', contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> };

export type ExternalAccountLinkingFragment = { __typename?: 'TenantConfiguration', externalAccountLinking?: { __typename?: 'ExternalAccountLinking', enabled: boolean, authUri?: string | null, clientID?: string | null, redirectUri?: string | null, shouldLinkSSOInRegistrationFlow?: boolean | null } | null };

export type ProductFragmentFragment = { __typename?: 'Product', id: string, name: string, description?: string | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number }, categoryPairs?: Array<{ __typename?: 'ProductVariantPair', id: string, category: { __typename?: 'ProductCategory', id: string, name: string }, option: { __typename?: 'ProductCategoryOption', id: string, name: string } }> | null }>, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, options: Array<{ __typename?: 'ProductCategoryOption', id: string, name: string }> }>, customFields: Array<{ __typename?: 'ProductCustomField', id: string, question: string, type: CustomFieldType, dropdownOptions?: Array<{ __typename?: 'ProductDropdownOption', id: string, label: string }> | null, option?: { __typename?: 'ProductCustomFieldOption', category: { __typename?: 'ProductCategory', id: string }, option: { __typename?: 'ProductCategoryOption', id: string } } | null }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }>, registrationSettings?: { __typename?: 'ProductRegistrationSettings', required: boolean, maxQuantity?: number | null } | null };

export type ProfileClaimMutationVariables = Exact<{
  input: ClaimProfileInput;
  overrides?: InputMaybe<ClaimProfileOverrides>;
}>;


export type ProfileClaimMutation = { __typename?: 'Mutation', profileClaim: { __typename?: 'ProfileMerge', id: string, status: MergeStatus } };

export type VerificationCodeGenerateMutationVariables = Exact<{
  input: ClaimProfileInput;
  overrides?: InputMaybe<ClaimProfileOverrides>;
}>;


export type VerificationCodeGenerateMutation = { __typename?: 'Mutation', verificationCodeGenerate: { __typename?: 'ProfileMerge', id: string, status: MergeStatus } };

export type ClaimVerifyMutationVariables = Exact<{
  input: ClaimVerifyInput;
}>;


export type ClaimVerifyMutation = { __typename?: 'Mutation', claimVerify: { __typename?: 'ProfileMerge', id: string, status: MergeStatus } };

export type RoundFixtureDiscoverTeamFragmentFragment = { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } };

type RoundFixtureTeamFragment_DiscoverTeam_Fragment = { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } };

type RoundFixtureTeamFragment_ProvisionalTeam_Fragment = { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null };

export type RoundFixtureTeamFragmentFragment = RoundFixtureTeamFragment_DiscoverTeam_Fragment | RoundFixtureTeamFragment_ProvisionalTeam_Fragment;

export type RoundFixtureFragmentFragment = { __typename?: 'DiscoverRoundFixture', byes: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } }>, games: Array<{ __typename?: 'DiscoverGame', id: string, alias?: string | null, date: string, dates?: Array<string> | null, isStale?: boolean | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, away: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, home: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status: { __typename?: 'GameStatus', name: string, value: GameStatusType }, allocation?: { __typename?: 'DiscoverAllocation', time: string, dateTimeList?: Array<{ __typename?: 'DateTime', date: string, time: string }> | null, court: { __typename?: 'DiscoverCourt', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, venue: { __typename?: 'DiscoverVenue', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string, country: string } } } | null, gameType?: { __typename?: 'GameType', name?: string | null, value?: string | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null } | null }> };

export type AvailableCharitiesFragmentFragment = { __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null };

export type SelectedCharitiesFragmentFragment = { __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null };

export type CartFragmentFragment = { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', discount?: { __typename?: 'CartDiscount', id: string, name: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null, fee: { __typename?: 'MembershipAdvancedFee', description?: string | null, applicationRole?: string | null, applicationDescription: string, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, selectedPayment?: { __typename?: 'MembershipAdvancedFeePayment', id: string } | null, payments: Array<{ __typename?: 'MembershipAdvancedFeePayment', id: string, type: MembershipApplicationPaymentTypes, amount: { __typename?: 'Price', net: number } }> } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productVariantID: string, fulfilmentMethod: FulfilmentMethod, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee', id: string, description?: string | null, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, amountDeferred?: { __typename: 'Price', net: number, currency: { __typename: 'Currency', code: string } } | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, selectedOption?: { __typename?: 'ParticipantFeeOption', id: string } | null, options?: Array<{ __typename?: 'ParticipantFeeOption', id: string, description?: string | null, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null } | { __typename?: 'TeamFee' } }>, totals: { __typename?: 'CartTotals', vouchers?: Array<{ __typename?: 'CartVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> | null, promotionalVouchers?: Array<{ __typename?: 'CartPromotionalVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, externalVouchers?: Array<{ __typename?: 'CartExternalVoucher', code: string, isExistingMember?: boolean | null, identifiedDisability?: boolean | null, culturalLinguisticDiversity?: boolean | null, aboriginalOrTorresStraightIslander?: boolean | null, englishMainLanguageSpokenAtHome?: boolean | null, alternativeMainLanguageSpokenAtHome?: string | null, costToRegisterForActivity?: number | null, scheme: { __typename?: 'VoucherScheme', id: string, name: string, hasAmount: boolean }, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredSubtotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredServiceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, selectedCharities?: Array<{ __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }, productsAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, feesAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, availableExternalVouchers?: Array<{ __typename?: 'ExternalVoucher', scheme: { __typename?: 'VoucherScheme', id: string, name: string, externalOwner: string, hasAmount: boolean, minAmount?: number | null, maxAmount?: number | null } }> | null, availableCharities?: Array<{ __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }> | null };

export type SeasonRegistrationCartQueryVariables = Exact<{
  args: SeasonRegistrationCartArgs;
  code: Scalars['String'];
  role?: InputMaybe<SeasonRegistrationUserType>;
}>;


export type SeasonRegistrationCartQuery = { __typename?: 'Query', seasonRegistrationCart: { __typename?: 'CartPayload', cart: { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', discount?: { __typename?: 'CartDiscount', id: string, name: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null, fee: { __typename?: 'MembershipAdvancedFee', description?: string | null, applicationRole?: string | null, applicationDescription: string, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, selectedPayment?: { __typename?: 'MembershipAdvancedFeePayment', id: string } | null, payments: Array<{ __typename?: 'MembershipAdvancedFeePayment', id: string, type: MembershipApplicationPaymentTypes, amount: { __typename?: 'Price', net: number } }> } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productVariantID: string, fulfilmentMethod: FulfilmentMethod, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee', id: string, description?: string | null, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, amountDeferred?: { __typename: 'Price', net: number, currency: { __typename: 'Currency', code: string } } | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, selectedOption?: { __typename?: 'ParticipantFeeOption', id: string } | null, options?: Array<{ __typename?: 'ParticipantFeeOption', id: string, description?: string | null, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null } | { __typename?: 'TeamFee' } }>, totals: { __typename?: 'CartTotals', vouchers?: Array<{ __typename?: 'CartVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> | null, promotionalVouchers?: Array<{ __typename?: 'CartPromotionalVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, externalVouchers?: Array<{ __typename?: 'CartExternalVoucher', code: string, isExistingMember?: boolean | null, identifiedDisability?: boolean | null, culturalLinguisticDiversity?: boolean | null, aboriginalOrTorresStraightIslander?: boolean | null, englishMainLanguageSpokenAtHome?: boolean | null, alternativeMainLanguageSpokenAtHome?: string | null, costToRegisterForActivity?: number | null, scheme: { __typename?: 'VoucherScheme', id: string, name: string, hasAmount: boolean }, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredSubtotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredServiceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, selectedCharities?: Array<{ __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }, productsAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, feesAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, availableExternalVouchers?: Array<{ __typename?: 'ExternalVoucher', scheme: { __typename?: 'VoucherScheme', id: string, name: string, externalOwner: string, hasAmount: boolean, minAmount?: number | null, maxAmount?: number | null } }> | null, availableCharities?: Array<{ __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }> | null }, errors: Array<{ __typename?: 'UserError', field?: string | null, message: string }>, checkoutSession?: { __typename: 'Gr4vyCheckoutSession' } | { __typename: 'Gr4vyEmbedCheckoutSession', id: string, expiryDate?: string | null, embedToken?: string | null } | { __typename: 'StripeCheckoutSession' } | null }, discoverSeasonRegistration: { __typename?: 'DiscoverRegistration', id: string, marketingOptInText?: string | null, products?: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number }, categoryPairs?: Array<{ __typename?: 'ProductVariantPair', id: string, category: { __typename?: 'ProductCategory', id: string, name: string }, option: { __typename?: 'ProductCategoryOption', id: string, name: string } }> | null }>, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, options: Array<{ __typename?: 'ProductCategoryOption', id: string, name: string }> }>, customFields: Array<{ __typename?: 'ProductCustomField', id: string, question: string, type: CustomFieldType, dropdownOptions?: Array<{ __typename?: 'ProductDropdownOption', id: string, label: string }> | null, option?: { __typename?: 'ProductCustomFieldOption', category: { __typename?: 'ProductCategory', id: string }, option: { __typename?: 'ProductCategoryOption', id: string } } | null }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }>, registrationSettings?: { __typename?: 'ProductRegistrationSettings', required: boolean, maxQuantity?: number | null } | null }> | null, organisationTermsAndConditions?: Array<{ __typename?: 'OrganisationTermsAndConditions', name: string, type: TermsAndConditionsType, value: string }> | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, season: { __typename?: 'DiscoverSeason', id: string, endDate: string, competition: { __typename?: 'DiscoverCompetition', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } | { __typename?: 'ProgramSeason', id: string, endDate: string, program: { __typename?: 'Program', id: string } } } };

export type TeamCartFragmentFragment = { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', fee: { __typename?: 'MembershipAdvancedFee' } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productVariantID: string, fulfilmentMethod: FulfilmentMethod, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee' } | { __typename?: 'TeamFee', id: string, description?: string | null, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }>, totals: { __typename?: 'CartTotals', vouchers?: Array<{ __typename?: 'CartVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> | null, promotionalVouchers?: Array<{ __typename?: 'CartPromotionalVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, externalVouchers?: Array<{ __typename?: 'CartExternalVoucher', code: string, scheme: { __typename?: 'VoucherScheme', id: string, name: string, hasAmount: boolean }, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredSubtotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredServiceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }, productsAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, feesAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } };

export type SocialTeamRegistrationCartQueryVariables = Exact<{
  args: SocialTeamRegistrationCartArgs;
  code: Scalars['ID'];
}>;


export type SocialTeamRegistrationCartQuery = { __typename?: 'Query', socialTeamRegistrationCart: { __typename?: 'CartPayload', cart: { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', fee: { __typename?: 'MembershipAdvancedFee' } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productVariantID: string, fulfilmentMethod: FulfilmentMethod, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee' } | { __typename?: 'TeamFee', id: string, description?: string | null, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }>, totals: { __typename?: 'CartTotals', vouchers?: Array<{ __typename?: 'CartVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> | null, promotionalVouchers?: Array<{ __typename?: 'CartPromotionalVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, externalVouchers?: Array<{ __typename?: 'CartExternalVoucher', code: string, scheme: { __typename?: 'VoucherScheme', id: string, name: string, hasAmount: boolean }, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredSubtotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredServiceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }, productsAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, feesAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } }, errors: Array<{ __typename?: 'UserError', field?: string | null, message: string }>, checkoutSession?: { __typename: 'Gr4vyCheckoutSession' } | { __typename: 'Gr4vyEmbedCheckoutSession', id: string, expiryDate?: string | null, embedToken?: string | null } | { __typename: 'StripeCheckoutSession' } | null }, discoverSocialTeamRegistration: { __typename?: 'DiscoverSocialTeamRegistration', id: string, products?: Array<{ __typename?: 'Product', id: string, name: string, description?: string | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number }, categoryPairs?: Array<{ __typename?: 'ProductVariantPair', id: string, category: { __typename?: 'ProductCategory', id: string, name: string }, option: { __typename?: 'ProductCategoryOption', id: string, name: string } }> | null }>, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, options: Array<{ __typename?: 'ProductCategoryOption', id: string, name: string }> }>, customFields: Array<{ __typename?: 'ProductCustomField', id: string, question: string, type: CustomFieldType, dropdownOptions?: Array<{ __typename?: 'ProductDropdownOption', id: string, label: string }> | null, option?: { __typename?: 'ProductCustomFieldOption', category: { __typename?: 'ProductCategory', id: string }, option: { __typename?: 'ProductCategoryOption', id: string } } | null }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }>, registrationSettings?: { __typename?: 'ProductRegistrationSettings', required: boolean, maxQuantity?: number | null } | null }> | null, organisationTermsAndConditions: Array<{ __typename?: 'OrganisationTermsAndConditions', name: string, type: TermsAndConditionsType, value: string }> } };

export type SupportedCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedCountriesQuery = { __typename?: 'Query', configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null } };

export type DiscoverTeamFragmentFragment = { __typename?: 'DiscoverTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } };

type TeamFragment_DiscoverTeam_Fragment = { __typename?: 'DiscoverTeam', id: string, name: string, playerPointsCap?: number | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } };

type TeamFragment_ProvisionalTeam_Fragment = { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null };

export type TeamFragmentFragment = TeamFragment_DiscoverTeam_Fragment | TeamFragment_ProvisionalTeam_Fragment;

export type GameSheetGenerateMutationVariables = Exact<{
  input: GameSheetGenerateInput;
}>;


export type GameSheetGenerateMutation = { __typename?: 'Mutation', gameSheetGenerate?: { __typename?: 'GameSheetGenerateResponse', stateID?: string | null } | null };

export type GameSheetDownloadQueryVariables = Exact<{
  stateID: Scalars['ID'];
}>;


export type GameSheetDownloadQuery = { __typename?: 'Query', gameSheetDownload?: { __typename?: 'GameSheetDownloadResponse', stateID?: string | null, status?: GameSheetDownloadStatus | null, document?: { __typename?: 'Document', url: string } | null } | null };

export type GetLocalisationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocalisationQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, localisation?: { __typename?: 'TenantLocalisation', country: string, locale: string, currency: { __typename?: 'Currency', code: string, symbol: string, symbolLocation: SymbolLocation } } | null } | null };

export type PlayerNumberDisabledTenantConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type PlayerNumberDisabledTenantConfigQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, playerNumberDisabled?: boolean | null } | null };

export type MyProfileAndDependantsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileAndDependantsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', visible: boolean, id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, otherDisability?: string | null, disabilityHelp?: string | null, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } } | null, guardians?: Array<{ __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null }> | null, dependants?: Array<{ __typename?: 'Profile', id: string, firstName: string, lastName: string, wwc?: { __typename?: 'WWC', id: string, number: string, expiryDate: string, stateOfIssue: string } | null, childSafety?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null }> | null }> | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }>, gender?: { __typename?: 'TenantField', name: string, value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', name: string, value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, hasDisability?: { __typename?: 'TenantField', name: string, value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } | null } | null };

export type ProfileTenantHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProfileTenantHistoryQuery = { __typename?: 'Query', profileTenantHistory: { __typename?: 'ProfileTenantDetails', myTeams: Array<{ __typename?: 'TenantField', name: string, value: string }>, coachingAccreditation: Array<{ __typename?: 'TenantField', name: string, value: string }>, registrationHistory: Array<{ __typename?: 'TenantField', name: string, value: string }>, memberships: Array<{ __typename?: 'TenantField', name: string, value: string }>, concussionIncidents?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } };

export type ChangeEmailAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type ChangeEmailAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', firstName: string, lastName: string, email?: string | null } | null } | null };

export type ProfileEmailChangeMutationVariables = Exact<{
  request: ProfileEmailChangeInput;
}>;


export type ProfileEmailChangeMutation = { __typename?: 'Mutation', profileEmailChange?: string | null };

export type ProfileEmailVerifyMutationVariables = Exact<{
  id: Scalars['ID'];
  code: Scalars['String'];
}>;


export type ProfileEmailVerifyMutation = { __typename?: 'Mutation', profileEmailVerify?: { __typename?: 'ProfileEmailChangeResult', id: string, status?: ProfileEmailStatus | null } | null };

export type OrganisationRegistrationsQueryVariables = Exact<{
  code: Scalars['ID'];
  codeString: Scalars['String'];
}>;


export type OrganisationRegistrationsQuery = { __typename?: 'Query', discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } | null, organisationRegistrations: Array<{ __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, registrationCode: string, startDate: { __typename?: 'TimeZoneDateTime', date: string, time: string, timezone: string }, endDate: { __typename?: 'TimeZoneDateTime', date: string, time: string, timezone: string }, season: { __typename?: 'DiscoverSeason', id: string, name: string, startDate: string, endDate: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } } | { __typename?: 'ProgramSeason', id: string, name: string, startDate: string, endDate: string, program: { __typename?: 'Program', id: string, name: string, description: string, alias?: string | null } }, hostOrganisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null }, registrationUserTypes: Array<{ __typename?: 'RegistrationUserType', name: string, displayName?: string | null, value: SeasonRegistrationUserType }> }>, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, sport?: { __typename?: 'SportConfiguration', name: string } | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type FindMyProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type FindMyProfilesQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, dateOfBirth?: string | null, gender?: { __typename?: 'TenantField', value: string } | null, dependants?: Array<{ __typename?: 'Profile', id: string, firstName: string, lastName: string, dateOfBirth?: string | null, gender?: { __typename?: 'TenantField', value: string } | null }> | null } | null };

export type FindMyProfilesClaimProfilesQueryVariables = Exact<{
  input: DuplicateProfileSearchInput;
}>;


export type FindMyProfilesClaimProfilesQuery = { __typename?: 'Query', duplicateProfiles?: Array<{ __typename?: 'DuplicateProfile', id: string, firstName: string, lastName: string, email: string, mobileNumber?: string | null, lastRegisteredRole?: SeasonRegistrationUserType | null, claimability: ClaimabilityStatus, isPrivate?: boolean | null, isMigrated?: boolean | null, lastRegisteredSeason?: { __typename?: 'DiscoverSeason', id: string, name: string } | null, lastRegisteredOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null }> | null };

export type GameCentreDiscoverGameQueryVariables = Exact<{
  gameId: Scalars['ID'];
}>;


export type GameCentreDiscoverGameQuery = { __typename?: 'Query', discoverGame?: { __typename?: 'DiscoverGame', id: string, alias?: string | null, away: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam', name: string }, home: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam', name: string }, round: { __typename?: 'DiscoverRound', id: string, name: string, abbreviatedName: string, grade: { __typename?: 'DiscoverGrade', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } } } } } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type GameManageJwtGenerateMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type GameManageJwtGenerateMutation = { __typename?: 'Mutation', gameManageJWTGenerate?: { __typename?: 'GameManageJWTGenerateResponse', jwt?: string | null, gameID?: string | null } | null };

export type DiscoverGradeQueryVariables = Exact<{
  gradeID: Scalars['ID'];
}>;


export type DiscoverGradeQuery = { __typename?: 'Query', discoverGrade?: { __typename?: 'DiscoverGrade', id: string, name: string, type?: GradeType | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } } } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, statistics?: { __typename?: 'TenantStatistics', enabled: boolean } | null, gradeTypes?: Array<{ __typename?: 'GradeTypeConfig', value?: GradeType | null, isAllPlay?: boolean | null, features?: { __typename?: 'GradeTypeFeatures', hasRounds?: boolean | null, hasSeasonStats?: boolean | null, hasCareerStats?: boolean | null, hasGameStats?: boolean | null, hasFixture?: boolean | null, hasLadder?: boolean | null } | null }> | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type GradeLadderQueryVariables = Exact<{
  gradeID: Scalars['ID'];
}>;


export type GradeLadderQuery = { __typename?: 'Query', discoverGrade?: { __typename?: 'DiscoverGrade', id: string, name: string, ladderType?: LadderTemplate | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, type: CompetitionType, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }, ladder: Array<{ __typename?: 'LadderPool', gameTypeValue?: string | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, generatedFrom: { __typename?: 'DiscoverRound', id: string, name: string }, standings: Array<{ __typename?: 'LadderStanding', played: number, won: number, lost: number, drawn: number, byes: number, pointsFor: number, pointsAgainst: number, pointsDifference?: number | null, forfeits: number, disqualifications: number, adjustments: number, percentage: number, alternatePercentage?: number | null, competitionPoints: number, pointsAverage?: number | null, noResults?: number | null, ties?: number | null, quotient?: number | null, netRunRate?: number | null, runsFor?: number | null, oversFaced?: number | null, wicketsLost?: number | null, runsAgainst?: number | null, oversBowled?: number | null, wicketsTaken?: number | null, winOutright?: number | null, winFirstInnings?: number | null, lossOutright?: number | null, lossFirstInnings?: number | null, matchRatio?: number | null, bonusPoints?: number | null, team: { __typename?: 'DiscoverTeam', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } }> }>, gameTypes?: Array<{ __typename?: 'GameType', name?: string | null, value?: string | null, ladderType?: LadderTemplate | null, ladderFields?: Array<{ __typename?: 'LadderField', shortName?: string | null, key?: string | null, toolTip?: string | null, extendedToolTip?: string | null, type?: LadderFieldType | null, displayOrder?: number | null, dataType?: LadderDataType | null, truncateTrailingZeros?: boolean | null, decimals?: number | null }> | null, ladderRankingFields?: Array<{ __typename?: 'LadderField', fullName?: string | null, shortName?: string | null, key?: string | null, sortOrder?: number | null, toolTip?: string | null }> | null }> | null, overallLadder?: { __typename?: 'OverallLadder', ladderType?: OverallLadderTemplate | null } | null, overallLadderFields?: Array<{ __typename?: 'LadderField', shortName?: string | null, key?: string | null, toolTip?: string | null, type?: LadderFieldType | null, displayOrder?: number | null, dataType?: LadderDataType | null, truncateTrailingZeros?: boolean | null, decimals?: number | null }> | null, overallLadderRankingFields?: Array<{ __typename?: 'LadderField', fullName?: string | null, shortName?: string | null, key?: string | null, sortOrder?: number | null, toolTip?: string | null }> | null } | null };

export type GradeListDiscoverSeasonQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GradeListDiscoverSeasonQuery = { __typename?: 'Query', discoverSeason?: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, type: CompetitionType, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } }, status: { __typename?: 'DiscoverSeasonStatus', name: string, value: DiscoverSeasonStatusType }, grades: Array<{ __typename?: 'DiscoverGrade', id: string, name: string, day?: { __typename?: 'TenantField', name: string, value: string } | null, gender?: { __typename?: 'TenantField', name: string, value: string } | null, age?: { __typename?: 'TenantField', name: string, value: string } | null }> } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, competition: { __typename?: 'CompetitionConfiguration', ageGroups: Array<{ __typename?: 'TenantField', name: string, value: string }>, genders: Array<{ __typename?: 'TenantField', name: string, value: string }> }, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type PublicGradeStatisticsQueryVariables = Exact<{
  gradeID: Scalars['ID'];
  filter?: InputMaybe<GradePlayerStatisticsFilter>;
}>;


export type PublicGradeStatisticsQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', statistics?: { __typename?: 'TenantStatistics', enabled: boolean, publicGradeStatisticsMeta?: Array<{ __typename?: 'StatisticsMeta', value: string, name: string, shortName: string }> | null } | null } | null, discoverGrade?: { __typename?: 'DiscoverGrade', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } } | null, gradePlayerStatistics?: { __typename?: 'GradePlayerStatistics', meta?: { __typename?: 'SearchResultMeta', page: number, totalPages: number, totalRecords: number } | null, results?: Array<{ __typename?: 'GradePlayerStatisticsResult', ranking?: number | null, profile?: { __typename?: 'StatisticsProfile', id: string, firstName?: string | null, lastName?: string | null } | null, team?: { __typename?: 'StatisticsTeam', name?: string | null } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null }> | null } | null };

export type SubmitIncidentClearanceMutationVariables = Exact<{
  incidentID: Scalars['ID'];
  input: ConcussionClearanceInput;
}>;


export type SubmitIncidentClearanceMutation = { __typename?: 'Mutation', submitIncidentClearance?: { __typename?: 'Incident', id: string } | null };

export type RegistrationTypeQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type RegistrationTypeQuery = { __typename?: 'Query', registrationSettings?: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType } | { __typename?: 'DiscoverSocialTeamRegistration', id: string } | null };

export type MyTeamsEnterVotesQueryVariables = Exact<{
  gameId: Scalars['ID'];
  teamId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
}>;


export type MyTeamsEnterVotesQuery = { __typename?: 'Query', gameTeamAward?: { __typename?: 'GameTeamAwardResponse', award?: { __typename?: 'GameTeamAward', isOpen?: boolean | null, configuration?: { __typename?: 'TeamAwardConfiguration', awardName?: string | null, highestVote?: number | null, totalVoters?: number | null } | null, voteSlips?: Array<{ __typename?: 'GameTeamAwardVoteSlip', voterName?: string | null, voterNumber?: number | null }> | null } | null, players?: Array<{ __typename?: 'GameTeamAwardPlayer', id: string, playerNumber?: string | null, firstName?: string | null, lastName?: string | null }> | null } | null, discoverGame?: { __typename?: 'DiscoverGame', id: string, home: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam' }, away: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam' }, round: { __typename?: 'DiscoverRound', id: string, name: string } } | null };

export type MyTeamsFixtureQueryVariables = Exact<{
  teamID: Scalars['ID'];
}>;


export type MyTeamsFixtureQuery = { __typename?: 'Query', discoverTeamFixture: Array<{ __typename?: 'DiscoverRound', id: string, name: string, isStale?: boolean | null, provisionalDates?: Array<string> | null, grade: { __typename?: 'DiscoverGrade', id: string, name: string, type?: GradeType | null, hideScores: boolean, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, type: CompetitionType, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } }, fixture: { __typename?: 'DiscoverRoundFixture', byes: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } }>, games: Array<{ __typename?: 'DiscoverGame', id: string, alias?: string | null, date: string, dates?: Array<string> | null, isStale?: boolean | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, away: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, home: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status: { __typename?: 'GameStatus', name: string, value: GameStatusType }, allocation?: { __typename?: 'DiscoverAllocation', time: string, dateTimeList?: Array<{ __typename?: 'DateTime', date: string, time: string }> | null, court: { __typename?: 'DiscoverCourt', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, venue: { __typename?: 'DiscoverVenue', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string, country: string } } } | null, gameType?: { __typename?: 'GameType', name?: string | null, value?: string | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null } | null }> } }>, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, gradeTypes?: Array<{ __typename?: 'GradeTypeConfig', value?: GradeType | null, isAllPlay?: boolean | null, features?: { __typename?: 'GradeTypeFeatures', hasRounds?: boolean | null, hasSeasonStats?: boolean | null, hasCareerStats?: boolean | null, hasGameStats?: boolean | null, hasFixture?: boolean | null, hasLadder?: boolean | null } | null }> | null } | null };

export type MyTeamsGameManagementAccessQueryVariables = Exact<{
  gameId: Scalars['ID'];
  teamContextId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
}>;


export type MyTeamsGameManagementAccessQuery = { __typename?: 'Query', gameTeamAward?: { __typename?: 'GameTeamAwardResponse', award?: { __typename?: 'GameTeamAward', isOpen?: boolean | null, configuration?: { __typename?: 'TeamAwardConfiguration', awardName?: string | null } | null } | null } | null, myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, hasManagementAccess?: boolean | null, hasIncidentAccess?: boolean | null, dates?: Array<string> | null } | null, discoverGame?: { __typename?: 'DiscoverGame', id: string, home: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam', name: string }, away: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam', name: string }, round: { __typename?: 'DiscoverRound', id: string, name: string, abbreviatedName: string, grade: { __typename?: 'DiscoverGrade', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string } } } } } } | null };

export type MyTeamsGameIncidentDetailsQueryVariables = Exact<{
  gameId: Scalars['ID'];
  teamContextId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
}>;


export type MyTeamsGameIncidentDetailsQuery = { __typename?: 'Query', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, myTeamsTeam?: { __typename?: 'MyTeamsTeam', id: string, teamPlayers?: Array<{ __typename?: 'MyTeamsTeamPlayer', participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null }> | null } | null };

export type CreateIncidentMutationVariables = Exact<{
  input: IncidentCreateInput;
}>;


export type CreateIncidentMutation = { __typename?: 'Mutation', incidentCreate?: { __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null } | null };

export type GetIncidentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetIncidentQuery = { __typename?: 'Query', incident?: { __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null } | null };

export type GetIncidentRelatedGameQueryVariables = Exact<{
  gameId: Scalars['ID'];
  teamContextId: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
}>;


export type GetIncidentRelatedGameQuery = { __typename?: 'Query', myTeamsGame?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null };

export type UpdateIncidentMutationVariables = Exact<{
  id: Scalars['ID'];
  input: IncidentUpdateInput;
}>;


export type UpdateIncidentMutation = { __typename?: 'Mutation', incidentUpdate?: { __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null } | null };

export type DeleteIncidentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIncidentMutation = { __typename?: 'Mutation', incidentDelete?: { __typename: 'Incident' } | null };

export type ConfirmIncidentClearanceMutationVariables = Exact<{
  incidentID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
}>;


export type ConfirmIncidentClearanceMutation = { __typename?: 'Mutation', confirmIncidentClearance?: { __typename?: 'Incident', id: string } | null };

export type IncidentGameFieldsFragment = { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null };

export type IncidentGameTeamFieldsFragment = { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null };

export type IncidentFieldsFragment = { __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null };

export type GetTeamIncidentsQueryVariables = Exact<{
  teamID: Scalars['ID'];
  profileId?: InputMaybe<Scalars['ID']>;
}>;


export type GetTeamIncidentsQuery = { __typename?: 'Query', myTeamsTeam?: { __typename?: 'MyTeamsTeam', id: string, teamPlayers?: Array<{ __typename?: 'MyTeamsTeamPlayer', participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null }> | null, concussionIncidents?: Array<{ __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null }> | null } | null };

export type MyTeamsLadderQueryVariables = Exact<{
  teamID: Scalars['ID'];
}>;


export type MyTeamsLadderQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, type: CompetitionType } }, grade?: { __typename?: 'DiscoverGrade', id: string, name: string, ladderType?: LadderTemplate | null, ladder: Array<{ __typename?: 'LadderPool', gameTypeValue?: string | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, generatedFrom: { __typename?: 'DiscoverRound', id: string, name: string }, standings: Array<{ __typename?: 'LadderStanding', played: number, won: number, lost: number, drawn: number, byes: number, pointsFor: number, pointsAgainst: number, pointsDifference?: number | null, forfeits: number, disqualifications: number, adjustments: number, percentage: number, alternatePercentage?: number | null, competitionPoints: number, pointsAverage?: number | null, noResults?: number | null, ties?: number | null, quotient?: number | null, netRunRate?: number | null, runsFor?: number | null, oversFaced?: number | null, wicketsLost?: number | null, runsAgainst?: number | null, oversBowled?: number | null, wicketsTaken?: number | null, winOutright?: number | null, winFirstInnings?: number | null, lossOutright?: number | null, lossFirstInnings?: number | null, matchRatio?: number | null, bonusPoints?: number | null, team: { __typename?: 'DiscoverTeam', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } }> }>, gameTypes?: Array<{ __typename?: 'GameType', name?: string | null, value?: string | null, ladderFields?: Array<{ __typename?: 'LadderField', shortName?: string | null, key?: string | null, toolTip?: string | null, extendedToolTip?: string | null, type?: LadderFieldType | null, displayOrder?: number | null, dataType?: LadderDataType | null, decimals?: number | null }> | null, ladderRankingFields?: Array<{ __typename?: 'LadderField', fullName?: string | null, shortName?: string | null, key?: string | null, sortOrder?: number | null, toolTip?: string | null }> | null }> | null, overallLadder?: { __typename?: 'OverallLadder', ladderType?: OverallLadderTemplate | null } | null, overallLadderFields?: Array<{ __typename?: 'LadderField', shortName?: string | null, key?: string | null, toolTip?: string | null, type?: LadderFieldType | null, displayOrder?: number | null, dataType?: LadderDataType | null, decimals?: number | null }> | null, overallLadderRankingFields?: Array<{ __typename?: 'LadderField', fullName?: string | null, shortName?: string | null, key?: string | null, sortOrder?: number | null, toolTip?: string | null }> | null } | null, organisation: { __typename?: 'DiscoverOrganisation', name: string } } | null };

export type MyTeamsSquadQueryVariables = Exact<{
  teamID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
}>;


export type MyTeamsSquadQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, season: { __typename?: 'DiscoverSeason', id: string, endDate: string, status: { __typename?: 'DiscoverSeasonStatus', value: DiscoverSeasonStatusType } } } | null, myTeamsTeam?: { __typename?: 'MyTeamsTeam', id: string, hasManagementAccess?: boolean | null, registrationCode?: string | null, teamPlayers?: Array<{ __typename?: 'MyTeamsTeamPlayer', playerNumber?: string | null, participant?: { __typename?: 'MyTeamsParticipant', id: string, gamesPlayed?: number | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, preferredName?: string | null, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null, accountManagedBy?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', displayNumber: string } } | null, guardians?: Array<{ __typename?: 'MyTeamsGuardian', firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null }> | null } | null, totalStatistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', shortName: string, value: string } }> | null } | null, captain?: { __typename?: 'Captain', name?: string | null, value?: string | null, shortName?: string | null } | null }> | null, coach?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, preferredName?: string | null, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null, accountManagedBy?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', displayNumber: string } } | null, guardians?: Array<{ __typename?: 'MyTeamsGuardian', firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null }> | null } | null } | null, assistantCoaches?: Array<{ __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, preferredName?: string | null, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null, accountManagedBy?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', displayNumber: string } } | null, guardians?: Array<{ __typename?: 'MyTeamsGuardian', firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null }> | null } | null }> | null, teamManagers?: Array<{ __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, preferredName?: string | null, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null, accountManagedBy?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', displayNumber: string } } | null, guardians?: Array<{ __typename?: 'MyTeamsGuardian', firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null }> | null } | null }> | null, organiser?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, preferredName?: string | null, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null, accountManagedBy?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', displayNumber: string } } | null, guardians?: Array<{ __typename?: 'MyTeamsGuardian', firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null }> | null } | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', statistics?: { __typename?: 'TenantStatistics', seasonStatisticsMeta?: Array<{ __typename?: 'StatisticsMeta', value: string, isDisplayable: boolean, inOffenceList?: boolean | null, offenceListPublicVisible?: boolean | null, shortName: string, name: string }> | null } | null } | null };

export type MyTeamsSquadProfileFragmentFragment = { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, preferredName?: string | null, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null, accountManagedBy?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', displayNumber: string } } | null, guardians?: Array<{ __typename?: 'MyTeamsGuardian', firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null } | { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string, email?: string | null, homeNumber?: string | null, mobileNumber?: { __typename?: 'Mobile', displayNumber: string } | null }> | null };

export type MyTeamsTeamQueryVariables = Exact<{
  teamID: Scalars['ID'];
  profileID?: InputMaybe<Scalars['ID']>;
}>;


export type MyTeamsTeamQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, endDate: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string }, status: { __typename?: 'DiscoverSeasonStatus', value: DiscoverSeasonStatusType } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, tenant?: { __typename?: 'TenantOrganisation', id: string, name: string } | null } } | null, myTeamsTeam?: { __typename?: 'MyTeamsTeam', id: string, hasManagementAccess?: boolean | null, hasIncidentAccess?: boolean | null, teamPlayers?: Array<{ __typename?: 'MyTeamsTeamPlayer', participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null }> | null } | null };

export type GetOrganisationNewsQueryVariables = Exact<{
  orgCode: Scalars['String'];
}>;


export type GetOrganisationNewsQuery = { __typename?: 'Query', discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null };

export type GetOrganisationNewsResultsQueryVariables = Exact<{
  input: DiscoverOrganisationPostsInput;
}>;


export type GetOrganisationNewsResultsQuery = { __typename?: 'Query', discoverOrganisationPosts?: { __typename?: 'DiscoverOrganisationPosts', results?: Array<{ __typename?: 'DiscoverPost', id: string, title?: string | null, publishedDateTime?: string | null, updatedDateTime?: string | null, image?: { __typename?: 'PostImage', heroImageUrl?: string | null, thumbnailUrl?: string | null } | null }> | null, meta?: { __typename?: 'SearchResultMeta', page: number, totalPages: number, totalRecords: number } | null } | null };

export type GetNewsItemQueryVariables = Exact<{
  postID: Scalars['ID'];
  includeProducts?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetNewsItemQuery = { __typename?: 'Query', discoverPost?: { __typename?: 'DiscoverPost', id: string, title?: string | null, body?: string | null, publishedDateTime?: string | null, updatedDateTime?: string | null, organisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string, isTenantOrganisation?: boolean | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', height: number, width: number } }> } | null } | null, image?: { __typename?: 'PostImage', heroImageUrl?: string | null, caption?: string | null } | null, products?: Array<{ __typename?: 'Product', id: string, name: string, activeShop?: boolean | null, productType: ProductType, variants: Array<{ __typename?: 'ProductVariant', amount: { __typename?: 'Price', net: number } }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string }> }> }> | null } | null };

export type PostProductFragment = { __typename?: 'Product', id: string, name: string, activeShop?: boolean | null, productType: ProductType, variants: Array<{ __typename?: 'ProductVariant', amount: { __typename?: 'Price', net: number } }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string }> }> };

export type EmailNotificationUnsubscribeMutationVariables = Exact<{
  input: EmailNotificationUnsubscribeInput;
}>;


export type EmailNotificationUnsubscribeMutation = { __typename?: 'Mutation', emailNotificationUnsubscribe: { __typename?: 'EmailNotificationUnsubscribe', success?: boolean | null } };

export type GetPaymentRequestProductQueryVariables = Exact<{
  productId: Scalars['ID'];
}>;


export type GetPaymentRequestProductQuery = { __typename?: 'Query', paymentRequestProduct?: { __typename?: 'Product', id: string, name: string, description?: string | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number } }> } | null };

export type GetPostEmailUnsubscribeQueryVariables = Exact<{
  orgCode: Scalars['String'];
}>;


export type GetPostEmailUnsubscribeQuery = { __typename?: 'Query', discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null };

export type PostEmailUnsubscribeMutationVariables = Exact<{
  input: PostEmailUnsubscribeInput;
}>;


export type PostEmailUnsubscribeMutation = { __typename?: 'Mutation', postEmailUnsubscribe: { __typename?: 'PostEmailUnsubscribe', success?: boolean | null } };

export type ProfileHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileHistoryQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, dependants?: Array<{ __typename?: 'Profile', id: string, registrationHistory?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, preferredGrade?: string | null, registeredDate?: string | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, availableRegistrations: Array<{ __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, registrationCode: string }> } } | { __typename?: 'Participant', id: string, type: string, displayName?: string | null, gender: string, dateOfBirth: string, wwcNumber?: string | null, wwcExpiryDate?: string | null, wwcStateOfIssue?: string | null, coachingAccreditationLevel?: string | null, teamName?: string | null, school?: string | null, schoolYear?: string | null, registeredAt: string, cancelledAt?: string | null, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } | { __typename?: 'ProgramSeason', id: string, name: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, preferredGroup?: { __typename?: 'Group', id: string, name: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null }> | null }> | null, registrationHistory?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, preferredGrade?: string | null, registeredDate?: string | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, availableRegistrations: Array<{ __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, registrationCode: string }> } } | { __typename?: 'Participant', id: string, type: string, displayName?: string | null, gender: string, dateOfBirth: string, wwcNumber?: string | null, wwcExpiryDate?: string | null, wwcStateOfIssue?: string | null, coachingAccreditationLevel?: string | null, teamName?: string | null, school?: string | null, schoolYear?: string | null, registeredAt: string, cancelledAt?: string | null, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } | { __typename?: 'ProgramSeason', id: string, name: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, preferredGroup?: { __typename?: 'Group', id: string, name: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null }> | null } | null } | null };

export type HistoryFragmentFragment = { __typename?: 'Profile', id: string, registrationHistory?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, preferredGrade?: string | null, registeredDate?: string | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, availableRegistrations: Array<{ __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, registrationCode: string }> } } | { __typename?: 'Participant', id: string, type: string, displayName?: string | null, gender: string, dateOfBirth: string, wwcNumber?: string | null, wwcExpiryDate?: string | null, wwcStateOfIssue?: string | null, coachingAccreditationLevel?: string | null, teamName?: string | null, school?: string | null, schoolYear?: string | null, registeredAt: string, cancelledAt?: string | null, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } | { __typename?: 'ProgramSeason', id: string, name: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, preferredGroup?: { __typename?: 'Group', id: string, name: string } | null, permit?: { __typename?: 'Permit', id: string, fromDate: string, toDate: string } | null }> | null };

export type GetProfileIncidentsQueryVariables = Exact<{
  profileID: Scalars['ID'];
  includeDependant: Scalars['Boolean'];
}>;


export type GetProfileIncidentsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', concussionIncidents?: Array<{ __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null }> | null } | null } | null, dependantProfile?: { __typename?: 'Profile', concussionIncidents?: Array<{ __typename?: 'Incident', id: string, note?: string | null, status?: IncidentStatus | null, createdAt?: string | null, seasonName?: string | null, incidentDate?: string | null, type?: IncidentType | null, category?: IncidentCategory | null, participant?: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string } | null } | null, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null, outcome?: { __typename?: 'ConcussionOutcome', id: string, note?: string | null, clearance?: { __typename?: 'ConcussionClearance', returnDate?: string | null, doctor?: string | null, medicalFacilityAddress?: string | null, medicalFacilityContactNumber?: string | null, providerID?: string | null } | null } | { __typename?: 'SuspensionOutcome', id: string, note?: string | null } | null, owningOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, game?: { __typename?: 'MyTeamsGame', id: string, dates?: Array<string> | null, home?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, away?: { __typename?: 'MyTeamsTeam', id: string } | { __typename?: 'ProvisionalTeam' } | null, teams?: { __typename?: 'MyTeamsGameTeams', home?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null, away?: { __typename?: 'MyTeamsGameTeam', lineup?: { __typename?: 'MyTeamsGameTeamLineup', players?: Array<{ __typename?: 'MyTeamsGameTeamPlayer', selected?: boolean | null, participant?: { __typename?: 'MyTeamsGamePermitFillInPlayer', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | { __typename?: 'MyTeamsParticipantFillInPlayer', id: string, participant?: { __typename?: 'MyTeamsParticipant', id: string, profile?: { __typename?: 'MyTeamsProfile', id: string, firstName: string, lastName: string } | null } | null } | { __typename?: 'MyTeamsRegularFillInPlayer' } | null }> | null } | null } | null } | null } | null, team?: { __typename?: 'MyTeamsTeam', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'ProvisionalTeam' } | null }> | null } | null };

export type InvoiceListQueryVariables = Exact<{
  filter?: InputMaybe<InvoicePaginatedFilter>;
}>;


export type InvoiceListQuery = { __typename?: 'Query', invoiceList: { __typename?: 'InvoiceList', meta?: { __typename?: 'SearchResultMeta', page: number, totalPages: number, totalRecords: number } | null, results: Array<{ __typename?: 'Invoice', id: string, createdAt?: string | null, orderID?: string | null, total?: { __typename?: 'Price', net: number, label: string, currency: { __typename?: 'Currency', code: string, symbol: string } } | null }> } };

export type InvoiceDownloadMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type InvoiceDownloadMutation = { __typename?: 'Mutation', invoiceDownload?: { __typename?: 'Document', url: string } | null };

export type ProfileMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileMembershipsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, dependants?: Array<{ __typename?: 'Profile', id: string, memberships: Array<{ __typename?: 'Membership', id: string, application: { __typename?: 'MembershipApplication', id: string, name: string, role?: { __typename?: 'MembershipApplicationRoleType', name?: string | null, value?: MembershipApplicationRole | null } | null }, history: Array<{ __typename?: 'UserMembership', id: string, startDate: string, expiryDate: string, purchaseDate: string, source: MembershipSource }>, organisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null }> }> | null, memberships: Array<{ __typename?: 'Membership', id: string, application: { __typename?: 'MembershipApplication', id: string, name: string, role?: { __typename?: 'MembershipApplicationRoleType', name?: string | null, value?: MembershipApplicationRole | null } | null }, history: Array<{ __typename?: 'UserMembership', id: string, startDate: string, expiryDate: string, purchaseDate: string, source: MembershipSource }>, organisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null }> } | null } | null };

export type ProfileMembershipsWithOrgFragmentFragment = { __typename?: 'Profile', id: string, memberships: Array<{ __typename?: 'Membership', id: string, application: { __typename?: 'MembershipApplication', id: string, name: string, role?: { __typename?: 'MembershipApplicationRoleType', name?: string | null, value?: MembershipApplicationRole | null } | null }, history: Array<{ __typename?: 'UserMembership', id: string, startDate: string, expiryDate: string, purchaseDate: string, source: MembershipSource }>, organisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null }> };

export type AccountMyTeamsListQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountMyTeamsListQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, dependants?: Array<{ __typename?: 'Profile', id: string, myTeamsList?: { __typename?: 'MyTeamsList', results?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, status: { __typename?: 'DiscoverSeasonStatus', name: string, value: DiscoverSeasonStatusType } }, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null }> | null } | null }> | null, myTeamsList?: { __typename?: 'MyTeamsList', results?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, status: { __typename?: 'DiscoverSeasonStatus', name: string, value: DiscoverSeasonStatusType } }, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null }> | null } | null } | null } | null };

export type ProfileTeamsFragment = { __typename?: 'Profile', id: string, myTeamsList?: { __typename?: 'MyTeamsList', results?: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, status: { __typename?: 'DiscoverSeasonStatus', name: string, value: DiscoverSeasonStatusType } }, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null }> | null } | null };

export type PublicProfileQueryVariables = Exact<{
  profileID: Scalars['ID'];
}>;


export type PublicProfileQuery = { __typename?: 'Query', publicProfile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null };

export type PublicProfileTenantHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PublicProfileTenantHistoryQuery = { __typename?: 'Query', profileTenantHistory: { __typename?: 'ProfileTenantDetails', registrationHistory: Array<{ __typename?: 'TenantField', name: string, value: string }> } };

export type ExternalStatisticsUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ExternalStatisticsUrlQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, externalStatisticsUrls?: Array<{ __typename?: 'UrlTenantField', url: string, name: string, value: string }> | null } | null };

export type PublicProfileStatisticsQueryVariables = Exact<{
  profileID: Scalars['ID'];
}>;


export type PublicProfileStatisticsQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, statistics?: { __typename?: 'TenantStatistics', enabled: boolean, careerStatisticsMeta?: Array<{ __typename?: 'StatisticsMeta', value: string, name: string, shortName: string, isDisplayable: boolean }> | null, seasonStatisticsMeta?: Array<{ __typename?: 'StatisticsMeta', value: string, name: string, shortName: string, isDisplayable: boolean }> | null } | null } | null, publicProfileStatistics?: { __typename?: 'PublicProfileStatistics', careerStatistics?: { __typename?: 'CareerStatistics', totalStatistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null, clubStatistics?: Array<{ __typename?: 'ClubStatistics', id: string, club?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null }> | null } | null, seasonStatistics?: Array<{ __typename?: 'SeasonStatistics', name: string, player: { __typename?: 'DiscoverAnonymousParticipant', hasGamePermit?: boolean | null }, statistics?: Array<{ __typename?: 'SeasonStatisticsRegistrations', role: SeasonRegistrationUserType, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }, club?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, totalStatistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null, teamStatistics?: Array<{ __typename?: 'TeamStatistics', team?: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam' } | null, totalStatistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null, gradeStatistics?: Array<{ __typename?: 'GradeStatistics', grade: { __typename?: 'DiscoverGrade', id: string, name: string }, totalStatistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null, gameStatistics?: Array<{ __typename?: 'SeasonGameStatistics', game: { __typename?: 'DiscoverGame', id: string, date: string, round: { __typename?: 'DiscoverRound', name: string }, home: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam' }, away: { __typename?: 'DiscoverTeam', id: string, name: string } | { __typename?: 'ProvisionalTeam' }, allocation?: { __typename?: 'DiscoverAllocation', court: { __typename?: 'DiscoverCourt', abbreviatedName: string, venue: { __typename?: 'DiscoverVenue', name: string } } } | null }, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, details?: { __typename?: 'GameStatistic', value: string } | null }> | null }> | null }> | null }> | null }> | null }> | null } | null, publicProfile?: { __typename?: 'DiscoverProfile', id: string, firstName: string, lastName: string } | null };

export type ProfilesToRegisterQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfilesToRegisterQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, dependants?: Array<{ __typename?: 'Profile', id: string, firstName: string, lastName: string }> | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', externalAccountID: string, tenantSlug: string }> } | null } | null };

export type GetDuplicateProfilesQueryVariables = Exact<{
  participantID: Scalars['ID'];
  registrationCode: Scalars['String'];
}>;


export type GetDuplicateProfilesQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, claimProfilesIsMandatory: boolean } | null, participant: { __typename?: 'Participant', id: string, profile?: { __typename?: 'Profile', id: string, duplicateProfiles?: Array<{ __typename?: 'DuplicateProfile', id: string, firstName: string, lastName: string, email: string, mobileNumber?: string | null, lastRegisteredRole?: SeasonRegistrationUserType | null, claimability: ClaimabilityStatus, isPrivate?: boolean | null, isMigrated?: boolean | null, lastRegisteredSeason?: { __typename?: 'DiscoverSeason', id: string, name: string } | null, lastRegisteredOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null }> | null } | null } };

export type GetParticipantTransferRequestsQueryVariables = Exact<{
  participantID: Scalars['ID'];
}>;


export type GetParticipantTransferRequestsQuery = { __typename?: 'Query', participant: { __typename?: 'Participant', id: string, type: string, status?: ParticipantStatus | null, clubChangeOptions?: Array<ClubChangeOption> | null, transferRequired?: { __typename?: 'ParticipantTransferRequired', hasRegistrationInSameSeason: boolean, transferDeniedReason?: TransferDeniedReason | null, pendingTransferRequest?: { __typename?: 'TransferRequest', id: string, destinationClub: { __typename?: 'DiscoverOrganisation', name: string } } | null, exceptionPeriod?: { __typename?: 'TransferExceptionPeriod', id: string } | null } | null, profile?: { __typename?: 'Profile', id: string } | null, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string } } } | { __typename?: 'ProgramSeason' } } }, tenantConfiguration?: { __typename?: 'TenantConfiguration', transfers: { __typename?: 'TenantTransferSettings', transferSettingsOwner: TransferSettingsOwner } } | null };

export type LinkExternalAccountMutationVariables = Exact<{
  input: LinkExternalAccountInput;
}>;


export type LinkExternalAccountMutation = { __typename?: 'Mutation', linkExternalAccount: { __typename?: 'ExternalAccount', tenantSlug: string, externalAccountID: string } };

export type AccountLinkingConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountLinkingConfigurationQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', externalAccountLinking?: { __typename?: 'ExternalAccountLinking', enabled: boolean, authUri?: string | null, clientID?: string | null, redirectUri?: string | null, shouldLinkSSOInRegistrationFlow?: boolean | null } | null } | null };

export type GetSportNameQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSportNameQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', sport?: { __typename?: 'SportConfiguration', name: string } | null } | null };

export type UpdatePendingParticipantMutationVariables = Exact<{
  input: UpdatePendingParticipantInput;
}>;


export type UpdatePendingParticipantMutation = { __typename?: 'Mutation', updatePendingParticipant?: boolean | null };

export type RegistrationOverviewQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type RegistrationOverviewQuery = { __typename?: 'Query', registrationSettings?: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, pricingInfo?: string | null, additionalInfo?: string | null, sessionCount?: number | null, gender?: GradeGender | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, startDate: string, endDate: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, ageRestrictionRange?: { __typename?: 'AgeRestrictionRange', dobFromDate: string, dobToDate: string } | null, ageGroups?: Array<{ __typename?: 'SeasonAgeGroup', minDOB?: string | null, maxDOB?: string | null, ageGroup?: { __typename?: 'AgeGroup', name: string, value: string } | null, equalToOrOlderThan?: { __typename?: 'YearsMonthsDays', years?: number | null, months?: number | null, days?: number | null } | null, youngerThan?: { __typename?: 'YearsMonthsDays', years?: number | null, months?: number | null, days?: number | null } | null }> | null } | { __typename?: 'ProgramSeason', id: string, name: string, startDate: string, endDate: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } }, registrationUserTypes: Array<{ __typename?: 'RegistrationUserType', name: string, displayName?: string | null, value: SeasonRegistrationUserType }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, registrationAgeRestriction?: { __typename?: 'AgeRestriction', asAtDate: string, range: { __typename?: 'IntRange', min: number, max: number } } | null, groups: Array<{ __typename?: 'Group', id: string, name: string, days: Array<DayOfTheWeek>, sessionCount?: number | null, gender?: GradeGender | null, startDate?: string | null, sessionStartTime?: string | null, sessionEndTime?: string | null, daySessions?: Array<{ __typename?: 'DaySession', day: DayOfTheWeek, startTime?: string | null, endTime?: string | null }> | null, playingSurface?: { __typename?: 'PlayingSurface', id: string, name: string, venue: { __typename?: 'Venue', id: string, name: string } } | null }>, ageGroupRestrictions?: Array<{ __typename?: 'AgeGroupRestriction', registrationInfo?: string | null, ageGroup?: { __typename?: 'AgeGroup', value: string } | null }> | null, daySessions?: Array<{ __typename?: 'DaySession', day: DayOfTheWeek, startTime?: string | null, endTime?: string | null }> | null, playingSurface?: { __typename?: 'PlayingSurface', id: string, name: string, venue: { __typename?: 'Venue', id: string, name: string } } | null } | { __typename?: 'DiscoverSocialTeamRegistration', id: string, pricingInfo?: string | null, additionalInfo?: string | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, startDate: string, endDate: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } } | null };

export type ParticipantRegisterMutationVariables = Exact<{
  input: ParticipantRegisterInput;
  registrationCode?: InputMaybe<Scalars['String']>;
}>;


export type ParticipantRegisterMutation = { __typename?: 'Mutation', participantRegister?: { __typename?: 'Participant', id: string, type: string, status?: ParticipantStatus | null, clubChangeOptions?: Array<ClubChangeOption> | null, profile?: { __typename?: 'Profile', id: string, firstName: string, duplicateProfiles?: Array<{ __typename?: 'DuplicateProfile', id: string }> | null } | null, transferRequired?: { __typename?: 'ParticipantTransferRequired', hasRegistrationInSameSeason: boolean, transferDeniedReason?: TransferDeniedReason | null, pendingTransferRequest?: { __typename?: 'TransferRequest', id: string, createdAt?: string | null, requestedBy?: TransferRequestedByRole | null, destinationClub: { __typename?: 'DiscoverOrganisation', id: string, name: string }, sourceAffiliation: { __typename?: 'Affiliation', club: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, season?: { __typename?: 'DiscoverSeason', id: string, name: string } | null } | null, exceptionPeriod?: { __typename?: 'TransferExceptionPeriod', id: string } | null } | null, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string, organisation: { __typename?: 'DiscoverOrganisation', id: string } } } | { __typename?: 'ProgramSeason' } } } | null };

export type FieldSetFragmentFragment = { __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null };

export type GetRegistrationTenantConfigurationQueryVariables = Exact<{
  registrationId: Scalars['String'];
  role?: InputMaybe<CustomFieldApplicableRole>;
}>;


export type GetRegistrationTenantConfigurationQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, seasonRegistration: { __typename?: 'SeasonRegistrationConfiguration', coachingAccreditationConfig?: { __typename?: 'CoachingAccreditationConfiguration', selfSubmit?: boolean | null, accreditations?: Array<{ __typename?: 'TenantField', name: string, value: string }> | null } | null, disabilities: Array<{ __typename?: 'TenantField', name: string, value: string }> }, discloseOptions: Array<{ __typename?: 'TenantField', name: string, value: string }>, sport?: { __typename?: 'SportConfiguration', name: string } | null } | null, configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null }, discoverSeasonRegistration: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, questions: Array<{ __typename?: 'RegistrationQuestion', id: string, question: string }>, customFields: Array<{ __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }>, groups: Array<{ __typename?: 'Group', id: string, name: string, days: Array<DayOfTheWeek>, sessionCount?: number | null, gender?: GradeGender | null, startDate?: string | null, sessionStartTime?: string | null, sessionEndTime?: string | null, userTypesMeta?: Array<{ __typename?: 'GroupUserTypeMeta', name?: string | null, value?: SeasonRegistrationUserType | null, registrationLimit?: { __typename?: 'RegistrationLimit', limitReached?: boolean | null } | null, fee?: { __typename?: 'Price', label: string } | null }> | null, daySessions?: Array<{ __typename?: 'DaySession', day: DayOfTheWeek, startTime?: string | null, endTime?: string | null }> | null, playingSurface?: { __typename?: 'PlayingSurface', id: string, name: string, venue: { __typename?: 'Venue', id: string, name: string } } | null }>, fieldEntries?: { __typename?: 'RegistrationFields', childSafety?: { __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null } | null, profileQuestions?: { __typename?: 'FieldSet', label?: string | null, name?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null, conditionalFields?: { __typename?: 'ConditionalFields', value?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, hidden?: boolean | null, required?: boolean | null, value?: string | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null } | null }> | null } | null } | null } };

export type GetParticipantDetailsQueryVariables = Exact<{
  participantId: Scalars['ID'];
}>;


export type GetParticipantDetailsQuery = { __typename?: 'Query', participant: { __typename?: 'Participant', id: string, school?: string | null, schoolYear?: string | null, playerNumber?: string | null, profile?: { __typename?: 'Profile', id: string, visible: boolean } | null, schoolData?: { __typename?: 'School', schoolID: string, name: string, suburb?: string | null, state?: string | null, postcode?: string | null } | null, customFieldAnswers: Array<{ __typename?: 'DropdownCustomFieldAnswer', question: { __typename?: 'DropdownCustomField', id: string }, dropdownAnswer?: { __typename?: 'DropdownOption', id: string } | null } | { __typename?: 'TextCustomFieldAnswer', answer?: string | null, question: { __typename?: 'TextCustomField', id: string } }>, preferredGroup?: { __typename?: 'Group', id: string } | null } };

export type GetProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfileQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, guardian1CountryOfBirth?: string | null, guardian2CountryOfBirth?: string | null, otherDisability?: string | null, disabilityHelp?: string | null, visible: boolean, gender?: { __typename?: 'TenantField', value: string } | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', value: string } } | null, indigenousDescent?: { __typename?: 'TenantField', value: string } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, displayNumber: string, number: string, countryCode: { __typename?: 'TenantField', value: string } } } | null, guardians?: Array<{ __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, displayNumber: string, number: string, countryCode: { __typename?: 'TenantField', value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, displayNumber: string, number: string, countryCode: { __typename?: 'TenantField', value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null }> | null, coachingAccreditation?: { __typename?: 'CoachingAccreditation', id: string, level: { __typename?: 'TenantField', value: string } } | null, childSafety?: Array<{ __typename?: 'FieldSet', name?: string | null, label?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, value?: string | null, hidden?: boolean | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, value?: string | null, hidden?: boolean | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', name?: string | null, fields?: Array<{ __typename?: 'FieldInput', name?: string | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, value?: string | null }> | null }> | null, guardianBornOverseas?: { __typename?: 'TenantField', value: string } | null, hasDisability?: { __typename?: 'TenantField', value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', value: string }> | null } | null } | null };

export type GetParentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetParentProfileQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | null } | null };

export type GetExistingDependantQueryVariables = Exact<{
  profileID: Scalars['ID'];
}>;


export type GetExistingDependantQuery = { __typename?: 'Query', dependantProfile?: { __typename?: 'Profile', id: string, firstName: string, lastName: string, genderSelfDescribe?: string | null, dateOfBirth?: string | null, preferredName?: string | null, countryOfBirth?: string | null, homeNumber?: string | null, guardian1CountryOfBirth?: string | null, guardian2CountryOfBirth?: string | null, otherDisability?: string | null, disabilityHelp?: string | null, visible: boolean, gender?: { __typename?: 'TenantField', value: string } | null, indigenousDescent?: { __typename?: 'TenantField', value: string } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, emergencyContact?: { __typename?: 'EmergencyContact', id: string, firstName: string, lastName: string, email: string, relation: string, mobileNumber: { __typename?: 'Mobile', countryAlphaCode?: string | null, number: string, displayNumber: string, countryCode: { __typename?: 'TenantField', value: string } } } | null, guardians?: Array<{ __typename?: 'Guardian', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, displayNumber: string, number: string, countryCode: { __typename?: 'TenantField', value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | { __typename?: 'Profile', id: string, firstName: string, lastName: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', countryAlphaCode?: string | null, displayNumber: string, number: string, countryCode: { __typename?: 'TenantField', value: string } } | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null }> | null, coachingAccreditation?: { __typename?: 'CoachingAccreditation', id: string, level: { __typename?: 'TenantField', value: string } } | null, childSafety?: Array<{ __typename?: 'FieldSet', name?: string | null, label?: string | null, fields?: Array<{ __typename?: 'FieldInput', type?: FieldInputType | null, name?: string | null, label?: string | null, value?: string | null, hidden?: boolean | null } | { __typename?: 'FieldSelect', name?: string | null, label?: string | null, value?: string | null, hidden?: boolean | null, options?: Array<{ __typename?: 'FieldOption', label?: string | null, value?: string | null }> | null }> | null }> | null, profileQuestions?: Array<{ __typename?: 'FieldSet', name?: string | null, fields?: Array<{ __typename?: 'FieldInput', name?: string | null, value?: string | null } | { __typename?: 'FieldSelect', name?: string | null, value?: string | null }> | null }> | null, guardianBornOverseas?: { __typename?: 'TenantField', value: string } | null, hasDisability?: { __typename?: 'TenantField', value: string } | null, disabilities?: Array<{ __typename?: 'TenantField', value: string }> | null } | null };

export type RegistrationAssertQueryVariables = Exact<{
  input: RegistrationAssertInput;
}>;


export type RegistrationAssertQuery = { __typename?: 'Query', registrationAssert: { __typename?: 'AssertHash', hashKey?: string | null, timestampIso?: string | null } };

export type GetPaymentDetailsQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type GetPaymentDetailsQuery = { __typename?: 'Query', registrationSettings?: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, season: { __typename?: 'DiscoverSeason', id: string, name: string, startDate: string, endDate: string, ageRestrictionRange?: { __typename?: 'AgeRestrictionRange', dobFromDate: string, dobToDate: string } | null, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, format?: { __typename?: 'TenantField', name: string } | null } } | { __typename?: 'ProgramSeason', id: string, name: string, startDate: string, endDate: string, program: { __typename?: 'Program', id: string, name: string, format?: { __typename?: 'TenantField', name: string } | null } } } | { __typename?: 'DiscoverSocialTeamRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, startDate: string, endDate: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, format?: { __typename?: 'TenantField', name: string } | null } } } | null, configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null }, account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null } | null } | null };

export type OrderSubmitMutationVariables = Exact<{
  input: OrderSubmitInput;
}>;


export type OrderSubmitMutation = { __typename?: 'Mutation', orderSubmit: { __typename?: 'Order', id: string, status?: OrderStatus | null, amount: { __typename?: 'Price', net: number } } };

export type GetParticipantExternalQueryVariables = Exact<{
  participantID: Scalars['ID'];
}>;


export type GetParticipantExternalQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, email?: string | null, mobileNumber?: { __typename?: 'Mobile', number: string, countryCode: { __typename?: 'TenantField', value: string } } | null, externalAccounts: Array<{ __typename?: 'ExternalAccount', tenantSlug: string, externalAccountID: string }> } | null } | null, participant: { __typename?: 'Participant', id: string, type: string, profile?: { __typename?: 'Profile', id: string, gender?: { __typename?: 'TenantField', name: string, value: string } | null } | null } };

export type ProductsUpdateCartMutationVariables = Exact<{
  input: SeasonRegistrationProductCartInput;
}>;


export type ProductsUpdateCartMutation = { __typename?: 'Mutation', productsUpdateCart: { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', discount?: { __typename?: 'CartDiscount', id: string, name: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null, fee: { __typename?: 'MembershipAdvancedFee', description?: string | null, applicationRole?: string | null, applicationDescription: string, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, selectedPayment?: { __typename?: 'MembershipAdvancedFeePayment', id: string } | null, payments: Array<{ __typename?: 'MembershipAdvancedFeePayment', id: string, type: MembershipApplicationPaymentTypes, amount: { __typename?: 'Price', net: number } }> } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productVariantID: string, fulfilmentMethod: FulfilmentMethod, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee', id: string, description?: string | null, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, amountDeferred?: { __typename: 'Price', net: number, currency: { __typename: 'Currency', code: string } } | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, selectedOption?: { __typename?: 'ParticipantFeeOption', id: string } | null, options?: Array<{ __typename?: 'ParticipantFeeOption', id: string, description?: string | null, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null } | { __typename?: 'TeamFee' } }>, totals: { __typename?: 'CartTotals', vouchers?: Array<{ __typename?: 'CartVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> | null, promotionalVouchers?: Array<{ __typename?: 'CartPromotionalVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, externalVouchers?: Array<{ __typename?: 'CartExternalVoucher', code: string, isExistingMember?: boolean | null, identifiedDisability?: boolean | null, culturalLinguisticDiversity?: boolean | null, aboriginalOrTorresStraightIslander?: boolean | null, englishMainLanguageSpokenAtHome?: boolean | null, alternativeMainLanguageSpokenAtHome?: string | null, costToRegisterForActivity?: number | null, scheme: { __typename?: 'VoucherScheme', id: string, name: string, hasAmount: boolean }, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredSubtotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredServiceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, selectedCharities?: Array<{ __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }, productsAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, feesAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, availableExternalVouchers?: Array<{ __typename?: 'ExternalVoucher', scheme: { __typename?: 'VoucherScheme', id: string, name: string, externalOwner: string, hasAmount: boolean, minAmount?: number | null, maxAmount?: number | null } }> | null, availableCharities?: Array<{ __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }> | null } };

export type ProductUpdateSocialTeamCartMutationVariables = Exact<{
  input: SocialTeamRegistrationProductCartInput;
}>;


export type ProductUpdateSocialTeamCartMutation = { __typename?: 'Mutation', productUpdateSocialTeamCart: { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', fee: { __typename?: 'MembershipAdvancedFee' } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productVariantID: string, fulfilmentMethod: FulfilmentMethod, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee' } | { __typename?: 'TeamFee', id: string, description?: string | null, quantity: number, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }>, totals: { __typename?: 'CartTotals', vouchers?: Array<{ __typename?: 'CartVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> | null, promotionalVouchers?: Array<{ __typename?: 'CartPromotionalVoucher', id: string, name: string, code: string, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, externalVouchers?: Array<{ __typename?: 'CartExternalVoucher', code: string, scheme: { __typename?: 'VoucherScheme', id: string, name: string, hasAmount: boolean }, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisations: Array<{ __typename?: 'DiscoverOrganisation', id: string, name: string }> }> | null, totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredSubtotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, deferredServiceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }, productsAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, feesAmount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } } };

export type GetProfilePhotoVerificationUploadUrlQueryVariables = Exact<{
  dependantProfileID?: InputMaybe<Scalars['ID']>;
}>;


export type GetProfilePhotoVerificationUploadUrlQuery = { __typename?: 'Query', profilePhotoVerificationUploadURL: { __typename?: 'SignedUrl', url: string } };

export type GetProfilePhotoVerificationUrlQueryVariables = Exact<{
  profileID?: InputMaybe<Scalars['ID']>;
}>;


export type GetProfilePhotoVerificationUrlQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', profilePhotoVerificationURL?: { __typename?: 'SignedUrl', url: string } | null } | null };

export type GetDependantProfilePhotoVerificationUrlQueryVariables = Exact<{
  profileID: Scalars['ID'];
}>;


export type GetDependantProfilePhotoVerificationUrlQuery = { __typename?: 'Query', dependantProfile?: { __typename?: 'Profile', profilePhotoVerificationURL?: { __typename?: 'SignedUrl', url: string } | null } | null };

export type GetProfilePhotoVerificationConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProfilePhotoVerificationConfigQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', seasonRegistration: { __typename?: 'SeasonRegistrationConfiguration', photoVerification?: { __typename?: 'RegistrationPhotoVerificationConfiguration', enabled?: boolean | null, requiredMinimumAge?: number | null, roles?: Array<SeasonRegistrationUserType> | null } | null } } | null };

export type GetRegistrationStatusQueryVariables = Exact<{
  code: Scalars['String'];
  participantId: Scalars['ID'];
}>;


export type GetRegistrationStatusQuery = { __typename?: 'Query', participant: { __typename?: 'Participant', id: string, status?: ParticipantStatus | null, clubChangeOptions?: Array<ClubChangeOption> | null, profile?: { __typename?: 'Profile', id: string, registrationHistory?: Array<{ __typename?: 'DiscoverTeam' } | { __typename?: 'Participant', id: string, type: string, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string } } | { __typename?: 'ProgramSeason' }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }> | null } | null }, registrationSettings?: { __typename?: 'DiscoverRegistration', season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } | { __typename?: 'ProgramSeason' }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'DiscoverSocialTeamRegistration' } | null };

export type TransferRequestCreateMutationVariables = Exact<{
  participantID: Scalars['ID'];
}>;


export type TransferRequestCreateMutation = { __typename?: 'Mutation', transferRequestCreate: { __typename?: 'TransferRequest', id: string } };

export type PermitRequestCreateMutationVariables = Exact<{
  participantID: Scalars['ID'];
}>;


export type PermitRequestCreateMutation = { __typename?: 'Mutation', permitRequestCreate?: { __typename?: 'Permit', id: string } | null };

export type RegistrationCheckQueryVariables = Exact<{
  input: RegistrationCheckInput;
}>;


export type RegistrationCheckQuery = { __typename?: 'Query', registrationCheck?: { __typename?: 'RegistrationCheckResult', alreadyRegisteredToRole?: boolean | null, approvedParticipantID?: string | null, hasAffiliationChangedSinceParticipantCreation?: boolean | null, transferRequest?: { __typename?: 'TransferRequest', id: string, status?: TransferRequestStatus | null, createdAt?: string | null, requestedBy?: TransferRequestedByRole | null, sourceAffiliation: { __typename?: 'Affiliation', id: string, club: { __typename?: 'DiscoverOrganisation', id: string, name: string } }, destinationClub: { __typename?: 'DiscoverOrganisation', id: string, name: string }, season?: { __typename?: 'DiscoverSeason', id: string, name: string } | null } | null, permitRequest?: { __typename?: 'Permit', id: string, status: PermitStatus } | null } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', transfers: { __typename?: 'TenantTransferSettings', transferSettingsOwner: TransferSettingsOwner } } | null };

export type GetPendingTransferRequestForPrimaryProfileQueryVariables = Exact<{
  filter?: InputMaybe<TransferRequestsFilter>;
}>;


export type GetPendingTransferRequestForPrimaryProfileQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, transferRequests: Array<{ __typename?: 'TransferRequest', id: string }> } | null } | null };

export type GetPendingTransferRequestForExistingDependantQueryVariables = Exact<{
  profileID: Scalars['ID'];
  filter?: InputMaybe<TransferRequestsFilter>;
}>;


export type GetPendingTransferRequestForExistingDependantQuery = { __typename?: 'Query', dependantProfile?: { __typename?: 'Profile', id: string, transferRequests: Array<{ __typename?: 'TransferRequest', id: string }> } | null };

export type DiscoverSeasonRegistrationQueryVariables = Exact<{
  registrationId: Scalars['String'];
}>;


export type DiscoverSeasonRegistrationQuery = { __typename?: 'Query', discoverSeasonRegistration: { __typename?: 'DiscoverRegistration', id: string, registrationUserTypes: Array<{ __typename?: 'RegistrationUserType', name: string, displayName?: string | null, value: SeasonRegistrationUserType, registrationLimit?: { __typename?: 'RegistrationLimit', limitReached?: boolean | null } | null }> } };

export type RegistrationHistoryFragmentFragment = { __typename?: 'Profile', id: string, registrationHistory?: Array<{ __typename?: 'DiscoverTeam' } | { __typename?: 'Participant', id: string, type: string, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string } } | { __typename?: 'ProgramSeason', id: string, program: { __typename?: 'Program', id: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string } } }> | null };

export type ProfileRegistrationHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileRegistrationHistoryQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, dependants?: Array<{ __typename?: 'Profile', id: string, registrationHistory?: Array<{ __typename?: 'DiscoverTeam' } | { __typename?: 'Participant', id: string, type: string, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string } } | { __typename?: 'ProgramSeason', id: string, program: { __typename?: 'Program', id: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string } } }> | null }> | null, registrationHistory?: Array<{ __typename?: 'DiscoverTeam' } | { __typename?: 'Participant', id: string, type: string, seasonRegistration: { __typename?: 'DiscoverRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, competition: { __typename?: 'DiscoverCompetition', id: string } } | { __typename?: 'ProgramSeason', id: string, program: { __typename?: 'Program', id: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string } } }> | null } | null } | null };

export type DiscoverSeasonDetailsFragment = { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } };

export type ProgramSeasonDetailsFragment = { __typename?: 'ProgramSeason', id: string, name: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } };

export type GetRegistrationForShareQueryVariables = Exact<{
  code: Scalars['String'];
  teamId: Scalars['ID'];
  skipTeam?: Scalars['Boolean'];
}>;


export type GetRegistrationForShareQuery = { __typename?: 'Query', registrationSettings?: { __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } | { __typename?: 'ProgramSeason', id: string, name: string, program: { __typename?: 'Program', id: string, name: string, alias?: string | null } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'DiscoverSocialTeamRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } } | null, discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, preferredGrade?: string | null } | null };

export type SocialTeamRegistrationSubmitMutationVariables = Exact<{
  input: SocialTeamCreateInput;
}>;


export type SocialTeamRegistrationSubmitMutation = { __typename?: 'Mutation', socialTeamRegistrationSubmit: { __typename?: 'DiscoverTeam', id: string, name: string } };

export type GetSocialTeamGradesAndOrganisationQueryVariables = Exact<{
  code: Scalars['ID'];
}>;


export type GetSocialTeamGradesAndOrganisationQuery = { __typename?: 'Query', discoverSocialTeamRegistration: { __typename?: 'DiscoverSocialTeamRegistration', id: string, grades: Array<{ __typename?: 'DiscoverGrade', id: string, name: string, day?: { __typename?: 'TenantField', value: string } | null, gender?: { __typename?: 'TenantField', value: string } | null }>, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }, customFields: Array<{ __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string, customField?: { __typename?: 'DropdownCustomField', id: string, name: string, required?: boolean | null, dropdownOptions: Array<{ __typename?: 'DropdownOption', id: string, label: string }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | { __typename?: 'TextCustomField', id: string, name: string, required?: boolean | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } }> } };

export type GetMySocialTeamsQueryVariables = Exact<{
  organisationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetMySocialTeamsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, profile?: { __typename?: 'Profile', id: string, socialTeams: Array<{ __typename?: 'TeamOrigin', id: string, name: string }> } | null } | null };

export type DiscoverDiscountQueryVariables = Exact<{
  input: DiscoverDiscountInput;
}>;


export type DiscoverDiscountQuery = { __typename?: 'Query', discoverDiscount?: { __typename?: 'Discount', id: string, enabled: boolean } | null };

export type SeasonRegistrationsQueryVariables = Exact<{
  seasonId: Scalars['ID'];
}>;


export type SeasonRegistrationsQuery = { __typename?: 'Query', seasonRegistrations: Array<{ __typename?: 'DiscoverRegistration', id: string, type: SeasonRegistrationType, registrationCode: string }> };

export type GetTeamAndSeasonRegQueryVariables = Exact<{
  code: Scalars['String'];
  teamId: Scalars['ID'];
}>;


export type GetTeamAndSeasonRegQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, preferredGrade?: string | null } | null, registrationSettings?: { __typename?: 'DiscoverRegistration' } | { __typename?: 'DiscoverSocialTeamRegistration', id: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } } | null };

export type GetParticipantQueryVariables = Exact<{
  participantId: Scalars['ID'];
}>;


export type GetParticipantQuery = { __typename?: 'Query', participant: { __typename?: 'Participant', id: string, transferRequired?: { __typename?: 'ParticipantTransferRequired', hasRegistrationInSameSeason: boolean, pendingTransferRequest?: { __typename?: 'TransferRequest', id: string } | null } | null } };

export type RequestTransferMutationVariables = Exact<{
  participantId: Scalars['ID'];
}>;


export type RequestTransferMutation = { __typename?: 'Mutation', transferRequestCreate: { __typename?: 'TransferRequest', id: string } };

export type GetCompetitionTypeQueryVariables = Exact<{
  gradeID: Scalars['ID'];
}>;


export type GetCompetitionTypeQuery = { __typename?: 'Query', discoverGrade?: { __typename?: 'DiscoverGrade', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, type: CompetitionType, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } } | null };

export type DiscoverCompetitionsQueryVariables = Exact<{
  organisationID: Scalars['ID'];
  organisationCode: Scalars['String'];
}>;


export type DiscoverCompetitionsQuery = { __typename?: 'Query', discoverCompetitions: Array<{ __typename?: 'DiscoverCompetition', id: string, name: string, seasons: Array<{ __typename?: 'DiscoverSeason', id: string, name: string, startDate: string, endDate: string, status: { __typename?: 'DiscoverSeasonStatus', name: string, value: DiscoverSeasonStatusType } }>, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null } }>, discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, sport?: { __typename?: 'SportConfiguration', name: string } | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type GetOrganisationShopProductsQueryVariables = Exact<{
  orgCode: Scalars['String'];
  shopFilter?: InputMaybe<ShopProductsFilter>;
}>;


export type GetOrganisationShopProductsQuery = { __typename?: 'Query', shopProducts?: Array<{ __typename?: 'ShallowProduct', id: string, name?: string | null, productType?: ProductType | null, maxPrice?: { __typename?: 'Price', net: number } | null, minPrice?: { __typename?: 'Price', net: number } | null, images?: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }> | null }> | null };

export type GetTenantStripeKeyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantStripeKeyQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', stripePublicKey?: string | null } | null };

export type GetShopCheckoutConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShopCheckoutConfigQuery = { __typename?: 'Query', configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null } };

export type GetShopCheckoutSessionQueryVariables = Exact<{
  shopCartInput: ShopCartArgs;
}>;


export type GetShopCheckoutSessionQuery = { __typename?: 'Query', shopCart?: { __typename?: 'ShopCart', checkoutSession?: { __typename: 'Gr4vyCheckoutSession' } | { __typename: 'Gr4vyEmbedCheckoutSession', id: string, expiryDate?: string | null, embedToken?: string | null } | { __typename: 'StripeCheckoutSession' } | null } | null };

export type GetShopProductQueryVariables = Exact<{
  orgCode: Scalars['String'];
  productId: Scalars['ID'];
}>;


export type GetShopProductQuery = { __typename?: 'Query', discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, name: string } | null, shopProduct?: { __typename?: 'Product', id: string, name: string, description?: string | null, activeShop?: boolean | null, productType: ProductType, settings?: { __typename?: 'ProductSettings', validFrom?: { __typename?: 'DateTime', date: string } | null, validTo?: { __typename?: 'DateTime', date: string } | null } | null, variants: Array<{ __typename?: 'ProductVariant', id: string, name?: string | null, available: boolean, amount: { __typename?: 'Price', net: number }, categoryPairs?: Array<{ __typename?: 'ProductVariantPair', id: string, category: { __typename?: 'ProductCategory', id: string, name: string }, option: { __typename?: 'ProductCategoryOption', id: string, name: string } }> | null }>, categories: Array<{ __typename?: 'ProductCategory', id: string, name: string, options: Array<{ __typename?: 'ProductCategoryOption', id: string, name: string }> }>, customFields: Array<{ __typename?: 'ProductCustomField', id: string, question: string, type: CustomFieldType, dropdownOptions?: Array<{ __typename?: 'ProductDropdownOption', id: string, label: string }> | null, option?: { __typename?: 'ProductCustomFieldOption', category: { __typename?: 'ProductCategory', id: string }, option: { __typename?: 'ProductCategoryOption', id: string } } | null }>, images: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }> } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null } | null };

export type UpdateShopCartMutationVariables = Exact<{
  input: ShopCartUpsertInput;
}>;


export type UpdateShopCartMutation = { __typename?: 'Mutation', shopCartUpsert?: { __typename?: 'ShopCart', id: string, items?: Array<{ __typename?: 'CartItem', fee: { __typename?: 'MembershipAdvancedFee' } | { __typename?: 'MerchandiseFee', description?: string | null, quantity: number, productID: string, productVariantID: string, productType: ProductType, fulfilmentMethod: FulfilmentMethod, fulfilmentProvider?: string | null, amount: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, images?: Array<{ __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number } }> }> | null, categoryPairs?: Array<{ __typename?: 'CategoryPair', id: string, name?: string | null, value?: string | null }> | null, customFieldAnswers?: Array<{ __typename?: 'MerchandiseFeeCustomFieldResponse', answer: string, customField: { __typename?: 'ProductCustomField', id: string } }> | null } | { __typename?: 'ParticipantFee' } | { __typename?: 'TeamFee' } }> | null, availableCharities?: Array<{ __typename?: 'Charity', id: string, name?: string | null, description?: string | null, charityIdentifier?: string | null, learnMoreUrl?: string | null, options?: Array<{ __typename?: 'DonationOption', amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null }> | null, totals?: { __typename?: 'CartTotals', totalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, subTotalAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, serviceFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, shippingFeeAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null, selectedCharities?: Array<{ __typename?: 'SelectedCharity', id: string, amount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null }> | null } | null, productsAmount?: { __typename?: 'Price', net: number, currency: { __typename?: 'Currency', code: string } } | null } | null };

export type GetOrganisationShopSettingsQueryVariables = Exact<{
  orgCode: Scalars['String'];
}>;


export type GetOrganisationShopSettingsQuery = { __typename?: 'Query', discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type SignUpQueryVariables = Exact<{ [key: string]: never; }>;


export type SignUpQuery = { __typename?: 'Query', configuration: { __typename?: 'Configuration', supportedCountries?: Array<{ __typename?: 'SupportedCountry', name: string, alpha2Code: string, mobileCountryCode: string }> | null } };

export type AccountConfirmMutationVariables = Exact<{
  input: AccountConfirmInput;
}>;


export type AccountConfirmMutation = { __typename?: 'Mutation', accountConfirm: { __typename?: 'AccountConfirmation', success: boolean } };

export type DiscoverTeamQueryVariables = Exact<{
  teamID: Scalars['ID'];
}>;


export type DiscoverTeamQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null };

export type TeamFixtureQueryVariables = Exact<{
  teamID: Scalars['ID'];
}>;


export type TeamFixtureQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string }, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } | null, discoverTeamFixture: Array<{ __typename?: 'DiscoverRound', id: string, name: string, isStale?: boolean | null, provisionalDates?: Array<string> | null, grade: { __typename?: 'DiscoverGrade', id: string, name: string, type?: GradeType | null, hideScores: boolean, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, type: CompetitionType, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string } } } }, fixture: { __typename?: 'DiscoverRoundFixture', byes: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } }>, games: Array<{ __typename?: 'DiscoverGame', id: string, alias?: string | null, date: string, dates?: Array<string> | null, isStale?: boolean | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, away: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, home: { __typename?: 'DiscoverTeam', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } | { __typename?: 'ProvisionalTeam', name: string, pool?: { __typename?: 'Pool', id: string, name: string } | null }, result?: { __typename?: 'GameResult', winner?: { __typename?: 'TenantField', name: string, value: string } | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, home: { __typename?: 'GameTeamResult', gameOutcomeDescription?: string | null, outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null }, away: { __typename?: 'GameTeamResult', outcome?: { __typename?: 'TenantField', name: string, value: string } | null, statistics?: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', value: string } }> | null, periods?: Array<{ __typename?: 'GamePeriodStatistics', type?: PeriodType | null, closureStatus?: ClosureStatus | null, period: { __typename?: 'Period', label: string, value: PeriodValue }, statistics: Array<{ __typename?: 'Statistic', count?: number | null, type: { __typename?: 'GameEventConfiguration', label: string, value: string } }> }> | null } } | null, status: { __typename?: 'GameStatus', name: string, value: GameStatusType }, allocation?: { __typename?: 'DiscoverAllocation', time: string, dateTimeList?: Array<{ __typename?: 'DateTime', date: string, time: string }> | null, court: { __typename?: 'DiscoverCourt', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, venue: { __typename?: 'DiscoverVenue', id: string, name: string, abbreviatedName: string, latitude?: string | null, longitude?: string | null, address: string, suburb: string, state: string, postcode: string, country: string } } } | null, gameType?: { __typename?: 'GameType', name?: string | null, value?: string | null, eScoringSettings?: { __typename?: 'EScoringSettings', dismissalsPerBatter?: number | null, legalBallsPerOver?: number | null } | null } | null }> } }>, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, gradeTypes?: Array<{ __typename?: 'GradeTypeConfig', value?: GradeType | null, isAllPlay?: boolean | null, features?: { __typename?: 'GradeTypeFeatures', hasRounds?: boolean | null, hasSeasonStats?: boolean | null, hasCareerStats?: boolean | null, hasGameStats?: boolean | null, hasFixture?: boolean | null, hasLadder?: boolean | null } | null }> | null } | null };

export type TeamLadderQueryVariables = Exact<{
  teamID: Scalars['ID'];
}>;


export type TeamLadderQuery = { __typename?: 'Query', discoverTeam?: { __typename?: 'DiscoverTeam', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, type: CompetitionType } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string }, grade?: { __typename?: 'DiscoverGrade', id: string, name: string, ladderType?: LadderTemplate | null, ladder: Array<{ __typename?: 'LadderPool', gameTypeValue?: string | null, pool?: { __typename?: 'Pool', id: string, name: string } | null, generatedFrom: { __typename?: 'DiscoverRound', id: string, name: string }, standings: Array<{ __typename?: 'LadderStanding', played: number, won: number, lost: number, drawn: number, byes: number, pointsFor: number, pointsAgainst: number, pointsDifference?: number | null, percentage: number, alternatePercentage?: number | null, competitionPoints: number, pointsAverage?: number | null, forfeits: number, disqualifications: number, adjustments: number, noResults?: number | null, ties?: number | null, quotient?: number | null, netRunRate?: number | null, runsFor?: number | null, oversFaced?: number | null, wicketsLost?: number | null, runsAgainst?: number | null, oversBowled?: number | null, wicketsTaken?: number | null, winOutright?: number | null, winFirstInnings?: number | null, lossOutright?: number | null, lossFirstInnings?: number | null, matchRatio?: number | null, bonusPoints?: number | null, team: { __typename?: 'DiscoverTeam', id: string, name: string, season: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string } }, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, type: OrganisationType } } }> }>, gameTypes?: Array<{ __typename?: 'GameType', name?: string | null, value?: string | null, ladderFields?: Array<{ __typename?: 'LadderField', shortName?: string | null, key?: string | null, toolTip?: string | null, extendedToolTip?: string | null, type?: LadderFieldType | null, displayOrder?: number | null, dataType?: LadderDataType | null, decimals?: number | null }> | null, ladderRankingFields?: Array<{ __typename?: 'LadderField', fullName?: string | null, shortName?: string | null, key?: string | null, sortOrder?: number | null, toolTip?: string | null }> | null }> | null, overallLadderFields?: Array<{ __typename?: 'LadderField', shortName?: string | null, key?: string | null, toolTip?: string | null, type?: LadderFieldType | null, displayOrder?: number | null, dataType?: LadderDataType | null, decimals?: number | null }> | null, overallLadderRankingFields?: Array<{ __typename?: 'LadderField', fullName?: string | null, shortName?: string | null, key?: string | null, sortOrder?: number | null, toolTip?: string | null }> | null } | null } | null };

export type DiscoverOrganisationTeamsQueryVariables = Exact<{
  seasonCode: Scalars['String'];
  seasonId: Scalars['ID'];
  organisationCode: Scalars['String'];
  organisationId: Scalars['ID'];
}>;


export type DiscoverOrganisationTeamsQuery = { __typename?: 'Query', discoverSeason?: { __typename?: 'DiscoverSeason', id: string, name: string, competition: { __typename?: 'DiscoverCompetition', id: string, name: string, organisation: { __typename?: 'DiscoverOrganisation', id: string, name: string, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null } }, status: { __typename?: 'DiscoverSeasonStatus', name: string, value: DiscoverSeasonStatusType }, grades: Array<{ __typename?: 'DiscoverGrade', id: string, name: string }> } | null, tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, competition: { __typename?: 'CompetitionConfiguration', ageGroups: Array<{ __typename?: 'TenantField', name: string, value: string }>, genders: Array<{ __typename?: 'TenantField', name: string, value: string }> }, contactRoles: Array<{ __typename?: 'TenantField', name: string, value: string }> } | null, discoverTeams: Array<{ __typename?: 'DiscoverTeam', id: string, name: string, gender: { __typename?: 'TenantField', name: string, value: string }, ageGroup: { __typename?: 'TenantField', name: string, value: string }, grade?: { __typename?: 'DiscoverGrade', id: string, name: string } | null }>, discoverOrganisation?: { __typename?: 'DiscoverOrganisation', id: string, type: OrganisationType, name: string, email: string, contactNumber: string, websiteUrl?: string | null, shopVisible?: boolean | null, address?: { __typename?: 'Address', id: string, line1: string, suburb: string, postcode: string, state: string, country: string } | null, logo?: { __typename?: 'Image', sizes: Array<{ __typename?: 'ImageSource', url: string, dimensions: { __typename?: 'ImageDimension', width: number, height: number } }> } | null, contacts: Array<{ __typename?: 'DiscoverOrganisationContact', id: string, firstName: string, lastName: string, position: string, email?: string | null, phone?: string | null }> } | null };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'Query', tenantConfiguration?: { __typename?: 'TenantConfiguration', label?: string | null, sport?: { __typename?: 'SportConfiguration', name: string } | null } | null };

type DiscriminateUnion<T, U> = T extends U ? T : never;

export type SearchAddressesVariables = SearchAddressesQueryVariables;
export type AddressVariables = AddressQueryVariables;
export type AddressAddress = (NonNullable<AddressQuery['address']>);
export type AppBannerVariables = AppBannerQueryVariables;
export type AppBannerTenantConfiguration = (NonNullable<AppBannerQuery['tenantConfiguration']>);
export type AppBannerExternalAppUrls = NonNullable<(NonNullable<(NonNullable<AppBannerQuery['tenantConfiguration']>)['externalAppUrls']>)[number]>;
export type AppBannerOutswingConfiguration = (NonNullable<(NonNullable<AppBannerQuery['tenantConfiguration']>)['outswingConfiguration']>);
export type AppFooterBannerVariables = AppFooterBannerQueryVariables;
export type AppFooterBannerTenantConfiguration = (NonNullable<AppFooterBannerQuery['tenantConfiguration']>);
export type AppFooterBannerOutswingConfiguration = (NonNullable<(NonNullable<AppFooterBannerQuery['tenantConfiguration']>)['outswingConfiguration']>);
export type AppPromoBannerVariables = AppPromoBannerQueryVariables;
export type AppPromoBannerTenantConfiguration = (NonNullable<AppPromoBannerQuery['tenantConfiguration']>);
export type AppPromoBannerOutswingConfiguration = (NonNullable<(NonNullable<AppPromoBannerQuery['tenantConfiguration']>)['outswingConfiguration']>);
export type CheckoutSessionCreateVariables = CheckoutSessionCreateMutationVariables;
export type CheckoutSessionCreateCheckoutSessionCreate = (NonNullable<CheckoutSessionCreateMutation['checkoutSessionCreate']>);
export type CheckoutSessionCreateGr4vyCheckoutSessionInlineFragment = (DiscriminateUnion<(NonNullable<CheckoutSessionCreateMutation['checkoutSessionCreate']>), { __typename?: 'Gr4vyCheckoutSession' }>);
export type CheckoutSessionCreateGr4vyEmbedCheckoutSessionInlineFragment = (DiscriminateUnion<(NonNullable<CheckoutSessionCreateMutation['checkoutSessionCreate']>), { __typename?: 'Gr4vyEmbedCheckoutSession' }>);
export type GameViewVariables = GameViewQueryVariables;
export type GameViewDiscoverGame = (NonNullable<GameViewQuery['discoverGame']>);
export type GameViewAway = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['away']>);
export type GameViewHome = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['home']>);
export type GameViewResult = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>);
export type GameViewWinner = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['winner']>);
export type GameViewOutcome = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['outcome']>);
export type GameView_Home = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>);
export type GameView_Outcome = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['outcome']>);
export type GameViewStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['statistics']>)[number]>;
export type GameViewType = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['statistics']>)[number]>['type']>);
export type GameViewPeriods = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['periods']>)[number]>;
export type GameViewPeriod = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['periods']>)[number]>['period']>);
export type GameView_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>;
export type GameView_Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type GameView_Away = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>);
export type GameView__Outcome = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['outcome']>);
export type GameView__Statistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['statistics']>)[number]>;
export type GameView__Type = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['statistics']>)[number]>['type']>);
export type GameView_Periods = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['periods']>)[number]>;
export type GameView_Period = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['periods']>)[number]>['period']>);
export type GameView___Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>;
export type GameView___Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type GameViewStatus = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['status']>);
export type GameViewRound = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>);
export type GameViewGrade = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>);
export type GameViewDay = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['day']>);
export type GameViewSeason = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['season']>);
export type GameViewCompetition = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['season']>)['competition']>);
export type GameViewOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['season']>)['competition']>)['organisation']>);
export type GameViewGameEvents = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameEvents']>);
export type GameViewParticipantEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameEvents']>)['participantEvents']>)[number]>;
export type GameViewPeriodEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameEvents']>)['periodEvents']>)[number]>;
export type GameViewPeriodScoresDisplayType = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['periodScoresDisplayType']>);
export type GameView__Periods = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['periods']>)[number]>;
export type GameViewPlayerPoints = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['playerPoints']>);
export type GameViewBestPlayers = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['bestPlayers']>);
export type GameViewGameStatisticsConfiguration = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameStatisticsConfiguration']>);
export type GameViewGameStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>;
export type GameViewGlossary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>['glossary']>);
export type GameViewDefault = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>['glossary']>)['default']>);
export type GameViewScoring = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>['glossary']>)['scoring']>);
export type GameViewAllocation = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['allocation']>);
export type GameViewDateTimeList = NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['allocation']>)['dateTimeList']>)[number]>;
export type GameViewCourt = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['allocation']>)['court']>);
export type GameViewVenue = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['allocation']>)['court']>)['venue']>);
export type GameView____Statistics = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>);
export type GameView__Home = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['home']>);
export type GameView__Away = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['away']>);
export type GameViewShared = NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['shared']>)[number]>;
export type GameView__Period = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['shared']>)[number]>['period']>);
export type GameView_____Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['shared']>)[number]>['statistics']>)[number]>;
export type GameView____Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['shared']>)[number]>['statistics']>)[number]>['type']>);
export type GameViewPlayers = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['statistics']>)['shared']>)[number]>['players']>)[number]>;
export type GameViewGameType = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['gameType']>);
export type GameViewEScoringSettings = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['gameType']>)['eScoringSettings']>);
export type GameViewEmergencyPlayersSettings = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['gameType']>)['emergencyPlayersSettings']>);
export type GameViewPlayerPositionsSettings = (NonNullable<(NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['gameType']>)['playerPositionsSettings']>);
export type GameViewFormation = (NonNullable<(NonNullable<GameViewQuery['discoverGame']>)['formation']>);
export type GameViewTenantConfiguration = (NonNullable<GameViewQuery['tenantConfiguration']>);
export type GameView______Statistics = (NonNullable<(NonNullable<GameViewQuery['tenantConfiguration']>)['statistics']>);
export type GameViewPeriodType = NonNullable<(NonNullable<(NonNullable<GameViewQuery['tenantConfiguration']>)['periodType']>)[number]>;
export type GameViewGameTypes = NonNullable<(NonNullable<(NonNullable<GameViewQuery['tenantConfiguration']>)['gameTypes']>)[number]>;
export type GameView_GameType = (NonNullable<NonNullable<(NonNullable<(NonNullable<GameViewQuery['tenantConfiguration']>)['gameTypes']>)[number]>['gameType']>);
export type GameViewGameTypeFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<GameViewQuery['tenantConfiguration']>)['gameTypes']>)[number]>['gameTypeFeatures']>);
export type GameViewGameTeamStatisticsFragmentPlayers = NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>;
export type GameViewGameTeamStatisticsFragmentPlayer = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>);
export type GameViewGameTeamStatisticsFragmentDiscoverParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverParticipant' }>);
export type GameViewGameTeamStatisticsFragmentProfile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverParticipant' }>)['profile']>);
export type GameViewGameTeamStatisticsFragmentDiscoverParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverParticipantFillInPlayer' }>);
export type GameViewGameTeamStatisticsFragment_Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverParticipantFillInPlayer' }>)['profile']>);
export type GameViewGameTeamStatisticsFragmentDiscoverGamePermitFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverGamePermitFillInPlayer' }>);
export type GameViewGameTeamStatisticsFragment__Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverGamePermitFillInPlayer' }>)['profile']>);
export type GameViewGameTeamStatisticsFragmentDiscoverRegularFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverRegularFillInPlayer' }>);
export type GameViewGameTeamStatisticsFragmentDiscoverAnonymousParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['player']>), { __typename?: 'DiscoverAnonymousParticipant' }>);
export type GameViewGameTeamStatisticsFragmentStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['statistics']>)[number]>;
export type GameViewGameTeamStatisticsFragmentType = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['statistics']>)[number]>['type']>);
export type GameViewGameTeamStatisticsFragmentPeriodStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periodStatistics']>)[number]>;
export type GameViewGameTeamStatisticsFragmentPeriod = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periodStatistics']>)[number]>['period']>);
export type GameViewGameTeamStatisticsFragment_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periodStatistics']>)[number]>['statistics']>)[number]>;
export type GameViewGameTeamStatisticsFragment_Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periodStatistics']>)[number]>['statistics']>)[number]>['type']>);
export type GameViewGameTeamStatisticsFragmentDetails = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periodStatistics']>)[number]>['statistics']>)[number]>['details']>);
export type GameViewGameTeamStatisticsFragmentPeriods = NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periods']>)[number]>;
export type GameViewGameTeamStatisticsFragment_Period = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periods']>)[number]>['period']>);
export type GameViewGameTeamStatisticsFragmentInGamePositions = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['periods']>)[number]>['inGamePositions']>)[number]>;
export type GameViewGameTeamStatisticsFragmentPlayerPosition = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['playerPosition']>);
export type GameViewGameTeamStatisticsFragmentCaptain = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['players']>)[number]>['captain']>);
export type GameViewGameTeamStatisticsFragment__Statistics = NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['statistics']>)[number]>;
export type GameViewGameTeamStatisticsFragment__Type = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['statistics']>)[number]>['type']>);
export type GameViewGameTeamStatisticsFragment_Periods = NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>;
export type GameViewGameTeamStatisticsFragment__Period = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>['period']>);
export type GameViewGameTeamStatisticsFragment___Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>['statistics']>)[number]>;
export type GameViewGameTeamStatisticsFragment___Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>['statistics']>)[number]>['type']>);
export type GameViewGameTeamStatisticsFragmentTeamEvents = NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>['teamEvents']>)[number]>;
export type GameViewGameTeamStatisticsFragmentStatistic = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>['teamEvents']>)[number]>['statistic']>);
export type GameViewGameTeamStatisticsFragment____Type = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['periods']>)[number]>['teamEvents']>)[number]>['statistic']>)['type']>);
export type GameViewGameTeamStatisticsFragmentEmergencyPlayers = NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>;
export type GameViewGameTeamStatisticsFragment_Player = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>);
export type GameViewGameTeamStatisticsFragment_DiscoverParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverParticipant' }>);
export type GameViewGameTeamStatisticsFragment___Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverParticipant' }>)['profile']>);
export type GameViewGameTeamStatisticsFragment_DiscoverParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverParticipantFillInPlayer' }>);
export type GameViewGameTeamStatisticsFragment____Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverParticipantFillInPlayer' }>)['profile']>);
export type GameViewGameTeamStatisticsFragment_DiscoverGamePermitFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverGamePermitFillInPlayer' }>);
export type GameViewGameTeamStatisticsFragment_____Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverGamePermitFillInPlayer' }>)['profile']>);
export type GameViewGameTeamStatisticsFragment_DiscoverAnonymousParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['emergencyPlayers']>)[number]>['player']>), { __typename?: 'DiscoverAnonymousParticipant' }>);
export type GameViewGameTeamStatisticsFragmentBestPlayers = NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>;
export type GameViewGameTeamStatisticsFragmentParticipant = (NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['participant']>);
export type GameViewGameTeamStatisticsFragment__DiscoverParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['participant']>), { __typename?: 'DiscoverParticipant' }>);
export type GameViewGameTeamStatisticsFragment______Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['participant']>), { __typename?: 'DiscoverParticipant' }>)['profile']>);
export type GameViewGameTeamStatisticsFragment__DiscoverAnonymousParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<GameViewGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['participant']>), { __typename?: 'DiscoverAnonymousParticipant' }>);
export type GameViewGameTeamStatisticsFragmentCoinTossWinningResult = (NonNullable<GameViewGameTeamStatisticsFragmentFragment['coinTossWinningResult']>);
export type OrderIdentifierGenerateVariables = OrderIdentifierGenerateMutationVariables;
export type GradeAllRoundsVariables = GradeAllRoundsQueryVariables;
export type GradeAllRoundsDiscoverGradeFixture = NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>;
export type GradeAllRoundsGrade = (NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['grade']>);
export type GradeAllRoundsByes = NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>;
export type GradeAllRoundsLogo = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>['logo']>);
export type GradeAllRoundsSizes = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>['logo']>)['sizes']>)[number]>;
export type GradeAllRoundsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>['logo']>)['sizes']>)[number]>['dimensions']>);
export type GradeAllRoundsSeason = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>['season']>);
export type GradeAllRoundsCompetition = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>['season']>)['competition']>);
export type GradeAllRoundsOrganisation = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['byes']>)[number]>['organisation']>);
export type GradeAllRoundsGames = NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>;
export type GradeAllRoundsPool = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['pool']>);
export type GradeAllRoundsAway = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>);
export type GradeAllRoundsProvisionalTeamInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'ProvisionalTeam' }>);
export type GradeAllRounds_Pool = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'ProvisionalTeam' }>)['pool']>);
export type GradeAllRoundsDiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>);
export type GradeAllRounds_Logo = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>)['logo']>);
export type GradeAllRounds_Sizes = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>)['logo']>)['sizes']>)[number]>;
export type GradeAllRounds_Dimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type GradeAllRounds_Season = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>)['season']>);
export type GradeAllRounds_Competition = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>)['season']>)['competition']>);
export type GradeAllRounds_Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['away']>), { __typename?: 'DiscoverTeam' }>)['organisation']>);
export type GradeAllRoundsHome = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>);
export type GradeAllRounds_ProvisionalTeamInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'ProvisionalTeam' }>);
export type GradeAllRounds__Pool = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'ProvisionalTeam' }>)['pool']>);
export type GradeAllRounds_DiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>);
export type GradeAllRounds__Logo = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>)['logo']>);
export type GradeAllRounds__Sizes = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>)['logo']>)['sizes']>)[number]>;
export type GradeAllRounds__Dimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type GradeAllRounds__Season = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>)['season']>);
export type GradeAllRounds__Competition = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>)['season']>)['competition']>);
export type GradeAllRounds__Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['home']>), { __typename?: 'DiscoverTeam' }>)['organisation']>);
export type GradeAllRoundsResult = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>);
export type GradeAllRoundsWinner = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['winner']>);
export type GradeAllRoundsOutcome = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['outcome']>);
export type GradeAllRounds_Home = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>);
export type GradeAllRounds_Outcome = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['outcome']>);
export type GradeAllRoundsStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['statistics']>)[number]>;
export type GradeAllRoundsType = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['statistics']>)[number]>['type']>);
export type GradeAllRoundsPeriods = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['periods']>)[number]>;
export type GradeAllRoundsPeriod = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['periods']>)[number]>['period']>);
export type GradeAllRounds_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>;
export type GradeAllRounds_Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type GradeAllRounds_Away = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>);
export type GradeAllRounds__Outcome = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['outcome']>);
export type GradeAllRounds__Statistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['statistics']>)[number]>;
export type GradeAllRounds__Type = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['statistics']>)[number]>['type']>);
export type GradeAllRounds_Periods = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['periods']>)[number]>;
export type GradeAllRounds_Period = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['periods']>)[number]>['period']>);
export type GradeAllRounds___Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>;
export type GradeAllRounds___Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type GradeAllRoundsStatus = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['status']>);
export type GradeAllRoundsAllocation = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['allocation']>);
export type GradeAllRoundsDateTimeList = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['allocation']>)['dateTimeList']>)[number]>;
export type GradeAllRoundsCourt = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['allocation']>)['court']>);
export type GradeAllRoundsVenue = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['allocation']>)['court']>)['venue']>);
export type GradeAllRoundsGameType = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['gameType']>);
export type GradeAllRoundsEScoringSettings = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GradeAllRoundsQuery['discoverGradeFixture']>)[number]>['games']>)[number]>['gameType']>)['eScoringSettings']>);
export type GradeAllRoundsTenantConfiguration = (NonNullable<GradeAllRoundsQuery['tenantConfiguration']>);
export type GradeAllRoundsGradeTypes = NonNullable<(NonNullable<(NonNullable<GradeAllRoundsQuery['tenantConfiguration']>)['gradeTypes']>)[number]>;
export type GradeAllRoundsFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeAllRoundsQuery['tenantConfiguration']>)['gradeTypes']>)[number]>['features']>);
export type GradeRoundsVariables = GradeRoundsQueryVariables;
export type GradeRoundsDiscoverGrade = (NonNullable<GradeRoundsQuery['discoverGrade']>);
export type GradeRoundsRounds = NonNullable<(NonNullable<(NonNullable<GradeRoundsQuery['discoverGrade']>)['rounds']>)[number]>;
export type GradeRoundsSeason = (NonNullable<(NonNullable<GradeRoundsQuery['discoverGrade']>)['season']>);
export type GradeRoundsCompetition = (NonNullable<(NonNullable<(NonNullable<GradeRoundsQuery['discoverGrade']>)['season']>)['competition']>);
export type GradeRoundsOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GradeRoundsQuery['discoverGrade']>)['season']>)['competition']>)['organisation']>);
export type GradeRoundsTenantConfiguration = (NonNullable<GradeRoundsQuery['tenantConfiguration']>);
export type GradeRoundsGradeTypes = NonNullable<(NonNullable<(NonNullable<GradeRoundsQuery['tenantConfiguration']>)['gradeTypes']>)[number]>;
export type GradeRoundsFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeRoundsQuery['tenantConfiguration']>)['gradeTypes']>)[number]>['features']>);
export type DiscoverFixtureByRoundVariables = DiscoverFixtureByRoundQueryVariables;
export type DiscoverFixtureByRoundDiscoverFixtureByRound = (NonNullable<DiscoverFixtureByRoundQuery['discoverFixtureByRound']>);
export type GroupLabelDaySessions = NonNullable<(NonNullable<GroupLabelFragment['daySessions']>)[number]>;
export type GroupLabelPlayingSurface = (NonNullable<GroupLabelFragment['playingSurface']>);
export type GroupLabelVenue = (NonNullable<(NonNullable<GroupLabelFragment['playingSurface']>)['venue']>);
export type SearchRegisteredPlayerVariables = SearchRegisteredPlayerQueryVariables;
export type SearchRegisteredPlayerMyTeamsParticipants = (NonNullable<SearchRegisteredPlayerQuery['myTeamsParticipants']>);
export type SearchRegisteredPlayerResult = NonNullable<(NonNullable<(NonNullable<SearchRegisteredPlayerQuery['myTeamsParticipants']>)['result']>)[number]>;
export type SearchRegisteredPlayerPermit = (NonNullable<NonNullable<(NonNullable<(NonNullable<SearchRegisteredPlayerQuery['myTeamsParticipants']>)['result']>)[number]>['permit']>);
export type SearchRegisteredPlayerProfile = (NonNullable<NonNullable<(NonNullable<(NonNullable<SearchRegisteredPlayerQuery['myTeamsParticipants']>)['result']>)[number]>['profile']>);
export type SearchRegisteredPlayerTeams = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<SearchRegisteredPlayerQuery['myTeamsParticipants']>)['result']>)[number]>['teams']>)[number]>;
export type ValidateGameLineupVariables = ValidateGameLineupQueryVariables;
export type ValidateGameLineupGameTeamLineupValidate = NonNullable<(NonNullable<ValidateGameLineupQuery['gameTeamLineupValidate']>)[number]>;
export type ValidateGameLineupErrors = NonNullable<(NonNullable<NonNullable<(NonNullable<ValidateGameLineupQuery['gameTeamLineupValidate']>)[number]>['errors']>)[number]>;
export type GameTeamAwardVotesUpdateVariables = GameTeamAwardVotesUpdateMutationVariables;
export type GameTeamAwardVotesUpdateGameTeamAwardVotesUpdate = (NonNullable<GameTeamAwardVotesUpdateMutation['gameTeamAwardVotesUpdate']>);
export type GameTeamAwardVotesUpdateConfiguration = (NonNullable<(NonNullable<GameTeamAwardVotesUpdateMutation['gameTeamAwardVotesUpdate']>)['configuration']>);
export type GameTeamAwardVotesUpdateVoteSlips = NonNullable<(NonNullable<(NonNullable<GameTeamAwardVotesUpdateMutation['gameTeamAwardVotesUpdate']>)['voteSlips']>)[number]>;
export type MyTeamsGameManageVariables = MyTeamsGameManageQueryVariables;
export type MyTeamsGameManageMyTeamsGame = (NonNullable<MyTeamsGameManageQuery['myTeamsGame']>);
export type MyTeamsGameManageTenantConfiguration = (NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>);
export type MyTeamsGameManageVolunteerRoles = NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['volunteerRoles']>)[number]>;
export type MyTeamsGameManagePlayerPositions = NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['playerPositions']>)[number]>;
export type MyTeamsGameManagePlayerDismissalTypes = NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['playerDismissalTypes']>)[number]>;
export type MyTeamsGameManageGameTypes = NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['gameTypes']>)[number]>;
export type MyTeamsGameManageGameType = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['gameTypes']>)[number]>['gameType']>);
export type MyTeamsGameManageClosureStatusOptions = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['gameTypes']>)[number]>['closureStatusOptions']>)[number]>;
export type MyTeamsGameManageGameOutcomeOverride = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['gameTypes']>)[number]>['gameOutcomeOverride']>)[number]>;
export type MyTeamsGameManagePossibleGameOutcomesMap = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['gameTypes']>)[number]>['possibleGameOutcomesMap']>)[number]>;
export type MyTeamsGameManageGameTypeFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['gameTypes']>)[number]>['gameTypeFeatures']>);
export type MyTeamsGameManageCaptainOptions = NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['captainOptions']>)[number]>;
export type MyTeamsGameManageOffenceTypeOptions = NonNullable<(NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['offenceTypeOptions']>)[number]>;
export type MyTeamsGameManageOutswingConfiguration = (NonNullable<(NonNullable<MyTeamsGameManageQuery['tenantConfiguration']>)['outswingConfiguration']>);
export type MyTeamsGamePlayerUpdateStatistics = (NonNullable<MyTeamsGamePlayerUpdateFragment['statistics']>);
export type MyTeamsGamePlayerUpdateHome = (NonNullable<(NonNullable<MyTeamsGamePlayerUpdateFragment['statistics']>)['home']>);
export type MyTeamsGamePlayerUpdateAway = (NonNullable<(NonNullable<MyTeamsGamePlayerUpdateFragment['statistics']>)['away']>);
export type MyTeamsGamePlayerUpdateGameTeams = (NonNullable<MyTeamsGamePlayerUpdateFragment['gameTeams']>);
export type MyTeamsGamePlayerUpdate_Home = (NonNullable<(NonNullable<MyTeamsGamePlayerUpdateFragment['gameTeams']>)['home']>);
export type MyTeamsGamePlayerUpdate_Away = (NonNullable<(NonNullable<MyTeamsGamePlayerUpdateFragment['gameTeams']>)['away']>);
export type GamePlayerUpdateVariables = GamePlayerUpdateMutationVariables;
export type GamePlayerUpdateMyTeamsGamePlayerUpdate = (NonNullable<GamePlayerUpdateMutation['myTeamsGamePlayerUpdate']>);
export type GamePlayerUpdateMyTeamsGame = (NonNullable<(NonNullable<GamePlayerUpdateMutation['myTeamsGamePlayerUpdate']>)['myTeamsGame']>);
export type GameFillinPlayerUpdateVariables = GameFillinPlayerUpdateMutationVariables;
export type GameFillinPlayerUpdateMyTeamsGameFillInPlayerUpdate = (NonNullable<GameFillinPlayerUpdateMutation['myTeamsGameFillInPlayerUpdate']>);
export type GameFillinPlayerUpdateMyTeamsGame = (NonNullable<(NonNullable<GameFillinPlayerUpdateMutation['myTeamsGameFillInPlayerUpdate']>)['myTeamsGame']>);
export type GameTeamUpdateVariables = GameTeamUpdateMutationVariables;
export type GameTeamUpdateMyTeamsGameTeamUpdate = (NonNullable<GameTeamUpdateMutation['myTeamsGameTeamUpdate']>);
export type GameTeamUpdateMyTeamsGame = (NonNullable<(NonNullable<GameTeamUpdateMutation['myTeamsGameTeamUpdate']>)['myTeamsGame']>);
export type OrganisationPageWrapperVariables = OrganisationPageWrapperQueryVariables;
export type OrganisationPageWrapperDiscoverOrganisation = (NonNullable<OrganisationPageWrapperQuery['discoverOrganisation']>);
export type OrganisationPageWrapperTenantConfiguration = (NonNullable<OrganisationPageWrapperQuery['tenantConfiguration']>);
export type OrganisationPageWrapperNewsVariables = OrganisationPageWrapperNewsQueryVariables;
export type OrganisationPageWrapperNewsDiscoverOrganisationPosts = (NonNullable<OrganisationPageWrapperNewsQuery['discoverOrganisationPosts']>);
export type OrganisationPageWrapperNewsMeta = (NonNullable<(NonNullable<OrganisationPageWrapperNewsQuery['discoverOrganisationPosts']>)['meta']>);
export type ProfileQuestionsUpdateVariables = ProfileQuestionsUpdateMutationVariables;
export type ProfileQuestionsUpdateProfileQuestionsUpdate = (NonNullable<ProfileQuestionsUpdateMutation['profileQuestionsUpdate']>);
export type ProfileQuestionsUpdateFields = NonNullable<(NonNullable<(NonNullable<ProfileQuestionsUpdateMutation['profileQuestionsUpdate']>)['fields']>)[number]>;
export type ProfileQuestionsUpdateFieldInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<ProfileQuestionsUpdateMutation['profileQuestionsUpdate']>)['fields']>)[number]>, { __typename?: 'FieldInput' }>);
export type ProfileQuestionsUpdateFieldSelectInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<ProfileQuestionsUpdateMutation['profileQuestionsUpdate']>)['fields']>)[number]>, { __typename?: 'FieldSelect' }>);
export type ProfileQuestionsUpdateOptions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<ProfileQuestionsUpdateMutation['profileQuestionsUpdate']>)['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['options']>)[number]>;
export type ChildSafetyUpdateVariables = ChildSafetyUpdateMutationVariables;
export type ChildSafetyUpdateChildSafetyUpdate = (NonNullable<ChildSafetyUpdateMutation['childSafetyUpdate']>);
export type ChildSafetyUpdateFields = NonNullable<(NonNullable<(NonNullable<ChildSafetyUpdateMutation['childSafetyUpdate']>)['fields']>)[number]>;
export type ChildSafetyUpdateFieldInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<ChildSafetyUpdateMutation['childSafetyUpdate']>)['fields']>)[number]>, { __typename?: 'FieldInput' }>);
export type ChildSafetyUpdateFieldSelectInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<ChildSafetyUpdateMutation['childSafetyUpdate']>)['fields']>)[number]>, { __typename?: 'FieldSelect' }>);
export type ChildSafetyUpdateOptions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<ChildSafetyUpdateMutation['childSafetyUpdate']>)['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['options']>)[number]>;
export type CoachingAccreditationsVariables = CoachingAccreditationsQueryVariables;
export type CoachingAccreditationsAccount = (NonNullable<CoachingAccreditationsQuery['account']>);
export type CoachingAccreditationsProfile = (NonNullable<(NonNullable<CoachingAccreditationsQuery['account']>)['profile']>);
export type CoachingAccreditationsCoachingAccreditation = (NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['account']>)['profile']>)['coachingAccreditation']>);
export type CoachingAccreditationsLevel = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['account']>)['profile']>)['coachingAccreditation']>)['level']>);
export type CoachingAccreditationsDependants = NonNullable<(NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['account']>)['profile']>)['dependants']>)[number]>;
export type CoachingAccreditations_CoachingAccreditation = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['account']>)['profile']>)['dependants']>)[number]>['coachingAccreditation']>);
export type CoachingAccreditations_Level = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['account']>)['profile']>)['dependants']>)[number]>['coachingAccreditation']>)['level']>);
export type CoachingAccreditationsTenantConfiguration = (NonNullable<CoachingAccreditationsQuery['tenantConfiguration']>);
export type CoachingAccreditationsSeasonRegistration = (NonNullable<(NonNullable<CoachingAccreditationsQuery['tenantConfiguration']>)['seasonRegistration']>);
export type CoachingAccreditationsCoachingAccreditationConfig = (NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['tenantConfiguration']>)['seasonRegistration']>)['coachingAccreditationConfig']>);
export type CoachingAccreditationsAccreditations = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<CoachingAccreditationsQuery['tenantConfiguration']>)['seasonRegistration']>)['coachingAccreditationConfig']>)['accreditations']>)[number]>;
export type CoachingAccreditationUpdateVariables = CoachingAccreditationUpdateMutationVariables;
export type CoachingAccreditationUpdateCoachingAccreditationUpdate = (NonNullable<CoachingAccreditationUpdateMutation['coachingAccreditationUpdate']>);
export type CoachingAccreditationUpdateLevel = (NonNullable<(NonNullable<CoachingAccreditationUpdateMutation['coachingAccreditationUpdate']>)['level']>);
export type UnlinkExternalAccountVariables = UnlinkExternalAccountMutationVariables;
export type UnlinkExternalAccountUnlinkExternalAccount = (NonNullable<UnlinkExternalAccountMutation['unlinkExternalAccount']>);
export type ProfileDisabilityUpdateVariables = ProfileDisabilityUpdateMutationVariables;
export type ProfileDisabilityUpdateProfileUpdate = (NonNullable<ProfileDisabilityUpdateMutation['profileUpdate']>);
export type EmergencyContactUpdateVariables = EmergencyContactUpdateMutationVariables;
export type EmergencyContactUpdateEmergencyContactUpdate = (NonNullable<EmergencyContactUpdateMutation['emergencyContactUpdate']>);
export type EmergencyContactUpdateMobileNumber = (NonNullable<(NonNullable<EmergencyContactUpdateMutation['emergencyContactUpdate']>)['mobileNumber']>);
export type EmergencyContactUpdateCountryCode = (NonNullable<(NonNullable<(NonNullable<EmergencyContactUpdateMutation['emergencyContactUpdate']>)['mobileNumber']>)['countryCode']>);
export type GuardianDetailsMobileNumber = (NonNullable<GuardianDetailsFragment['mobileNumber']>);
export type GuardianDetailsCountryCode = (NonNullable<(NonNullable<GuardianDetailsFragment['mobileNumber']>)['countryCode']>);
export type GuardianDetailsAddress = (NonNullable<GuardianDetailsFragment['address']>);
export type GuardianCreateVariables = GuardianCreateMutationVariables;
export type GuardianCreateGuardianCreate = (NonNullable<GuardianCreateMutation['guardianCreate']>);
export type GuardianUpdateVariables = GuardianUpdateMutationVariables;
export type GuardianUpdateGuardianUpdate = (NonNullable<GuardianUpdateMutation['guardianUpdate']>);
export type GuardianDeleteVariables = GuardianDeleteMutationVariables;
export type GuardianDeleteGuardianDelete = (NonNullable<GuardianDeleteMutation['guardianDelete']>);
export type ProfileUpdateVariables = ProfileUpdateMutationVariables;
export type ProfileUpdateProfileUpdate = (NonNullable<ProfileUpdateMutation['profileUpdate']>);
export type ProfileAndAddressUpdateVariables = ProfileAndAddressUpdateMutationVariables;
export type ProfileAndAddressUpdateProfileUpdate = (NonNullable<ProfileAndAddressUpdateMutation['profileUpdate']>);
export type ProfileAndAddressUpdateAddressUpdate = (NonNullable<ProfileAndAddressUpdateMutation['addressUpdate']>);
export type UpdatePrivacyVariables = UpdatePrivacyMutationVariables;
export type UpdatePrivacyProfileUpdate = (NonNullable<UpdatePrivacyMutation['profileUpdate']>);
export type CurrentAccountVariables = CurrentAccountQueryVariables;
export type CurrentAccountAccount = (NonNullable<CurrentAccountQuery['account']>);
export type CurrentAccountProfile = (NonNullable<(NonNullable<CurrentAccountQuery['account']>)['profile']>);
export type CurrentAccountMobileNumber = (NonNullable<(NonNullable<(NonNullable<CurrentAccountQuery['account']>)['profile']>)['mobileNumber']>);
export type CurrentAccountCountryCode = (NonNullable<(NonNullable<(NonNullable<(NonNullable<CurrentAccountQuery['account']>)['profile']>)['mobileNumber']>)['countryCode']>);
export type ShopCartFragmentItems = NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>;
export type ShopCartFragmentFee = (NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>);
export type ShopCartFragmentMerchandiseFeeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>);
export type ShopCartFragmentAmount = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['amount']>);
export type ShopCartFragmentCurrency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['amount']>)['currency']>);
export type ShopCartFragmentOrganisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['organisation']>);
export type ShopCartFragmentImages = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['images']>)[number]>;
export type ShopCartFragmentSizes = NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['images']>)[number]>['sizes']>)[number]>;
export type ShopCartFragmentDimensions = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['images']>)[number]>['sizes']>)[number]>['dimensions']>);
export type ShopCartFragmentCategoryPairs = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['categoryPairs']>)[number]>;
export type ShopCartFragmentCustomFieldAnswers = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['customFieldAnswers']>)[number]>;
export type ShopCartFragmentCustomField = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<ShopCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['customFieldAnswers']>)[number]>['customField']>);
export type ShopCartFragmentAvailableCharities = NonNullable<(NonNullable<ShopCartFragmentFragment['availableCharities']>)[number]>;
export type ShopCartFragmentTotals = (NonNullable<ShopCartFragmentFragment['totals']>);
export type ShopCartFragmentTotalAmount = (NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['totalAmount']>);
export type ShopCartFragment_Currency = (NonNullable<(NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['totalAmount']>)['currency']>);
export type ShopCartFragmentSubTotalAmount = (NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['subTotalAmount']>);
export type ShopCartFragment__Currency = (NonNullable<(NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['subTotalAmount']>)['currency']>);
export type ShopCartFragmentServiceFeeAmount = (NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['serviceFeeAmount']>);
export type ShopCartFragment___Currency = (NonNullable<(NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['serviceFeeAmount']>)['currency']>);
export type ShopCartFragmentShippingFeeAmount = (NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['shippingFeeAmount']>);
export type ShopCartFragment____Currency = (NonNullable<(NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['shippingFeeAmount']>)['currency']>);
export type ShopCartFragmentSelectedCharities = NonNullable<(NonNullable<(NonNullable<ShopCartFragmentFragment['totals']>)['selectedCharities']>)[number]>;
export type ShopCartFragmentProductsAmount = (NonNullable<ShopCartFragmentFragment['productsAmount']>);
export type ShopCartFragment_____Currency = (NonNullable<(NonNullable<ShopCartFragmentFragment['productsAmount']>)['currency']>);
export type GetShopCartVariables = GetShopCartQueryVariables;
export type GetShopCartShopCart = (NonNullable<GetShopCartQuery['shopCart']>);
export type IncidentFormSelectionsVariables = IncidentFormSelectionsQueryVariables;
export type IncidentFormSelectionsDiscoverTeam = (NonNullable<IncidentFormSelectionsQuery['discoverTeam']>);
export type IncidentFormSelectionsSeason = (NonNullable<(NonNullable<IncidentFormSelectionsQuery['discoverTeam']>)['season']>);
export type IncidentFormSelectionsOrganisation = (NonNullable<(NonNullable<IncidentFormSelectionsQuery['discoverTeam']>)['organisation']>);
export type IncidentFormSelectionsMyTeamsTeam = (NonNullable<IncidentFormSelectionsQuery['myTeamsTeam']>);
export type IncidentFormSelectionsTeamPlayers = NonNullable<(NonNullable<(NonNullable<IncidentFormSelectionsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>;
export type IncidentFormSelectionsParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentFormSelectionsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>);
export type IncidentFormSelectionsProfile = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentFormSelectionsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['profile']>);
export type MyTeamsPreviousLineupVariables = MyTeamsPreviousLineupQueryVariables;
export type MyTeamsPreviousLineupMyTeamsGame = (NonNullable<MyTeamsPreviousLineupQuery['myTeamsGame']>);
export type MyTeamsPreviousLineupTeams = (NonNullable<(NonNullable<MyTeamsPreviousLineupQuery['myTeamsGame']>)['teams']>);
export type MyTeamsPreviousLineupHome = (NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupQuery['myTeamsGame']>)['teams']>)['home']>);
export type MyTeamsPreviousLineupAway = (NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupQuery['myTeamsGame']>)['teams']>)['away']>);
export type CountryCodesVariables = CountryCodesQueryVariables;
export type CountryCodesTenantConfiguration = (NonNullable<CountryCodesQuery['tenantConfiguration']>);
export type CountryCodesCountryCodes = NonNullable<(NonNullable<(NonNullable<CountryCodesQuery['tenantConfiguration']>)['countryCodes']>)[number]>;
export type TextCustomFieldDetailsOrganisation = (NonNullable<TextCustomFieldDetailsFragment['organisation']>);
export type DropdownCustomFieldDetailsOrganisation = (NonNullable<DropdownCustomFieldDetailsFragment['organisation']>);
export type RecursiveDropdownCustomFieldsDetailsDropdownOptions = NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>;
export type RecursiveDropdownCustomFieldsDetailsCustomField = (NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>);
export type RecursiveDropdownCustomFieldsDetailsDropdownCustomFieldInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>);
export type RecursiveDropdownCustomFieldsDetails_DropdownOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>;
export type RecursiveDropdownCustomFieldsDetails_CustomField = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>);
export type RecursiveDropdownCustomFieldsDetails_DropdownCustomFieldInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>);
export type RecursiveDropdownCustomFieldsDetails__DropdownOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>;
export type RecursiveDropdownCustomFieldsDetails__CustomField = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>);
export type RecursiveDropdownCustomFieldsDetails__DropdownCustomFieldInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>);
export type RecursiveDropdownCustomFieldsDetails___DropdownOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<RecursiveDropdownCustomFieldsDetailsFragment['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>['customField']>), { __typename?: 'DropdownCustomField' }>)['dropdownOptions']>)[number]>;
export type ExternalAccountsFragmentExternalAccounts = NonNullable<(NonNullable<ExternalAccountsFragmentFragment['externalAccounts']>)[number]>;
export type GetLinkedExternalAccountsVariables = GetLinkedExternalAccountsQueryVariables;
export type GetLinkedExternalAccountsAccount = (NonNullable<GetLinkedExternalAccountsQuery['account']>);
export type GetLinkedExternalAccountsProfile = (NonNullable<(NonNullable<GetLinkedExternalAccountsQuery['account']>)['profile']>);
export type GetParticipantTypeVariables = GetParticipantTypeQueryVariables;
export type GetParticipantTypeParticipant = (NonNullable<GetParticipantTypeQuery['participant']>);
export type ProfilePersonalDetailsGender = (NonNullable<ProfilePersonalDetailsFragment['gender']>);
export type ProfilePersonalDetailsMobileNumber = (NonNullable<ProfilePersonalDetailsFragment['mobileNumber']>);
export type ProfilePersonalDetailsCountryCode = (NonNullable<(NonNullable<ProfilePersonalDetailsFragment['mobileNumber']>)['countryCode']>);
export type ProfilePersonalDetailsAddress = (NonNullable<ProfilePersonalDetailsFragment['address']>);
export type ProfileDisabilityDetailsHasDisability = (NonNullable<ProfileDisabilityDetailsFragment['hasDisability']>);
export type ProfileDisabilityDetailsDisabilities = NonNullable<(NonNullable<ProfileDisabilityDetailsFragment['disabilities']>)[number]>;
export type ProfileOverviewWwc = (NonNullable<ProfileOverviewFragment['wwc']>);
export type ProfileOverviewChildSafety = NonNullable<(NonNullable<ProfileOverviewFragment['childSafety']>)[number]>;
export type ProfileOverviewProfileQuestions = NonNullable<(NonNullable<ProfileOverviewFragment['profileQuestions']>)[number]>;
export type ProfileOverviewEmergencyContact = (NonNullable<ProfileOverviewFragment['emergencyContact']>);
export type ProfileOverviewMobileNumber = (NonNullable<(NonNullable<ProfileOverviewFragment['emergencyContact']>)['mobileNumber']>);
export type ProfileOverviewCountryCode = (NonNullable<(NonNullable<(NonNullable<ProfileOverviewFragment['emergencyContact']>)['mobileNumber']>)['countryCode']>);
export type ProfileOverviewGuardians = NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>;
export type ProfileOverviewProfileInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Profile' }>);
export type ProfileOverview_MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Profile' }>)['mobileNumber']>);
export type ProfileOverview_CountryCode = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Profile' }>)['mobileNumber']>)['countryCode']>);
export type ProfileOverviewAddress = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Profile' }>)['address']>);
export type ProfileOverviewGuardianInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Guardian' }>);
export type ProfileOverview__MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Guardian' }>)['mobileNumber']>);
export type ProfileOverview__CountryCode = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Guardian' }>)['mobileNumber']>)['countryCode']>);
export type ProfileOverview_Address = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<ProfileOverviewFragment['guardians']>)[number]>, { __typename?: 'Guardian' }>)['address']>);
export type ProfileOverviewDependants = NonNullable<(NonNullable<ProfileOverviewFragment['dependants']>)[number]>;
export type ProfileOverview_Wwc = (NonNullable<NonNullable<(NonNullable<ProfileOverviewFragment['dependants']>)[number]>['wwc']>);
export type ProfileOverview_ChildSafety = NonNullable<(NonNullable<NonNullable<(NonNullable<ProfileOverviewFragment['dependants']>)[number]>['childSafety']>)[number]>;
export type ProfileOverview_ProfileQuestions = NonNullable<(NonNullable<NonNullable<(NonNullable<ProfileOverviewFragment['dependants']>)[number]>['profileQuestions']>)[number]>;
export type ProfileOverviewExternalAccounts = NonNullable<(NonNullable<ProfileOverviewFragment['externalAccounts']>)[number]>;
export type ProfileTenantConfigurationSeasonRegistration = (NonNullable<ProfileTenantConfigurationFragment['seasonRegistration']>);
export type ProfileTenantConfigurationIndigenousDescent = NonNullable<(NonNullable<(NonNullable<ProfileTenantConfigurationFragment['seasonRegistration']>)['indigenousDescent']>)[number]>;
export type ProfileTenantConfigurationDisabilities = NonNullable<(NonNullable<(NonNullable<ProfileTenantConfigurationFragment['seasonRegistration']>)['disabilities']>)[number]>;
export type ProfileTenantConfigurationCountries = NonNullable<(NonNullable<ProfileTenantConfigurationFragment['countries']>)[number]>;
export type ProfileTenantConfigurationCountryCodes = NonNullable<(NonNullable<ProfileTenantConfigurationFragment['countryCodes']>)[number]>;
export type ProfileTenantConfigurationDiscloseOptions = NonNullable<(NonNullable<ProfileTenantConfigurationFragment['discloseOptions']>)[number]>;
export type ProfileConfigurationSupportedCountries = NonNullable<(NonNullable<ProfileConfigurationFragment['supportedCountries']>)[number]>;
export type ProfileConfigurationExternalAccountLinking = NonNullable<(NonNullable<ProfileConfigurationFragment['externalAccountLinking']>)[number]>;
export type ProfileConfigurationConfig = (NonNullable<NonNullable<(NonNullable<ProfileConfigurationFragment['externalAccountLinking']>)[number]>['config']>);
export type MyProfileVariables = MyProfileQueryVariables;
export type MyProfileAccount = (NonNullable<MyProfileQuery['account']>);
export type MyProfileProfile = (NonNullable<(NonNullable<MyProfileQuery['account']>)['profile']>);
export type MyProfileTenantConfiguration = (NonNullable<MyProfileQuery['tenantConfiguration']>);
export type MyProfileConfiguration = (NonNullable<MyProfileQuery['configuration']>);
export type DependantProfileVariables = DependantProfileQueryVariables;
export type DependantProfileDependantProfile = (NonNullable<DependantProfileQuery['dependantProfile']>);
export type DependantProfileTenantConfiguration = (NonNullable<DependantProfileQuery['tenantConfiguration']>);
export type DependantProfileConfiguration = (NonNullable<DependantProfileQuery['configuration']>);
export type RegistrationOrganisationDetailsAddress = (NonNullable<RegistrationOrganisationDetailsFragment['address']>);
export type RegistrationOrganisationDetailsLogo = (NonNullable<RegistrationOrganisationDetailsFragment['logo']>);
export type RegistrationOrganisationDetailsSizes = NonNullable<(NonNullable<(NonNullable<RegistrationOrganisationDetailsFragment['logo']>)['sizes']>)[number]>;
export type RegistrationOrganisationDetailsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<RegistrationOrganisationDetailsFragment['logo']>)['sizes']>)[number]>['dimensions']>);
export type RegistrationOrganisationDetailsContacts = NonNullable<(NonNullable<RegistrationOrganisationDetailsFragment['contacts']>)[number]>;
export type GetRegistrationVariables = GetRegistrationQueryVariables;
export type GetRegistrationRegistrationSettings = (NonNullable<GetRegistrationQuery['registrationSettings']>);
export type GetRegistrationDiscoverRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>);
export type GetRegistrationStartDate = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['startDate']>);
export type GetRegistrationEndDate = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['endDate']>);
export type GetRegistrationSeason = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>);
export type GetRegistrationDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type GetRegistrationCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type GetRegistrationOrganisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type GetRegistrationProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>);
export type GetRegistrationProgram = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type GetRegistration_Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>);
export type GetRegistrationAddress = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>)['address']>);
export type GetRegistrationLogo = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>)['logo']>);
export type GetRegistrationSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>)['logo']>)['sizes']>)[number]>;
export type GetRegistrationDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type GetRegistrationContacts = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>)['contacts']>)[number]>;
export type GetRegistrationProducts = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['products']>)[number]>;
export type GetRegistrationDiscoverSocialTeamRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>);
export type GetRegistration_StartDate = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['startDate']>);
export type GetRegistration_EndDate = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['endDate']>);
export type GetRegistration_Season = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>);
export type GetRegistration_Competition = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>);
export type GetRegistration__Organisation = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>)['organisation']>);
export type GetRegistrationGrades = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['grades']>)[number]>;
export type GetRegistration_Products = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['products']>)[number]>;
export type GetRegistrationTenantConfiguration = (NonNullable<GetRegistrationQuery['tenantConfiguration']>);
export type GetRegistrationSport = (NonNullable<(NonNullable<GetRegistrationQuery['tenantConfiguration']>)['sport']>);
export type TeamVariables = TeamQueryVariables;
export type TeamDiscoverTeam = (NonNullable<TeamQuery['discoverTeam']>);
export type MyTeamsPossibleTeamFragmentProvisionalTeamInlineFragment = (DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'ProvisionalTeam' }>);
export type MyTeamsPossibleTeamFragmentPool = (NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'ProvisionalTeam' }>)['pool']>);
export type MyTeamsPossibleTeamFragmentMyTeamsTeamInlineFragment = (DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>);
export type MyTeamsPossibleTeamFragmentLogo = (NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>)['logo']>);
export type MyTeamsPossibleTeamFragmentSizes = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>)['logo']>)['sizes']>)[number]>;
export type MyTeamsPossibleTeamFragmentDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type MyTeamsPossibleTeamFragmentSeason = (NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>)['season']>);
export type MyTeamsPossibleTeamFragmentCompetition = (NonNullable<(NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>)['season']>)['competition']>);
export type MyTeamsPossibleTeamFragmentOrganisation = (NonNullable<(DiscriminateUnion<MyTeamsPossibleTeamFragmentFragment, { __typename?: 'MyTeamsTeam' }>)['organisation']>);
export type MyTeamsGameTeamStatisticsFragmentCoaches = NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentParticipant = (NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>['participant']>);
export type MyTeamsGameTeamStatisticsFragmentMyTeamsParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>);
export type MyTeamsGameTeamStatisticsFragmentProfile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>)['profile']>);
export type MyTeamsGameTeamStatisticsFragmentMyTeamsFillInCoachInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>['participant']>), { __typename?: 'MyTeamsFillInCoach' }>);
export type MyTeamsGameTeamStatisticsFragmentStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentType = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coaches']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameTeamStatisticsFragment_Statistics = NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['statistics']>)[number]>;
export type MyTeamsGameTeamStatisticsFragment_Type = (NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['statistics']>)[number]>['type']>);
export type MyTeamsGameTeamStatisticsFragmentRecordedTimeList = NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['statistics']>)[number]>['recordedTimeList']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentPeriods = NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentPeriod = (NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>['period']>);
export type MyTeamsGameTeamStatisticsFragment__Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameTeamStatisticsFragment__Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameTeamStatisticsFragmentTeamEvents = NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>['teamEvents']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentStatistic = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>['teamEvents']>)[number]>['statistic']>);
export type MyTeamsGameTeamStatisticsFragment___Type = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['periods']>)[number]>['teamEvents']>)[number]>['statistic']>)['type']>);
export type MyTeamsGameTeamStatisticsFragmentBestPlayers = NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentPlayer = (NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>);
export type MyTeamsGameTeamStatisticsFragment_MyTeamsParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsParticipant' }>);
export type MyTeamsGameTeamStatisticsFragment_Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsParticipant' }>)['profile']>);
export type MyTeamsGameTeamStatisticsFragmentMyTeamsParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>);
export type MyTeamsGameTeamStatisticsFragment_Participant = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>);
export type MyTeamsGameTeamStatisticsFragment__Profile = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['profile']>);
export type MyTeamsGameTeamStatisticsFragmentMyTeamsGamePermitFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>);
export type MyTeamsGameTeamStatisticsFragment___Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['bestPlayers']>)[number]>['player']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>)['profile']>);
export type MyTeamsGameTeamStatisticsFragmentVolunteers = NonNullable<(NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['volunteers']>)[number]>;
export type MyTeamsGameTeamStatisticsFragmentCoinTossWinningResult = (NonNullable<MyTeamsGameTeamStatisticsFragmentFragment['coinTossWinningResult']>);
export type MyTeamsGameTeamFragmentLineup = (NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>);
export type MyTeamsGameTeamFragmentPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>;
export type MyTeamsGameTeamFragmentParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>);
export type MyTeamsGameTeamFragmentNodeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'Node' }>);
export type MyTeamsGameTeamFragmentMyTeamsParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>);
export type MyTeamsGameTeamFragmentProfile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>)['profile']>);
export type MyTeamsGameTeamFragmentPermit = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>)['permit']>);
export type MyTeamsGameTeamFragmentMyTeamsParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>);
export type MyTeamsGameTeamFragment_Participant = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>);
export type MyTeamsGameTeamFragment_Profile = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['profile']>);
export type MyTeamsGameTeamFragment_Permit = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['permit']>);
export type MyTeamsGameTeamFragmentMyTeamsGamePermitFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>);
export type MyTeamsGameTeamFragment__Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>)['profile']>);
export type MyTeamsGameTeamFragmentMyTeamsRegularFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsRegularFillInPlayer' }>);
export type MyTeamsGameTeamFragmentStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameTeamFragmentType = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameTeamFragmentRecordedTimeList = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['statistics']>)[number]>['recordedTimeList']>)[number]>;
export type MyTeamsGameTeamFragmentPeriodStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periodStatistics']>)[number]>;
export type MyTeamsGameTeamFragmentPeriod = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periodStatistics']>)[number]>['period']>);
export type MyTeamsGameTeamFragment_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periodStatistics']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameTeamFragment_Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periodStatistics']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameTeamFragmentDetails = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periodStatistics']>)[number]>['statistics']>)[number]>['details']>);
export type MyTeamsGameTeamFragmentPeriods = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periods']>)[number]>;
export type MyTeamsGameTeamFragment_Period = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periods']>)[number]>['period']>);
export type MyTeamsGameTeamFragmentInGamePositions = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['periods']>)[number]>['inGamePositions']>)[number]>;
export type MyTeamsGameTeamFragmentIneligibilityStatus = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['ineligibilityStatus']>)[number]>;
export type MyTeamsGameTeamFragmentPlayerPosition = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['playerPosition']>);
export type MyTeamsGameTeamFragmentCaptain = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['players']>)[number]>['captain']>);
export type MyTeamsGameTeamFragmentEmergencyPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>;
export type MyTeamsGameTeamFragment__Participant = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>);
export type MyTeamsGameTeamFragment_NodeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'Node' }>);
export type MyTeamsGameTeamFragment_MyTeamsParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>);
export type MyTeamsGameTeamFragment___Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>)['profile']>);
export type MyTeamsGameTeamFragment_MyTeamsParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>);
export type MyTeamsGameTeamFragment___Participant = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>);
export type MyTeamsGameTeamFragment____Profile = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['profile']>);
export type MyTeamsGameTeamFragment_MyTeamsGamePermitFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>);
export type MyTeamsGameTeamFragment_____Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameTeamFragmentFragment['lineup']>)['emergencyPlayers']>)[number]>['participant']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>)['profile']>);
export type MyTeamsPreviousLineupFragmentPreviousRoundLineup = (NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>);
export type MyTeamsPreviousLineupFragmentPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>;
export type MyTeamsPreviousLineupFragmentPlayer = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>);
export type MyTeamsPreviousLineupFragmentNodeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'Node' }>);
export type MyTeamsPreviousLineupFragmentMyTeamsParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipant' }>);
export type MyTeamsPreviousLineupFragmentProfile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipant' }>)['profile']>);
export type MyTeamsPreviousLineupFragmentPermit = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipant' }>)['permit']>);
export type MyTeamsPreviousLineupFragmentMyTeamsParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>);
export type MyTeamsPreviousLineupFragmentParticipant = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>);
export type MyTeamsPreviousLineupFragment_Profile = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['profile']>);
export type MyTeamsPreviousLineupFragment_Permit = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['player']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['permit']>);
export type MyTeamsPreviousLineupFragmentPlayerPosition = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['playerPosition']>);
export type MyTeamsPreviousLineupFragmentCaptain = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsPreviousLineupFragmentFragment['previousRoundLineup']>)['players']>)[number]>['captain']>);
export type MyTeamsGameDetailsFragmentAway = (NonNullable<MyTeamsGameDetailsFragmentFragment['away']>);
export type MyTeamsGameDetailsFragmentHome = (NonNullable<MyTeamsGameDetailsFragmentFragment['home']>);
export type MyTeamsGameDetailsFragmentResult = (NonNullable<MyTeamsGameDetailsFragmentFragment['result']>);
export type MyTeamsGameDetailsFragmentWinner = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['winner']>);
export type MyTeamsGameDetailsFragmentOutcome = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['outcome']>);
export type MyTeamsGameDetailsFragment_Home = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>);
export type MyTeamsGameDetailsFragment_Outcome = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['outcome']>);
export type MyTeamsGameDetailsFragmentStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['statistics']>)[number]>;
export type MyTeamsGameDetailsFragmentType = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['statistics']>)[number]>['type']>);
export type MyTeamsGameDetailsFragmentPeriods = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['periods']>)[number]>;
export type MyTeamsGameDetailsFragmentPeriod = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['periods']>)[number]>['period']>);
export type MyTeamsGameDetailsFragment_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameDetailsFragment_Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameDetailsFragment_Away = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>);
export type MyTeamsGameDetailsFragment__Outcome = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['outcome']>);
export type MyTeamsGameDetailsFragment__Statistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['statistics']>)[number]>;
export type MyTeamsGameDetailsFragment__Type = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['statistics']>)[number]>['type']>);
export type MyTeamsGameDetailsFragment_Periods = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['periods']>)[number]>;
export type MyTeamsGameDetailsFragment_Period = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['periods']>)[number]>['period']>);
export type MyTeamsGameDetailsFragment___Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameDetailsFragment___Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameDetailsFragmentStatus = (NonNullable<MyTeamsGameDetailsFragmentFragment['status']>);
export type MyTeamsGameDetailsFragmentRound = (NonNullable<MyTeamsGameDetailsFragmentFragment['round']>);
export type MyTeamsGameDetailsFragmentGrade = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>);
export type MyTeamsGameDetailsFragmentDay = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['day']>);
export type MyTeamsGameDetailsFragmentSeason = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['season']>);
export type MyTeamsGameDetailsFragmentCompetition = (NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['season']>)['competition']>);
export type MyTeamsGameDetailsFragmentOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['season']>)['competition']>)['organisation']>);
export type MyTeamsGameDetailsFragmentGameEvents = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameEvents']>);
export type MyTeamsGameDetailsFragmentParticipantEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameEvents']>)['participantEvents']>)[number]>;
export type MyTeamsGameDetailsFragmentPeriodEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameEvents']>)['periodEvents']>)[number]>;
export type MyTeamsGameDetailsFragmentTeamEvents = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameEvents']>)['teamEvents']>)[number]>;
export type MyTeamsGameDetailsFragmentPeriodScoresDisplayType = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['periodScoresDisplayType']>);
export type MyTeamsGameDetailsFragment__Periods = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['periods']>)[number]>;
export type MyTeamsGameDetailsFragmentPlayerPoints = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['playerPoints']>);
export type MyTeamsGameDetailsFragmentBestPlayers = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['bestPlayers']>);
export type MyTeamsGameDetailsFragmentGameStatisticsConfiguration = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameStatisticsConfiguration']>);
export type MyTeamsGameDetailsFragmentGameStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>;
export type MyTeamsGameDetailsFragmentGlossary = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>['glossary']>);
export type MyTeamsGameDetailsFragmentDefault = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>['glossary']>)['default']>);
export type MyTeamsGameDetailsFragmentScoring = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['round']>)['grade']>)['gameStatisticsConfiguration']>)['gameStatistics']>)[number]>['glossary']>)['scoring']>);
export type MyTeamsGameDetailsFragmentAllocation = (NonNullable<MyTeamsGameDetailsFragmentFragment['allocation']>);
export type MyTeamsGameDetailsFragmentCourt = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['allocation']>)['court']>);
export type MyTeamsGameDetailsFragmentVenue = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['allocation']>)['court']>)['venue']>);
export type MyTeamsGameDetailsFragment____Statistics = (NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>);
export type MyTeamsGameDetailsFragment__Home = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['home']>);
export type MyTeamsGameDetailsFragment__Away = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['away']>);
export type MyTeamsGameDetailsFragmentShared = NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['shared']>)[number]>;
export type MyTeamsGameDetailsFragment__Period = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['shared']>)[number]>['period']>);
export type MyTeamsGameDetailsFragment_____Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['shared']>)[number]>['statistics']>)[number]>;
export type MyTeamsGameDetailsFragment____Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['shared']>)[number]>['statistics']>)[number]>['type']>);
export type MyTeamsGameDetailsFragmentPlayers = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['statistics']>)['shared']>)[number]>['players']>)[number]>;
export type MyTeamsGameDetailsFragmentManagementAuthorisation = (NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>);
export type MyTeamsGameDetailsFragmentResultAndPeriodScores = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['resultAndPeriodScores']>);
export type MyTeamsGameDetailsFragment___Home = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['home']>);
export type MyTeamsGameDetailsFragmentLineUp = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['home']>)['lineUp']>);
export type MyTeamsGameDetailsFragmentStats = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['home']>)['stats']>);
export type MyTeamsGameDetailsFragment___Away = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['away']>);
export type MyTeamsGameDetailsFragment_LineUp = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['away']>)['lineUp']>);
export type MyTeamsGameDetailsFragment_Stats = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['managementAuthorisation']>)['away']>)['stats']>);
export type MyTeamsGameDetailsFragmentClubScoringAccess = (NonNullable<MyTeamsGameDetailsFragmentFragment['clubScoringAccess']>);
export type MyTeamsGameDetailsFragmentGameType = (NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>);
export type MyTeamsGameDetailsFragmentPlayerPositionsSettings = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>)['playerPositionsSettings']>);
export type MyTeamsGameDetailsFragmentEScoringSettings = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>)['eScoringSettings']>);
export type MyTeamsGameDetailsFragmentEmergencyPlayersSettings = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>)['emergencyPlayersSettings']>);
export type MyTeamsGameDetailsFragmentLineupLimits = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>)['lineupLimits']>);
export type MyTeamsGameDetailsFragment_Players = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>)['lineupLimits']>)['players']>);
export type MyTeamsGameDetailsFragmentCoaches = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameType']>)['lineupLimits']>)['coaches']>);
export type MyTeamsGameDetailsFragmentGameTeams = (NonNullable<MyTeamsGameDetailsFragmentFragment['gameTeams']>);
export type MyTeamsGameDetailsFragment____Home = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameTeams']>)['home']>);
export type MyTeamsGameDetailsFragment____Away = (NonNullable<(NonNullable<MyTeamsGameDetailsFragmentFragment['gameTeams']>)['away']>);
export type MyTeamsGameUpdateVariables = MyTeamsGameUpdateMutationVariables;
export type MyTeamsGameUpdateMyTeamsGameUpdate = (NonNullable<MyTeamsGameUpdateMutation['myTeamsGameUpdate']>);
export type MyTeamsGameUpdateMyTeamsGame = (NonNullable<(NonNullable<MyTeamsGameUpdateMutation['myTeamsGameUpdate']>)['myTeamsGame']>);
export type OrganisationDetailsAddress = (NonNullable<OrganisationDetailsFragment['address']>);
export type OrganisationDetailsLogo = (NonNullable<OrganisationDetailsFragment['logo']>);
export type OrganisationDetailsSizes = NonNullable<(NonNullable<(NonNullable<OrganisationDetailsFragment['logo']>)['sizes']>)[number]>;
export type OrganisationDetailsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<OrganisationDetailsFragment['logo']>)['sizes']>)[number]>['dimensions']>);
export type OrganisationDetailsContacts = NonNullable<(NonNullable<OrganisationDetailsFragment['contacts']>)[number]>;
export type TenantContactRolesConfigurationContactRoles = NonNullable<(NonNullable<TenantContactRolesConfigurationFragment['contactRoles']>)[number]>;
export type ExternalAccountLinkingExternalAccountLinking = (NonNullable<ExternalAccountLinkingFragment['externalAccountLinking']>);
export type ProductFragmentSettings = (NonNullable<ProductFragmentFragment['settings']>);
export type ProductFragmentValidFrom = (NonNullable<(NonNullable<ProductFragmentFragment['settings']>)['validFrom']>);
export type ProductFragmentValidTo = (NonNullable<(NonNullable<ProductFragmentFragment['settings']>)['validTo']>);
export type ProductFragmentVariants = NonNullable<(NonNullable<ProductFragmentFragment['variants']>)[number]>;
export type ProductFragmentAmount = (NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['variants']>)[number]>['amount']>);
export type ProductFragmentCategoryPairs = NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['variants']>)[number]>['categoryPairs']>)[number]>;
export type ProductFragmentCategory = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['variants']>)[number]>['categoryPairs']>)[number]>['category']>);
export type ProductFragmentOption = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['variants']>)[number]>['categoryPairs']>)[number]>['option']>);
export type ProductFragmentCategories = NonNullable<(NonNullable<ProductFragmentFragment['categories']>)[number]>;
export type ProductFragmentOptions = NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['categories']>)[number]>['options']>)[number]>;
export type ProductFragmentCustomFields = NonNullable<(NonNullable<ProductFragmentFragment['customFields']>)[number]>;
export type ProductFragmentDropdownOptions = NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['customFields']>)[number]>['dropdownOptions']>)[number]>;
export type ProductFragment_Option = (NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['customFields']>)[number]>['option']>);
export type ProductFragment_Category = (NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['customFields']>)[number]>['option']>)['category']>);
export type ProductFragment__Option = (NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['customFields']>)[number]>['option']>)['option']>);
export type ProductFragmentImages = NonNullable<(NonNullable<ProductFragmentFragment['images']>)[number]>;
export type ProductFragmentSizes = NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['images']>)[number]>['sizes']>)[number]>;
export type ProductFragmentDimensions = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<ProductFragmentFragment['images']>)[number]>['sizes']>)[number]>['dimensions']>);
export type ProductFragmentRegistrationSettings = (NonNullable<ProductFragmentFragment['registrationSettings']>);
export type ProfileClaimVariables = ProfileClaimMutationVariables;
export type ProfileClaimProfileClaim = (NonNullable<ProfileClaimMutation['profileClaim']>);
export type VerificationCodeGenerateVariables = VerificationCodeGenerateMutationVariables;
export type VerificationCodeGenerateVerificationCodeGenerate = (NonNullable<VerificationCodeGenerateMutation['verificationCodeGenerate']>);
export type ClaimVerifyVariables = ClaimVerifyMutationVariables;
export type ClaimVerifyClaimVerify = (NonNullable<ClaimVerifyMutation['claimVerify']>);
export type RoundFixtureDiscoverTeamFragmentLogo = (NonNullable<RoundFixtureDiscoverTeamFragmentFragment['logo']>);
export type RoundFixtureDiscoverTeamFragmentSizes = NonNullable<(NonNullable<(NonNullable<RoundFixtureDiscoverTeamFragmentFragment['logo']>)['sizes']>)[number]>;
export type RoundFixtureDiscoverTeamFragmentDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<RoundFixtureDiscoverTeamFragmentFragment['logo']>)['sizes']>)[number]>['dimensions']>);
export type RoundFixtureDiscoverTeamFragmentSeason = (NonNullable<RoundFixtureDiscoverTeamFragmentFragment['season']>);
export type RoundFixtureDiscoverTeamFragmentCompetition = (NonNullable<(NonNullable<RoundFixtureDiscoverTeamFragmentFragment['season']>)['competition']>);
export type RoundFixtureDiscoverTeamFragmentOrganisation = (NonNullable<RoundFixtureDiscoverTeamFragmentFragment['organisation']>);
export type RoundFixtureTeamFragmentProvisionalTeamInlineFragment = (DiscriminateUnion<RoundFixtureTeamFragmentFragment, { __typename?: 'ProvisionalTeam' }>);
export type RoundFixtureTeamFragmentPool = (NonNullable<(DiscriminateUnion<RoundFixtureTeamFragmentFragment, { __typename?: 'ProvisionalTeam' }>)['pool']>);
export type RoundFixtureFragmentByes = NonNullable<(NonNullable<RoundFixtureFragmentFragment['byes']>)[number]>;
export type RoundFixtureFragmentGames = NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>;
export type RoundFixtureFragmentPool = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['pool']>);
export type RoundFixtureFragmentAway = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['away']>);
export type RoundFixtureFragmentHome = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['home']>);
export type RoundFixtureFragmentResult = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>);
export type RoundFixtureFragmentWinner = (NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['winner']>);
export type RoundFixtureFragmentOutcome = (NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['outcome']>);
export type RoundFixtureFragment_Home = (NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>);
export type RoundFixtureFragment_Outcome = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['outcome']>);
export type RoundFixtureFragmentStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['statistics']>)[number]>;
export type RoundFixtureFragmentType = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['statistics']>)[number]>['type']>);
export type RoundFixtureFragmentPeriods = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['periods']>)[number]>;
export type RoundFixtureFragmentPeriod = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['periods']>)[number]>['period']>);
export type RoundFixtureFragment_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>;
export type RoundFixtureFragment_Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['home']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type RoundFixtureFragment_Away = (NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>);
export type RoundFixtureFragment__Outcome = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['outcome']>);
export type RoundFixtureFragment__Statistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['statistics']>)[number]>;
export type RoundFixtureFragment__Type = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['statistics']>)[number]>['type']>);
export type RoundFixtureFragment_Periods = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['periods']>)[number]>;
export type RoundFixtureFragment_Period = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['periods']>)[number]>['period']>);
export type RoundFixtureFragment___Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>;
export type RoundFixtureFragment___Type = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['result']>)['away']>)['periods']>)[number]>['statistics']>)[number]>['type']>);
export type RoundFixtureFragmentStatus = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['status']>);
export type RoundFixtureFragmentAllocation = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['allocation']>);
export type RoundFixtureFragmentDateTimeList = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['allocation']>)['dateTimeList']>)[number]>;
export type RoundFixtureFragmentCourt = (NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['allocation']>)['court']>);
export type RoundFixtureFragmentVenue = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['allocation']>)['court']>)['venue']>);
export type RoundFixtureFragmentGameType = (NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['gameType']>);
export type RoundFixtureFragmentEScoringSettings = (NonNullable<(NonNullable<NonNullable<(NonNullable<RoundFixtureFragmentFragment['games']>)[number]>['gameType']>)['eScoringSettings']>);
export type AvailableCharitiesFragmentOptions = NonNullable<(NonNullable<AvailableCharitiesFragmentFragment['options']>)[number]>;
export type AvailableCharitiesFragmentAmount = (NonNullable<NonNullable<(NonNullable<AvailableCharitiesFragmentFragment['options']>)[number]>['amount']>);
export type AvailableCharitiesFragmentCurrency = (NonNullable<(NonNullable<NonNullable<(NonNullable<AvailableCharitiesFragmentFragment['options']>)[number]>['amount']>)['currency']>);
export type SelectedCharitiesFragmentAmount = (NonNullable<SelectedCharitiesFragmentFragment['amount']>);
export type SelectedCharitiesFragmentCurrency = (NonNullable<(NonNullable<SelectedCharitiesFragmentFragment['amount']>)['currency']>);
export type CartFragmentItems = NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>;
export type CartFragmentDiscount = (NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['discount']>);
export type CartFragmentAmount = (NonNullable<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['discount']>)['amount']>);
export type CartFragmentFee = (NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>);
export type CartFragmentMerchandiseFeeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>);
export type CartFragment_Amount = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['amount']>);
export type CartFragmentCurrency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['amount']>)['currency']>);
export type CartFragmentOrganisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['organisation']>);
export type CartFragmentCustomFieldAnswers = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['customFieldAnswers']>)[number]>;
export type CartFragmentCustomField = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['customFieldAnswers']>)[number]>['customField']>);
export type CartFragmentParticipantFeeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>);
export type CartFragment__Amount = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['amount']>);
export type CartFragment_Currency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['amount']>)['currency']>);
export type CartFragmentAmountDeferred = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['amountDeferred']>);
export type CartFragment__Currency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['amountDeferred']>)['currency']>);
export type CartFragment_Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['organisation']>);
export type CartFragmentSelectedOption = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['selectedOption']>);
export type CartFragmentOptions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['options']>)[number]>;
export type CartFragment___Amount = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['options']>)[number]>['amount']>);
export type CartFragment___Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'ParticipantFee' }>)['options']>)[number]>['amount']>)['currency']>);
export type CartFragmentMembershipAdvancedFeeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>);
export type CartFragment____Amount = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>)['amount']>);
export type CartFragment____Currency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>)['amount']>)['currency']>);
export type CartFragment__Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>)['organisation']>);
export type CartFragmentSelectedPayment = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>)['selectedPayment']>);
export type CartFragmentPayments = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>)['payments']>)[number]>;
export type CartFragment_____Amount = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MembershipAdvancedFee' }>)['payments']>)[number]>['amount']>);
export type CartFragment_Discount = (NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['discount']>);
export type CartFragment______Amount = (NonNullable<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['discount']>)['amount']>);
export type CartFragment_____Currency = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['discount']>)['amount']>)['currency']>);
export type CartFragment___Organisation = (NonNullable<(NonNullable<NonNullable<(NonNullable<CartFragmentFragment['items']>)[number]>['discount']>)['organisation']>);
export type CartFragmentTotals = (NonNullable<CartFragmentFragment['totals']>);
export type CartFragmentVouchers = NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['vouchers']>)[number]>;
export type CartFragment_______Amount = (NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['vouchers']>)[number]>['amount']>);
export type CartFragment______Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['vouchers']>)[number]>['amount']>)['currency']>);
export type CartFragment____Organisation = (NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['vouchers']>)[number]>['organisation']>);
export type CartFragmentPromotionalVouchers = NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>;
export type CartFragment________Amount = (NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>['amount']>);
export type CartFragment_______Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>['amount']>)['currency']>);
export type CartFragmentOrganisations = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>['organisations']>)[number]>;
export type CartFragmentExternalVouchers = NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['externalVouchers']>)[number]>;
export type CartFragmentScheme = (NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['externalVouchers']>)[number]>['scheme']>);
export type CartFragment_________Amount = (NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['externalVouchers']>)[number]>['amount']>);
export type CartFragment________Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['externalVouchers']>)[number]>['amount']>)['currency']>);
export type CartFragment_Organisations = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['externalVouchers']>)[number]>['organisations']>)[number]>;
export type CartFragmentTotalAmount = (NonNullable<(NonNullable<CartFragmentFragment['totals']>)['totalAmount']>);
export type CartFragment_________Currency = (NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['totalAmount']>)['currency']>);
export type CartFragmentSubTotalAmount = (NonNullable<(NonNullable<CartFragmentFragment['totals']>)['subTotalAmount']>);
export type CartFragment__________Currency = (NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['subTotalAmount']>)['currency']>);
export type CartFragmentServiceFeeAmount = (NonNullable<(NonNullable<CartFragmentFragment['totals']>)['serviceFeeAmount']>);
export type CartFragment___________Currency = (NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['serviceFeeAmount']>)['currency']>);
export type CartFragmentShippingFeeAmount = (NonNullable<(NonNullable<CartFragmentFragment['totals']>)['shippingFeeAmount']>);
export type CartFragment____________Currency = (NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['shippingFeeAmount']>)['currency']>);
export type CartFragmentDeferredSubtotalAmount = (NonNullable<(NonNullable<CartFragmentFragment['totals']>)['deferredSubtotalAmount']>);
export type CartFragment_____________Currency = (NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['deferredSubtotalAmount']>)['currency']>);
export type CartFragmentDeferredServiceFeeAmount = (NonNullable<(NonNullable<CartFragmentFragment['totals']>)['deferredServiceFeeAmount']>);
export type CartFragment______________Currency = (NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['deferredServiceFeeAmount']>)['currency']>);
export type CartFragmentSelectedCharities = NonNullable<(NonNullable<(NonNullable<CartFragmentFragment['totals']>)['selectedCharities']>)[number]>;
export type CartFragmentProductsAmount = (NonNullable<CartFragmentFragment['productsAmount']>);
export type CartFragment_______________Currency = (NonNullable<(NonNullable<CartFragmentFragment['productsAmount']>)['currency']>);
export type CartFragmentFeesAmount = (NonNullable<CartFragmentFragment['feesAmount']>);
export type CartFragment________________Currency = (NonNullable<(NonNullable<CartFragmentFragment['feesAmount']>)['currency']>);
export type CartFragmentAvailableExternalVouchers = NonNullable<(NonNullable<CartFragmentFragment['availableExternalVouchers']>)[number]>;
export type CartFragment_Scheme = (NonNullable<NonNullable<(NonNullable<CartFragmentFragment['availableExternalVouchers']>)[number]>['scheme']>);
export type CartFragmentAvailableCharities = NonNullable<(NonNullable<CartFragmentFragment['availableCharities']>)[number]>;
export type SeasonRegistrationCartVariables = SeasonRegistrationCartQueryVariables;
export type SeasonRegistrationCartSeasonRegistrationCart = (NonNullable<SeasonRegistrationCartQuery['seasonRegistrationCart']>);
export type SeasonRegistrationCartCart = (NonNullable<(NonNullable<SeasonRegistrationCartQuery['seasonRegistrationCart']>)['cart']>);
export type SeasonRegistrationCartErrors = NonNullable<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['seasonRegistrationCart']>)['errors']>)[number]>;
export type SeasonRegistrationCartCheckoutSession = (NonNullable<(NonNullable<SeasonRegistrationCartQuery['seasonRegistrationCart']>)['checkoutSession']>);
export type SeasonRegistrationCartGr4vyEmbedCheckoutSessionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['seasonRegistrationCart']>)['checkoutSession']>), { __typename?: 'Gr4vyEmbedCheckoutSession' }>);
export type SeasonRegistrationCartDiscoverSeasonRegistration = (NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>);
export type SeasonRegistrationCartProducts = NonNullable<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['products']>)[number]>;
export type SeasonRegistrationCartOrganisationTermsAndConditions = NonNullable<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['organisationTermsAndConditions']>)[number]>;
export type SeasonRegistrationCartOrganisation = (NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['organisation']>);
export type SeasonRegistrationCartSeason = (NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['season']>);
export type SeasonRegistrationCartDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type SeasonRegistrationCartCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type SeasonRegistrationCart_Organisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type SeasonRegistrationCartProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['season']>), { __typename?: 'ProgramSeason' }>);
export type SeasonRegistrationCartProgram = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<SeasonRegistrationCartQuery['discoverSeasonRegistration']>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type TeamCartFragmentItems = NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>;
export type TeamCartFragmentFee = (NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>);
export type TeamCartFragmentMerchandiseFeeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>);
export type TeamCartFragmentAmount = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['amount']>);
export type TeamCartFragmentCurrency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['amount']>)['currency']>);
export type TeamCartFragmentOrganisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['organisation']>);
export type TeamCartFragmentCustomFieldAnswers = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['customFieldAnswers']>)[number]>;
export type TeamCartFragmentCustomField = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'MerchandiseFee' }>)['customFieldAnswers']>)[number]>['customField']>);
export type TeamCartFragmentTeamFeeInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'TeamFee' }>);
export type TeamCartFragment_Amount = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'TeamFee' }>)['amount']>);
export type TeamCartFragment_Currency = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'TeamFee' }>)['amount']>)['currency']>);
export type TeamCartFragment_Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<TeamCartFragmentFragment['items']>)[number]>['fee']>), { __typename?: 'TeamFee' }>)['organisation']>);
export type TeamCartFragmentTotals = (NonNullable<TeamCartFragmentFragment['totals']>);
export type TeamCartFragmentVouchers = NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['vouchers']>)[number]>;
export type TeamCartFragment__Amount = (NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['vouchers']>)[number]>['amount']>);
export type TeamCartFragment__Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['vouchers']>)[number]>['amount']>)['currency']>);
export type TeamCartFragment__Organisation = (NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['vouchers']>)[number]>['organisation']>);
export type TeamCartFragmentPromotionalVouchers = NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>;
export type TeamCartFragment___Amount = (NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>['amount']>);
export type TeamCartFragment___Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>['amount']>)['currency']>);
export type TeamCartFragmentOrganisations = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['promotionalVouchers']>)[number]>['organisations']>)[number]>;
export type TeamCartFragmentExternalVouchers = NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['externalVouchers']>)[number]>;
export type TeamCartFragmentScheme = (NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['externalVouchers']>)[number]>['scheme']>);
export type TeamCartFragment____Amount = (NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['externalVouchers']>)[number]>['amount']>);
export type TeamCartFragment____Currency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['externalVouchers']>)[number]>['amount']>)['currency']>);
export type TeamCartFragment_Organisations = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['externalVouchers']>)[number]>['organisations']>)[number]>;
export type TeamCartFragmentTotalAmount = (NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['totalAmount']>);
export type TeamCartFragment_____Currency = (NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['totalAmount']>)['currency']>);
export type TeamCartFragmentSubTotalAmount = (NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['subTotalAmount']>);
export type TeamCartFragment______Currency = (NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['subTotalAmount']>)['currency']>);
export type TeamCartFragmentServiceFeeAmount = (NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['serviceFeeAmount']>);
export type TeamCartFragment_______Currency = (NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['serviceFeeAmount']>)['currency']>);
export type TeamCartFragmentShippingFeeAmount = (NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['shippingFeeAmount']>);
export type TeamCartFragment________Currency = (NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['shippingFeeAmount']>)['currency']>);
export type TeamCartFragmentDeferredSubtotalAmount = (NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['deferredSubtotalAmount']>);
export type TeamCartFragment_________Currency = (NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['deferredSubtotalAmount']>)['currency']>);
export type TeamCartFragmentDeferredServiceFeeAmount = (NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['deferredServiceFeeAmount']>);
export type TeamCartFragment__________Currency = (NonNullable<(NonNullable<(NonNullable<TeamCartFragmentFragment['totals']>)['deferredServiceFeeAmount']>)['currency']>);
export type TeamCartFragmentProductsAmount = (NonNullable<TeamCartFragmentFragment['productsAmount']>);
export type TeamCartFragment___________Currency = (NonNullable<(NonNullable<TeamCartFragmentFragment['productsAmount']>)['currency']>);
export type TeamCartFragmentFeesAmount = (NonNullable<TeamCartFragmentFragment['feesAmount']>);
export type TeamCartFragment____________Currency = (NonNullable<(NonNullable<TeamCartFragmentFragment['feesAmount']>)['currency']>);
export type SocialTeamRegistrationCartVariables = SocialTeamRegistrationCartQueryVariables;
export type SocialTeamRegistrationCartSocialTeamRegistrationCart = (NonNullable<SocialTeamRegistrationCartQuery['socialTeamRegistrationCart']>);
export type SocialTeamRegistrationCartCart = (NonNullable<(NonNullable<SocialTeamRegistrationCartQuery['socialTeamRegistrationCart']>)['cart']>);
export type SocialTeamRegistrationCartErrors = NonNullable<(NonNullable<(NonNullable<SocialTeamRegistrationCartQuery['socialTeamRegistrationCart']>)['errors']>)[number]>;
export type SocialTeamRegistrationCartCheckoutSession = (NonNullable<(NonNullable<SocialTeamRegistrationCartQuery['socialTeamRegistrationCart']>)['checkoutSession']>);
export type SocialTeamRegistrationCartGr4vyEmbedCheckoutSessionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<SocialTeamRegistrationCartQuery['socialTeamRegistrationCart']>)['checkoutSession']>), { __typename?: 'Gr4vyEmbedCheckoutSession' }>);
export type SocialTeamRegistrationCartDiscoverSocialTeamRegistration = (NonNullable<SocialTeamRegistrationCartQuery['discoverSocialTeamRegistration']>);
export type SocialTeamRegistrationCartProducts = NonNullable<(NonNullable<(NonNullable<SocialTeamRegistrationCartQuery['discoverSocialTeamRegistration']>)['products']>)[number]>;
export type SocialTeamRegistrationCartOrganisationTermsAndConditions = NonNullable<(NonNullable<(NonNullable<SocialTeamRegistrationCartQuery['discoverSocialTeamRegistration']>)['organisationTermsAndConditions']>)[number]>;
export type SupportedCountriesVariables = SupportedCountriesQueryVariables;
export type SupportedCountriesConfiguration = (NonNullable<SupportedCountriesQuery['configuration']>);
export type SupportedCountriesSupportedCountries = NonNullable<(NonNullable<(NonNullable<SupportedCountriesQuery['configuration']>)['supportedCountries']>)[number]>;
export type DiscoverTeamFragmentLogo = (NonNullable<DiscoverTeamFragmentFragment['logo']>);
export type DiscoverTeamFragmentSizes = NonNullable<(NonNullable<(NonNullable<DiscoverTeamFragmentFragment['logo']>)['sizes']>)[number]>;
export type DiscoverTeamFragmentDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<DiscoverTeamFragmentFragment['logo']>)['sizes']>)[number]>['dimensions']>);
export type DiscoverTeamFragmentSeason = (NonNullable<DiscoverTeamFragmentFragment['season']>);
export type DiscoverTeamFragmentCompetition = (NonNullable<(NonNullable<DiscoverTeamFragmentFragment['season']>)['competition']>);
export type DiscoverTeamFragmentOrganisation = (NonNullable<DiscoverTeamFragmentFragment['organisation']>);
export type TeamFragmentProvisionalTeamInlineFragment = (DiscriminateUnion<TeamFragmentFragment, { __typename?: 'ProvisionalTeam' }>);
export type TeamFragmentPool = (NonNullable<(DiscriminateUnion<TeamFragmentFragment, { __typename?: 'ProvisionalTeam' }>)['pool']>);
export type GameSheetGenerateVariables = GameSheetGenerateMutationVariables;
export type GameSheetGenerateGameSheetGenerate = (NonNullable<GameSheetGenerateMutation['gameSheetGenerate']>);
export type GameSheetDownloadVariables = GameSheetDownloadQueryVariables;
export type GameSheetDownloadGameSheetDownload = (NonNullable<GameSheetDownloadQuery['gameSheetDownload']>);
export type GetLocalisationVariables = GetLocalisationQueryVariables;
export type GetLocalisationTenantConfiguration = (NonNullable<GetLocalisationQuery['tenantConfiguration']>);
export type GetLocalisationLocalisation = (NonNullable<(NonNullable<GetLocalisationQuery['tenantConfiguration']>)['localisation']>);
export type GetLocalisationCurrency = (NonNullable<(NonNullable<(NonNullable<GetLocalisationQuery['tenantConfiguration']>)['localisation']>)['currency']>);
export type PlayerNumberDisabledTenantConfigVariables = PlayerNumberDisabledTenantConfigQueryVariables;
export type PlayerNumberDisabledTenantConfigTenantConfiguration = (NonNullable<PlayerNumberDisabledTenantConfigQuery['tenantConfiguration']>);
export type MyProfileAndDependantsVariables = MyProfileAndDependantsQueryVariables;
export type MyProfileAndDependantsAccount = (NonNullable<MyProfileAndDependantsQuery['account']>);
export type MyProfileAndDependantsProfile = (NonNullable<(NonNullable<MyProfileAndDependantsQuery['account']>)['profile']>);
export type ProfileTenantHistoryVariables = ProfileTenantHistoryQueryVariables;
export type ProfileTenantHistoryProfileTenantHistory = (NonNullable<ProfileTenantHistoryQuery['profileTenantHistory']>);
export type ProfileTenantHistoryMyTeams = NonNullable<(NonNullable<(NonNullable<ProfileTenantHistoryQuery['profileTenantHistory']>)['myTeams']>)[number]>;
export type ProfileTenantHistoryCoachingAccreditation = NonNullable<(NonNullable<(NonNullable<ProfileTenantHistoryQuery['profileTenantHistory']>)['coachingAccreditation']>)[number]>;
export type ProfileTenantHistoryRegistrationHistory = NonNullable<(NonNullable<(NonNullable<ProfileTenantHistoryQuery['profileTenantHistory']>)['registrationHistory']>)[number]>;
export type ProfileTenantHistoryMemberships = NonNullable<(NonNullable<(NonNullable<ProfileTenantHistoryQuery['profileTenantHistory']>)['memberships']>)[number]>;
export type ProfileTenantHistoryConcussionIncidents = NonNullable<(NonNullable<(NonNullable<ProfileTenantHistoryQuery['profileTenantHistory']>)['concussionIncidents']>)[number]>;
export type ChangeEmailAccountVariables = ChangeEmailAccountQueryVariables;
export type ChangeEmailAccountAccount = (NonNullable<ChangeEmailAccountQuery['account']>);
export type ChangeEmailAccountProfile = (NonNullable<(NonNullable<ChangeEmailAccountQuery['account']>)['profile']>);
export type ProfileEmailChangeVariables = ProfileEmailChangeMutationVariables;
export type ProfileEmailVerifyVariables = ProfileEmailVerifyMutationVariables;
export type ProfileEmailVerifyProfileEmailVerify = (NonNullable<ProfileEmailVerifyMutation['profileEmailVerify']>);
export type OrganisationRegistrationsVariables = OrganisationRegistrationsQueryVariables;
export type OrganisationRegistrationsDiscoverOrganisation = (NonNullable<OrganisationRegistrationsQuery['discoverOrganisation']>);
export type OrganisationRegistrationsAddress = (NonNullable<(NonNullable<OrganisationRegistrationsQuery['discoverOrganisation']>)['address']>);
export type OrganisationRegistrationsLogo = (NonNullable<(NonNullable<OrganisationRegistrationsQuery['discoverOrganisation']>)['logo']>);
export type OrganisationRegistrationsSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<OrganisationRegistrationsQuery['discoverOrganisation']>)['logo']>)['sizes']>)[number]>;
export type OrganisationRegistrationsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<OrganisationRegistrationsQuery['discoverOrganisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type OrganisationRegistrationsContacts = NonNullable<(NonNullable<(NonNullable<OrganisationRegistrationsQuery['discoverOrganisation']>)['contacts']>)[number]>;
export type OrganisationRegistrationsOrganisationRegistrations = NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>;
export type OrganisationRegistrationsStartDate = (NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['startDate']>);
export type OrganisationRegistrationsEndDate = (NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['endDate']>);
export type OrganisationRegistrationsSeason = (NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['season']>);
export type OrganisationRegistrationsProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['season']>), { __typename?: 'ProgramSeason' }>);
export type OrganisationRegistrationsProgram = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type OrganisationRegistrationsDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['season']>), { __typename?: 'DiscoverSeason' }>);
export type OrganisationRegistrationsCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type OrganisationRegistrationsHostOrganisation = (NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['hostOrganisation']>);
export type OrganisationRegistrations_Logo = (NonNullable<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['hostOrganisation']>)['logo']>);
export type OrganisationRegistrations_Sizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['hostOrganisation']>)['logo']>)['sizes']>)[number]>;
export type OrganisationRegistrations_Dimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['hostOrganisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type OrganisationRegistrationsRegistrationUserTypes = NonNullable<(NonNullable<NonNullable<(NonNullable<OrganisationRegistrationsQuery['organisationRegistrations']>)[number]>['registrationUserTypes']>)[number]>;
export type OrganisationRegistrationsTenantConfiguration = (NonNullable<OrganisationRegistrationsQuery['tenantConfiguration']>);
export type OrganisationRegistrationsSport = (NonNullable<(NonNullable<OrganisationRegistrationsQuery['tenantConfiguration']>)['sport']>);
export type FindMyProfilesVariables = FindMyProfilesQueryVariables;
export type FindMyProfilesProfile = (NonNullable<FindMyProfilesQuery['profile']>);
export type FindMyProfilesGender = (NonNullable<(NonNullable<FindMyProfilesQuery['profile']>)['gender']>);
export type FindMyProfilesDependants = NonNullable<(NonNullable<(NonNullable<FindMyProfilesQuery['profile']>)['dependants']>)[number]>;
export type FindMyProfiles_Gender = (NonNullable<NonNullable<(NonNullable<(NonNullable<FindMyProfilesQuery['profile']>)['dependants']>)[number]>['gender']>);
export type FindMyProfilesClaimProfilesVariables = FindMyProfilesClaimProfilesQueryVariables;
export type FindMyProfilesClaimProfilesDuplicateProfiles = NonNullable<(NonNullable<FindMyProfilesClaimProfilesQuery['duplicateProfiles']>)[number]>;
export type FindMyProfilesClaimProfilesLastRegisteredSeason = (NonNullable<NonNullable<(NonNullable<FindMyProfilesClaimProfilesQuery['duplicateProfiles']>)[number]>['lastRegisteredSeason']>);
export type FindMyProfilesClaimProfilesLastRegisteredOrganisation = (NonNullable<NonNullable<(NonNullable<FindMyProfilesClaimProfilesQuery['duplicateProfiles']>)[number]>['lastRegisteredOrganisation']>);
export type GameCentreDiscoverGameVariables = GameCentreDiscoverGameQueryVariables;
export type GameCentreDiscoverGameDiscoverGame = (NonNullable<GameCentreDiscoverGameQuery['discoverGame']>);
export type GameCentreDiscoverGameAway = (NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['away']>);
export type GameCentreDiscoverGameProvisionalTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['away']>), { __typename?: 'ProvisionalTeam' }>);
export type GameCentreDiscoverGameDiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['away']>), { __typename?: 'DiscoverTeam' }>);
export type GameCentreDiscoverGameHome = (NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['home']>);
export type GameCentreDiscoverGame_ProvisionalTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['home']>), { __typename?: 'ProvisionalTeam' }>);
export type GameCentreDiscoverGame_DiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['home']>), { __typename?: 'DiscoverTeam' }>);
export type GameCentreDiscoverGameRound = (NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['round']>);
export type GameCentreDiscoverGameGrade = (NonNullable<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['round']>)['grade']>);
export type GameCentreDiscoverGameSeason = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['round']>)['grade']>)['season']>);
export type GameCentreDiscoverGameCompetition = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['round']>)['grade']>)['season']>)['competition']>);
export type GameCentreDiscoverGameOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GameCentreDiscoverGameQuery['discoverGame']>)['round']>)['grade']>)['season']>)['competition']>)['organisation']>);
export type GameCentreDiscoverGameTenantConfiguration = (NonNullable<GameCentreDiscoverGameQuery['tenantConfiguration']>);
export type GameManageJwtGenerateVariables = GameManageJwtGenerateMutationVariables;
export type GameManageJwtGenerateGameManageJwtGenerate = (NonNullable<GameManageJwtGenerateMutation['gameManageJWTGenerate']>);
export type DiscoverGradeVariables = DiscoverGradeQueryVariables;
export type DiscoverGradeDiscoverGrade = (NonNullable<DiscoverGradeQuery['discoverGrade']>);
export type DiscoverGradeSeason = (NonNullable<(NonNullable<DiscoverGradeQuery['discoverGrade']>)['season']>);
export type DiscoverGradeCompetition = (NonNullable<(NonNullable<(NonNullable<DiscoverGradeQuery['discoverGrade']>)['season']>)['competition']>);
export type DiscoverGradeOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverGradeQuery['discoverGrade']>)['season']>)['competition']>)['organisation']>);
export type DiscoverGradeTenantConfiguration = (NonNullable<DiscoverGradeQuery['tenantConfiguration']>);
export type DiscoverGradeStatistics = (NonNullable<(NonNullable<DiscoverGradeQuery['tenantConfiguration']>)['statistics']>);
export type DiscoverGradeGradeTypes = NonNullable<(NonNullable<(NonNullable<DiscoverGradeQuery['tenantConfiguration']>)['gradeTypes']>)[number]>;
export type DiscoverGradeFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<DiscoverGradeQuery['tenantConfiguration']>)['gradeTypes']>)[number]>['features']>);
export type GradeLadderVariables = GradeLadderQueryVariables;
export type GradeLadderDiscoverGrade = (NonNullable<GradeLadderQuery['discoverGrade']>);
export type GradeLadderSeason = (NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['season']>);
export type GradeLadderCompetition = (NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['season']>)['competition']>);
export type GradeLadderOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['season']>)['competition']>)['organisation']>);
export type GradeLadderLadder = NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>;
export type GradeLadderPool = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['pool']>);
export type GradeLadderGeneratedFrom = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['generatedFrom']>);
export type GradeLadderStandings = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['standings']>)[number]>;
export type GradeLadderTeam = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['standings']>)[number]>['team']>);
export type GradeLadder_Season = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['season']>);
export type GradeLadder_Competition = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['season']>)['competition']>);
export type GradeLadder_Organisation = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['organisation']>);
export type GradeLadderGameTypes = NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['gameTypes']>)[number]>;
export type GradeLadderLadderFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['gameTypes']>)[number]>['ladderFields']>)[number]>;
export type GradeLadderLadderRankingFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['gameTypes']>)[number]>['ladderRankingFields']>)[number]>;
export type GradeLadderOverallLadder = (NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['overallLadder']>);
export type GradeLadderOverallLadderFields = NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['overallLadderFields']>)[number]>;
export type GradeLadderOverallLadderRankingFields = NonNullable<(NonNullable<(NonNullable<GradeLadderQuery['discoverGrade']>)['overallLadderRankingFields']>)[number]>;
export type GradeListDiscoverSeasonVariables = GradeListDiscoverSeasonQueryVariables;
export type GradeListDiscoverSeasonDiscoverSeason = (NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>);
export type GradeListDiscoverSeasonCompetition = (NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['competition']>);
export type GradeListDiscoverSeasonOrganisation = (NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['competition']>)['organisation']>);
export type GradeListDiscoverSeasonStatus = (NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['status']>);
export type GradeListDiscoverSeasonGrades = NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['grades']>)[number]>;
export type GradeListDiscoverSeasonDay = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['grades']>)[number]>['day']>);
export type GradeListDiscoverSeasonGender = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['grades']>)[number]>['gender']>);
export type GradeListDiscoverSeasonAge = (NonNullable<NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['discoverSeason']>)['grades']>)[number]>['age']>);
export type GradeListDiscoverSeasonTenantConfiguration = (NonNullable<GradeListDiscoverSeasonQuery['tenantConfiguration']>);
export type GradeListDiscoverSeason_Competition = (NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['tenantConfiguration']>)['competition']>);
export type GradeListDiscoverSeasonAgeGroups = NonNullable<(NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['tenantConfiguration']>)['competition']>)['ageGroups']>)[number]>;
export type GradeListDiscoverSeasonGenders = NonNullable<(NonNullable<(NonNullable<(NonNullable<GradeListDiscoverSeasonQuery['tenantConfiguration']>)['competition']>)['genders']>)[number]>;
export type PublicGradeStatisticsVariables = PublicGradeStatisticsQueryVariables;
export type PublicGradeStatisticsTenantConfiguration = (NonNullable<PublicGradeStatisticsQuery['tenantConfiguration']>);
export type PublicGradeStatisticsStatistics = (NonNullable<(NonNullable<PublicGradeStatisticsQuery['tenantConfiguration']>)['statistics']>);
export type PublicGradeStatisticsPublicGradeStatisticsMeta = NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['tenantConfiguration']>)['statistics']>)['publicGradeStatisticsMeta']>)[number]>;
export type PublicGradeStatisticsDiscoverGrade = (NonNullable<PublicGradeStatisticsQuery['discoverGrade']>);
export type PublicGradeStatisticsSeason = (NonNullable<(NonNullable<PublicGradeStatisticsQuery['discoverGrade']>)['season']>);
export type PublicGradeStatisticsCompetition = (NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['discoverGrade']>)['season']>)['competition']>);
export type PublicGradeStatisticsOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['discoverGrade']>)['season']>)['competition']>)['organisation']>);
export type PublicGradeStatisticsGradePlayerStatistics = (NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>);
export type PublicGradeStatisticsMeta = (NonNullable<(NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>)['meta']>);
export type PublicGradeStatisticsResults = NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>)['results']>)[number]>;
export type PublicGradeStatisticsProfile = (NonNullable<NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>)['results']>)[number]>['profile']>);
export type PublicGradeStatisticsTeam = (NonNullable<NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>)['results']>)[number]>['team']>);
export type PublicGradeStatistics_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>)['results']>)[number]>['statistics']>)[number]>;
export type PublicGradeStatisticsDetails = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicGradeStatisticsQuery['gradePlayerStatistics']>)['results']>)[number]>['statistics']>)[number]>['details']>);
export type SubmitIncidentClearanceVariables = SubmitIncidentClearanceMutationVariables;
export type SubmitIncidentClearanceSubmitIncidentClearance = (NonNullable<SubmitIncidentClearanceMutation['submitIncidentClearance']>);
export type RegistrationTypeVariables = RegistrationTypeQueryVariables;
export type RegistrationTypeRegistrationSettings = (NonNullable<RegistrationTypeQuery['registrationSettings']>);
export type RegistrationTypeDiscoverRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<RegistrationTypeQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>);
export type RegistrationTypeDiscoverSocialTeamRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<RegistrationTypeQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>);
export type MyTeamsEnterVotesVariables = MyTeamsEnterVotesQueryVariables;
export type MyTeamsEnterVotesGameTeamAward = (NonNullable<MyTeamsEnterVotesQuery['gameTeamAward']>);
export type MyTeamsEnterVotesAward = (NonNullable<(NonNullable<MyTeamsEnterVotesQuery['gameTeamAward']>)['award']>);
export type MyTeamsEnterVotesConfiguration = (NonNullable<(NonNullable<(NonNullable<MyTeamsEnterVotesQuery['gameTeamAward']>)['award']>)['configuration']>);
export type MyTeamsEnterVotesVoteSlips = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsEnterVotesQuery['gameTeamAward']>)['award']>)['voteSlips']>)[number]>;
export type MyTeamsEnterVotesPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsEnterVotesQuery['gameTeamAward']>)['players']>)[number]>;
export type MyTeamsEnterVotesDiscoverGame = (NonNullable<MyTeamsEnterVotesQuery['discoverGame']>);
export type MyTeamsEnterVotesHome = (NonNullable<(NonNullable<MyTeamsEnterVotesQuery['discoverGame']>)['home']>);
export type MyTeamsEnterVotesDiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<MyTeamsEnterVotesQuery['discoverGame']>)['home']>), { __typename?: 'DiscoverTeam' }>);
export type MyTeamsEnterVotesAway = (NonNullable<(NonNullable<MyTeamsEnterVotesQuery['discoverGame']>)['away']>);
export type MyTeamsEnterVotes_DiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<MyTeamsEnterVotesQuery['discoverGame']>)['away']>), { __typename?: 'DiscoverTeam' }>);
export type MyTeamsEnterVotesRound = (NonNullable<(NonNullable<MyTeamsEnterVotesQuery['discoverGame']>)['round']>);
export type MyTeamsFixtureVariables = MyTeamsFixtureQueryVariables;
export type MyTeamsFixtureDiscoverTeamFixture = NonNullable<(NonNullable<MyTeamsFixtureQuery['discoverTeamFixture']>)[number]>;
export type MyTeamsFixtureGrade = (NonNullable<NonNullable<(NonNullable<MyTeamsFixtureQuery['discoverTeamFixture']>)[number]>['grade']>);
export type MyTeamsFixtureSeason = (NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsFixtureQuery['discoverTeamFixture']>)[number]>['grade']>)['season']>);
export type MyTeamsFixtureCompetition = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsFixtureQuery['discoverTeamFixture']>)[number]>['grade']>)['season']>)['competition']>);
export type MyTeamsFixtureOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<MyTeamsFixtureQuery['discoverTeamFixture']>)[number]>['grade']>)['season']>)['competition']>)['organisation']>);
export type MyTeamsFixtureFixture = (NonNullable<NonNullable<(NonNullable<MyTeamsFixtureQuery['discoverTeamFixture']>)[number]>['fixture']>);
export type MyTeamsFixtureTenantConfiguration = (NonNullable<MyTeamsFixtureQuery['tenantConfiguration']>);
export type MyTeamsFixtureGradeTypes = NonNullable<(NonNullable<(NonNullable<MyTeamsFixtureQuery['tenantConfiguration']>)['gradeTypes']>)[number]>;
export type MyTeamsFixtureFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsFixtureQuery['tenantConfiguration']>)['gradeTypes']>)[number]>['features']>);
export type MyTeamsGameManagementAccessVariables = MyTeamsGameManagementAccessQueryVariables;
export type MyTeamsGameManagementAccessGameTeamAward = (NonNullable<MyTeamsGameManagementAccessQuery['gameTeamAward']>);
export type MyTeamsGameManagementAccessAward = (NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['gameTeamAward']>)['award']>);
export type MyTeamsGameManagementAccessConfiguration = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['gameTeamAward']>)['award']>)['configuration']>);
export type MyTeamsGameManagementAccessMyTeamsGame = (NonNullable<MyTeamsGameManagementAccessQuery['myTeamsGame']>);
export type MyTeamsGameManagementAccessDiscoverGame = (NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>);
export type MyTeamsGameManagementAccessHome = (NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['home']>);
export type MyTeamsGameManagementAccessProvisionalTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['home']>), { __typename?: 'ProvisionalTeam' }>);
export type MyTeamsGameManagementAccessDiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['home']>), { __typename?: 'DiscoverTeam' }>);
export type MyTeamsGameManagementAccessAway = (NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['away']>);
export type MyTeamsGameManagementAccess_ProvisionalTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['away']>), { __typename?: 'ProvisionalTeam' }>);
export type MyTeamsGameManagementAccess_DiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['away']>), { __typename?: 'DiscoverTeam' }>);
export type MyTeamsGameManagementAccessRound = (NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['round']>);
export type MyTeamsGameManagementAccessGrade = (NonNullable<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['round']>)['grade']>);
export type MyTeamsGameManagementAccessSeason = (NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['round']>)['grade']>)['season']>);
export type MyTeamsGameManagementAccessCompetition = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['round']>)['grade']>)['season']>)['competition']>);
export type MyTeamsGameManagementAccessOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsGameManagementAccessQuery['discoverGame']>)['round']>)['grade']>)['season']>)['competition']>)['organisation']>);
export type MyTeamsGameIncidentDetailsVariables = MyTeamsGameIncidentDetailsQueryVariables;
export type MyTeamsGameIncidentDetailsMyTeamsGame = (NonNullable<MyTeamsGameIncidentDetailsQuery['myTeamsGame']>);
export type MyTeamsGameIncidentDetailsMyTeamsTeam = (NonNullable<MyTeamsGameIncidentDetailsQuery['myTeamsTeam']>);
export type MyTeamsGameIncidentDetailsTeamPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsGameIncidentDetailsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>;
export type MyTeamsGameIncidentDetailsParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameIncidentDetailsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>);
export type MyTeamsGameIncidentDetailsProfile = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsGameIncidentDetailsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['profile']>);
export type CreateIncidentVariables = CreateIncidentMutationVariables;
export type CreateIncidentIncidentCreate = (NonNullable<CreateIncidentMutation['incidentCreate']>);
export type GetIncidentVariables = GetIncidentQueryVariables;
export type GetIncidentIncident = (NonNullable<GetIncidentQuery['incident']>);
export type GetIncidentRelatedGameVariables = GetIncidentRelatedGameQueryVariables;
export type GetIncidentRelatedGameMyTeamsGame = (NonNullable<GetIncidentRelatedGameQuery['myTeamsGame']>);
export type UpdateIncidentVariables = UpdateIncidentMutationVariables;
export type UpdateIncidentIncidentUpdate = (NonNullable<UpdateIncidentMutation['incidentUpdate']>);
export type DeleteIncidentVariables = DeleteIncidentMutationVariables;
export type DeleteIncidentIncidentDelete = (NonNullable<DeleteIncidentMutation['incidentDelete']>);
export type ConfirmIncidentClearanceVariables = ConfirmIncidentClearanceMutationVariables;
export type ConfirmIncidentClearanceConfirmIncidentClearance = (NonNullable<ConfirmIncidentClearanceMutation['confirmIncidentClearance']>);
export type IncidentGameFieldsHome = (NonNullable<IncidentGameFieldsFragment['home']>);
export type IncidentGameFieldsMyTeamsTeamInlineFragment = (DiscriminateUnion<(NonNullable<IncidentGameFieldsFragment['home']>), { __typename?: 'MyTeamsTeam' }>);
export type IncidentGameFieldsAway = (NonNullable<IncidentGameFieldsFragment['away']>);
export type IncidentGameFields_MyTeamsTeamInlineFragment = (DiscriminateUnion<(NonNullable<IncidentGameFieldsFragment['away']>), { __typename?: 'MyTeamsTeam' }>);
export type IncidentGameFieldsTeams = (NonNullable<IncidentGameFieldsFragment['teams']>);
export type IncidentGameFields_Home = (NonNullable<(NonNullable<IncidentGameFieldsFragment['teams']>)['home']>);
export type IncidentGameFields_Away = (NonNullable<(NonNullable<IncidentGameFieldsFragment['teams']>)['away']>);
export type IncidentGameTeamFieldsLineup = (NonNullable<IncidentGameTeamFieldsFragment['lineup']>);
export type IncidentGameTeamFieldsPlayers = NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>;
export type IncidentGameTeamFieldsParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>);
export type IncidentGameTeamFieldsMyTeamsParticipantInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>);
export type IncidentGameTeamFieldsProfile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipant' }>)['profile']>);
export type IncidentGameTeamFieldsMyTeamsParticipantFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>);
export type IncidentGameTeamFields_Participant = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>);
export type IncidentGameTeamFields_Profile = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsParticipantFillInPlayer' }>)['participant']>)['profile']>);
export type IncidentGameTeamFieldsMyTeamsGamePermitFillInPlayerInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>);
export type IncidentGameTeamFields__Profile = (NonNullable<(DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<(NonNullable<IncidentGameTeamFieldsFragment['lineup']>)['players']>)[number]>['participant']>), { __typename?: 'MyTeamsGamePermitFillInPlayer' }>)['profile']>);
export type IncidentFieldsParticipant = (NonNullable<IncidentFieldsFragment['participant']>);
export type IncidentFieldsProfile = (NonNullable<(NonNullable<IncidentFieldsFragment['participant']>)['profile']>);
export type IncidentFields_Profile = (NonNullable<IncidentFieldsFragment['profile']>);
export type IncidentFieldsOutcome = (NonNullable<IncidentFieldsFragment['outcome']>);
export type IncidentFieldsConcussionOutcomeInlineFragment = (DiscriminateUnion<(NonNullable<IncidentFieldsFragment['outcome']>), { __typename?: 'ConcussionOutcome' }>);
export type IncidentFieldsClearance = (NonNullable<(DiscriminateUnion<(NonNullable<IncidentFieldsFragment['outcome']>), { __typename?: 'ConcussionOutcome' }>)['clearance']>);
export type IncidentFieldsOwningOrganisation = (NonNullable<IncidentFieldsFragment['owningOrganisation']>);
export type IncidentFieldsGame = (NonNullable<IncidentFieldsFragment['game']>);
export type IncidentFieldsTeam = (NonNullable<IncidentFieldsFragment['team']>);
export type IncidentFieldsMyTeamsTeamInlineFragment = (DiscriminateUnion<(NonNullable<IncidentFieldsFragment['team']>), { __typename?: 'MyTeamsTeam' }>);
export type IncidentFieldsOrganisation = (NonNullable<(DiscriminateUnion<(NonNullable<IncidentFieldsFragment['team']>), { __typename?: 'MyTeamsTeam' }>)['organisation']>);
export type GetTeamIncidentsVariables = GetTeamIncidentsQueryVariables;
export type GetTeamIncidentsMyTeamsTeam = (NonNullable<GetTeamIncidentsQuery['myTeamsTeam']>);
export type GetTeamIncidentsTeamPlayers = NonNullable<(NonNullable<(NonNullable<GetTeamIncidentsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>;
export type GetTeamIncidentsParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetTeamIncidentsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>);
export type GetTeamIncidentsProfile = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetTeamIncidentsQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['profile']>);
export type GetTeamIncidentsConcussionIncidents = NonNullable<(NonNullable<(NonNullable<GetTeamIncidentsQuery['myTeamsTeam']>)['concussionIncidents']>)[number]>;
export type MyTeamsLadderVariables = MyTeamsLadderQueryVariables;
export type MyTeamsLadderDiscoverTeam = (NonNullable<MyTeamsLadderQuery['discoverTeam']>);
export type MyTeamsLadderSeason = (NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['season']>);
export type MyTeamsLadderCompetition = (NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['season']>)['competition']>);
export type MyTeamsLadderGrade = (NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>);
export type MyTeamsLadderLadder = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>;
export type MyTeamsLadderPool = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['pool']>);
export type MyTeamsLadderGeneratedFrom = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['generatedFrom']>);
export type MyTeamsLadderStandings = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>;
export type MyTeamsLadderTeam = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>);
export type MyTeamsLadder_Season = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['season']>);
export type MyTeamsLadder_Competition = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['season']>)['competition']>);
export type MyTeamsLadderOrganisation = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['organisation']>);
export type MyTeamsLadderGameTypes = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['gameTypes']>)[number]>;
export type MyTeamsLadderLadderFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['gameTypes']>)[number]>['ladderFields']>)[number]>;
export type MyTeamsLadderLadderRankingFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['gameTypes']>)[number]>['ladderRankingFields']>)[number]>;
export type MyTeamsLadderOverallLadder = (NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['overallLadder']>);
export type MyTeamsLadderOverallLadderFields = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['overallLadderFields']>)[number]>;
export type MyTeamsLadderOverallLadderRankingFields = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['grade']>)['overallLadderRankingFields']>)[number]>;
export type MyTeamsLadder_Organisation = (NonNullable<(NonNullable<MyTeamsLadderQuery['discoverTeam']>)['organisation']>);
export type MyTeamsSquadVariables = MyTeamsSquadQueryVariables;
export type MyTeamsSquadDiscoverTeam = (NonNullable<MyTeamsSquadQuery['discoverTeam']>);
export type MyTeamsSquadSeason = (NonNullable<(NonNullable<MyTeamsSquadQuery['discoverTeam']>)['season']>);
export type MyTeamsSquadStatus = (NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['discoverTeam']>)['season']>)['status']>);
export type MyTeamsSquadMyTeamsTeam = (NonNullable<MyTeamsSquadQuery['myTeamsTeam']>);
export type MyTeamsSquadTeamPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamPlayers']>)[number]>;
export type MyTeamsSquadParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>);
export type MyTeamsSquadProfile = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['profile']>);
export type MyTeamsSquadTotalStatistics = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['totalStatistics']>)[number]>;
export type MyTeamsSquadType = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['totalStatistics']>)[number]>['type']>);
export type MyTeamsSquadCaptain = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['captain']>);
export type MyTeamsSquadCoach = (NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['coach']>);
export type MyTeamsSquad_Profile = (NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['coach']>)['profile']>);
export type MyTeamsSquadAssistantCoaches = NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['assistantCoaches']>)[number]>;
export type MyTeamsSquad__Profile = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['assistantCoaches']>)[number]>['profile']>);
export type MyTeamsSquadTeamManagers = NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamManagers']>)[number]>;
export type MyTeamsSquad___Profile = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['teamManagers']>)[number]>['profile']>);
export type MyTeamsSquadOrganiser = (NonNullable<(NonNullable<MyTeamsSquadQuery['myTeamsTeam']>)['organiser']>);
export type MyTeamsSquadTenantConfiguration = (NonNullable<MyTeamsSquadQuery['tenantConfiguration']>);
export type MyTeamsSquadStatistics = (NonNullable<(NonNullable<MyTeamsSquadQuery['tenantConfiguration']>)['statistics']>);
export type MyTeamsSquadSeasonStatisticsMeta = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsSquadQuery['tenantConfiguration']>)['statistics']>)['seasonStatisticsMeta']>)[number]>;
export type MyTeamsSquadProfileFragmentMobileNumber = (NonNullable<MyTeamsSquadProfileFragmentFragment['mobileNumber']>);
export type MyTeamsSquadProfileFragmentAccountManagedBy = (NonNullable<MyTeamsSquadProfileFragmentFragment['accountManagedBy']>);
export type MyTeamsSquadProfileFragment_MobileNumber = (NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['accountManagedBy']>)['mobileNumber']>);
export type MyTeamsSquadProfileFragmentEmergencyContact = (NonNullable<MyTeamsSquadProfileFragmentFragment['emergencyContact']>);
export type MyTeamsSquadProfileFragment__MobileNumber = (NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['emergencyContact']>)['mobileNumber']>);
export type MyTeamsSquadProfileFragmentGuardians = NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['guardians']>)[number]>;
export type MyTeamsSquadProfileFragmentMyTeamsGuardianInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['guardians']>)[number]>, { __typename?: 'MyTeamsGuardian' }>);
export type MyTeamsSquadProfileFragment___MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['guardians']>)[number]>, { __typename?: 'MyTeamsGuardian' }>)['mobileNumber']>);
export type MyTeamsSquadProfileFragmentMyTeamsProfileInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['guardians']>)[number]>, { __typename?: 'MyTeamsProfile' }>);
export type MyTeamsSquadProfileFragment____MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<MyTeamsSquadProfileFragmentFragment['guardians']>)[number]>, { __typename?: 'MyTeamsProfile' }>)['mobileNumber']>);
export type MyTeamsTeamVariables = MyTeamsTeamQueryVariables;
export type MyTeamsTeamDiscoverTeam = (NonNullable<MyTeamsTeamQuery['discoverTeam']>);
export type MyTeamsTeamLogo = (NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['logo']>);
export type MyTeamsTeamSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['logo']>)['sizes']>)[number]>;
export type MyTeamsTeamDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type MyTeamsTeamGrade = (NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['grade']>);
export type MyTeamsTeamSeason = (NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['season']>);
export type MyTeamsTeamCompetition = (NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['season']>)['competition']>);
export type MyTeamsTeamStatus = (NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['season']>)['status']>);
export type MyTeamsTeamOrganisation = (NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['organisation']>);
export type MyTeamsTeamTenant = (NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['discoverTeam']>)['organisation']>)['tenant']>);
export type MyTeamsTeamMyTeamsTeam = (NonNullable<MyTeamsTeamQuery['myTeamsTeam']>);
export type MyTeamsTeamTeamPlayers = NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['myTeamsTeam']>)['teamPlayers']>)[number]>;
export type MyTeamsTeamParticipant = (NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>);
export type MyTeamsTeamProfile = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<MyTeamsTeamQuery['myTeamsTeam']>)['teamPlayers']>)[number]>['participant']>)['profile']>);
export type GetOrganisationNewsVariables = GetOrganisationNewsQueryVariables;
export type GetOrganisationNewsDiscoverOrganisation = (NonNullable<GetOrganisationNewsQuery['discoverOrganisation']>);
export type GetOrganisationNewsResultsVariables = GetOrganisationNewsResultsQueryVariables;
export type GetOrganisationNewsResultsDiscoverOrganisationPosts = (NonNullable<GetOrganisationNewsResultsQuery['discoverOrganisationPosts']>);
export type GetOrganisationNewsResultsResults = NonNullable<(NonNullable<(NonNullable<GetOrganisationNewsResultsQuery['discoverOrganisationPosts']>)['results']>)[number]>;
export type GetOrganisationNewsResultsImage = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetOrganisationNewsResultsQuery['discoverOrganisationPosts']>)['results']>)[number]>['image']>);
export type GetOrganisationNewsResultsMeta = (NonNullable<(NonNullable<GetOrganisationNewsResultsQuery['discoverOrganisationPosts']>)['meta']>);
export type GetNewsItemVariables = GetNewsItemQueryVariables;
export type GetNewsItemDiscoverPost = (NonNullable<GetNewsItemQuery['discoverPost']>);
export type GetNewsItemOrganisation = (NonNullable<(NonNullable<GetNewsItemQuery['discoverPost']>)['organisation']>);
export type GetNewsItemLogo = (NonNullable<(NonNullable<(NonNullable<GetNewsItemQuery['discoverPost']>)['organisation']>)['logo']>);
export type GetNewsItemSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GetNewsItemQuery['discoverPost']>)['organisation']>)['logo']>)['sizes']>)[number]>;
export type GetNewsItemDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GetNewsItemQuery['discoverPost']>)['organisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type GetNewsItemImage = (NonNullable<(NonNullable<GetNewsItemQuery['discoverPost']>)['image']>);
export type GetNewsItemProducts = NonNullable<(NonNullable<(NonNullable<GetNewsItemQuery['discoverPost']>)['products']>)[number]>;
export type PostProductVariants = NonNullable<(NonNullable<PostProductFragment['variants']>)[number]>;
export type PostProductAmount = (NonNullable<NonNullable<(NonNullable<PostProductFragment['variants']>)[number]>['amount']>);
export type PostProductImages = NonNullable<(NonNullable<PostProductFragment['images']>)[number]>;
export type PostProductSizes = NonNullable<(NonNullable<NonNullable<(NonNullable<PostProductFragment['images']>)[number]>['sizes']>)[number]>;
export type EmailNotificationUnsubscribeVariables = EmailNotificationUnsubscribeMutationVariables;
export type EmailNotificationUnsubscribeEmailNotificationUnsubscribe = (NonNullable<EmailNotificationUnsubscribeMutation['emailNotificationUnsubscribe']>);
export type GetPaymentRequestProductVariables = GetPaymentRequestProductQueryVariables;
export type GetPaymentRequestProductPaymentRequestProduct = (NonNullable<GetPaymentRequestProductQuery['paymentRequestProduct']>);
export type GetPaymentRequestProductSettings = (NonNullable<(NonNullable<GetPaymentRequestProductQuery['paymentRequestProduct']>)['settings']>);
export type GetPaymentRequestProductValidFrom = (NonNullable<(NonNullable<(NonNullable<GetPaymentRequestProductQuery['paymentRequestProduct']>)['settings']>)['validFrom']>);
export type GetPaymentRequestProductValidTo = (NonNullable<(NonNullable<(NonNullable<GetPaymentRequestProductQuery['paymentRequestProduct']>)['settings']>)['validTo']>);
export type GetPaymentRequestProductVariants = NonNullable<(NonNullable<(NonNullable<GetPaymentRequestProductQuery['paymentRequestProduct']>)['variants']>)[number]>;
export type GetPaymentRequestProductAmount = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetPaymentRequestProductQuery['paymentRequestProduct']>)['variants']>)[number]>['amount']>);
export type GetPostEmailUnsubscribeVariables = GetPostEmailUnsubscribeQueryVariables;
export type GetPostEmailUnsubscribeDiscoverOrganisation = (NonNullable<GetPostEmailUnsubscribeQuery['discoverOrganisation']>);
export type PostEmailUnsubscribeVariables = PostEmailUnsubscribeMutationVariables;
export type PostEmailUnsubscribePostEmailUnsubscribe = (NonNullable<PostEmailUnsubscribeMutation['postEmailUnsubscribe']>);
export type ProfileHistoryVariables = ProfileHistoryQueryVariables;
export type ProfileHistoryAccount = (NonNullable<ProfileHistoryQuery['account']>);
export type ProfileHistoryProfile = (NonNullable<(NonNullable<ProfileHistoryQuery['account']>)['profile']>);
export type ProfileHistoryDependants = NonNullable<(NonNullable<(NonNullable<(NonNullable<ProfileHistoryQuery['account']>)['profile']>)['dependants']>)[number]>;
export type HistoryFragmentRegistrationHistory = NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>;
export type HistoryFragmentDiscoverTeamInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'DiscoverTeam' }>);
export type HistoryFragmentSeason = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'DiscoverTeam' }>)['season']>);
export type HistoryFragmentDiscoverSeasonInlineFragment = ({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'DiscoverTeam' }>)['season']>), 'id' | 'name' | 'competition' | 'availableRegistrations'>);
export type HistoryFragmentCompetition = (NonNullable<({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'DiscoverTeam' }>)['season']>), 'id' | 'name' | 'competition' | 'availableRegistrations'>)['competition']>);
export type HistoryFragmentOrganisation = (NonNullable<(NonNullable<({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'DiscoverTeam' }>)['season']>), 'id' | 'name' | 'competition' | 'availableRegistrations'>)['competition']>)['organisation']>);
export type HistoryFragmentAvailableRegistrations = NonNullable<(NonNullable<({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'DiscoverTeam' }>)['season']>), 'id' | 'name' | 'competition' | 'availableRegistrations'>)['availableRegistrations']>)[number]>;
export type HistoryFragmentParticipantInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>);
export type HistoryFragmentSeasonRegistration = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>);
export type HistoryFragment_Season = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>);
export type HistoryFragmentProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'ProgramSeason' }>);
export type HistoryFragmentProgram = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type HistoryFragment_DiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type HistoryFragment_Competition = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type HistoryFragment_Organisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type HistoryFragment__Organisation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['organisation']>);
export type HistoryFragmentPreferredGroup = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['preferredGroup']>);
export type HistoryFragmentPermit = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<HistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['permit']>);
export type GetProfileIncidentsVariables = GetProfileIncidentsQueryVariables;
export type GetProfileIncidentsAccount = (NonNullable<GetProfileIncidentsQuery['account']>);
export type GetProfileIncidentsProfile = (NonNullable<(NonNullable<GetProfileIncidentsQuery['account']>)['profile']>);
export type GetProfileIncidentsConcussionIncidents = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileIncidentsQuery['account']>)['profile']>)['concussionIncidents']>)[number]>;
export type GetProfileIncidentsDependantProfile = (NonNullable<GetProfileIncidentsQuery['dependantProfile']>);
export type GetProfileIncidents_ConcussionIncidents = NonNullable<(NonNullable<(NonNullable<GetProfileIncidentsQuery['dependantProfile']>)['concussionIncidents']>)[number]>;
export type InvoiceListVariables = InvoiceListQueryVariables;
export type InvoiceListInvoiceList = (NonNullable<InvoiceListQuery['invoiceList']>);
export type InvoiceListMeta = (NonNullable<(NonNullable<InvoiceListQuery['invoiceList']>)['meta']>);
export type InvoiceListResults = NonNullable<(NonNullable<(NonNullable<InvoiceListQuery['invoiceList']>)['results']>)[number]>;
export type InvoiceListTotal = (NonNullable<NonNullable<(NonNullable<(NonNullable<InvoiceListQuery['invoiceList']>)['results']>)[number]>['total']>);
export type InvoiceListCurrency = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<InvoiceListQuery['invoiceList']>)['results']>)[number]>['total']>)['currency']>);
export type InvoiceDownloadVariables = InvoiceDownloadMutationVariables;
export type InvoiceDownloadInvoiceDownload = (NonNullable<InvoiceDownloadMutation['invoiceDownload']>);
export type ProfileMembershipsVariables = ProfileMembershipsQueryVariables;
export type ProfileMembershipsAccount = (NonNullable<ProfileMembershipsQuery['account']>);
export type ProfileMembershipsProfile = (NonNullable<(NonNullable<ProfileMembershipsQuery['account']>)['profile']>);
export type ProfileMembershipsDependants = NonNullable<(NonNullable<(NonNullable<(NonNullable<ProfileMembershipsQuery['account']>)['profile']>)['dependants']>)[number]>;
export type ProfileMembershipsWithOrgFragmentMemberships = NonNullable<(NonNullable<ProfileMembershipsWithOrgFragmentFragment['memberships']>)[number]>;
export type ProfileMembershipsWithOrgFragmentApplication = (NonNullable<NonNullable<(NonNullable<ProfileMembershipsWithOrgFragmentFragment['memberships']>)[number]>['application']>);
export type ProfileMembershipsWithOrgFragmentRole = (NonNullable<(NonNullable<NonNullable<(NonNullable<ProfileMembershipsWithOrgFragmentFragment['memberships']>)[number]>['application']>)['role']>);
export type ProfileMembershipsWithOrgFragmentHistory = NonNullable<(NonNullable<NonNullable<(NonNullable<ProfileMembershipsWithOrgFragmentFragment['memberships']>)[number]>['history']>)[number]>;
export type ProfileMembershipsWithOrgFragmentOrganisation = (NonNullable<NonNullable<(NonNullable<ProfileMembershipsWithOrgFragmentFragment['memberships']>)[number]>['organisation']>);
export type AccountMyTeamsListVariables = AccountMyTeamsListQueryVariables;
export type AccountMyTeamsListAccount = (NonNullable<AccountMyTeamsListQuery['account']>);
export type AccountMyTeamsListProfile = (NonNullable<(NonNullable<AccountMyTeamsListQuery['account']>)['profile']>);
export type AccountMyTeamsListDependants = NonNullable<(NonNullable<(NonNullable<(NonNullable<AccountMyTeamsListQuery['account']>)['profile']>)['dependants']>)[number]>;
export type ProfileTeamsMyTeamsList = (NonNullable<ProfileTeamsFragment['myTeamsList']>);
export type ProfileTeamsResults = NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>;
export type ProfileTeamsGrade = (NonNullable<NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>['grade']>);
export type ProfileTeamsSeason = (NonNullable<NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>['season']>);
export type ProfileTeamsStatus = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>['season']>)['status']>);
export type ProfileTeamsLogo = (NonNullable<NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>['logo']>);
export type ProfileTeamsSizes = NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>['logo']>)['sizes']>)[number]>;
export type ProfileTeamsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<ProfileTeamsFragment['myTeamsList']>)['results']>)[number]>['logo']>)['sizes']>)[number]>['dimensions']>);
export type PublicProfileVariables = PublicProfileQueryVariables;
export type PublicProfilePublicProfile = (NonNullable<PublicProfileQuery['publicProfile']>);
export type PublicProfileTenantHistoryVariables = PublicProfileTenantHistoryQueryVariables;
export type PublicProfileTenantHistoryProfileTenantHistory = (NonNullable<PublicProfileTenantHistoryQuery['profileTenantHistory']>);
export type PublicProfileTenantHistoryRegistrationHistory = NonNullable<(NonNullable<(NonNullable<PublicProfileTenantHistoryQuery['profileTenantHistory']>)['registrationHistory']>)[number]>;
export type ExternalStatisticsUrlVariables = ExternalStatisticsUrlQueryVariables;
export type ExternalStatisticsUrlTenantConfiguration = (NonNullable<ExternalStatisticsUrlQuery['tenantConfiguration']>);
export type ExternalStatisticsUrlExternalStatisticsUrls = NonNullable<(NonNullable<(NonNullable<ExternalStatisticsUrlQuery['tenantConfiguration']>)['externalStatisticsUrls']>)[number]>;
export type PublicProfileStatisticsVariables = PublicProfileStatisticsQueryVariables;
export type PublicProfileStatisticsTenantConfiguration = (NonNullable<PublicProfileStatisticsQuery['tenantConfiguration']>);
export type PublicProfileStatisticsStatistics = (NonNullable<(NonNullable<PublicProfileStatisticsQuery['tenantConfiguration']>)['statistics']>);
export type PublicProfileStatisticsCareerStatisticsMeta = NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['tenantConfiguration']>)['statistics']>)['careerStatisticsMeta']>)[number]>;
export type PublicProfileStatisticsSeasonStatisticsMeta = NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['tenantConfiguration']>)['statistics']>)['seasonStatisticsMeta']>)[number]>;
export type PublicProfileStatisticsPublicProfileStatistics = (NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>);
export type PublicProfileStatisticsCareerStatistics = (NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>);
export type PublicProfileStatisticsTotalStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>)['totalStatistics']>)[number]>;
export type PublicProfileStatisticsDetails = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>)['totalStatistics']>)[number]>['details']>);
export type PublicProfileStatisticsClubStatistics = NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>)['clubStatistics']>)[number]>;
export type PublicProfileStatisticsClub = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>)['clubStatistics']>)[number]>['club']>);
export type PublicProfileStatistics_Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>)['clubStatistics']>)[number]>['statistics']>)[number]>;
export type PublicProfileStatistics_Details = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['careerStatistics']>)['clubStatistics']>)[number]>['statistics']>)[number]>['details']>);
export type PublicProfileStatisticsSeasonStatistics = NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>;
export type PublicProfileStatisticsPlayer = (NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['player']>);
export type PublicProfileStatistics__Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>;
export type PublicProfileStatisticsSeason = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['season']>);
export type PublicProfileStatisticsCompetition = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['season']>)['competition']>);
export type PublicProfileStatisticsOrganisation = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['season']>)['competition']>)['organisation']>);
export type PublicProfileStatistics_Club = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['club']>);
export type PublicProfileStatistics_TotalStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['totalStatistics']>)[number]>;
export type PublicProfileStatistics__Details = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['totalStatistics']>)[number]>['details']>);
export type PublicProfileStatisticsTeamStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>;
export type PublicProfileStatisticsTeam = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['team']>);
export type PublicProfileStatisticsDiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['team']>), { __typename?: 'DiscoverTeam' }>);
export type PublicProfileStatistics__TotalStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['totalStatistics']>)[number]>;
export type PublicProfileStatistics___Details = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['totalStatistics']>)[number]>['details']>);
export type PublicProfileStatisticsGradeStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>;
export type PublicProfileStatisticsGrade = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['grade']>);
export type PublicProfileStatistics___TotalStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['totalStatistics']>)[number]>;
export type PublicProfileStatistics____Details = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['totalStatistics']>)[number]>['details']>);
export type PublicProfileStatisticsGameStatistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>;
export type PublicProfileStatisticsGame = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>);
export type PublicProfileStatisticsRound = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['round']>);
export type PublicProfileStatisticsHome = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['home']>);
export type PublicProfileStatistics_DiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['home']>), { __typename?: 'DiscoverTeam' }>);
export type PublicProfileStatisticsAway = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['away']>);
export type PublicProfileStatistics__DiscoverTeamInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['away']>), { __typename?: 'DiscoverTeam' }>);
export type PublicProfileStatisticsAllocation = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['allocation']>);
export type PublicProfileStatisticsCourt = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['allocation']>)['court']>);
export type PublicProfileStatisticsVenue = (NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['game']>)['allocation']>)['court']>)['venue']>);
export type PublicProfileStatistics___Statistics = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['statistics']>)[number]>;
export type PublicProfileStatistics_____Details = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<PublicProfileStatisticsQuery['publicProfileStatistics']>)['seasonStatistics']>)[number]>['statistics']>)[number]>['teamStatistics']>)[number]>['gradeStatistics']>)[number]>['gameStatistics']>)[number]>['statistics']>)[number]>['details']>);
export type PublicProfileStatisticsPublicProfile = (NonNullable<PublicProfileStatisticsQuery['publicProfile']>);
export type ProfilesToRegisterVariables = ProfilesToRegisterQueryVariables;
export type ProfilesToRegisterAccount = (NonNullable<ProfilesToRegisterQuery['account']>);
export type ProfilesToRegisterProfile = (NonNullable<(NonNullable<ProfilesToRegisterQuery['account']>)['profile']>);
export type ProfilesToRegisterDependants = NonNullable<(NonNullable<(NonNullable<(NonNullable<ProfilesToRegisterQuery['account']>)['profile']>)['dependants']>)[number]>;
export type GetDuplicateProfilesVariables = GetDuplicateProfilesQueryVariables;
export type GetDuplicateProfilesTenantConfiguration = (NonNullable<GetDuplicateProfilesQuery['tenantConfiguration']>);
export type GetDuplicateProfilesParticipant = (NonNullable<GetDuplicateProfilesQuery['participant']>);
export type GetDuplicateProfilesProfile = (NonNullable<(NonNullable<GetDuplicateProfilesQuery['participant']>)['profile']>);
export type GetDuplicateProfilesDuplicateProfiles = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetDuplicateProfilesQuery['participant']>)['profile']>)['duplicateProfiles']>)[number]>;
export type GetDuplicateProfilesLastRegisteredSeason = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetDuplicateProfilesQuery['participant']>)['profile']>)['duplicateProfiles']>)[number]>['lastRegisteredSeason']>);
export type GetDuplicateProfilesLastRegisteredOrganisation = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetDuplicateProfilesQuery['participant']>)['profile']>)['duplicateProfiles']>)[number]>['lastRegisteredOrganisation']>);
export type GetParticipantTransferRequestsVariables = GetParticipantTransferRequestsQueryVariables;
export type GetParticipantTransferRequestsParticipant = (NonNullable<GetParticipantTransferRequestsQuery['participant']>);
export type GetParticipantTransferRequestsTransferRequired = (NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['transferRequired']>);
export type GetParticipantTransferRequestsPendingTransferRequest = (NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['transferRequired']>)['pendingTransferRequest']>);
export type GetParticipantTransferRequestsDestinationClub = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['transferRequired']>)['pendingTransferRequest']>)['destinationClub']>);
export type GetParticipantTransferRequestsExceptionPeriod = (NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['transferRequired']>)['exceptionPeriod']>);
export type GetParticipantTransferRequestsProfile = (NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['profile']>);
export type GetParticipantTransferRequestsSeasonRegistration = (NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['seasonRegistration']>);
export type GetParticipantTransferRequestsSeason = (NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['seasonRegistration']>)['season']>);
export type GetParticipantTransferRequestsDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type GetParticipantTransferRequestsCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type GetParticipantTransferRequestsOrganisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['participant']>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type GetParticipantTransferRequestsTenantConfiguration = (NonNullable<GetParticipantTransferRequestsQuery['tenantConfiguration']>);
export type GetParticipantTransferRequestsTransfers = (NonNullable<(NonNullable<GetParticipantTransferRequestsQuery['tenantConfiguration']>)['transfers']>);
export type LinkExternalAccountVariables = LinkExternalAccountMutationVariables;
export type LinkExternalAccountLinkExternalAccount = (NonNullable<LinkExternalAccountMutation['linkExternalAccount']>);
export type AccountLinkingConfigurationVariables = AccountLinkingConfigurationQueryVariables;
export type AccountLinkingConfigurationTenantConfiguration = (NonNullable<AccountLinkingConfigurationQuery['tenantConfiguration']>);
export type GetSportNameVariables = GetSportNameQueryVariables;
export type GetSportNameTenantConfiguration = (NonNullable<GetSportNameQuery['tenantConfiguration']>);
export type GetSportNameSport = (NonNullable<(NonNullable<GetSportNameQuery['tenantConfiguration']>)['sport']>);
export type UpdatePendingParticipantVariables = UpdatePendingParticipantMutationVariables;
export type RegistrationOverviewVariables = RegistrationOverviewQueryVariables;
export type RegistrationOverviewRegistrationSettings = (NonNullable<RegistrationOverviewQuery['registrationSettings']>);
export type RegistrationOverviewDiscoverRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>);
export type RegistrationOverviewSeason = (NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>);
export type RegistrationOverviewDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type RegistrationOverviewCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type RegistrationOverviewOrganisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type RegistrationOverviewAgeRestrictionRange = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['ageRestrictionRange']>);
export type RegistrationOverviewAgeGroups = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['ageGroups']>)[number]>;
export type RegistrationOverviewAgeGroup = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['ageGroups']>)[number]>['ageGroup']>);
export type RegistrationOverviewEqualToOrOlderThan = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['ageGroups']>)[number]>['equalToOrOlderThan']>);
export type RegistrationOverviewYoungerThan = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['ageGroups']>)[number]>['youngerThan']>);
export type RegistrationOverviewProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>);
export type RegistrationOverviewProgram = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type RegistrationOverviewRegistrationUserTypes = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['registrationUserTypes']>)[number]>;
export type RegistrationOverview_Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>);
export type RegistrationOverviewRegistrationAgeRestriction = (NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['registrationAgeRestriction']>);
export type RegistrationOverviewRange = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['registrationAgeRestriction']>)['range']>);
export type RegistrationOverviewGroups = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['groups']>)[number]>;
export type RegistrationOverviewAgeGroupRestrictions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['ageGroupRestrictions']>)[number]>;
export type RegistrationOverview_AgeGroup = (NonNullable<NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['ageGroupRestrictions']>)[number]>['ageGroup']>);
export type RegistrationOverviewDaySessions = NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['daySessions']>)[number]>;
export type RegistrationOverviewPlayingSurface = (NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['playingSurface']>);
export type RegistrationOverviewVenue = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['playingSurface']>)['venue']>);
export type RegistrationOverviewDiscoverSocialTeamRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>);
export type RegistrationOverview_Season = (NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>);
export type RegistrationOverview_DiscoverSeasonInlineFragment = ({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>), 'id' | 'name' | 'startDate' | 'endDate' | 'competition'>);
export type RegistrationOverview_Competition = (NonNullable<({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>), 'id' | 'name' | 'startDate' | 'endDate' | 'competition'>)['competition']>);
export type RegistrationOverview__Organisation = (NonNullable<(NonNullable<({ __typename: 'DiscoverSeason' } & Pick<(NonNullable<(DiscriminateUnion<(NonNullable<RegistrationOverviewQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>), 'id' | 'name' | 'startDate' | 'endDate' | 'competition'>)['competition']>)['organisation']>);
export type ParticipantRegisterVariables = ParticipantRegisterMutationVariables;
export type ParticipantRegisterParticipantRegister = (NonNullable<ParticipantRegisterMutation['participantRegister']>);
export type ParticipantRegisterProfile = (NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['profile']>);
export type ParticipantRegisterDuplicateProfiles = NonNullable<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['profile']>)['duplicateProfiles']>)[number]>;
export type ParticipantRegisterTransferRequired = (NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>);
export type ParticipantRegisterPendingTransferRequest = (NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>)['pendingTransferRequest']>);
export type ParticipantRegisterDestinationClub = (NonNullable<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>)['pendingTransferRequest']>)['destinationClub']>);
export type ParticipantRegisterSourceAffiliation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>)['pendingTransferRequest']>)['sourceAffiliation']>);
export type ParticipantRegisterClub = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>)['pendingTransferRequest']>)['sourceAffiliation']>)['club']>);
export type ParticipantRegisterSeason = (NonNullable<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>)['pendingTransferRequest']>)['season']>);
export type ParticipantRegisterExceptionPeriod = (NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['transferRequired']>)['exceptionPeriod']>);
export type ParticipantRegisterSeasonRegistration = (NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['seasonRegistration']>);
export type ParticipantRegister_Season = (NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['seasonRegistration']>)['season']>);
export type ParticipantRegisterDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type ParticipantRegisterCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type ParticipantRegisterOrganisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(NonNullable<ParticipantRegisterMutation['participantRegister']>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type FieldSetFragmentFields = NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>;
export type FieldSetFragmentFieldInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldInput' }>);
export type FieldSetFragmentFieldSelectInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>);
export type FieldSetFragmentOptions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['options']>)[number]>;
export type FieldSetFragmentConditionalFields = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['conditionalFields']>);
export type FieldSetFragment_Fields = NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['conditionalFields']>)['fields']>)[number]>;
export type FieldSetFragment_FieldInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['conditionalFields']>)['fields']>)[number]>, { __typename?: 'FieldInput' }>);
export type FieldSetFragment_FieldSelectInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['conditionalFields']>)['fields']>)[number]>, { __typename?: 'FieldSelect' }>);
export type FieldSetFragment_Options = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<FieldSetFragmentFragment['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['conditionalFields']>)['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['options']>)[number]>;
export type GetRegistrationTenantConfigurationVariables = GetRegistrationTenantConfigurationQueryVariables;
export type GetRegistrationTenantConfigurationTenantConfiguration = (NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>);
export type GetRegistrationTenantConfigurationSeasonRegistration = (NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>)['seasonRegistration']>);
export type GetRegistrationTenantConfigurationCoachingAccreditationConfig = (NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>)['seasonRegistration']>)['coachingAccreditationConfig']>);
export type GetRegistrationTenantConfigurationAccreditations = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>)['seasonRegistration']>)['coachingAccreditationConfig']>)['accreditations']>)[number]>;
export type GetRegistrationTenantConfigurationDisabilities = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>)['seasonRegistration']>)['disabilities']>)[number]>;
export type GetRegistrationTenantConfigurationDiscloseOptions = NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>)['discloseOptions']>)[number]>;
export type GetRegistrationTenantConfigurationSport = (NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['tenantConfiguration']>)['sport']>);
export type GetRegistrationTenantConfigurationConfiguration = (NonNullable<GetRegistrationTenantConfigurationQuery['configuration']>);
export type GetRegistrationTenantConfigurationSupportedCountries = NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['configuration']>)['supportedCountries']>)[number]>;
export type GetRegistrationTenantConfigurationDiscoverSeasonRegistration = (NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>);
export type GetRegistrationTenantConfigurationQuestions = NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['questions']>)[number]>;
export type GetRegistrationTenantConfigurationCustomFields = NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['customFields']>)[number]>;
export type GetRegistrationTenantConfigurationGroups = NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['groups']>)[number]>;
export type GetRegistrationTenantConfigurationUserTypesMeta = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['groups']>)[number]>['userTypesMeta']>)[number]>;
export type GetRegistrationTenantConfigurationRegistrationLimit = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['groups']>)[number]>['userTypesMeta']>)[number]>['registrationLimit']>);
export type GetRegistrationTenantConfigurationFee = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['groups']>)[number]>['userTypesMeta']>)[number]>['fee']>);
export type GetRegistrationTenantConfigurationFieldEntries = (NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['fieldEntries']>);
export type GetRegistrationTenantConfigurationChildSafety = (NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['fieldEntries']>)['childSafety']>);
export type GetRegistrationTenantConfigurationProfileQuestions = (NonNullable<(NonNullable<(NonNullable<GetRegistrationTenantConfigurationQuery['discoverSeasonRegistration']>)['fieldEntries']>)['profileQuestions']>);
export type GetParticipantDetailsVariables = GetParticipantDetailsQueryVariables;
export type GetParticipantDetailsParticipant = (NonNullable<GetParticipantDetailsQuery['participant']>);
export type GetParticipantDetailsProfile = (NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['profile']>);
export type GetParticipantDetailsSchoolData = (NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['schoolData']>);
export type GetParticipantDetailsCustomFieldAnswers = NonNullable<(NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['customFieldAnswers']>)[number]>;
export type GetParticipantDetailsTextCustomFieldAnswerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['customFieldAnswers']>)[number]>, { __typename?: 'TextCustomFieldAnswer' }>);
export type GetParticipantDetailsQuestion = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['customFieldAnswers']>)[number]>, { __typename?: 'TextCustomFieldAnswer' }>)['question']>);
export type GetParticipantDetailsDropdownCustomFieldAnswerInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['customFieldAnswers']>)[number]>, { __typename?: 'DropdownCustomFieldAnswer' }>);
export type GetParticipantDetails_Question = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['customFieldAnswers']>)[number]>, { __typename?: 'DropdownCustomFieldAnswer' }>)['question']>);
export type GetParticipantDetailsDropdownAnswer = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['customFieldAnswers']>)[number]>, { __typename?: 'DropdownCustomFieldAnswer' }>)['dropdownAnswer']>);
export type GetParticipantDetailsPreferredGroup = (NonNullable<(NonNullable<GetParticipantDetailsQuery['participant']>)['preferredGroup']>);
export type GetProfileVariables = GetProfileQueryVariables;
export type GetProfileAccount = (NonNullable<GetProfileQuery['account']>);
export type GetProfileProfile = (NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>);
export type GetProfileGender = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['gender']>);
export type GetProfileMobileNumber = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['mobileNumber']>);
export type GetProfileCountryCode = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['mobileNumber']>)['countryCode']>);
export type GetProfileIndigenousDescent = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['indigenousDescent']>);
export type GetProfileAddress = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['address']>);
export type GetProfileEmergencyContact = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['emergencyContact']>);
export type GetProfile_MobileNumber = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['emergencyContact']>)['mobileNumber']>);
export type GetProfile_CountryCode = (NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['emergencyContact']>)['mobileNumber']>)['countryCode']>);
export type GetProfileGuardians = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>;
export type GetProfileProfileInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>);
export type GetProfile__MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>)['mobileNumber']>);
export type GetProfile__CountryCode = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>)['mobileNumber']>)['countryCode']>);
export type GetProfile_Address = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>)['address']>);
export type GetProfileGuardianInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>);
export type GetProfile___MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>)['mobileNumber']>);
export type GetProfile___CountryCode = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>)['mobileNumber']>)['countryCode']>);
export type GetProfile__Address = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>)['address']>);
export type GetProfileCoachingAccreditation = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['coachingAccreditation']>);
export type GetProfileLevel = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['coachingAccreditation']>)['level']>);
export type GetProfileChildSafety = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['childSafety']>)[number]>;
export type GetProfileFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['childSafety']>)[number]>['fields']>)[number]>;
export type GetProfileFieldInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['childSafety']>)[number]>['fields']>)[number]>, { __typename?: 'FieldInput' }>);
export type GetProfileFieldSelectInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['childSafety']>)[number]>['fields']>)[number]>, { __typename?: 'FieldSelect' }>);
export type GetProfileOptions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['childSafety']>)[number]>['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['options']>)[number]>;
export type GetProfileProfileQuestions = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['profileQuestions']>)[number]>;
export type GetProfile_Fields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['profileQuestions']>)[number]>['fields']>)[number]>;
export type GetProfileGuardianBornOverseas = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['guardianBornOverseas']>);
export type GetProfileHasDisability = (NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['hasDisability']>);
export type GetProfileDisabilities = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetProfileQuery['account']>)['profile']>)['disabilities']>)[number]>;
export type GetParentProfileVariables = GetParentProfileQueryVariables;
export type GetParentProfileAccount = (NonNullable<GetParentProfileQuery['account']>);
export type GetParentProfileProfile = (NonNullable<(NonNullable<GetParentProfileQuery['account']>)['profile']>);
export type GetParentProfileMobileNumber = (NonNullable<(NonNullable<(NonNullable<GetParentProfileQuery['account']>)['profile']>)['mobileNumber']>);
export type GetParentProfileCountryCode = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetParentProfileQuery['account']>)['profile']>)['mobileNumber']>)['countryCode']>);
export type GetParentProfileAddress = (NonNullable<(NonNullable<(NonNullable<GetParentProfileQuery['account']>)['profile']>)['address']>);
export type GetExistingDependantVariables = GetExistingDependantQueryVariables;
export type GetExistingDependantDependantProfile = (NonNullable<GetExistingDependantQuery['dependantProfile']>);
export type GetExistingDependantGender = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['gender']>);
export type GetExistingDependantIndigenousDescent = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['indigenousDescent']>);
export type GetExistingDependantAddress = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['address']>);
export type GetExistingDependantEmergencyContact = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['emergencyContact']>);
export type GetExistingDependantMobileNumber = (NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['emergencyContact']>)['mobileNumber']>);
export type GetExistingDependantCountryCode = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['emergencyContact']>)['mobileNumber']>)['countryCode']>);
export type GetExistingDependantGuardians = NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>;
export type GetExistingDependantProfileInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>);
export type GetExistingDependant_MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>)['mobileNumber']>);
export type GetExistingDependant_CountryCode = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>)['mobileNumber']>)['countryCode']>);
export type GetExistingDependant_Address = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Profile' }>)['address']>);
export type GetExistingDependantGuardianInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>);
export type GetExistingDependant__MobileNumber = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>)['mobileNumber']>);
export type GetExistingDependant__CountryCode = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>)['mobileNumber']>)['countryCode']>);
export type GetExistingDependant__Address = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardians']>)[number]>, { __typename?: 'Guardian' }>)['address']>);
export type GetExistingDependantCoachingAccreditation = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['coachingAccreditation']>);
export type GetExistingDependantLevel = (NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['coachingAccreditation']>)['level']>);
export type GetExistingDependantChildSafety = NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['childSafety']>)[number]>;
export type GetExistingDependantFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['childSafety']>)[number]>['fields']>)[number]>;
export type GetExistingDependantFieldInputInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['childSafety']>)[number]>['fields']>)[number]>, { __typename?: 'FieldInput' }>);
export type GetExistingDependantFieldSelectInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['childSafety']>)[number]>['fields']>)[number]>, { __typename?: 'FieldSelect' }>);
export type GetExistingDependantOptions = NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['childSafety']>)[number]>['fields']>)[number]>, { __typename?: 'FieldSelect' }>)['options']>)[number]>;
export type GetExistingDependantProfileQuestions = NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['profileQuestions']>)[number]>;
export type GetExistingDependant_Fields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['profileQuestions']>)[number]>['fields']>)[number]>;
export type GetExistingDependantGuardianBornOverseas = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['guardianBornOverseas']>);
export type GetExistingDependantHasDisability = (NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['hasDisability']>);
export type GetExistingDependantDisabilities = NonNullable<(NonNullable<(NonNullable<GetExistingDependantQuery['dependantProfile']>)['disabilities']>)[number]>;
export type RegistrationAssertVariables = RegistrationAssertQueryVariables;
export type RegistrationAssertRegistrationAssert = (NonNullable<RegistrationAssertQuery['registrationAssert']>);
export type GetPaymentDetailsVariables = GetPaymentDetailsQueryVariables;
export type GetPaymentDetailsRegistrationSettings = (NonNullable<GetPaymentDetailsQuery['registrationSettings']>);
export type GetPaymentDetailsDiscoverSocialTeamRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>);
export type GetPaymentDetailsSeason = (NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>);
export type GetPaymentDetailsCompetition = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>);
export type GetPaymentDetailsOrganisation = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>)['organisation']>);
export type GetPaymentDetailsFormat = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>)['format']>);
export type GetPaymentDetailsDiscoverRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>);
export type GetPaymentDetails_Season = (NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>);
export type GetPaymentDetailsDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type GetPaymentDetailsAgeRestrictionRange = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['ageRestrictionRange']>);
export type GetPaymentDetails_Competition = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type GetPaymentDetails_Organisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type GetPaymentDetails_Format = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['format']>);
export type GetPaymentDetailsProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>);
export type GetPaymentDetailsProgram = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type GetPaymentDetails__Format = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetPaymentDetailsQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>)['format']>);
export type GetPaymentDetailsConfiguration = (NonNullable<GetPaymentDetailsQuery['configuration']>);
export type GetPaymentDetailsSupportedCountries = NonNullable<(NonNullable<(NonNullable<GetPaymentDetailsQuery['configuration']>)['supportedCountries']>)[number]>;
export type GetPaymentDetailsAccount = (NonNullable<GetPaymentDetailsQuery['account']>);
export type GetPaymentDetailsProfile = (NonNullable<(NonNullable<GetPaymentDetailsQuery['account']>)['profile']>);
export type GetPaymentDetailsAddress = (NonNullable<(NonNullable<(NonNullable<GetPaymentDetailsQuery['account']>)['profile']>)['address']>);
export type OrderSubmitVariables = OrderSubmitMutationVariables;
export type OrderSubmitOrderSubmit = (NonNullable<OrderSubmitMutation['orderSubmit']>);
export type OrderSubmitAmount = (NonNullable<(NonNullable<OrderSubmitMutation['orderSubmit']>)['amount']>);
export type GetParticipantExternalVariables = GetParticipantExternalQueryVariables;
export type GetParticipantExternalAccount = (NonNullable<GetParticipantExternalQuery['account']>);
export type GetParticipantExternalProfile = (NonNullable<(NonNullable<GetParticipantExternalQuery['account']>)['profile']>);
export type GetParticipantExternalMobileNumber = (NonNullable<(NonNullable<(NonNullable<GetParticipantExternalQuery['account']>)['profile']>)['mobileNumber']>);
export type GetParticipantExternalCountryCode = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetParticipantExternalQuery['account']>)['profile']>)['mobileNumber']>)['countryCode']>);
export type GetParticipantExternalExternalAccounts = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetParticipantExternalQuery['account']>)['profile']>)['externalAccounts']>)[number]>;
export type GetParticipantExternalParticipant = (NonNullable<GetParticipantExternalQuery['participant']>);
export type GetParticipantExternal_Profile = (NonNullable<(NonNullable<GetParticipantExternalQuery['participant']>)['profile']>);
export type GetParticipantExternalGender = (NonNullable<(NonNullable<(NonNullable<GetParticipantExternalQuery['participant']>)['profile']>)['gender']>);
export type ProductsUpdateCartVariables = ProductsUpdateCartMutationVariables;
export type ProductsUpdateCartProductsUpdateCart = (NonNullable<ProductsUpdateCartMutation['productsUpdateCart']>);
export type ProductUpdateSocialTeamCartVariables = ProductUpdateSocialTeamCartMutationVariables;
export type ProductUpdateSocialTeamCartProductUpdateSocialTeamCart = (NonNullable<ProductUpdateSocialTeamCartMutation['productUpdateSocialTeamCart']>);
export type GetProfilePhotoVerificationUploadUrlVariables = GetProfilePhotoVerificationUploadUrlQueryVariables;
export type GetProfilePhotoVerificationUploadUrlProfilePhotoVerificationUploadUrl = (NonNullable<GetProfilePhotoVerificationUploadUrlQuery['profilePhotoVerificationUploadURL']>);
export type GetProfilePhotoVerificationUrlVariables = GetProfilePhotoVerificationUrlQueryVariables;
export type GetProfilePhotoVerificationUrlProfile = (NonNullable<GetProfilePhotoVerificationUrlQuery['profile']>);
export type GetProfilePhotoVerificationUrlProfilePhotoVerificationUrl = (NonNullable<(NonNullable<GetProfilePhotoVerificationUrlQuery['profile']>)['profilePhotoVerificationURL']>);
export type GetDependantProfilePhotoVerificationUrlVariables = GetDependantProfilePhotoVerificationUrlQueryVariables;
export type GetDependantProfilePhotoVerificationUrlDependantProfile = (NonNullable<GetDependantProfilePhotoVerificationUrlQuery['dependantProfile']>);
export type GetDependantProfilePhotoVerificationUrlProfilePhotoVerificationUrl = (NonNullable<(NonNullable<GetDependantProfilePhotoVerificationUrlQuery['dependantProfile']>)['profilePhotoVerificationURL']>);
export type GetProfilePhotoVerificationConfigVariables = GetProfilePhotoVerificationConfigQueryVariables;
export type GetProfilePhotoVerificationConfigTenantConfiguration = (NonNullable<GetProfilePhotoVerificationConfigQuery['tenantConfiguration']>);
export type GetProfilePhotoVerificationConfigSeasonRegistration = (NonNullable<(NonNullable<GetProfilePhotoVerificationConfigQuery['tenantConfiguration']>)['seasonRegistration']>);
export type GetProfilePhotoVerificationConfigPhotoVerification = (NonNullable<(NonNullable<(NonNullable<GetProfilePhotoVerificationConfigQuery['tenantConfiguration']>)['seasonRegistration']>)['photoVerification']>);
export type GetRegistrationStatusVariables = GetRegistrationStatusQueryVariables;
export type GetRegistrationStatusParticipant = (NonNullable<GetRegistrationStatusQuery['participant']>);
export type GetRegistrationStatusProfile = (NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>);
export type GetRegistrationStatusRegistrationHistory = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>;
export type GetRegistrationStatusParticipantInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>, { __typename?: 'Participant' }>);
export type GetRegistrationStatusSeasonRegistration = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>);
export type GetRegistrationStatusSeason = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>);
export type GetRegistrationStatusDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type GetRegistrationStatusCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type GetRegistrationStatusOrganisation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetRegistrationStatusQuery['participant']>)['profile']>)['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['organisation']>);
export type GetRegistrationStatusRegistrationSettings = (NonNullable<GetRegistrationStatusQuery['registrationSettings']>);
export type GetRegistrationStatusDiscoverRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetRegistrationStatusQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>);
export type GetRegistrationStatus_Season = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationStatusQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>);
export type GetRegistrationStatus_DiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationStatusQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type GetRegistrationStatus_Competition = (NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationStatusQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type GetRegistrationStatus_Organisation = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationStatusQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>)['organisation']>);
export type GetRegistrationStatus__Organisation = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationStatusQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>);
export type TransferRequestCreateVariables = TransferRequestCreateMutationVariables;
export type TransferRequestCreateTransferRequestCreate = (NonNullable<TransferRequestCreateMutation['transferRequestCreate']>);
export type PermitRequestCreateVariables = PermitRequestCreateMutationVariables;
export type PermitRequestCreatePermitRequestCreate = (NonNullable<PermitRequestCreateMutation['permitRequestCreate']>);
export type RegistrationCheckVariables = RegistrationCheckQueryVariables;
export type RegistrationCheckRegistrationCheck = (NonNullable<RegistrationCheckQuery['registrationCheck']>);
export type RegistrationCheckTransferRequest = (NonNullable<(NonNullable<RegistrationCheckQuery['registrationCheck']>)['transferRequest']>);
export type RegistrationCheckSourceAffiliation = (NonNullable<(NonNullable<(NonNullable<RegistrationCheckQuery['registrationCheck']>)['transferRequest']>)['sourceAffiliation']>);
export type RegistrationCheckClub = (NonNullable<(NonNullable<(NonNullable<(NonNullable<RegistrationCheckQuery['registrationCheck']>)['transferRequest']>)['sourceAffiliation']>)['club']>);
export type RegistrationCheckDestinationClub = (NonNullable<(NonNullable<(NonNullable<RegistrationCheckQuery['registrationCheck']>)['transferRequest']>)['destinationClub']>);
export type RegistrationCheckSeason = (NonNullable<(NonNullable<(NonNullable<RegistrationCheckQuery['registrationCheck']>)['transferRequest']>)['season']>);
export type RegistrationCheckPermitRequest = (NonNullable<(NonNullable<RegistrationCheckQuery['registrationCheck']>)['permitRequest']>);
export type RegistrationCheckTenantConfiguration = (NonNullable<RegistrationCheckQuery['tenantConfiguration']>);
export type RegistrationCheckTransfers = (NonNullable<(NonNullable<RegistrationCheckQuery['tenantConfiguration']>)['transfers']>);
export type GetPendingTransferRequestForPrimaryProfileVariables = GetPendingTransferRequestForPrimaryProfileQueryVariables;
export type GetPendingTransferRequestForPrimaryProfileAccount = (NonNullable<GetPendingTransferRequestForPrimaryProfileQuery['account']>);
export type GetPendingTransferRequestForPrimaryProfileProfile = (NonNullable<(NonNullable<GetPendingTransferRequestForPrimaryProfileQuery['account']>)['profile']>);
export type GetPendingTransferRequestForPrimaryProfileTransferRequests = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetPendingTransferRequestForPrimaryProfileQuery['account']>)['profile']>)['transferRequests']>)[number]>;
export type GetPendingTransferRequestForExistingDependantVariables = GetPendingTransferRequestForExistingDependantQueryVariables;
export type GetPendingTransferRequestForExistingDependantDependantProfile = (NonNullable<GetPendingTransferRequestForExistingDependantQuery['dependantProfile']>);
export type GetPendingTransferRequestForExistingDependantTransferRequests = NonNullable<(NonNullable<(NonNullable<GetPendingTransferRequestForExistingDependantQuery['dependantProfile']>)['transferRequests']>)[number]>;
export type DiscoverSeasonRegistrationVariables = DiscoverSeasonRegistrationQueryVariables;
export type DiscoverSeasonRegistrationDiscoverSeasonRegistration = (NonNullable<DiscoverSeasonRegistrationQuery['discoverSeasonRegistration']>);
export type DiscoverSeasonRegistrationRegistrationUserTypes = NonNullable<(NonNullable<(NonNullable<DiscoverSeasonRegistrationQuery['discoverSeasonRegistration']>)['registrationUserTypes']>)[number]>;
export type DiscoverSeasonRegistrationRegistrationLimit = (NonNullable<NonNullable<(NonNullable<(NonNullable<DiscoverSeasonRegistrationQuery['discoverSeasonRegistration']>)['registrationUserTypes']>)[number]>['registrationLimit']>);
export type RegistrationHistoryFragmentRegistrationHistory = NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>;
export type RegistrationHistoryFragmentParticipantInlineFragment = (DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>);
export type RegistrationHistoryFragmentSeasonRegistration = (NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>);
export type RegistrationHistoryFragmentSeason = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>);
export type RegistrationHistoryFragmentDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type RegistrationHistoryFragmentCompetition = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'DiscoverSeason' }>)['competition']>);
export type RegistrationHistoryFragmentProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'ProgramSeason' }>);
export type RegistrationHistoryFragmentProgram = (NonNullable<(DiscriminateUnion<(NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['season']>), { __typename?: 'ProgramSeason' }>)['program']>);
export type RegistrationHistoryFragmentOrganisation = (NonNullable<(NonNullable<(DiscriminateUnion<NonNullable<(NonNullable<RegistrationHistoryFragmentFragment['registrationHistory']>)[number]>, { __typename?: 'Participant' }>)['seasonRegistration']>)['organisation']>);
export type ProfileRegistrationHistoryVariables = ProfileRegistrationHistoryQueryVariables;
export type ProfileRegistrationHistoryAccount = (NonNullable<ProfileRegistrationHistoryQuery['account']>);
export type ProfileRegistrationHistoryProfile = (NonNullable<(NonNullable<ProfileRegistrationHistoryQuery['account']>)['profile']>);
export type ProfileRegistrationHistoryDependants = NonNullable<(NonNullable<(NonNullable<(NonNullable<ProfileRegistrationHistoryQuery['account']>)['profile']>)['dependants']>)[number]>;
export type DiscoverSeasonDetailsCompetition = (NonNullable<DiscoverSeasonDetailsFragment['competition']>);
export type DiscoverSeasonDetailsOrganisation = (NonNullable<(NonNullable<DiscoverSeasonDetailsFragment['competition']>)['organisation']>);
export type ProgramSeasonDetailsProgram = (NonNullable<ProgramSeasonDetailsFragment['program']>);
export type GetRegistrationForShareVariables = GetRegistrationForShareQueryVariables;
export type GetRegistrationForShareRegistrationSettings = (NonNullable<GetRegistrationForShareQuery['registrationSettings']>);
export type GetRegistrationForShareDiscoverRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>);
export type GetRegistrationForShareSeason = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>);
export type GetRegistrationForShareDiscoverSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'DiscoverSeason' }>);
export type GetRegistrationForShareProgramSeasonInlineFragment = (DiscriminateUnion<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['season']>), { __typename?: 'ProgramSeason' }>);
export type GetRegistrationForShareOrganisation = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverRegistration' }>)['organisation']>);
export type GetRegistrationForShareDiscoverSocialTeamRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>);
export type GetRegistrationForShare_Season = (NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>);
export type GetRegistrationForShareCompetition = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>);
export type GetRegistrationForShare_Organisation = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetRegistrationForShareQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>)['organisation']>);
export type GetRegistrationForShareDiscoverTeam = (NonNullable<GetRegistrationForShareQuery['discoverTeam']>);
export type SocialTeamRegistrationSubmitVariables = SocialTeamRegistrationSubmitMutationVariables;
export type SocialTeamRegistrationSubmitSocialTeamRegistrationSubmit = (NonNullable<SocialTeamRegistrationSubmitMutation['socialTeamRegistrationSubmit']>);
export type GetSocialTeamGradesAndOrganisationVariables = GetSocialTeamGradesAndOrganisationQueryVariables;
export type GetSocialTeamGradesAndOrganisationDiscoverSocialTeamRegistration = (NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>);
export type GetSocialTeamGradesAndOrganisationGrades = NonNullable<(NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['grades']>)[number]>;
export type GetSocialTeamGradesAndOrganisationDay = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['grades']>)[number]>['day']>);
export type GetSocialTeamGradesAndOrganisationGender = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['grades']>)[number]>['gender']>);
export type GetSocialTeamGradesAndOrganisationSeason = (NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['season']>);
export type GetSocialTeamGradesAndOrganisationCompetition = (NonNullable<(NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['season']>)['competition']>);
export type GetSocialTeamGradesAndOrganisationOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['season']>)['competition']>)['organisation']>);
export type GetSocialTeamGradesAndOrganisationCustomFields = NonNullable<(NonNullable<(NonNullable<GetSocialTeamGradesAndOrganisationQuery['discoverSocialTeamRegistration']>)['customFields']>)[number]>;
export type GetMySocialTeamsVariables = GetMySocialTeamsQueryVariables;
export type GetMySocialTeamsAccount = (NonNullable<GetMySocialTeamsQuery['account']>);
export type GetMySocialTeamsProfile = (NonNullable<(NonNullable<GetMySocialTeamsQuery['account']>)['profile']>);
export type GetMySocialTeamsSocialTeams = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetMySocialTeamsQuery['account']>)['profile']>)['socialTeams']>)[number]>;
export type DiscoverDiscountVariables = DiscoverDiscountQueryVariables;
export type DiscoverDiscountDiscoverDiscount = (NonNullable<DiscoverDiscountQuery['discoverDiscount']>);
export type SeasonRegistrationsVariables = SeasonRegistrationsQueryVariables;
export type SeasonRegistrationsSeasonRegistrations = NonNullable<(NonNullable<SeasonRegistrationsQuery['seasonRegistrations']>)[number]>;
export type GetTeamAndSeasonRegVariables = GetTeamAndSeasonRegQueryVariables;
export type GetTeamAndSeasonRegDiscoverTeam = (NonNullable<GetTeamAndSeasonRegQuery['discoverTeam']>);
export type GetTeamAndSeasonRegRegistrationSettings = (NonNullable<GetTeamAndSeasonRegQuery['registrationSettings']>);
export type GetTeamAndSeasonRegDiscoverSocialTeamRegistrationInlineFragment = (DiscriminateUnion<(NonNullable<GetTeamAndSeasonRegQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>);
export type GetTeamAndSeasonRegSeason = (NonNullable<(DiscriminateUnion<(NonNullable<GetTeamAndSeasonRegQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>);
export type GetTeamAndSeasonRegCompetition = (NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetTeamAndSeasonRegQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>);
export type GetTeamAndSeasonRegOrganisation = (NonNullable<(NonNullable<(NonNullable<(DiscriminateUnion<(NonNullable<GetTeamAndSeasonRegQuery['registrationSettings']>), { __typename?: 'DiscoverSocialTeamRegistration' }>)['season']>)['competition']>)['organisation']>);
export type GetParticipantVariables = GetParticipantQueryVariables;
export type GetParticipantParticipant = (NonNullable<GetParticipantQuery['participant']>);
export type GetParticipantTransferRequired = (NonNullable<(NonNullable<GetParticipantQuery['participant']>)['transferRequired']>);
export type GetParticipantPendingTransferRequest = (NonNullable<(NonNullable<(NonNullable<GetParticipantQuery['participant']>)['transferRequired']>)['pendingTransferRequest']>);
export type RequestTransferVariables = RequestTransferMutationVariables;
export type RequestTransferTransferRequestCreate = (NonNullable<RequestTransferMutation['transferRequestCreate']>);
export type GetCompetitionTypeVariables = GetCompetitionTypeQueryVariables;
export type GetCompetitionTypeDiscoverGrade = (NonNullable<GetCompetitionTypeQuery['discoverGrade']>);
export type GetCompetitionTypeSeason = (NonNullable<(NonNullable<GetCompetitionTypeQuery['discoverGrade']>)['season']>);
export type GetCompetitionTypeCompetition = (NonNullable<(NonNullable<(NonNullable<GetCompetitionTypeQuery['discoverGrade']>)['season']>)['competition']>);
export type GetCompetitionTypeOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<GetCompetitionTypeQuery['discoverGrade']>)['season']>)['competition']>)['organisation']>);
export type DiscoverCompetitionsVariables = DiscoverCompetitionsQueryVariables;
export type DiscoverCompetitionsDiscoverCompetitions = NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>;
export type DiscoverCompetitionsSeasons = NonNullable<(NonNullable<NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>['seasons']>)[number]>;
export type DiscoverCompetitionsStatus = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>['seasons']>)[number]>['status']>);
export type DiscoverCompetitionsOrganisation = (NonNullable<NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>['organisation']>);
export type DiscoverCompetitionsLogo = (NonNullable<(NonNullable<NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>['organisation']>)['logo']>);
export type DiscoverCompetitionsSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>['organisation']>)['logo']>)['sizes']>)[number]>;
export type DiscoverCompetitionsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<DiscoverCompetitionsQuery['discoverCompetitions']>)[number]>['organisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type DiscoverCompetitionsDiscoverOrganisation = (NonNullable<DiscoverCompetitionsQuery['discoverOrganisation']>);
export type DiscoverCompetitionsTenantConfiguration = (NonNullable<DiscoverCompetitionsQuery['tenantConfiguration']>);
export type DiscoverCompetitionsSport = (NonNullable<(NonNullable<DiscoverCompetitionsQuery['tenantConfiguration']>)['sport']>);
export type GetOrganisationShopProductsVariables = GetOrganisationShopProductsQueryVariables;
export type GetOrganisationShopProductsShopProducts = NonNullable<(NonNullable<GetOrganisationShopProductsQuery['shopProducts']>)[number]>;
export type GetOrganisationShopProductsMaxPrice = (NonNullable<NonNullable<(NonNullable<GetOrganisationShopProductsQuery['shopProducts']>)[number]>['maxPrice']>);
export type GetOrganisationShopProductsMinPrice = (NonNullable<NonNullable<(NonNullable<GetOrganisationShopProductsQuery['shopProducts']>)[number]>['minPrice']>);
export type GetOrganisationShopProductsImages = NonNullable<(NonNullable<NonNullable<(NonNullable<GetOrganisationShopProductsQuery['shopProducts']>)[number]>['images']>)[number]>;
export type GetOrganisationShopProductsSizes = NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GetOrganisationShopProductsQuery['shopProducts']>)[number]>['images']>)[number]>['sizes']>)[number]>;
export type GetOrganisationShopProductsDimensions = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<GetOrganisationShopProductsQuery['shopProducts']>)[number]>['images']>)[number]>['sizes']>)[number]>['dimensions']>);
export type GetTenantStripeKeyVariables = GetTenantStripeKeyQueryVariables;
export type GetTenantStripeKeyTenantConfiguration = (NonNullable<GetTenantStripeKeyQuery['tenantConfiguration']>);
export type GetShopCheckoutConfigVariables = GetShopCheckoutConfigQueryVariables;
export type GetShopCheckoutConfigConfiguration = (NonNullable<GetShopCheckoutConfigQuery['configuration']>);
export type GetShopCheckoutConfigSupportedCountries = NonNullable<(NonNullable<(NonNullable<GetShopCheckoutConfigQuery['configuration']>)['supportedCountries']>)[number]>;
export type GetShopCheckoutSessionVariables = GetShopCheckoutSessionQueryVariables;
export type GetShopCheckoutSessionShopCart = (NonNullable<GetShopCheckoutSessionQuery['shopCart']>);
export type GetShopCheckoutSessionCheckoutSession = (NonNullable<(NonNullable<GetShopCheckoutSessionQuery['shopCart']>)['checkoutSession']>);
export type GetShopCheckoutSessionGr4vyEmbedCheckoutSessionInlineFragment = (DiscriminateUnion<(NonNullable<(NonNullable<GetShopCheckoutSessionQuery['shopCart']>)['checkoutSession']>), { __typename?: 'Gr4vyEmbedCheckoutSession' }>);
export type GetShopProductVariables = GetShopProductQueryVariables;
export type GetShopProductDiscoverOrganisation = (NonNullable<GetShopProductQuery['discoverOrganisation']>);
export type GetShopProductShopProduct = (NonNullable<GetShopProductQuery['shopProduct']>);
export type GetShopProductSettings = (NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['settings']>);
export type GetShopProductValidFrom = (NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['settings']>)['validFrom']>);
export type GetShopProductValidTo = (NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['settings']>)['validTo']>);
export type GetShopProductVariants = NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['variants']>)[number]>;
export type GetShopProductAmount = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['variants']>)[number]>['amount']>);
export type GetShopProductCategoryPairs = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['variants']>)[number]>['categoryPairs']>)[number]>;
export type GetShopProductCategory = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['variants']>)[number]>['categoryPairs']>)[number]>['category']>);
export type GetShopProductOption = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['variants']>)[number]>['categoryPairs']>)[number]>['option']>);
export type GetShopProductCategories = NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['categories']>)[number]>;
export type GetShopProductOptions = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['categories']>)[number]>['options']>)[number]>;
export type GetShopProductCustomFields = NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['customFields']>)[number]>;
export type GetShopProductDropdownOptions = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['customFields']>)[number]>['dropdownOptions']>)[number]>;
export type GetShopProduct_Option = (NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['customFields']>)[number]>['option']>);
export type GetShopProduct_Category = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['customFields']>)[number]>['option']>)['category']>);
export type GetShopProduct__Option = (NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['customFields']>)[number]>['option']>)['option']>);
export type GetShopProductImages = NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['images']>)[number]>;
export type GetShopProductSizes = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['images']>)[number]>['sizes']>)[number]>;
export type GetShopProductDimensions = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<GetShopProductQuery['shopProduct']>)['images']>)[number]>['sizes']>)[number]>['dimensions']>);
export type GetShopProductTenantConfiguration = (NonNullable<GetShopProductQuery['tenantConfiguration']>);
export type UpdateShopCartVariables = UpdateShopCartMutationVariables;
export type UpdateShopCartShopCartUpsert = (NonNullable<UpdateShopCartMutation['shopCartUpsert']>);
export type GetOrganisationShopSettingsVariables = GetOrganisationShopSettingsQueryVariables;
export type GetOrganisationShopSettingsDiscoverOrganisation = (NonNullable<GetOrganisationShopSettingsQuery['discoverOrganisation']>);
export type GetOrganisationShopSettingsAddress = (NonNullable<(NonNullable<GetOrganisationShopSettingsQuery['discoverOrganisation']>)['address']>);
export type GetOrganisationShopSettingsLogo = (NonNullable<(NonNullable<GetOrganisationShopSettingsQuery['discoverOrganisation']>)['logo']>);
export type GetOrganisationShopSettingsSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<GetOrganisationShopSettingsQuery['discoverOrganisation']>)['logo']>)['sizes']>)[number]>;
export type GetOrganisationShopSettingsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<GetOrganisationShopSettingsQuery['discoverOrganisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type GetOrganisationShopSettingsContacts = NonNullable<(NonNullable<(NonNullable<GetOrganisationShopSettingsQuery['discoverOrganisation']>)['contacts']>)[number]>;
export type GetOrganisationShopSettingsTenantConfiguration = (NonNullable<GetOrganisationShopSettingsQuery['tenantConfiguration']>);
export type SignUpVariables = SignUpQueryVariables;
export type SignUpConfiguration = (NonNullable<SignUpQuery['configuration']>);
export type SignUpSupportedCountries = NonNullable<(NonNullable<(NonNullable<SignUpQuery['configuration']>)['supportedCountries']>)[number]>;
export type AccountConfirmVariables = AccountConfirmMutationVariables;
export type AccountConfirmAccountConfirm = (NonNullable<AccountConfirmMutation['accountConfirm']>);
export type DiscoverTeamVariables = DiscoverTeamQueryVariables;
export type DiscoverTeamDiscoverTeam = (NonNullable<DiscoverTeamQuery['discoverTeam']>);
export type DiscoverTeamLogo = (NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['logo']>);
export type DiscoverTeamSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['logo']>)['sizes']>)[number]>;
export type DiscoverTeamDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type DiscoverTeamGrade = (NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['grade']>);
export type DiscoverTeamSeason = (NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['season']>);
export type DiscoverTeamCompetition = (NonNullable<(NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['season']>)['competition']>);
export type DiscoverTeamOrganisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['season']>)['competition']>)['organisation']>);
export type DiscoverTeam_Organisation = (NonNullable<(NonNullable<DiscoverTeamQuery['discoverTeam']>)['organisation']>);
export type DiscoverTeamTenantConfiguration = (NonNullable<DiscoverTeamQuery['tenantConfiguration']>);
export type TeamFixtureVariables = TeamFixtureQueryVariables;
export type TeamFixtureDiscoverTeam = (NonNullable<TeamFixtureQuery['discoverTeam']>);
export type TeamFixtureSeason = (NonNullable<(NonNullable<TeamFixtureQuery['discoverTeam']>)['season']>);
export type TeamFixtureGrade = (NonNullable<(NonNullable<TeamFixtureQuery['discoverTeam']>)['grade']>);
export type TeamFixtureOrganisation = (NonNullable<(NonNullable<TeamFixtureQuery['discoverTeam']>)['organisation']>);
export type TeamFixtureDiscoverTeamFixture = NonNullable<(NonNullable<TeamFixtureQuery['discoverTeamFixture']>)[number]>;
export type TeamFixture_Grade = (NonNullable<NonNullable<(NonNullable<TeamFixtureQuery['discoverTeamFixture']>)[number]>['grade']>);
export type TeamFixture_Season = (NonNullable<(NonNullable<NonNullable<(NonNullable<TeamFixtureQuery['discoverTeamFixture']>)[number]>['grade']>)['season']>);
export type TeamFixtureCompetition = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<TeamFixtureQuery['discoverTeamFixture']>)[number]>['grade']>)['season']>)['competition']>);
export type TeamFixture_Organisation = (NonNullable<(NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<TeamFixtureQuery['discoverTeamFixture']>)[number]>['grade']>)['season']>)['competition']>)['organisation']>);
export type TeamFixtureFixture = (NonNullable<NonNullable<(NonNullable<TeamFixtureQuery['discoverTeamFixture']>)[number]>['fixture']>);
export type TeamFixtureTenantConfiguration = (NonNullable<TeamFixtureQuery['tenantConfiguration']>);
export type TeamFixtureGradeTypes = NonNullable<(NonNullable<(NonNullable<TeamFixtureQuery['tenantConfiguration']>)['gradeTypes']>)[number]>;
export type TeamFixtureFeatures = (NonNullable<NonNullable<(NonNullable<(NonNullable<TeamFixtureQuery['tenantConfiguration']>)['gradeTypes']>)[number]>['features']>);
export type TeamLadderVariables = TeamLadderQueryVariables;
export type TeamLadderDiscoverTeam = (NonNullable<TeamLadderQuery['discoverTeam']>);
export type TeamLadderSeason = (NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['season']>);
export type TeamLadderCompetition = (NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['season']>)['competition']>);
export type TeamLadderOrganisation = (NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['organisation']>);
export type TeamLadderGrade = (NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>);
export type TeamLadderLadder = NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>;
export type TeamLadderPool = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['pool']>);
export type TeamLadderGeneratedFrom = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['generatedFrom']>);
export type TeamLadderStandings = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>;
export type TeamLadderTeam = (NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>);
export type TeamLadder_Season = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['season']>);
export type TeamLadder_Competition = (NonNullable<(NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['season']>)['competition']>);
export type TeamLadder_Organisation = (NonNullable<(NonNullable<NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['ladder']>)[number]>['standings']>)[number]>['team']>)['organisation']>);
export type TeamLadderGameTypes = NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['gameTypes']>)[number]>;
export type TeamLadderLadderFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['gameTypes']>)[number]>['ladderFields']>)[number]>;
export type TeamLadderLadderRankingFields = NonNullable<(NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['gameTypes']>)[number]>['ladderRankingFields']>)[number]>;
export type TeamLadderOverallLadderFields = NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['overallLadderFields']>)[number]>;
export type TeamLadderOverallLadderRankingFields = NonNullable<(NonNullable<(NonNullable<(NonNullable<TeamLadderQuery['discoverTeam']>)['grade']>)['overallLadderRankingFields']>)[number]>;
export type DiscoverOrganisationTeamsVariables = DiscoverOrganisationTeamsQueryVariables;
export type DiscoverOrganisationTeamsDiscoverSeason = (NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>);
export type DiscoverOrganisationTeamsCompetition = (NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['competition']>);
export type DiscoverOrganisationTeamsOrganisation = (NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['competition']>)['organisation']>);
export type DiscoverOrganisationTeamsLogo = (NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['competition']>)['organisation']>)['logo']>);
export type DiscoverOrganisationTeamsSizes = NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['competition']>)['organisation']>)['logo']>)['sizes']>)[number]>;
export type DiscoverOrganisationTeamsDimensions = (NonNullable<NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['competition']>)['organisation']>)['logo']>)['sizes']>)[number]>['dimensions']>);
export type DiscoverOrganisationTeamsStatus = (NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['status']>);
export type DiscoverOrganisationTeamsGrades = NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverSeason']>)['grades']>)[number]>;
export type DiscoverOrganisationTeamsTenantConfiguration = (NonNullable<DiscoverOrganisationTeamsQuery['tenantConfiguration']>);
export type DiscoverOrganisationTeams_Competition = (NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['tenantConfiguration']>)['competition']>);
export type DiscoverOrganisationTeamsAgeGroups = NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['tenantConfiguration']>)['competition']>)['ageGroups']>)[number]>;
export type DiscoverOrganisationTeamsGenders = NonNullable<(NonNullable<(NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['tenantConfiguration']>)['competition']>)['genders']>)[number]>;
export type DiscoverOrganisationTeamsDiscoverTeams = NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverTeams']>)[number]>;
export type DiscoverOrganisationTeamsGender = (NonNullable<NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverTeams']>)[number]>['gender']>);
export type DiscoverOrganisationTeamsAgeGroup = (NonNullable<NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverTeams']>)[number]>['ageGroup']>);
export type DiscoverOrganisationTeamsGrade = (NonNullable<NonNullable<(NonNullable<DiscoverOrganisationTeamsQuery['discoverTeams']>)[number]>['grade']>);
export type DiscoverOrganisationTeamsDiscoverOrganisation = (NonNullable<DiscoverOrganisationTeamsQuery['discoverOrganisation']>);
export type TenantVariables = TenantQueryVariables;
export type TenantTenantConfiguration = (NonNullable<TenantQuery['tenantConfiguration']>);
export type TenantSport = (NonNullable<(NonNullable<TenantQuery['tenantConfiguration']>)['sport']>);
export const GameViewGameTeamStatisticsFragmentFragmentDoc = gql`
    fragment GameViewGameTeamStatisticsFragment on DiscoverGameTeamStatistics {
  players {
    playerNumber
    player {
      ... on DiscoverParticipant {
        id
        profile {
          id
          firstName
          lastName
        }
        hasSeasonPermit
      }
      ... on DiscoverParticipantFillInPlayer {
        id
        profile {
          id
          firstName
          lastName
        }
        hasSeasonPermit
      }
      ... on DiscoverGamePermitFillInPlayer {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      ... on DiscoverRegularFillInPlayer {
        id
        name
      }
      ... on DiscoverAnonymousParticipant {
        id
        name
        hasGamePermit
        hasSeasonPermit
      }
    }
    statistics {
      count
      type {
        value
      }
    }
    periodStatistics {
      period {
        label
        shortName
        value
      }
      type
      statistics {
        type {
          type
          label
          shortName
          value
          pointValue
          applicableTo
          advanced
        }
        count
        details {
          value
        }
      }
      status
      side
      displayOrder
    }
    periods {
      period {
        label
        shortName
        value
      }
      overtimeSequenceNo
      inGamePositions {
        shortName
      }
    }
    playerPoints
    playerPosition {
      positionType
      shortName
      order
    }
    captain {
      name
      shortName
    }
    lineupOrder
  }
  statistics {
    count
    type {
      value
      pointValue
    }
  }
  periods {
    period {
      value
    }
    overtimeSequenceNo
    statistics {
      type {
        value
      }
      count
    }
    teamEvents {
      sequenceNo
      playerID
      statistic {
        type {
          value
        }
        count
      }
    }
  }
  emergencyPlayers {
    playerNumber
    playerPoints
    player {
      ... on DiscoverParticipant {
        id
        profile {
          id
          firstName
          lastName
        }
        hasSeasonPermit
      }
      ... on DiscoverParticipantFillInPlayer {
        id
        profile {
          id
          firstName
          lastName
        }
        hasSeasonPermit
      }
      ... on DiscoverGamePermitFillInPlayer {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      ... on DiscoverAnonymousParticipant {
        id
        name
        hasGamePermit
        hasSeasonPermit
      }
    }
  }
  bestPlayers {
    participant {
      ... on DiscoverParticipant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      ... on DiscoverAnonymousParticipant {
        name
      }
    }
    ranking
  }
  coinTossWinningResult {
    preference
  }
}
    `;
export const GroupLabelFragmentDoc = gql`
    fragment GroupLabel on Group {
  id
  name
  days
  sessionCount
  gender
  startDate
  sessionStartTime
  sessionEndTime
  daySessions {
    day
    startTime
    endTime
  }
  playingSurface {
    id
    name
    venue {
      id
      name
    }
  }
}
    `;
export const MyTeamsGameTeamStatisticsFragmentFragmentDoc = gql`
    fragment MyTeamsGameTeamStatisticsFragment on MyTeamsGameTeamStatistics {
  coaches {
    participant {
      ... on MyTeamsParticipant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      ... on MyTeamsFillInCoach {
        id
        name
      }
    }
    role
    statistics {
      count
      type {
        value
      }
    }
    selected
    order
  }
  statistics {
    count
    type {
      value
      pointValue
    }
    recordedTimeList {
      minute
      stoppage
      description
      offenceType
    }
  }
  periods {
    period {
      value
    }
    overtimeSequenceNo
    statistics {
      type {
        value
      }
      count
    }
    teamEvents {
      sequenceNo
      playerID
      statistic {
        type {
          value
        }
        count
      }
    }
  }
  bestPlayers {
    player {
      ... on MyTeamsParticipant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
      ... on MyTeamsParticipantFillInPlayer {
        id
        participant {
          id
          profile {
            id
            firstName
            lastName
          }
        }
      }
      ... on MyTeamsGamePermitFillInPlayer {
        id
        profile {
          id
          firstName
          lastName
        }
      }
    }
    ranking
  }
  volunteers {
    fullName
    roleType
    roleTypeLabel
    number
  }
  coinTossWinningResult {
    preference
  }
  manualBonusPoints
}
    `;
export const MyTeamsGameTeamFragmentFragmentDoc = gql`
    fragment MyTeamsGameTeamFragment on MyTeamsGameTeam {
  lineup {
    players {
      playerNumber
      participant {
        ... on Node {
          id
        }
        ... on MyTeamsParticipant {
          profile {
            id
            firstName
            lastName
          }
          permit {
            id
            fromDate
            toDate
          }
        }
        ... on MyTeamsParticipantFillInPlayer {
          participant {
            id
            profile {
              id
              firstName
              lastName
            }
            permit {
              id
              fromDate
              toDate
            }
          }
        }
        ... on MyTeamsGamePermitFillInPlayer {
          profile {
            id
            firstName
            lastName
          }
        }
        ... on MyTeamsRegularFillInPlayer {
          id
          firstName
          lastName
        }
      }
      statistics {
        count
        type {
          value
        }
        recordedTimeList {
          minute
          stoppage
          description
          offenceType
        }
      }
      periodStatistics {
        period {
          label
          shortName
          value
        }
        type
        statistics {
          type {
            type
            label
            shortName
            value
            pointValue
            applicableTo
            advanced
          }
          count
          details {
            value
            required
            max
          }
        }
        status
        side
        displayOrder
      }
      periods {
        period {
          label
          shortName
          value
        }
        overtimeSequenceNo
        inGamePositions {
          shortName
          positionType
        }
      }
      playerPoints
      selected
      ineligibilityStatus {
        value
        message
      }
      playerPosition {
        label
        shortName
        positionType
        order
      }
      captain {
        name
        value
        shortName
      }
      availabilityStatus
      lineupOrder
    }
    emergencyPlayers {
      participant {
        ... on Node {
          id
        }
        ... on MyTeamsParticipant {
          profile {
            id
            firstName
            lastName
          }
        }
        ... on MyTeamsParticipantFillInPlayer {
          participant {
            id
            profile {
              id
              firstName
              lastName
            }
          }
        }
        ... on MyTeamsGamePermitFillInPlayer {
          profile {
            id
            firstName
            lastName
          }
        }
      }
      playerPoints
      playerNumber
    }
  }
}
    `;
export const MyTeamsGamePlayerUpdateFragmentDoc = gql`
    fragment MyTeamsGamePlayerUpdate on MyTeamsGame {
  id
  statistics {
    home {
      ...MyTeamsGameTeamStatisticsFragment
    }
    away {
      ...MyTeamsGameTeamStatisticsFragment
    }
  }
  gameTeams {
    home {
      ...MyTeamsGameTeamFragment
    }
    away {
      ...MyTeamsGameTeamFragment
    }
  }
}
    ${MyTeamsGameTeamStatisticsFragmentFragmentDoc}
${MyTeamsGameTeamFragmentFragmentDoc}`;
export const GuardianDetailsFragmentDoc = gql`
    fragment GuardianDetails on Guardian {
  id
  firstName
  lastName
  email
  mobileNumber {
    countryAlphaCode
    countryCode {
      name
      value
    }
    number
    displayNumber
  }
  address {
    id
    line1
    suburb
    postcode
    state
    country
  }
}
    `;
export const AvailableCharitiesFragmentFragmentDoc = gql`
    fragment AvailableCharitiesFragment on Charity {
  id
  name
  description
  charityIdentifier
  options {
    amount {
      net
      currency {
        code
      }
    }
  }
  learnMoreUrl
}
    `;
export const SelectedCharitiesFragmentFragmentDoc = gql`
    fragment SelectedCharitiesFragment on SelectedCharity {
  id
  amount {
    currency {
      code
    }
    net
  }
}
    `;
export const ShopCartFragmentFragmentDoc = gql`
    fragment ShopCartFragment on ShopCart {
  id
  items {
    fee {
      ... on MerchandiseFee {
        amount {
          currency {
            code
          }
          net
        }
        description
        organisation {
          id
          name
        }
        images {
          sizes {
            url
            dimensions {
              width
            }
          }
        }
        categoryPairs {
          id
          name
          value
        }
        quantity
        productID
        productVariantID
        productType
        fulfilmentMethod
        fulfilmentProvider
        customFieldAnswers {
          customField {
            id
          }
          answer
        }
      }
    }
  }
  availableCharities {
    ...AvailableCharitiesFragment
  }
  totals {
    totalAmount {
      currency {
        code
      }
      net
    }
    subTotalAmount {
      currency {
        code
      }
      net
    }
    serviceFeeAmount {
      currency {
        code
      }
      net
    }
    shippingFeeAmount {
      currency {
        code
      }
      net
    }
    selectedCharities {
      ...SelectedCharitiesFragment
    }
  }
  productsAmount {
    currency {
      code
    }
    net
  }
}
    ${AvailableCharitiesFragmentFragmentDoc}
${SelectedCharitiesFragmentFragmentDoc}`;
export const DropdownCustomFieldDetailsFragmentDoc = gql`
    fragment DropdownCustomFieldDetails on DropdownCustomField {
  id
  name
  required
  organisation {
    id
    name
  }
}
    `;
export const TextCustomFieldDetailsFragmentDoc = gql`
    fragment TextCustomFieldDetails on TextCustomField {
  id
  name
  required
  organisation {
    id
    name
  }
}
    `;
export const RecursiveDropdownCustomFieldsDetailsFragmentDoc = gql`
    fragment RecursiveDropdownCustomFieldsDetails on DropdownCustomField {
  ...DropdownCustomFieldDetails
  dropdownOptions {
    id
    label
    customField {
      ...TextCustomFieldDetails
      ...DropdownCustomFieldDetails
      ... on DropdownCustomField {
        dropdownOptions {
          id
          label
          customField {
            ...TextCustomFieldDetails
            ...DropdownCustomFieldDetails
            ... on DropdownCustomField {
              dropdownOptions {
                id
                label
                customField {
                  ...TextCustomFieldDetails
                  ...DropdownCustomFieldDetails
                  ... on DropdownCustomField {
                    dropdownOptions {
                      id
                      label
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${DropdownCustomFieldDetailsFragmentDoc}
${TextCustomFieldDetailsFragmentDoc}`;
export const ExternalAccountsFragmentFragmentDoc = gql`
    fragment ExternalAccountsFragment on Profile {
  externalAccounts {
    externalAccountID
    tenantSlug
  }
}
    `;
export const ProfilePersonalDetailsFragmentDoc = gql`
    fragment ProfilePersonalDetails on Profile {
  id
  firstName
  lastName
  email
  gender {
    name
    value
  }
  genderSelfDescribe
  dateOfBirth
  mobileNumber {
    countryAlphaCode
    countryCode {
      name
      value
    }
    number
    displayNumber
  }
  preferredName
  countryOfBirth
  homeNumber
  address {
    id
    line1
    suburb
    postcode
    state
    country
  }
}
    `;
export const ProfileDisabilityDetailsFragmentDoc = gql`
    fragment ProfileDisabilityDetails on Profile {
  id
  hasDisability {
    name
    value
  }
  disabilities {
    name
    value
  }
  otherDisability
  disabilityHelp
}
    `;
export const FieldSetFragmentFragmentDoc = gql`
    fragment FieldSetFragment on FieldSet {
  label
  name
  fields {
    name
    label
    hidden
    required
    value
    ... on FieldInput {
      type
    }
    ... on FieldSelect {
      options {
        label
        value
      }
      conditionalFields {
        value
        fields {
          name
          label
          hidden
          required
          value
          ... on FieldInput {
            type
          }
          ... on FieldSelect {
            options {
              label
              value
            }
          }
        }
      }
    }
  }
}
    `;
export const ProfileOverviewFragmentDoc = gql`
    fragment ProfileOverview on Profile {
  ...ProfilePersonalDetails
  ...ProfileDisabilityDetails
  wwc {
    id
    number
    expiryDate
    stateOfIssue
  }
  childSafety {
    ...FieldSetFragment
  }
  profileQuestions {
    ...FieldSetFragment
  }
  emergencyContact {
    id
    firstName
    lastName
    email
    relation
    mobileNumber {
      countryAlphaCode
      countryCode {
        name
        value
      }
      number
      displayNumber
    }
  }
  guardians {
    ... on Profile {
      id
      firstName
      lastName
      email
      mobileNumber {
        countryAlphaCode
        countryCode {
          name
          value
        }
        number
        displayNumber
      }
      address {
        id
        line1
        suburb
        postcode
        state
        country
      }
    }
    ... on Guardian {
      id
      firstName
      lastName
      email
      mobileNumber {
        countryAlphaCode
        countryCode {
          name
          value
        }
        number
        displayNumber
      }
      address {
        id
        line1
        suburb
        postcode
        state
        country
      }
    }
  }
  dependants {
    id
    firstName
    lastName
    wwc {
      id
      number
      expiryDate
      stateOfIssue
    }
    childSafety {
      ...FieldSetFragment
    }
    profileQuestions {
      ...FieldSetFragment
    }
  }
  externalAccounts {
    externalAccountID
    tenantSlug
  }
  visible
}
    ${ProfilePersonalDetailsFragmentDoc}
${ProfileDisabilityDetailsFragmentDoc}
${FieldSetFragmentFragmentDoc}`;
export const ProfileTenantConfigurationFragmentDoc = gql`
    fragment ProfileTenantConfiguration on TenantConfiguration {
  seasonRegistration {
    indigenousDescent {
      name
      value
    }
    disabilities {
      name
      value
    }
  }
  countries {
    name
    value
  }
  countryCodes {
    name
    value
  }
  discloseOptions {
    name
    value
  }
}
    `;
export const ProfileConfigurationFragmentDoc = gql`
    fragment ProfileConfiguration on Configuration {
  supportedCountries {
    name
    alpha2Code
    mobileCountryCode
  }
  externalAccountLinking {
    tenantSlug
    config {
      displayName
      profilePageInfoText
      logoURL
      externalURL
      allowParticipantToUnlink
      shouldLinkSSOInRegistrationFlow
    }
  }
}
    `;
export const RegistrationOrganisationDetailsFragmentDoc = gql`
    fragment RegistrationOrganisationDetails on DiscoverOrganisation {
  id
  name
  email
  contactNumber
  websiteUrl
  address {
    id
    line1
    suburb
    postcode
    state
    country
  }
  logo {
    sizes {
      url
      dimensions {
        width
        height
      }
    }
  }
  contacts {
    id
    firstName
    lastName
    position
    email
    phone
  }
  shopVisible
}
    `;
export const MyTeamsPreviousLineupFragmentFragmentDoc = gql`
    fragment MyTeamsPreviousLineupFragment on MyTeamsGameTeam {
  previousRoundLineup {
    players {
      player {
        ... on Node {
          id
        }
        ... on MyTeamsParticipant {
          profile {
            id
            firstName
            lastName
          }
          permit {
            id
            fromDate
            toDate
          }
        }
        ... on MyTeamsParticipantFillInPlayer {
          participant {
            id
            profile {
              id
              firstName
              lastName
            }
            permit {
              id
              fromDate
              toDate
            }
          }
        }
      }
      playerPoints
      playerNumber
      playerPosition {
        label
        shortName
        positionType
        order
      }
      captain {
        name
        value
        shortName
      }
      lineupOrder
    }
  }
}
    `;
export const MyTeamsPossibleTeamFragmentFragmentDoc = gql`
    fragment MyTeamsPossibleTeamFragment on MyTeamsPossibleTeam {
  ... on ProvisionalTeam {
    name
    pool {
      id
      name
    }
  }
  ... on MyTeamsTeam {
    id
    name
    logo {
      sizes {
        url
        dimensions {
          width
          height
        }
      }
    }
    season {
      id
      name
      competition {
        id
        name
      }
    }
    organisation {
      id
      name
      type
    }
    playerPointsCap
  }
}
    `;
export const OrganisationDetailsFragmentDoc = gql`
    fragment OrganisationDetails on DiscoverOrganisation {
  id
  type
  name
  email
  contactNumber
  websiteUrl
  address {
    id
    line1
    suburb
    postcode
    state
    country
  }
  logo {
    sizes {
      url
      dimensions {
        width
        height
      }
    }
  }
  contacts {
    id
    firstName
    lastName
    position
    email
    phone
  }
  shopVisible
}
    `;
export const MyTeamsGameDetailsFragmentFragmentDoc = gql`
    fragment MyTeamsGameDetailsFragment on MyTeamsGame {
  id
  away {
    ...MyTeamsPossibleTeamFragment
  }
  home {
    ...MyTeamsPossibleTeamFragment
  }
  result {
    winner {
      name
      value
    }
    outcome {
      name
      value
    }
    home {
      outcome {
        name
        value
      }
      statistics {
        count
        type {
          value
        }
      }
      periods {
        period {
          label
          value
        }
        type
        closureStatus
        statistics {
          count
          type {
            label
            value
          }
        }
      }
      gameOutcomeDescription
    }
    away {
      outcome {
        name
        value
      }
      statistics {
        count
        type {
          value
        }
      }
      periods {
        period {
          label
          value
        }
        type
        closureStatus
        statistics {
          count
          type {
            label
            value
          }
        }
      }
    }
  }
  status {
    name
    value
  }
  round {
    id
    name
    abbreviatedName
    grade {
      id
      name
      day {
        name
        value
      }
      hideScores
      season {
        id
        name
        competition {
          id
          name
          organisation {
            ...OrganisationDetails
          }
        }
      }
      gameEvents {
        participantEvents {
          type
          label
          shortName
          value
          pointValue
          applicableTo
          advanced
        }
        periodEvents {
          label
          shortName
          value
          pointValue
        }
        teamEvents {
          label
          value
          pointValue
          shortName
        }
      }
      hasPeriodScores
      periodScoresDisplayType {
        name
        value
      }
      periods {
        label
        shortName
        value
      }
      playerPoints {
        enforceTeamTotalCap
        teamPlayerPointsCap
      }
      bestPlayers {
        max
      }
      gameStatisticsConfiguration {
        gameStatistics(filter: $gameStatisticsFilter) {
          type
          glossary {
            default {
              name
              shortName
              message
              labelName
            }
            scoring {
              name
              shortName
              message
              labelName
            }
          }
          value
          pointValue
          applicableTo
          required
          max
        }
      }
    }
  }
  date
  allocation {
    time
    court {
      id
      abbreviatedName
      name
      venue {
        id
        name
        latitude
        longitude
        address
        suburb
        state
        postcode
      }
    }
  }
  statistics {
    home {
      ...MyTeamsGameTeamStatisticsFragment
    }
    away {
      ...MyTeamsGameTeamStatisticsFragment
    }
    shared {
      period {
        label
        shortName
        value
      }
      type
      status
      statistics {
        count
        type {
          value
        }
      }
      side
      players {
        playerID
        teamID
        role
      }
      dismissalType
      displayOrder
    }
  }
  hasManagementAccess
  managementAuthorisation {
    resultAndPeriodScores {
      read
      write
    }
    home {
      lineUp {
        read
        write
      }
      stats {
        read
        write
      }
    }
    away {
      lineUp {
        read
        write
      }
      stats {
        read
        write
      }
    }
    gameSheet
  }
  startDateTime
  clubScoringAccess {
    temporaryAccessEnabled
    endDateTime
  }
  hasOvertime
  gameType {
    value
    overs
    playerPositionsSettings {
      enabled
      enforcePositions
      isInGamePositionsLineupVisible
    }
    eScoringSettings {
      dismissalsPerBatter
      legalBallsPerOver
    }
    hasSuperOver
    emergencyPlayersSettings {
      enabled
      max
      min
      includeInLineupLimit
    }
    maxBattersPerInnings
    lineupLimits {
      players {
        min
        max
      }
      coaches {
        min
        max
      }
    }
    hasManualBonusPoints
    manualBonusPoints
    periodLength
  }
  gameTeams {
    home {
      ...MyTeamsGameTeamFragment
    }
    away {
      ...MyTeamsGameTeamFragment
    }
  }
}
    ${MyTeamsPossibleTeamFragmentFragmentDoc}
${OrganisationDetailsFragmentDoc}
${MyTeamsGameTeamStatisticsFragmentFragmentDoc}
${MyTeamsGameTeamFragmentFragmentDoc}`;
export const TenantContactRolesConfigurationFragmentDoc = gql`
    fragment TenantContactRolesConfiguration on TenantConfiguration {
  contactRoles {
    name
    value
  }
}
    `;
export const ExternalAccountLinkingFragmentDoc = gql`
    fragment ExternalAccountLinking on TenantConfiguration {
  externalAccountLinking {
    enabled
    authUri
    clientID
    redirectUri
    shouldLinkSSOInRegistrationFlow
  }
}
    `;
export const ProductFragmentFragmentDoc = gql`
    fragment ProductFragment on Product {
  id
  name
  description
  productType
  settings {
    validFrom {
      date
    }
    validTo {
      date
    }
  }
  variants {
    id
    name
    amount {
      net
    }
    available
    categoryPairs {
      id
      category {
        id
        name
      }
      option {
        id
        name
      }
    }
  }
  categories {
    id
    name
    options {
      id
      name
    }
  }
  customFields {
    id
    question
    type
    dropdownOptions {
      id
      label
    }
    option {
      category {
        id
      }
      option {
        id
      }
    }
  }
  images {
    sizes {
      url
      dimensions {
        width
      }
    }
  }
  registrationSettings {
    required
    maxQuantity
  }
}
    `;
export const RoundFixtureDiscoverTeamFragmentFragmentDoc = gql`
    fragment RoundFixtureDiscoverTeamFragment on DiscoverTeam {
  id
  name
  logo {
    sizes {
      url
      dimensions {
        width
        height
      }
    }
  }
  season {
    id
    name
    competition {
      id
      name
    }
  }
  organisation {
    id
    name
    type
  }
}
    `;
export const RoundFixtureTeamFragmentFragmentDoc = gql`
    fragment RoundFixtureTeamFragment on DiscoverPossibleTeam {
  ... on ProvisionalTeam {
    name
    pool {
      id
      name
    }
  }
  ...RoundFixtureDiscoverTeamFragment
}
    ${RoundFixtureDiscoverTeamFragmentFragmentDoc}`;
export const RoundFixtureFragmentFragmentDoc = gql`
    fragment RoundFixtureFragment on DiscoverRoundFixture {
  byes {
    ...RoundFixtureDiscoverTeamFragment
  }
  games {
    id
    alias
    pool {
      id
      name
    }
    away {
      ...RoundFixtureTeamFragment
    }
    home {
      ...RoundFixtureTeamFragment
    }
    result {
      winner {
        name
        value
      }
      outcome {
        name
        value
      }
      home {
        outcome {
          name
          value
        }
        statistics {
          count
          type {
            value
          }
        }
        periods {
          period {
            label
            value
          }
          type
          closureStatus
          statistics {
            count
            type {
              label
              value
            }
          }
        }
        gameOutcomeDescription
      }
      away {
        outcome {
          name
          value
        }
        statistics {
          count
          type {
            value
          }
        }
        periods {
          period {
            label
            value
          }
          type
          closureStatus
          statistics {
            count
            type {
              label
              value
            }
          }
        }
      }
    }
    status {
      name
      value
    }
    date
    dates
    allocation {
      time
      dateTimeList {
        date
        time
      }
      court {
        id
        name
        abbreviatedName
        latitude
        longitude
        venue {
          id
          name
          abbreviatedName
          latitude
          longitude
          address
          suburb
          state
          postcode
          country
        }
      }
    }
    isStale
    gameType {
      name
      value
      eScoringSettings {
        dismissalsPerBatter
        legalBallsPerOver
      }
    }
  }
}
    ${RoundFixtureDiscoverTeamFragmentFragmentDoc}
${RoundFixtureTeamFragmentFragmentDoc}`;
export const CartFragmentFragmentDoc = gql`
    fragment CartFragment on Cart {
  items {
    discount {
      id
      amount {
        net
      }
      name
    }
    fee {
      ... on MerchandiseFee {
        amount {
          currency {
            code
          }
          net
        }
        description
        organisation {
          id
          name
        }
        quantity
        productVariantID
        fulfilmentMethod
        customFieldAnswers {
          customField {
            id
          }
          answer
        }
      }
      ... on ParticipantFee {
        id
        amount {
          currency {
            code
          }
          net
        }
        amountDeferred {
          currency {
            code
            __typename
          }
          net
          __typename
        }
        description
        organisation {
          id
          name
        }
        quantity
        selectedOption {
          id
        }
        options {
          id
          amount {
            currency {
              code
            }
            net
          }
          description
        }
      }
      ... on MembershipAdvancedFee {
        amount {
          currency {
            code
          }
          net
        }
        description
        applicationRole
        applicationDescription
        organisation {
          id
          name
        }
        quantity
        selectedPayment {
          id
        }
        payments {
          id
          type
          amount {
            net
          }
        }
      }
    }
    discount {
      id
      name
      amount {
        currency {
          code
        }
        net
      }
      organisation {
        id
        name
      }
    }
  }
  totals {
    vouchers {
      id
      name
      code
      amount {
        currency {
          code
        }
        net
      }
      organisation {
        id
        name
      }
    }
    promotionalVouchers {
      id
      name
      code
      amount {
        currency {
          code
        }
        net
      }
      organisations {
        id
        name
      }
    }
    externalVouchers {
      scheme {
        id
        name
        hasAmount
      }
      code
      amount {
        currency {
          code
        }
        net
      }
      organisations {
        id
        name
      }
      isExistingMember
      identifiedDisability
      culturalLinguisticDiversity
      aboriginalOrTorresStraightIslander
      englishMainLanguageSpokenAtHome
      alternativeMainLanguageSpokenAtHome
      costToRegisterForActivity
    }
    totalAmount {
      currency {
        code
      }
      net
    }
    subTotalAmount {
      currency {
        code
      }
      net
    }
    serviceFeeAmount {
      currency {
        code
      }
      net
    }
    shippingFeeAmount {
      currency {
        code
      }
      net
    }
    deferredSubtotalAmount {
      currency {
        code
      }
      net
    }
    deferredServiceFeeAmount {
      currency {
        code
      }
      net
    }
    selectedCharities {
      ...SelectedCharitiesFragment
    }
  }
  productsAmount {
    currency {
      code
    }
    net
  }
  feesAmount {
    currency {
      code
    }
    net
  }
  availableExternalVouchers {
    scheme {
      id
      name
      externalOwner
      hasAmount
      minAmount
      maxAmount
    }
  }
  availableCharities {
    ...AvailableCharitiesFragment
  }
}
    ${SelectedCharitiesFragmentFragmentDoc}
${AvailableCharitiesFragmentFragmentDoc}`;
export const TeamCartFragmentFragmentDoc = gql`
    fragment TeamCartFragment on Cart {
  items {
    fee {
      ... on MerchandiseFee {
        amount {
          currency {
            code
          }
          net
        }
        description
        organisation {
          id
          name
        }
        quantity
        productVariantID
        fulfilmentMethod
        customFieldAnswers {
          customField {
            id
          }
          answer
        }
      }
      ... on TeamFee {
        id
        amount {
          currency {
            code
          }
          net
        }
        description
        organisation {
          id
          name
        }
        quantity
      }
    }
  }
  totals {
    vouchers {
      id
      name
      code
      amount {
        currency {
          code
        }
        net
      }
      organisation {
        id
        name
      }
    }
    promotionalVouchers {
      id
      name
      code
      amount {
        currency {
          code
        }
        net
      }
      organisations {
        id
        name
      }
    }
    externalVouchers {
      scheme {
        id
        name
        hasAmount
      }
      code
      amount {
        currency {
          code
        }
        net
      }
      organisations {
        id
        name
      }
    }
    totalAmount {
      currency {
        code
      }
      net
    }
    subTotalAmount {
      currency {
        code
      }
      net
    }
    serviceFeeAmount {
      currency {
        code
      }
      net
    }
    shippingFeeAmount {
      currency {
        code
      }
      net
    }
    deferredSubtotalAmount {
      currency {
        code
      }
      net
    }
    deferredServiceFeeAmount {
      currency {
        code
      }
      net
    }
  }
  productsAmount {
    currency {
      code
    }
    net
  }
  feesAmount {
    currency {
      code
    }
    net
  }
}
    `;
export const DiscoverTeamFragmentFragmentDoc = gql`
    fragment DiscoverTeamFragment on DiscoverTeam {
  id
  name
  logo {
    sizes {
      url
      dimensions {
        width
        height
      }
    }
  }
  season {
    id
    name
    competition {
      id
      name
    }
  }
  organisation {
    id
    name
    type
  }
  playerPointsCap
}
    `;
export const TeamFragmentFragmentDoc = gql`
    fragment TeamFragment on DiscoverPossibleTeam {
  ... on ProvisionalTeam {
    name
    pool {
      id
      name
    }
  }
  ...DiscoverTeamFragment
}
    ${DiscoverTeamFragmentFragmentDoc}`;
export const IncidentGameTeamFieldsFragmentDoc = gql`
    fragment IncidentGameTeamFields on MyTeamsGameTeam {
  lineup {
    players {
      selected
      participant {
        ... on MyTeamsParticipant {
          id
          profile {
            id
            firstName
            lastName
          }
        }
        ... on MyTeamsParticipantFillInPlayer {
          id
          participant {
            id
            profile {
              id
              firstName
              lastName
            }
          }
        }
        ... on MyTeamsGamePermitFillInPlayer {
          id
          profile {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
}
    `;
export const IncidentGameFieldsFragmentDoc = gql`
    fragment IncidentGameFields on MyTeamsGame {
  id
  dates
  home {
    ... on MyTeamsTeam {
      id
    }
  }
  away {
    ... on MyTeamsTeam {
      id
    }
  }
  teams {
    home {
      ...IncidentGameTeamFields
    }
    away {
      ...IncidentGameTeamFields
    }
  }
}
    ${IncidentGameTeamFieldsFragmentDoc}`;
export const IncidentFieldsFragmentDoc = gql`
    fragment IncidentFields on Incident {
  id
  note
  status
  participant {
    id
    profile {
      id
      firstName
      lastName
    }
  }
  profile {
    id
    firstName
    lastName
  }
  outcome {
    id
    note
    ... on ConcussionOutcome {
      clearance {
        returnDate
        doctor
        medicalFacilityAddress
        medicalFacilityContactNumber
        providerID
      }
    }
  }
  createdAt
  seasonName
  owningOrganisation {
    id
    name
  }
  incidentDate
  type
  category
  game {
    ...IncidentGameFields
  }
  team {
    ... on MyTeamsTeam {
      id
      organisation {
        id
        name
      }
    }
  }
}
    ${IncidentGameFieldsFragmentDoc}`;
export const MyTeamsSquadProfileFragmentFragmentDoc = gql`
    fragment MyTeamsSquadProfileFragment on MyTeamsProfile {
  id
  firstName
  lastName
  preferredName
  email
  mobileNumber {
    displayNumber
  }
  homeNumber
  accountManagedBy {
    id
    firstName
    lastName
    email
    mobileNumber {
      displayNumber
    }
    homeNumber
  }
  emergencyContact {
    id
    firstName
    lastName
    email
    mobileNumber {
      displayNumber
    }
    relation
  }
  guardians {
    ... on MyTeamsGuardian {
      firstName
      lastName
      email
      mobileNumber {
        displayNumber
      }
    }
    ... on MyTeamsProfile {
      id
      firstName
      lastName
      email
      mobileNumber {
        displayNumber
      }
      homeNumber
    }
  }
}
    `;
export const PostProductFragmentDoc = gql`
    fragment PostProduct on Product {
  id
  name
  activeShop
  productType
  variants {
    amount {
      net
    }
  }
  images {
    sizes {
      url
    }
  }
}
    `;
export const HistoryFragmentFragmentDoc = gql`
    fragment HistoryFragment on Profile {
  id
  registrationHistory {
    ... on DiscoverTeam {
      id
      name
      preferredGrade
      registeredDate
      season {
        ... on DiscoverSeason {
          id
          name
          competition {
            id
            name
            organisation {
              id
              name
            }
          }
          availableRegistrations {
            id
            type
            registrationCode
          }
        }
      }
    }
    ... on Participant {
      id
      type
      displayName
      gender
      dateOfBirth
      wwcNumber
      wwcExpiryDate
      wwcStateOfIssue
      coachingAccreditationLevel
      teamName
      school
      schoolYear
      seasonRegistration {
        id
        type
        season {
          ... on ProgramSeason {
            id
            name
            program {
              id
              name
              alias
            }
          }
          ... on DiscoverSeason {
            id
            name
            competition {
              id
              name
              organisation {
                id
                name
              }
            }
          }
        }
        organisation {
          id
          name
        }
      }
      registeredAt
      cancelledAt
      preferredGroup {
        id
        name
      }
      permit {
        id
        fromDate
        toDate
      }
    }
  }
}
    `;
export const ProfileMembershipsWithOrgFragmentFragmentDoc = gql`
    fragment ProfileMembershipsWithOrgFragment on Profile {
  id
  memberships {
    id
    application {
      id
      name
      role {
        name
        value
      }
    }
    history {
      id
      startDate
      expiryDate
      purchaseDate
      source
    }
    organisation {
      id
      name
    }
  }
}
    `;
export const ProfileTeamsFragmentDoc = gql`
    fragment ProfileTeams on Profile {
  id
  myTeamsList {
    results {
      id
      name
      grade {
        id
        name
      }
      season {
        id
        name
        status {
          name
          value
        }
      }
      logo {
        sizes {
          url
          dimensions {
            width
            height
          }
        }
      }
    }
  }
}
    `;
export const RegistrationHistoryFragmentFragmentDoc = gql`
    fragment RegistrationHistoryFragment on Profile {
  id
  registrationHistory {
    ... on Participant {
      id
      type
      seasonRegistration {
        id
        season {
          ... on DiscoverSeason {
            id
            competition {
              id
            }
          }
          ... on ProgramSeason {
            id
            program {
              id
            }
          }
        }
        organisation {
          id
        }
      }
    }
  }
}
    `;
export const DiscoverSeasonDetailsFragmentDoc = gql`
    fragment DiscoverSeasonDetails on DiscoverSeason {
  id
  name
  competition {
    id
    name
    organisation {
      id
      name
    }
  }
}
    `;
export const ProgramSeasonDetailsFragmentDoc = gql`
    fragment ProgramSeasonDetails on ProgramSeason {
  id
  name
  program {
    id
    name
    alias
  }
}
    `;
export const SearchAddressesDocument = gql`
    query searchAddresses($filter: SearchAddressesFilter!) {
  searchAddresses(filter: $filter)
}
    `;

/**
 * __useSearchAddressesQuery__
 *
 * To run a query within a React component, call `useSearchAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAddressesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchAddressesQuery(baseOptions: Apollo.QueryHookOptions<SearchAddressesQuery, SearchAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAddressesQuery, SearchAddressesQueryVariables>(SearchAddressesDocument, options);
      }
export function useSearchAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAddressesQuery, SearchAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAddressesQuery, SearchAddressesQueryVariables>(SearchAddressesDocument, options);
        }
export type SearchAddressesQueryHookResult = ReturnType<typeof useSearchAddressesQuery>;
export type SearchAddressesLazyQueryHookResult = ReturnType<typeof useSearchAddressesLazyQuery>;
export type SearchAddressesQueryResult = Apollo.QueryResult<SearchAddressesQuery, SearchAddressesQueryVariables>;
export const AddressDocument = gql`
    query address($filter: String!) {
  address(filter: $filter) {
    streetLine
    suburb
    state
    postcode
  }
}
    `;

/**
 * __useAddressQuery__
 *
 * To run a query within a React component, call `useAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddressQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useAddressQuery(baseOptions: Apollo.QueryHookOptions<AddressQuery, AddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddressQuery, AddressQueryVariables>(AddressDocument, options);
      }
export function useAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddressQuery, AddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddressQuery, AddressQueryVariables>(AddressDocument, options);
        }
export type AddressQueryHookResult = ReturnType<typeof useAddressQuery>;
export type AddressLazyQueryHookResult = ReturnType<typeof useAddressLazyQuery>;
export type AddressQueryResult = Apollo.QueryResult<AddressQuery, AddressQueryVariables>;
export const AppBannerDocument = gql`
    query appBanner {
  tenantConfiguration {
    externalAppUrls {
      name
      value
      url
    }
    outswingConfiguration {
      value
    }
  }
}
    `;

/**
 * __useAppBannerQuery__
 *
 * To run a query within a React component, call `useAppBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppBannerQuery(baseOptions?: Apollo.QueryHookOptions<AppBannerQuery, AppBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppBannerQuery, AppBannerQueryVariables>(AppBannerDocument, options);
      }
export function useAppBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppBannerQuery, AppBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppBannerQuery, AppBannerQueryVariables>(AppBannerDocument, options);
        }
export type AppBannerQueryHookResult = ReturnType<typeof useAppBannerQuery>;
export type AppBannerLazyQueryHookResult = ReturnType<typeof useAppBannerLazyQuery>;
export type AppBannerQueryResult = Apollo.QueryResult<AppBannerQuery, AppBannerQueryVariables>;
export const AppFooterBannerDocument = gql`
    query appFooterBanner {
  tenantConfiguration {
    outswingConfiguration {
      value
    }
  }
}
    `;

/**
 * __useAppFooterBannerQuery__
 *
 * To run a query within a React component, call `useAppFooterBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppFooterBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppFooterBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppFooterBannerQuery(baseOptions?: Apollo.QueryHookOptions<AppFooterBannerQuery, AppFooterBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppFooterBannerQuery, AppFooterBannerQueryVariables>(AppFooterBannerDocument, options);
      }
export function useAppFooterBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppFooterBannerQuery, AppFooterBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppFooterBannerQuery, AppFooterBannerQueryVariables>(AppFooterBannerDocument, options);
        }
export type AppFooterBannerQueryHookResult = ReturnType<typeof useAppFooterBannerQuery>;
export type AppFooterBannerLazyQueryHookResult = ReturnType<typeof useAppFooterBannerLazyQuery>;
export type AppFooterBannerQueryResult = Apollo.QueryResult<AppFooterBannerQuery, AppFooterBannerQueryVariables>;
export const AppPromoBannerDocument = gql`
    query appPromoBanner {
  tenantConfiguration {
    outswingConfiguration {
      value
    }
  }
}
    `;

/**
 * __useAppPromoBannerQuery__
 *
 * To run a query within a React component, call `useAppPromoBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppPromoBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppPromoBannerQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppPromoBannerQuery(baseOptions?: Apollo.QueryHookOptions<AppPromoBannerQuery, AppPromoBannerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppPromoBannerQuery, AppPromoBannerQueryVariables>(AppPromoBannerDocument, options);
      }
export function useAppPromoBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppPromoBannerQuery, AppPromoBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppPromoBannerQuery, AppPromoBannerQueryVariables>(AppPromoBannerDocument, options);
        }
export type AppPromoBannerQueryHookResult = ReturnType<typeof useAppPromoBannerQuery>;
export type AppPromoBannerLazyQueryHookResult = ReturnType<typeof useAppPromoBannerLazyQuery>;
export type AppPromoBannerQueryResult = Apollo.QueryResult<AppPromoBannerQuery, AppPromoBannerQueryVariables>;
export const CheckoutSessionCreateDocument = gql`
    mutation checkoutSessionCreate($input: CheckoutSessionCreateInput) {
  checkoutSessionCreate(input: $input) {
    ... on Gr4vyCheckoutSession {
      id
      expiryDate
      browser
    }
    ... on Gr4vyEmbedCheckoutSession {
      id
      expiryDate
      embedToken
    }
    __typename
  }
}
    `;
export type CheckoutSessionCreateMutationFn = Apollo.MutationFunction<CheckoutSessionCreateMutation, CheckoutSessionCreateMutationVariables>;

/**
 * __useCheckoutSessionCreateMutation__
 *
 * To run a mutation, you first call `useCheckoutSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckoutSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkoutSessionCreateMutation, { data, loading, error }] = useCheckoutSessionCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckoutSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<CheckoutSessionCreateMutation, CheckoutSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckoutSessionCreateMutation, CheckoutSessionCreateMutationVariables>(CheckoutSessionCreateDocument, options);
      }
export type CheckoutSessionCreateMutationHookResult = ReturnType<typeof useCheckoutSessionCreateMutation>;
export type CheckoutSessionCreateMutationResult = Apollo.MutationResult<CheckoutSessionCreateMutation>;
export type CheckoutSessionCreateMutationOptions = Apollo.BaseMutationOptions<CheckoutSessionCreateMutation, CheckoutSessionCreateMutationVariables>;
export const GameViewDocument = gql`
    query gameView($gameId: ID!, $gameStatisticsFilter: GameStatisticsFilter!) {
  discoverGame(gameID: $gameId) {
    id
    alias
    away {
      ...TeamFragment
    }
    home {
      ...TeamFragment
    }
    result {
      winner {
        name
        value
      }
      outcome {
        name
        value
      }
      home {
        score
        outcome {
          name
          value
        }
        statistics {
          count
          type {
            value
          }
        }
        periods {
          period {
            label
            value
          }
          type
          closureStatus
          statistics {
            count
            type {
              label
              value
            }
          }
        }
        gameOutcomeDescription
      }
      away {
        score
        outcome {
          name
          value
        }
        statistics {
          count
          type {
            value
          }
        }
        periods {
          period {
            label
            value
          }
          type
          closureStatus
          statistics {
            count
            type {
              label
              value
            }
          }
        }
      }
    }
    status {
      name
      value
    }
    round {
      id
      name
      abbreviatedName
      grade {
        id
        name
        day {
          name
          value
        }
        hideScores
        season {
          id
          name
          competition {
            id
            name
            organisation {
              ...OrganisationDetails
            }
          }
        }
        gameEvents {
          participantEvents {
            type
            label
            shortName
            value
            pointValue
            applicableTo
            advanced
          }
          periodEvents {
            value
          }
        }
        hasPeriodScores
        periodScoresDisplayType {
          name
          value
        }
        periods {
          shortName
          value
        }
        playerPoints {
          enforceTeamTotalCap
          teamPlayerPointsCap
          publicVisible
        }
        bestPlayers {
          max
        }
        gameStatisticsConfiguration {
          gameStatistics(filter: $gameStatisticsFilter) {
            type
            glossary {
              default {
                name
                shortName
                message
                labelName
              }
              scoring {
                name
                shortName
                message
                labelName
              }
            }
            value
            pointValue
            applicableTo
            required
            max
          }
        }
        lineupRemainsWhenGameStarted
      }
    }
    date
    dates
    allocation {
      time
      dateTimeList {
        date
        time
      }
      court {
        id
        abbreviatedName
        name
        venue {
          id
          name
          latitude
          longitude
          address
          suburb
          state
          postcode
        }
      }
    }
    statistics {
      home {
        ...GameViewGameTeamStatisticsFragment
      }
      away {
        ...GameViewGameTeamStatisticsFragment
      }
      shared {
        period {
          label
          shortName
          value
        }
        type
        status
        statistics {
          count
          type {
            value
          }
        }
        side
        players {
          playerID
          teamID
          role
        }
        dismissalType
        displayOrder
      }
    }
    publishLineup
    gameType {
      name
      value
      maxBattersPerInnings
      eScoringSettings {
        dismissalsPerBatter
        legalBallsPerOver
      }
      emergencyPlayersSettings {
        enabled
      }
      playerPositionsSettings {
        isInGamePositionsLineupVisible
      }
      clockType
    }
    formation {
      template
    }
  }
  tenantConfiguration {
    label
    statistics {
      enabled
    }
    showPlayerPositionsInLineup
    showDuckIconInBattingTable
    periodType {
      value
    }
    gameTypes {
      gameType {
        value
      }
      gameTypeFeatures {
        lineupOrderingEnabled
      }
    }
    ...TenantContactRolesConfiguration
  }
}
    ${TeamFragmentFragmentDoc}
${OrganisationDetailsFragmentDoc}
${GameViewGameTeamStatisticsFragmentFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useGameViewQuery__
 *
 * To run a query within a React component, call `useGameViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameViewQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      gameStatisticsFilter: // value for 'gameStatisticsFilter'
 *   },
 * });
 */
export function useGameViewQuery(baseOptions: Apollo.QueryHookOptions<GameViewQuery, GameViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameViewQuery, GameViewQueryVariables>(GameViewDocument, options);
      }
export function useGameViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameViewQuery, GameViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameViewQuery, GameViewQueryVariables>(GameViewDocument, options);
        }
export type GameViewQueryHookResult = ReturnType<typeof useGameViewQuery>;
export type GameViewLazyQueryHookResult = ReturnType<typeof useGameViewLazyQuery>;
export type GameViewQueryResult = Apollo.QueryResult<GameViewQuery, GameViewQueryVariables>;
export const OrderIdentifierGenerateDocument = gql`
    mutation orderIdentifierGenerate {
  orderIdentifierGenerate
}
    `;
export type OrderIdentifierGenerateMutationFn = Apollo.MutationFunction<OrderIdentifierGenerateMutation, OrderIdentifierGenerateMutationVariables>;

/**
 * __useOrderIdentifierGenerateMutation__
 *
 * To run a mutation, you first call `useOrderIdentifierGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderIdentifierGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderIdentifierGenerateMutation, { data, loading, error }] = useOrderIdentifierGenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useOrderIdentifierGenerateMutation(baseOptions?: Apollo.MutationHookOptions<OrderIdentifierGenerateMutation, OrderIdentifierGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderIdentifierGenerateMutation, OrderIdentifierGenerateMutationVariables>(OrderIdentifierGenerateDocument, options);
      }
export type OrderIdentifierGenerateMutationHookResult = ReturnType<typeof useOrderIdentifierGenerateMutation>;
export type OrderIdentifierGenerateMutationResult = Apollo.MutationResult<OrderIdentifierGenerateMutation>;
export type OrderIdentifierGenerateMutationOptions = Apollo.BaseMutationOptions<OrderIdentifierGenerateMutation, OrderIdentifierGenerateMutationVariables>;
export const GradeAllRoundsDocument = gql`
    query gradeAllRounds($gradeID: ID!) {
  discoverGradeFixture(gradeID: $gradeID) {
    id
    name
    provisionalDates
    isFinalsRound
    grade {
      type
      hideScores
    }
    byes {
      id
      name
      logo {
        sizes {
          url
          dimensions {
            width
            height
          }
        }
      }
      season {
        id
        name
        competition {
          id
          name
        }
      }
      organisation {
        id
        name
        type
      }
    }
    games {
      id
      alias
      pool {
        id
        name
      }
      away {
        ... on ProvisionalTeam {
          name
          pool {
            id
            name
          }
        }
        ... on DiscoverTeam {
          id
          name
          logo {
            sizes {
              url
              dimensions {
                width
                height
              }
            }
          }
          season {
            id
            name
            competition {
              id
              name
            }
          }
          organisation {
            id
            name
            type
          }
        }
      }
      home {
        ... on ProvisionalTeam {
          name
          pool {
            id
            name
          }
        }
        ... on DiscoverTeam {
          id
          name
          logo {
            sizes {
              url
              dimensions {
                width
                height
              }
            }
          }
          season {
            id
            name
            competition {
              id
              name
            }
          }
          organisation {
            id
            name
            type
          }
        }
      }
      result {
        winner {
          name
          value
        }
        outcome {
          name
          value
        }
        home {
          outcome {
            name
            value
          }
          statistics {
            count
            type {
              value
            }
          }
          periods {
            period {
              label
              value
            }
            type
            closureStatus
            statistics {
              count
              type {
                label
                value
              }
            }
          }
          gameOutcomeDescription
        }
        away {
          outcome {
            name
            value
          }
          statistics {
            count
            type {
              value
            }
          }
          periods {
            period {
              label
              value
            }
            type
            closureStatus
            statistics {
              count
              type {
                label
                value
              }
            }
          }
        }
      }
      status {
        name
        value
      }
      date
      dates
      allocation {
        dateTimeList {
          date
          time
        }
        time
        court {
          id
          name
          abbreviatedName
          latitude
          longitude
          venue {
            id
            name
            abbreviatedName
            latitude
            longitude
            address
            suburb
            state
            postcode
            country
          }
        }
      }
      gameType {
        name
        value
        eScoringSettings {
          dismissalsPerBatter
          legalBallsPerOver
        }
      }
    }
  }
  tenantConfiguration {
    label
    gradeTypes {
      value
      isAllPlay
      features {
        hasRounds
        hasSeasonStats
        hasCareerStats
        hasGameStats
        hasFixture
        hasLadder
      }
    }
  }
}
    `;

/**
 * __useGradeAllRoundsQuery__
 *
 * To run a query within a React component, call `useGradeAllRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradeAllRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradeAllRoundsQuery({
 *   variables: {
 *      gradeID: // value for 'gradeID'
 *   },
 * });
 */
export function useGradeAllRoundsQuery(baseOptions: Apollo.QueryHookOptions<GradeAllRoundsQuery, GradeAllRoundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GradeAllRoundsQuery, GradeAllRoundsQueryVariables>(GradeAllRoundsDocument, options);
      }
export function useGradeAllRoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GradeAllRoundsQuery, GradeAllRoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GradeAllRoundsQuery, GradeAllRoundsQueryVariables>(GradeAllRoundsDocument, options);
        }
export type GradeAllRoundsQueryHookResult = ReturnType<typeof useGradeAllRoundsQuery>;
export type GradeAllRoundsLazyQueryHookResult = ReturnType<typeof useGradeAllRoundsLazyQuery>;
export type GradeAllRoundsQueryResult = Apollo.QueryResult<GradeAllRoundsQuery, GradeAllRoundsQueryVariables>;
export const GradeRoundsDocument = gql`
    query gradeRounds($gradeID: ID!) {
  discoverGrade(gradeID: $gradeID) {
    id
    name
    type
    hideScores
    rounds {
      id
      name
      abbreviatedName
      current
      number
      isFinalsRound
      provisionalDates
    }
    season {
      id
      competition {
        id
        organisation {
          id
          name
        }
      }
    }
  }
  tenantConfiguration {
    label
    gradeTypes {
      value
      isAllPlay
      features {
        hasRounds
        hasSeasonStats
        hasCareerStats
        hasGameStats
        hasFixture
        hasLadder
      }
    }
  }
}
    `;

/**
 * __useGradeRoundsQuery__
 *
 * To run a query within a React component, call `useGradeRoundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradeRoundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradeRoundsQuery({
 *   variables: {
 *      gradeID: // value for 'gradeID'
 *   },
 * });
 */
export function useGradeRoundsQuery(baseOptions: Apollo.QueryHookOptions<GradeRoundsQuery, GradeRoundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GradeRoundsQuery, GradeRoundsQueryVariables>(GradeRoundsDocument, options);
      }
export function useGradeRoundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GradeRoundsQuery, GradeRoundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GradeRoundsQuery, GradeRoundsQueryVariables>(GradeRoundsDocument, options);
        }
export type GradeRoundsQueryHookResult = ReturnType<typeof useGradeRoundsQuery>;
export type GradeRoundsLazyQueryHookResult = ReturnType<typeof useGradeRoundsLazyQuery>;
export type GradeRoundsQueryResult = Apollo.QueryResult<GradeRoundsQuery, GradeRoundsQueryVariables>;
export const DiscoverFixtureByRoundDocument = gql`
    query discoverFixtureByRound($roundID: ID!) {
  discoverFixtureByRound(roundID: $roundID) {
    ...RoundFixtureFragment
  }
}
    ${RoundFixtureFragmentFragmentDoc}`;

/**
 * __useDiscoverFixtureByRoundQuery__
 *
 * To run a query within a React component, call `useDiscoverFixtureByRoundQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverFixtureByRoundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverFixtureByRoundQuery({
 *   variables: {
 *      roundID: // value for 'roundID'
 *   },
 * });
 */
export function useDiscoverFixtureByRoundQuery(baseOptions: Apollo.QueryHookOptions<DiscoverFixtureByRoundQuery, DiscoverFixtureByRoundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverFixtureByRoundQuery, DiscoverFixtureByRoundQueryVariables>(DiscoverFixtureByRoundDocument, options);
      }
export function useDiscoverFixtureByRoundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverFixtureByRoundQuery, DiscoverFixtureByRoundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverFixtureByRoundQuery, DiscoverFixtureByRoundQueryVariables>(DiscoverFixtureByRoundDocument, options);
        }
export type DiscoverFixtureByRoundQueryHookResult = ReturnType<typeof useDiscoverFixtureByRoundQuery>;
export type DiscoverFixtureByRoundLazyQueryHookResult = ReturnType<typeof useDiscoverFixtureByRoundLazyQuery>;
export type DiscoverFixtureByRoundQueryResult = Apollo.QueryResult<DiscoverFixtureByRoundQuery, DiscoverFixtureByRoundQueryVariables>;
export const SearchRegisteredPlayerDocument = gql`
    query searchRegisteredPlayer($filter: MyTeamsParticipantsFilter!) {
  myTeamsParticipants(filter: $filter) {
    result {
      id
      permit {
        id
        fromDate
        toDate
      }
      profile {
        id
        firstName
        lastName
      }
      playerPoints
      teams {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSearchRegisteredPlayerQuery__
 *
 * To run a query within a React component, call `useSearchRegisteredPlayerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRegisteredPlayerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRegisteredPlayerQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchRegisteredPlayerQuery(baseOptions: Apollo.QueryHookOptions<SearchRegisteredPlayerQuery, SearchRegisteredPlayerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchRegisteredPlayerQuery, SearchRegisteredPlayerQueryVariables>(SearchRegisteredPlayerDocument, options);
      }
export function useSearchRegisteredPlayerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchRegisteredPlayerQuery, SearchRegisteredPlayerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchRegisteredPlayerQuery, SearchRegisteredPlayerQueryVariables>(SearchRegisteredPlayerDocument, options);
        }
export type SearchRegisteredPlayerQueryHookResult = ReturnType<typeof useSearchRegisteredPlayerQuery>;
export type SearchRegisteredPlayerLazyQueryHookResult = ReturnType<typeof useSearchRegisteredPlayerLazyQuery>;
export type SearchRegisteredPlayerQueryResult = Apollo.QueryResult<SearchRegisteredPlayerQuery, SearchRegisteredPlayerQueryVariables>;
export const ValidateGameLineupDocument = gql`
    query validateGameLineup($input: GameTeamLineupValidateInput!) {
  gameTeamLineupValidate(input: $input) {
    entityID
    errors {
      value
      message
    }
  }
}
    `;

/**
 * __useValidateGameLineupQuery__
 *
 * To run a query within a React component, call `useValidateGameLineupQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateGameLineupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateGameLineupQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateGameLineupQuery(baseOptions: Apollo.QueryHookOptions<ValidateGameLineupQuery, ValidateGameLineupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateGameLineupQuery, ValidateGameLineupQueryVariables>(ValidateGameLineupDocument, options);
      }
export function useValidateGameLineupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateGameLineupQuery, ValidateGameLineupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateGameLineupQuery, ValidateGameLineupQueryVariables>(ValidateGameLineupDocument, options);
        }
export type ValidateGameLineupQueryHookResult = ReturnType<typeof useValidateGameLineupQuery>;
export type ValidateGameLineupLazyQueryHookResult = ReturnType<typeof useValidateGameLineupLazyQuery>;
export type ValidateGameLineupQueryResult = Apollo.QueryResult<ValidateGameLineupQuery, ValidateGameLineupQueryVariables>;
export const GameTeamAwardVotesUpdateDocument = gql`
    mutation gameTeamAwardVotesUpdate($input: GameTeamAwardVotesUpdateInput!) {
  gameTeamAwardVotesUpdate(input: $input) {
    isOpen
    configuration {
      awardName
      highestVote
      totalVoters
    }
    voteSlips {
      voterName
      voterNumber
    }
  }
}
    `;
export type GameTeamAwardVotesUpdateMutationFn = Apollo.MutationFunction<GameTeamAwardVotesUpdateMutation, GameTeamAwardVotesUpdateMutationVariables>;

/**
 * __useGameTeamAwardVotesUpdateMutation__
 *
 * To run a mutation, you first call `useGameTeamAwardVotesUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameTeamAwardVotesUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameTeamAwardVotesUpdateMutation, { data, loading, error }] = useGameTeamAwardVotesUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameTeamAwardVotesUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GameTeamAwardVotesUpdateMutation, GameTeamAwardVotesUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameTeamAwardVotesUpdateMutation, GameTeamAwardVotesUpdateMutationVariables>(GameTeamAwardVotesUpdateDocument, options);
      }
export type GameTeamAwardVotesUpdateMutationHookResult = ReturnType<typeof useGameTeamAwardVotesUpdateMutation>;
export type GameTeamAwardVotesUpdateMutationResult = Apollo.MutationResult<GameTeamAwardVotesUpdateMutation>;
export type GameTeamAwardVotesUpdateMutationOptions = Apollo.BaseMutationOptions<GameTeamAwardVotesUpdateMutation, GameTeamAwardVotesUpdateMutationVariables>;
export const MyTeamsGameManageDocument = gql`
    query myTeamsGameManage($gameId: ID!, $profileId: ID, $teamContextId: ID, $gameStatisticsFilter: GameStatisticsFilter!) {
  myTeamsGame(input: {gameID: $gameId, profileID: $profileId, teamContextID: $teamContextId}) {
    ...MyTeamsGameDetailsFragment
  }
  tenantConfiguration {
    label
    hasVolunteerRoles
    volunteerRoles {
      label
      number
      roleType
    }
    playerPositions {
      label
      shortName
      positionType
      lineupMax
    }
    playerDismissalTypes {
      name
      value
    }
    gameTypes {
      gameType {
        name
        value
      }
      closureStatusOptions {
        name
        value
      }
      gameOutcomeOverride {
        name
        value
      }
      possibleGameOutcomesMap {
        win
        labelWin
        loss
        labelLoss
      }
      gameTypeFeatures {
        lineupOrderingEnabled
        editIndividualPlayerStatistics
      }
    }
    canGenerateGameSheets
    showDuckIconInBattingTable
    captainOptions {
      name
      value
      shortName
    }
    offenceTypeOptions {
      value
      description
      applicableTo
    }
    outswingConfiguration {
      name
    }
  }
}
    ${MyTeamsGameDetailsFragmentFragmentDoc}`;

/**
 * __useMyTeamsGameManageQuery__
 *
 * To run a query within a React component, call `useMyTeamsGameManageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsGameManageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsGameManageQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      profileId: // value for 'profileId'
 *      teamContextId: // value for 'teamContextId'
 *      gameStatisticsFilter: // value for 'gameStatisticsFilter'
 *   },
 * });
 */
export function useMyTeamsGameManageQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsGameManageQuery, MyTeamsGameManageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsGameManageQuery, MyTeamsGameManageQueryVariables>(MyTeamsGameManageDocument, options);
      }
export function useMyTeamsGameManageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsGameManageQuery, MyTeamsGameManageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsGameManageQuery, MyTeamsGameManageQueryVariables>(MyTeamsGameManageDocument, options);
        }
export type MyTeamsGameManageQueryHookResult = ReturnType<typeof useMyTeamsGameManageQuery>;
export type MyTeamsGameManageLazyQueryHookResult = ReturnType<typeof useMyTeamsGameManageLazyQuery>;
export type MyTeamsGameManageQueryResult = Apollo.QueryResult<MyTeamsGameManageQuery, MyTeamsGameManageQueryVariables>;
export const GamePlayerUpdateDocument = gql`
    mutation gamePlayerUpdate($gameID: ID!, $input: MyTeamsGamePlayerUpdateInput!) {
  myTeamsGamePlayerUpdate(gameID: $gameID, input: $input) {
    myTeamsGame {
      ...MyTeamsGamePlayerUpdate
    }
  }
}
    ${MyTeamsGamePlayerUpdateFragmentDoc}`;
export type GamePlayerUpdateMutationFn = Apollo.MutationFunction<GamePlayerUpdateMutation, GamePlayerUpdateMutationVariables>;

/**
 * __useGamePlayerUpdateMutation__
 *
 * To run a mutation, you first call `useGamePlayerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGamePlayerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gamePlayerUpdateMutation, { data, loading, error }] = useGamePlayerUpdateMutation({
 *   variables: {
 *      gameID: // value for 'gameID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGamePlayerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GamePlayerUpdateMutation, GamePlayerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GamePlayerUpdateMutation, GamePlayerUpdateMutationVariables>(GamePlayerUpdateDocument, options);
      }
export type GamePlayerUpdateMutationHookResult = ReturnType<typeof useGamePlayerUpdateMutation>;
export type GamePlayerUpdateMutationResult = Apollo.MutationResult<GamePlayerUpdateMutation>;
export type GamePlayerUpdateMutationOptions = Apollo.BaseMutationOptions<GamePlayerUpdateMutation, GamePlayerUpdateMutationVariables>;
export const GameFillinPlayerUpdateDocument = gql`
    mutation gameFillinPlayerUpdate($gameID: ID!, $input: MyTeamsGamePlayerUpdateInput!) {
  myTeamsGameFillInPlayerUpdate(gameID: $gameID, input: $input) {
    myTeamsGame {
      ...MyTeamsGamePlayerUpdate
    }
  }
}
    ${MyTeamsGamePlayerUpdateFragmentDoc}`;
export type GameFillinPlayerUpdateMutationFn = Apollo.MutationFunction<GameFillinPlayerUpdateMutation, GameFillinPlayerUpdateMutationVariables>;

/**
 * __useGameFillinPlayerUpdateMutation__
 *
 * To run a mutation, you first call `useGameFillinPlayerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameFillinPlayerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameFillinPlayerUpdateMutation, { data, loading, error }] = useGameFillinPlayerUpdateMutation({
 *   variables: {
 *      gameID: // value for 'gameID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameFillinPlayerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GameFillinPlayerUpdateMutation, GameFillinPlayerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameFillinPlayerUpdateMutation, GameFillinPlayerUpdateMutationVariables>(GameFillinPlayerUpdateDocument, options);
      }
export type GameFillinPlayerUpdateMutationHookResult = ReturnType<typeof useGameFillinPlayerUpdateMutation>;
export type GameFillinPlayerUpdateMutationResult = Apollo.MutationResult<GameFillinPlayerUpdateMutation>;
export type GameFillinPlayerUpdateMutationOptions = Apollo.BaseMutationOptions<GameFillinPlayerUpdateMutation, GameFillinPlayerUpdateMutationVariables>;
export const GameTeamUpdateDocument = gql`
    mutation gameTeamUpdate($gameID: ID!, $side: Side!, $input: MyTeamsGameTeamUpdateInput!) {
  myTeamsGameTeamUpdate(gameID: $gameID, side: $side, input: $input) {
    myTeamsGame {
      ...MyTeamsGamePlayerUpdate
    }
  }
}
    ${MyTeamsGamePlayerUpdateFragmentDoc}`;
export type GameTeamUpdateMutationFn = Apollo.MutationFunction<GameTeamUpdateMutation, GameTeamUpdateMutationVariables>;

/**
 * __useGameTeamUpdateMutation__
 *
 * To run a mutation, you first call `useGameTeamUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameTeamUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameTeamUpdateMutation, { data, loading, error }] = useGameTeamUpdateMutation({
 *   variables: {
 *      gameID: // value for 'gameID'
 *      side: // value for 'side'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameTeamUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GameTeamUpdateMutation, GameTeamUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameTeamUpdateMutation, GameTeamUpdateMutationVariables>(GameTeamUpdateDocument, options);
      }
export type GameTeamUpdateMutationHookResult = ReturnType<typeof useGameTeamUpdateMutation>;
export type GameTeamUpdateMutationResult = Apollo.MutationResult<GameTeamUpdateMutation>;
export type GameTeamUpdateMutationOptions = Apollo.BaseMutationOptions<GameTeamUpdateMutation, GameTeamUpdateMutationVariables>;
export const OrganisationPageWrapperDocument = gql`
    query OrganisationPageWrapper($orgCode: String!) {
  discoverOrganisation(code: $orgCode) {
    ...OrganisationDetails
  }
  tenantConfiguration {
    ...TenantContactRolesConfiguration
  }
}
    ${OrganisationDetailsFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useOrganisationPageWrapperQuery__
 *
 * To run a query within a React component, call `useOrganisationPageWrapperQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPageWrapperQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationPageWrapperQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useOrganisationPageWrapperQuery(baseOptions: Apollo.QueryHookOptions<OrganisationPageWrapperQuery, OrganisationPageWrapperQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationPageWrapperQuery, OrganisationPageWrapperQueryVariables>(OrganisationPageWrapperDocument, options);
      }
export function useOrganisationPageWrapperLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationPageWrapperQuery, OrganisationPageWrapperQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationPageWrapperQuery, OrganisationPageWrapperQueryVariables>(OrganisationPageWrapperDocument, options);
        }
export type OrganisationPageWrapperQueryHookResult = ReturnType<typeof useOrganisationPageWrapperQuery>;
export type OrganisationPageWrapperLazyQueryHookResult = ReturnType<typeof useOrganisationPageWrapperLazyQuery>;
export type OrganisationPageWrapperQueryResult = Apollo.QueryResult<OrganisationPageWrapperQuery, OrganisationPageWrapperQueryVariables>;
export const OrganisationPageWrapperNewsDocument = gql`
    query OrganisationPageWrapperNews($orgCode: ID!) {
  discoverOrganisationPosts(input: {organisationID: $orgCode, limit: 0}) {
    meta {
      totalRecords
    }
  }
}
    `;

/**
 * __useOrganisationPageWrapperNewsQuery__
 *
 * To run a query within a React component, call `useOrganisationPageWrapperNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPageWrapperNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationPageWrapperNewsQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useOrganisationPageWrapperNewsQuery(baseOptions: Apollo.QueryHookOptions<OrganisationPageWrapperNewsQuery, OrganisationPageWrapperNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationPageWrapperNewsQuery, OrganisationPageWrapperNewsQueryVariables>(OrganisationPageWrapperNewsDocument, options);
      }
export function useOrganisationPageWrapperNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationPageWrapperNewsQuery, OrganisationPageWrapperNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationPageWrapperNewsQuery, OrganisationPageWrapperNewsQueryVariables>(OrganisationPageWrapperNewsDocument, options);
        }
export type OrganisationPageWrapperNewsQueryHookResult = ReturnType<typeof useOrganisationPageWrapperNewsQuery>;
export type OrganisationPageWrapperNewsLazyQueryHookResult = ReturnType<typeof useOrganisationPageWrapperNewsLazyQuery>;
export type OrganisationPageWrapperNewsQueryResult = Apollo.QueryResult<OrganisationPageWrapperNewsQuery, OrganisationPageWrapperNewsQueryVariables>;
export const ProfileQuestionsUpdateDocument = gql`
    mutation profileQuestionsUpdate($profileID: ID!, $input: [FormInput!]!) {
  profileQuestionsUpdate(profileID: $profileID, input: $input) {
    name
    label
    fields {
      name
      label
      value
      ... on FieldInput {
        type
      }
      ... on FieldSelect {
        options {
          label
          value
        }
      }
    }
  }
}
    `;
export type ProfileQuestionsUpdateMutationFn = Apollo.MutationFunction<ProfileQuestionsUpdateMutation, ProfileQuestionsUpdateMutationVariables>;

/**
 * __useProfileQuestionsUpdateMutation__
 *
 * To run a mutation, you first call `useProfileQuestionsUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileQuestionsUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileQuestionsUpdateMutation, { data, loading, error }] = useProfileQuestionsUpdateMutation({
 *   variables: {
 *      profileID: // value for 'profileID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfileQuestionsUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfileQuestionsUpdateMutation, ProfileQuestionsUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileQuestionsUpdateMutation, ProfileQuestionsUpdateMutationVariables>(ProfileQuestionsUpdateDocument, options);
      }
export type ProfileQuestionsUpdateMutationHookResult = ReturnType<typeof useProfileQuestionsUpdateMutation>;
export type ProfileQuestionsUpdateMutationResult = Apollo.MutationResult<ProfileQuestionsUpdateMutation>;
export type ProfileQuestionsUpdateMutationOptions = Apollo.BaseMutationOptions<ProfileQuestionsUpdateMutation, ProfileQuestionsUpdateMutationVariables>;
export const ChildSafetyUpdateDocument = gql`
    mutation childSafetyUpdate($input: FieldSetInput!) {
  childSafetyUpdate(input: $input) {
    name
    label
    fields {
      name
      label
      value
      ... on FieldInput {
        type
      }
      ... on FieldSelect {
        options {
          label
          value
        }
      }
    }
  }
}
    `;
export type ChildSafetyUpdateMutationFn = Apollo.MutationFunction<ChildSafetyUpdateMutation, ChildSafetyUpdateMutationVariables>;

/**
 * __useChildSafetyUpdateMutation__
 *
 * To run a mutation, you first call `useChildSafetyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChildSafetyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [childSafetyUpdateMutation, { data, loading, error }] = useChildSafetyUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChildSafetyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ChildSafetyUpdateMutation, ChildSafetyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChildSafetyUpdateMutation, ChildSafetyUpdateMutationVariables>(ChildSafetyUpdateDocument, options);
      }
export type ChildSafetyUpdateMutationHookResult = ReturnType<typeof useChildSafetyUpdateMutation>;
export type ChildSafetyUpdateMutationResult = Apollo.MutationResult<ChildSafetyUpdateMutation>;
export type ChildSafetyUpdateMutationOptions = Apollo.BaseMutationOptions<ChildSafetyUpdateMutation, ChildSafetyUpdateMutationVariables>;
export const CoachingAccreditationsDocument = gql`
    query coachingAccreditations {
  account {
    id
    profile {
      id
      coachingAccreditation {
        id
        level {
          name
          value
        }
      }
      dependants {
        id
        coachingAccreditation {
          id
          level {
            name
            value
          }
        }
      }
    }
  }
  tenantConfiguration {
    label
    seasonRegistration {
      coachingAccreditationConfig {
        selfSubmit
        accreditations {
          name
          value
        }
      }
    }
  }
}
    `;

/**
 * __useCoachingAccreditationsQuery__
 *
 * To run a query within a React component, call `useCoachingAccreditationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachingAccreditationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachingAccreditationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCoachingAccreditationsQuery(baseOptions?: Apollo.QueryHookOptions<CoachingAccreditationsQuery, CoachingAccreditationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CoachingAccreditationsQuery, CoachingAccreditationsQueryVariables>(CoachingAccreditationsDocument, options);
      }
export function useCoachingAccreditationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CoachingAccreditationsQuery, CoachingAccreditationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CoachingAccreditationsQuery, CoachingAccreditationsQueryVariables>(CoachingAccreditationsDocument, options);
        }
export type CoachingAccreditationsQueryHookResult = ReturnType<typeof useCoachingAccreditationsQuery>;
export type CoachingAccreditationsLazyQueryHookResult = ReturnType<typeof useCoachingAccreditationsLazyQuery>;
export type CoachingAccreditationsQueryResult = Apollo.QueryResult<CoachingAccreditationsQuery, CoachingAccreditationsQueryVariables>;
export const CoachingAccreditationUpdateDocument = gql`
    mutation coachingAccreditationUpdate($id: ID!, $input: CoachingAccreditationInput!) {
  coachingAccreditationUpdate(id: $id, input: $input) {
    id
    level {
      name
      value
    }
  }
}
    `;
export type CoachingAccreditationUpdateMutationFn = Apollo.MutationFunction<CoachingAccreditationUpdateMutation, CoachingAccreditationUpdateMutationVariables>;

/**
 * __useCoachingAccreditationUpdateMutation__
 *
 * To run a mutation, you first call `useCoachingAccreditationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoachingAccreditationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coachingAccreditationUpdateMutation, { data, loading, error }] = useCoachingAccreditationUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoachingAccreditationUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CoachingAccreditationUpdateMutation, CoachingAccreditationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CoachingAccreditationUpdateMutation, CoachingAccreditationUpdateMutationVariables>(CoachingAccreditationUpdateDocument, options);
      }
export type CoachingAccreditationUpdateMutationHookResult = ReturnType<typeof useCoachingAccreditationUpdateMutation>;
export type CoachingAccreditationUpdateMutationResult = Apollo.MutationResult<CoachingAccreditationUpdateMutation>;
export type CoachingAccreditationUpdateMutationOptions = Apollo.BaseMutationOptions<CoachingAccreditationUpdateMutation, CoachingAccreditationUpdateMutationVariables>;
export const UnlinkExternalAccountDocument = gql`
    mutation UnlinkExternalAccount($input: LinkExternalAccountInput!) {
  unlinkExternalAccount(input: $input) {
    tenantSlug
    externalAccountID
  }
}
    `;
export type UnlinkExternalAccountMutationFn = Apollo.MutationFunction<UnlinkExternalAccountMutation, UnlinkExternalAccountMutationVariables>;

/**
 * __useUnlinkExternalAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkExternalAccountMutation, { data, loading, error }] = useUnlinkExternalAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkExternalAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkExternalAccountMutation, UnlinkExternalAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkExternalAccountMutation, UnlinkExternalAccountMutationVariables>(UnlinkExternalAccountDocument, options);
      }
export type UnlinkExternalAccountMutationHookResult = ReturnType<typeof useUnlinkExternalAccountMutation>;
export type UnlinkExternalAccountMutationResult = Apollo.MutationResult<UnlinkExternalAccountMutation>;
export type UnlinkExternalAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkExternalAccountMutation, UnlinkExternalAccountMutationVariables>;
export const ProfileDisabilityUpdateDocument = gql`
    mutation profileDisabilityUpdate($id: ID!, $input: ProfileInput!) {
  profileUpdate(id: $id, input: $input) {
    ...ProfileDisabilityDetails
  }
}
    ${ProfileDisabilityDetailsFragmentDoc}`;
export type ProfileDisabilityUpdateMutationFn = Apollo.MutationFunction<ProfileDisabilityUpdateMutation, ProfileDisabilityUpdateMutationVariables>;

/**
 * __useProfileDisabilityUpdateMutation__
 *
 * To run a mutation, you first call `useProfileDisabilityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileDisabilityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileDisabilityUpdateMutation, { data, loading, error }] = useProfileDisabilityUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfileDisabilityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfileDisabilityUpdateMutation, ProfileDisabilityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileDisabilityUpdateMutation, ProfileDisabilityUpdateMutationVariables>(ProfileDisabilityUpdateDocument, options);
      }
export type ProfileDisabilityUpdateMutationHookResult = ReturnType<typeof useProfileDisabilityUpdateMutation>;
export type ProfileDisabilityUpdateMutationResult = Apollo.MutationResult<ProfileDisabilityUpdateMutation>;
export type ProfileDisabilityUpdateMutationOptions = Apollo.BaseMutationOptions<ProfileDisabilityUpdateMutation, ProfileDisabilityUpdateMutationVariables>;
export const EmergencyContactUpdateDocument = gql`
    mutation emergencyContactUpdate($id: ID!, $input: EmergencyContactInput!) {
  emergencyContactUpdate(id: $id, input: $input) {
    id
    firstName
    lastName
    email
    relation
    mobileNumber {
      countryAlphaCode
      countryCode {
        name
        value
      }
      number
      displayNumber
    }
  }
}
    `;
export type EmergencyContactUpdateMutationFn = Apollo.MutationFunction<EmergencyContactUpdateMutation, EmergencyContactUpdateMutationVariables>;

/**
 * __useEmergencyContactUpdateMutation__
 *
 * To run a mutation, you first call `useEmergencyContactUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmergencyContactUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emergencyContactUpdateMutation, { data, loading, error }] = useEmergencyContactUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmergencyContactUpdateMutation(baseOptions?: Apollo.MutationHookOptions<EmergencyContactUpdateMutation, EmergencyContactUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmergencyContactUpdateMutation, EmergencyContactUpdateMutationVariables>(EmergencyContactUpdateDocument, options);
      }
export type EmergencyContactUpdateMutationHookResult = ReturnType<typeof useEmergencyContactUpdateMutation>;
export type EmergencyContactUpdateMutationResult = Apollo.MutationResult<EmergencyContactUpdateMutation>;
export type EmergencyContactUpdateMutationOptions = Apollo.BaseMutationOptions<EmergencyContactUpdateMutation, EmergencyContactUpdateMutationVariables>;
export const GuardianCreateDocument = gql`
    mutation guardianCreate($profileID: ID!, $input: GuardianInput!) {
  guardianCreate(profileID: $profileID, input: $input) {
    ...GuardianDetails
  }
}
    ${GuardianDetailsFragmentDoc}`;
export type GuardianCreateMutationFn = Apollo.MutationFunction<GuardianCreateMutation, GuardianCreateMutationVariables>;

/**
 * __useGuardianCreateMutation__
 *
 * To run a mutation, you first call `useGuardianCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianCreateMutation, { data, loading, error }] = useGuardianCreateMutation({
 *   variables: {
 *      profileID: // value for 'profileID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuardianCreateMutation(baseOptions?: Apollo.MutationHookOptions<GuardianCreateMutation, GuardianCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuardianCreateMutation, GuardianCreateMutationVariables>(GuardianCreateDocument, options);
      }
export type GuardianCreateMutationHookResult = ReturnType<typeof useGuardianCreateMutation>;
export type GuardianCreateMutationResult = Apollo.MutationResult<GuardianCreateMutation>;
export type GuardianCreateMutationOptions = Apollo.BaseMutationOptions<GuardianCreateMutation, GuardianCreateMutationVariables>;
export const GuardianUpdateDocument = gql`
    mutation guardianUpdate($id: ID!, $input: GuardianInput!) {
  guardianUpdate(id: $id, input: $input) {
    ...GuardianDetails
  }
}
    ${GuardianDetailsFragmentDoc}`;
export type GuardianUpdateMutationFn = Apollo.MutationFunction<GuardianUpdateMutation, GuardianUpdateMutationVariables>;

/**
 * __useGuardianUpdateMutation__
 *
 * To run a mutation, you first call `useGuardianUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianUpdateMutation, { data, loading, error }] = useGuardianUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGuardianUpdateMutation(baseOptions?: Apollo.MutationHookOptions<GuardianUpdateMutation, GuardianUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuardianUpdateMutation, GuardianUpdateMutationVariables>(GuardianUpdateDocument, options);
      }
export type GuardianUpdateMutationHookResult = ReturnType<typeof useGuardianUpdateMutation>;
export type GuardianUpdateMutationResult = Apollo.MutationResult<GuardianUpdateMutation>;
export type GuardianUpdateMutationOptions = Apollo.BaseMutationOptions<GuardianUpdateMutation, GuardianUpdateMutationVariables>;
export const GuardianDeleteDocument = gql`
    mutation guardianDelete($id: ID!) {
  guardianDelete(id: $id) {
    id
  }
}
    `;
export type GuardianDeleteMutationFn = Apollo.MutationFunction<GuardianDeleteMutation, GuardianDeleteMutationVariables>;

/**
 * __useGuardianDeleteMutation__
 *
 * To run a mutation, you first call `useGuardianDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGuardianDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [guardianDeleteMutation, { data, loading, error }] = useGuardianDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGuardianDeleteMutation(baseOptions?: Apollo.MutationHookOptions<GuardianDeleteMutation, GuardianDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GuardianDeleteMutation, GuardianDeleteMutationVariables>(GuardianDeleteDocument, options);
      }
export type GuardianDeleteMutationHookResult = ReturnType<typeof useGuardianDeleteMutation>;
export type GuardianDeleteMutationResult = Apollo.MutationResult<GuardianDeleteMutation>;
export type GuardianDeleteMutationOptions = Apollo.BaseMutationOptions<GuardianDeleteMutation, GuardianDeleteMutationVariables>;
export const ProfileUpdateDocument = gql`
    mutation profileUpdate($id: ID!, $input: ProfileInput!) {
  profileUpdate(id: $id, input: $input) {
    ...ProfilePersonalDetails
  }
}
    ${ProfilePersonalDetailsFragmentDoc}`;
export type ProfileUpdateMutationFn = Apollo.MutationFunction<ProfileUpdateMutation, ProfileUpdateMutationVariables>;

/**
 * __useProfileUpdateMutation__
 *
 * To run a mutation, you first call `useProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileUpdateMutation, { data, loading, error }] = useProfileUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProfileUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileUpdateMutation, ProfileUpdateMutationVariables>(ProfileUpdateDocument, options);
      }
export type ProfileUpdateMutationHookResult = ReturnType<typeof useProfileUpdateMutation>;
export type ProfileUpdateMutationResult = Apollo.MutationResult<ProfileUpdateMutation>;
export type ProfileUpdateMutationOptions = Apollo.BaseMutationOptions<ProfileUpdateMutation, ProfileUpdateMutationVariables>;
export const ProfileAndAddressUpdateDocument = gql`
    mutation profileAndAddressUpdate($profileID: ID!, $profileInput: ProfileInput!, $addressID: ID!, $addressInput: AddressInput!) {
  profileUpdate(id: $profileID, input: $profileInput) {
    ...ProfilePersonalDetails
  }
  addressUpdate(id: $addressID, input: $addressInput) {
    id
    line1
    suburb
    postcode
    state
    country
  }
}
    ${ProfilePersonalDetailsFragmentDoc}`;
export type ProfileAndAddressUpdateMutationFn = Apollo.MutationFunction<ProfileAndAddressUpdateMutation, ProfileAndAddressUpdateMutationVariables>;

/**
 * __useProfileAndAddressUpdateMutation__
 *
 * To run a mutation, you first call `useProfileAndAddressUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileAndAddressUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileAndAddressUpdateMutation, { data, loading, error }] = useProfileAndAddressUpdateMutation({
 *   variables: {
 *      profileID: // value for 'profileID'
 *      profileInput: // value for 'profileInput'
 *      addressID: // value for 'addressID'
 *      addressInput: // value for 'addressInput'
 *   },
 * });
 */
export function useProfileAndAddressUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ProfileAndAddressUpdateMutation, ProfileAndAddressUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileAndAddressUpdateMutation, ProfileAndAddressUpdateMutationVariables>(ProfileAndAddressUpdateDocument, options);
      }
export type ProfileAndAddressUpdateMutationHookResult = ReturnType<typeof useProfileAndAddressUpdateMutation>;
export type ProfileAndAddressUpdateMutationResult = Apollo.MutationResult<ProfileAndAddressUpdateMutation>;
export type ProfileAndAddressUpdateMutationOptions = Apollo.BaseMutationOptions<ProfileAndAddressUpdateMutation, ProfileAndAddressUpdateMutationVariables>;
export const UpdatePrivacyDocument = gql`
    mutation updatePrivacy($id: ID!, $input: ProfileInput!) {
  profileUpdate(id: $id, input: $input) {
    id
    visible
  }
}
    `;
export type UpdatePrivacyMutationFn = Apollo.MutationFunction<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>;

/**
 * __useUpdatePrivacyMutation__
 *
 * To run a mutation, you first call `useUpdatePrivacyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePrivacyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePrivacyMutation, { data, loading, error }] = useUpdatePrivacyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePrivacyMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>(UpdatePrivacyDocument, options);
      }
export type UpdatePrivacyMutationHookResult = ReturnType<typeof useUpdatePrivacyMutation>;
export type UpdatePrivacyMutationResult = Apollo.MutationResult<UpdatePrivacyMutation>;
export type UpdatePrivacyMutationOptions = Apollo.BaseMutationOptions<UpdatePrivacyMutation, UpdatePrivacyMutationVariables>;
export const CurrentAccountDocument = gql`
    query currentAccount {
  account {
    id
    profile {
      id
      firstName
      lastName
      email
      mobileNumber {
        countryCode {
          value
        }
        number
      }
      ...ExternalAccountsFragment
    }
  }
}
    ${ExternalAccountsFragmentFragmentDoc}`;

/**
 * __useCurrentAccountQuery__
 *
 * To run a query within a React component, call `useCurrentAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentAccountQuery(baseOptions?: Apollo.QueryHookOptions<CurrentAccountQuery, CurrentAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentAccountQuery, CurrentAccountQueryVariables>(CurrentAccountDocument, options);
      }
export function useCurrentAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentAccountQuery, CurrentAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentAccountQuery, CurrentAccountQueryVariables>(CurrentAccountDocument, options);
        }
export type CurrentAccountQueryHookResult = ReturnType<typeof useCurrentAccountQuery>;
export type CurrentAccountLazyQueryHookResult = ReturnType<typeof useCurrentAccountLazyQuery>;
export type CurrentAccountQueryResult = Apollo.QueryResult<CurrentAccountQuery, CurrentAccountQueryVariables>;
export const GetShopCartDocument = gql`
    query getShopCart($input: ShopCartArgs!) {
  shopCart(input: $input) {
    ...ShopCartFragment
  }
}
    ${ShopCartFragmentFragmentDoc}`;

/**
 * __useGetShopCartQuery__
 *
 * To run a query within a React component, call `useGetShopCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopCartQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetShopCartQuery(baseOptions: Apollo.QueryHookOptions<GetShopCartQuery, GetShopCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopCartQuery, GetShopCartQueryVariables>(GetShopCartDocument, options);
      }
export function useGetShopCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopCartQuery, GetShopCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopCartQuery, GetShopCartQueryVariables>(GetShopCartDocument, options);
        }
export type GetShopCartQueryHookResult = ReturnType<typeof useGetShopCartQuery>;
export type GetShopCartLazyQueryHookResult = ReturnType<typeof useGetShopCartLazyQuery>;
export type GetShopCartQueryResult = Apollo.QueryResult<GetShopCartQuery, GetShopCartQueryVariables>;
export const IncidentFormSelectionsDocument = gql`
    query incidentFormSelections($teamID: ID!, $profileId: ID) {
  discoverTeam(teamID: $teamID) {
    id
    season {
      id
      name
    }
    organisation {
      id
      name
    }
  }
  myTeamsTeam(input: {teamID: $teamID, profileID: $profileId}) {
    id
    teamPlayers {
      participant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    `;

/**
 * __useIncidentFormSelectionsQuery__
 *
 * To run a query within a React component, call `useIncidentFormSelectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncidentFormSelectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncidentFormSelectionsQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useIncidentFormSelectionsQuery(baseOptions: Apollo.QueryHookOptions<IncidentFormSelectionsQuery, IncidentFormSelectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncidentFormSelectionsQuery, IncidentFormSelectionsQueryVariables>(IncidentFormSelectionsDocument, options);
      }
export function useIncidentFormSelectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncidentFormSelectionsQuery, IncidentFormSelectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncidentFormSelectionsQuery, IncidentFormSelectionsQueryVariables>(IncidentFormSelectionsDocument, options);
        }
export type IncidentFormSelectionsQueryHookResult = ReturnType<typeof useIncidentFormSelectionsQuery>;
export type IncidentFormSelectionsLazyQueryHookResult = ReturnType<typeof useIncidentFormSelectionsLazyQuery>;
export type IncidentFormSelectionsQueryResult = Apollo.QueryResult<IncidentFormSelectionsQuery, IncidentFormSelectionsQueryVariables>;
export const MyTeamsPreviousLineupDocument = gql`
    query myTeamsPreviousLineup($gameId: ID!, $profileId: ID, $teamContextId: ID) {
  myTeamsGame(input: {gameID: $gameId, profileID: $profileId, teamContextID: $teamContextId}) {
    id
    teams {
      home {
        ...MyTeamsPreviousLineupFragment
      }
      away {
        ...MyTeamsPreviousLineupFragment
      }
    }
  }
}
    ${MyTeamsPreviousLineupFragmentFragmentDoc}`;

/**
 * __useMyTeamsPreviousLineupQuery__
 *
 * To run a query within a React component, call `useMyTeamsPreviousLineupQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsPreviousLineupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsPreviousLineupQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      profileId: // value for 'profileId'
 *      teamContextId: // value for 'teamContextId'
 *   },
 * });
 */
export function useMyTeamsPreviousLineupQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsPreviousLineupQuery, MyTeamsPreviousLineupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsPreviousLineupQuery, MyTeamsPreviousLineupQueryVariables>(MyTeamsPreviousLineupDocument, options);
      }
export function useMyTeamsPreviousLineupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsPreviousLineupQuery, MyTeamsPreviousLineupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsPreviousLineupQuery, MyTeamsPreviousLineupQueryVariables>(MyTeamsPreviousLineupDocument, options);
        }
export type MyTeamsPreviousLineupQueryHookResult = ReturnType<typeof useMyTeamsPreviousLineupQuery>;
export type MyTeamsPreviousLineupLazyQueryHookResult = ReturnType<typeof useMyTeamsPreviousLineupLazyQuery>;
export type MyTeamsPreviousLineupQueryResult = Apollo.QueryResult<MyTeamsPreviousLineupQuery, MyTeamsPreviousLineupQueryVariables>;
export const CountryCodesDocument = gql`
    query countryCodes {
  tenantConfiguration {
    label
    countryCodes {
      name
      value
    }
  }
}
    `;

/**
 * __useCountryCodesQuery__
 *
 * To run a query within a React component, call `useCountryCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountryCodesQuery(baseOptions?: Apollo.QueryHookOptions<CountryCodesQuery, CountryCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CountryCodesQuery, CountryCodesQueryVariables>(CountryCodesDocument, options);
      }
export function useCountryCodesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountryCodesQuery, CountryCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CountryCodesQuery, CountryCodesQueryVariables>(CountryCodesDocument, options);
        }
export type CountryCodesQueryHookResult = ReturnType<typeof useCountryCodesQuery>;
export type CountryCodesLazyQueryHookResult = ReturnType<typeof useCountryCodesLazyQuery>;
export type CountryCodesQueryResult = Apollo.QueryResult<CountryCodesQuery, CountryCodesQueryVariables>;
export const GetLinkedExternalAccountsDocument = gql`
    query getLinkedExternalAccounts {
  account {
    id
    profile {
      id
      ...ExternalAccountsFragment
    }
  }
}
    ${ExternalAccountsFragmentFragmentDoc}`;

/**
 * __useGetLinkedExternalAccountsQuery__
 *
 * To run a query within a React component, call `useGetLinkedExternalAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedExternalAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedExternalAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLinkedExternalAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetLinkedExternalAccountsQuery, GetLinkedExternalAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLinkedExternalAccountsQuery, GetLinkedExternalAccountsQueryVariables>(GetLinkedExternalAccountsDocument, options);
      }
export function useGetLinkedExternalAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLinkedExternalAccountsQuery, GetLinkedExternalAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLinkedExternalAccountsQuery, GetLinkedExternalAccountsQueryVariables>(GetLinkedExternalAccountsDocument, options);
        }
export type GetLinkedExternalAccountsQueryHookResult = ReturnType<typeof useGetLinkedExternalAccountsQuery>;
export type GetLinkedExternalAccountsLazyQueryHookResult = ReturnType<typeof useGetLinkedExternalAccountsLazyQuery>;
export type GetLinkedExternalAccountsQueryResult = Apollo.QueryResult<GetLinkedExternalAccountsQuery, GetLinkedExternalAccountsQueryVariables>;
export const GetParticipantTypeDocument = gql`
    query getParticipantType($participantID: ID!) {
  participant(id: $participantID) {
    id
    type
  }
}
    `;

/**
 * __useGetParticipantTypeQuery__
 *
 * To run a query within a React component, call `useGetParticipantTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantTypeQuery({
 *   variables: {
 *      participantID: // value for 'participantID'
 *   },
 * });
 */
export function useGetParticipantTypeQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantTypeQuery, GetParticipantTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantTypeQuery, GetParticipantTypeQueryVariables>(GetParticipantTypeDocument, options);
      }
export function useGetParticipantTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantTypeQuery, GetParticipantTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantTypeQuery, GetParticipantTypeQueryVariables>(GetParticipantTypeDocument, options);
        }
export type GetParticipantTypeQueryHookResult = ReturnType<typeof useGetParticipantTypeQuery>;
export type GetParticipantTypeLazyQueryHookResult = ReturnType<typeof useGetParticipantTypeLazyQuery>;
export type GetParticipantTypeQueryResult = Apollo.QueryResult<GetParticipantTypeQuery, GetParticipantTypeQueryVariables>;
export const MyProfileDocument = gql`
    query myProfile {
  account {
    id
    profile {
      ...ProfileOverview
    }
  }
  tenantConfiguration {
    ...ProfileTenantConfiguration
  }
  configuration {
    ...ProfileConfiguration
  }
}
    ${ProfileOverviewFragmentDoc}
${ProfileTenantConfigurationFragmentDoc}
${ProfileConfigurationFragmentDoc}`;

/**
 * __useMyProfileQuery__
 *
 * To run a query within a React component, call `useMyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
      }
export function useMyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileQuery, MyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, options);
        }
export type MyProfileQueryHookResult = ReturnType<typeof useMyProfileQuery>;
export type MyProfileLazyQueryHookResult = ReturnType<typeof useMyProfileLazyQuery>;
export type MyProfileQueryResult = Apollo.QueryResult<MyProfileQuery, MyProfileQueryVariables>;
export const DependantProfileDocument = gql`
    query dependantProfile($id: ID!) {
  dependantProfile(id: $id) {
    ...ProfileOverview
  }
  tenantConfiguration {
    ...ProfileTenantConfiguration
  }
  configuration {
    ...ProfileConfiguration
  }
}
    ${ProfileOverviewFragmentDoc}
${ProfileTenantConfigurationFragmentDoc}
${ProfileConfigurationFragmentDoc}`;

/**
 * __useDependantProfileQuery__
 *
 * To run a query within a React component, call `useDependantProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDependantProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDependantProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDependantProfileQuery(baseOptions: Apollo.QueryHookOptions<DependantProfileQuery, DependantProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DependantProfileQuery, DependantProfileQueryVariables>(DependantProfileDocument, options);
      }
export function useDependantProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DependantProfileQuery, DependantProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DependantProfileQuery, DependantProfileQueryVariables>(DependantProfileDocument, options);
        }
export type DependantProfileQueryHookResult = ReturnType<typeof useDependantProfileQuery>;
export type DependantProfileLazyQueryHookResult = ReturnType<typeof useDependantProfileLazyQuery>;
export type DependantProfileQueryResult = Apollo.QueryResult<DependantProfileQuery, DependantProfileQueryVariables>;
export const GetRegistrationDocument = gql`
    query getRegistration($code: String!, $role: SeasonRegistrationUserType, $skipTenantConfig: Boolean!) {
  registrationSettings(code: $code) {
    ... on DiscoverRegistration {
      id
      type
      registrationCode
      startDate {
        date
        time
        timezone
      }
      endDate {
        date
        time
        timezone
      }
      season {
        ... on DiscoverSeason {
          id
          name
          competition {
            id
            name
            organisation {
              ...RegistrationOrganisationDetails
            }
          }
        }
        ... on ProgramSeason {
          id
          name
          program {
            id
            name
            alias
          }
        }
      }
      organisation {
        id
        name
        email
        contactNumber
        websiteUrl
        address {
          id
          line1
          suburb
          postcode
          state
          country
        }
        logo {
          sizes {
            url
            dimensions {
              width
              height
            }
          }
        }
        contacts {
          id
          firstName
          lastName
          position
          email
          phone
        }
        shopVisible
      }
      products(role: $role) {
        ...ProductFragment
      }
      deferredFees
      deferredFeesDueDate
      visible
    }
    ... on DiscoverSocialTeamRegistration {
      id
      registrationCode
      startDate {
        date
        time
        timezone
      }
      endDate {
        date
        time
        timezone
      }
      season {
        id
        name
        competition {
          id
          name
          organisation {
            ...RegistrationOrganisationDetails
          }
        }
      }
      grades {
        id
        name
      }
      products {
        ...ProductFragment
      }
      visible
    }
  }
  tenantConfiguration @skip(if: $skipTenantConfig) {
    label
    stripePublicKey
    sport {
      name
    }
    ...TenantContactRolesConfiguration
    ...ExternalAccountLinking
  }
}
    ${RegistrationOrganisationDetailsFragmentDoc}
${ProductFragmentFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}
${ExternalAccountLinkingFragmentDoc}`;

/**
 * __useGetRegistrationQuery__
 *
 * To run a query within a React component, call `useGetRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationQuery({
 *   variables: {
 *      code: // value for 'code'
 *      role: // value for 'role'
 *      skipTenantConfig: // value for 'skipTenantConfig'
 *   },
 * });
 */
export function useGetRegistrationQuery(baseOptions: Apollo.QueryHookOptions<GetRegistrationQuery, GetRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistrationQuery, GetRegistrationQueryVariables>(GetRegistrationDocument, options);
      }
export function useGetRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistrationQuery, GetRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistrationQuery, GetRegistrationQueryVariables>(GetRegistrationDocument, options);
        }
export type GetRegistrationQueryHookResult = ReturnType<typeof useGetRegistrationQuery>;
export type GetRegistrationLazyQueryHookResult = ReturnType<typeof useGetRegistrationLazyQuery>;
export type GetRegistrationQueryResult = Apollo.QueryResult<GetRegistrationQuery, GetRegistrationQueryVariables>;
export const TeamDocument = gql`
    query team($teamId: ID!) {
  discoverTeam(teamID: $teamId) {
    id
    name
  }
}
    `;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export const MyTeamsGameUpdateDocument = gql`
    mutation myTeamsGameUpdate($input: MyTeamsGameUpdateInput!, $gameStatisticsFilter: GameStatisticsFilter!) {
  myTeamsGameUpdate(input: $input) {
    myTeamsGame {
      ...MyTeamsGameDetailsFragment
    }
  }
}
    ${MyTeamsGameDetailsFragmentFragmentDoc}`;
export type MyTeamsGameUpdateMutationFn = Apollo.MutationFunction<MyTeamsGameUpdateMutation, MyTeamsGameUpdateMutationVariables>;

/**
 * __useMyTeamsGameUpdateMutation__
 *
 * To run a mutation, you first call `useMyTeamsGameUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsGameUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [myTeamsGameUpdateMutation, { data, loading, error }] = useMyTeamsGameUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      gameStatisticsFilter: // value for 'gameStatisticsFilter'
 *   },
 * });
 */
export function useMyTeamsGameUpdateMutation(baseOptions?: Apollo.MutationHookOptions<MyTeamsGameUpdateMutation, MyTeamsGameUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MyTeamsGameUpdateMutation, MyTeamsGameUpdateMutationVariables>(MyTeamsGameUpdateDocument, options);
      }
export type MyTeamsGameUpdateMutationHookResult = ReturnType<typeof useMyTeamsGameUpdateMutation>;
export type MyTeamsGameUpdateMutationResult = Apollo.MutationResult<MyTeamsGameUpdateMutation>;
export type MyTeamsGameUpdateMutationOptions = Apollo.BaseMutationOptions<MyTeamsGameUpdateMutation, MyTeamsGameUpdateMutationVariables>;
export const ProfileClaimDocument = gql`
    mutation profileClaim($input: ClaimProfileInput!, $overrides: ClaimProfileOverrides) {
  profileClaim(input: $input, overrides: $overrides) {
    id
    status
  }
}
    `;
export type ProfileClaimMutationFn = Apollo.MutationFunction<ProfileClaimMutation, ProfileClaimMutationVariables>;

/**
 * __useProfileClaimMutation__
 *
 * To run a mutation, you first call `useProfileClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileClaimMutation, { data, loading, error }] = useProfileClaimMutation({
 *   variables: {
 *      input: // value for 'input'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useProfileClaimMutation(baseOptions?: Apollo.MutationHookOptions<ProfileClaimMutation, ProfileClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileClaimMutation, ProfileClaimMutationVariables>(ProfileClaimDocument, options);
      }
export type ProfileClaimMutationHookResult = ReturnType<typeof useProfileClaimMutation>;
export type ProfileClaimMutationResult = Apollo.MutationResult<ProfileClaimMutation>;
export type ProfileClaimMutationOptions = Apollo.BaseMutationOptions<ProfileClaimMutation, ProfileClaimMutationVariables>;
export const VerificationCodeGenerateDocument = gql`
    mutation verificationCodeGenerate($input: ClaimProfileInput!, $overrides: ClaimProfileOverrides) {
  verificationCodeGenerate(input: $input, overrides: $overrides) {
    id
    status
  }
}
    `;
export type VerificationCodeGenerateMutationFn = Apollo.MutationFunction<VerificationCodeGenerateMutation, VerificationCodeGenerateMutationVariables>;

/**
 * __useVerificationCodeGenerateMutation__
 *
 * To run a mutation, you first call `useVerificationCodeGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerificationCodeGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verificationCodeGenerateMutation, { data, loading, error }] = useVerificationCodeGenerateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      overrides: // value for 'overrides'
 *   },
 * });
 */
export function useVerificationCodeGenerateMutation(baseOptions?: Apollo.MutationHookOptions<VerificationCodeGenerateMutation, VerificationCodeGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerificationCodeGenerateMutation, VerificationCodeGenerateMutationVariables>(VerificationCodeGenerateDocument, options);
      }
export type VerificationCodeGenerateMutationHookResult = ReturnType<typeof useVerificationCodeGenerateMutation>;
export type VerificationCodeGenerateMutationResult = Apollo.MutationResult<VerificationCodeGenerateMutation>;
export type VerificationCodeGenerateMutationOptions = Apollo.BaseMutationOptions<VerificationCodeGenerateMutation, VerificationCodeGenerateMutationVariables>;
export const ClaimVerifyDocument = gql`
    mutation claimVerify($input: ClaimVerifyInput!) {
  claimVerify(input: $input) {
    id
    status
  }
}
    `;
export type ClaimVerifyMutationFn = Apollo.MutationFunction<ClaimVerifyMutation, ClaimVerifyMutationVariables>;

/**
 * __useClaimVerifyMutation__
 *
 * To run a mutation, you first call `useClaimVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimVerifyMutation, { data, loading, error }] = useClaimVerifyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimVerifyMutation(baseOptions?: Apollo.MutationHookOptions<ClaimVerifyMutation, ClaimVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimVerifyMutation, ClaimVerifyMutationVariables>(ClaimVerifyDocument, options);
      }
export type ClaimVerifyMutationHookResult = ReturnType<typeof useClaimVerifyMutation>;
export type ClaimVerifyMutationResult = Apollo.MutationResult<ClaimVerifyMutation>;
export type ClaimVerifyMutationOptions = Apollo.BaseMutationOptions<ClaimVerifyMutation, ClaimVerifyMutationVariables>;
export const SeasonRegistrationCartDocument = gql`
    query seasonRegistrationCart($args: SeasonRegistrationCartArgs!, $code: String!, $role: SeasonRegistrationUserType) {
  seasonRegistrationCart(args: $args) {
    cart {
      ...CartFragment
    }
    errors {
      field
      message
    }
    checkoutSession {
      ... on Gr4vyEmbedCheckoutSession {
        id
        expiryDate
        embedToken
      }
      __typename
    }
  }
  discoverSeasonRegistration(registrationID: $code) {
    id
    products(role: $role) {
      ...ProductFragment
    }
    organisationTermsAndConditions {
      name
      type
      value
    }
    organisation {
      id
      name
    }
    season {
      ... on DiscoverSeason {
        id
        endDate
        competition {
          id
          organisation {
            id
            name
          }
        }
      }
      ... on ProgramSeason {
        id
        endDate
        program {
          id
        }
      }
    }
    marketingOptInText
  }
}
    ${CartFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;

/**
 * __useSeasonRegistrationCartQuery__
 *
 * To run a query within a React component, call `useSeasonRegistrationCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonRegistrationCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonRegistrationCartQuery({
 *   variables: {
 *      args: // value for 'args'
 *      code: // value for 'code'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSeasonRegistrationCartQuery(baseOptions: Apollo.QueryHookOptions<SeasonRegistrationCartQuery, SeasonRegistrationCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonRegistrationCartQuery, SeasonRegistrationCartQueryVariables>(SeasonRegistrationCartDocument, options);
      }
export function useSeasonRegistrationCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonRegistrationCartQuery, SeasonRegistrationCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonRegistrationCartQuery, SeasonRegistrationCartQueryVariables>(SeasonRegistrationCartDocument, options);
        }
export type SeasonRegistrationCartQueryHookResult = ReturnType<typeof useSeasonRegistrationCartQuery>;
export type SeasonRegistrationCartLazyQueryHookResult = ReturnType<typeof useSeasonRegistrationCartLazyQuery>;
export type SeasonRegistrationCartQueryResult = Apollo.QueryResult<SeasonRegistrationCartQuery, SeasonRegistrationCartQueryVariables>;
export const SocialTeamRegistrationCartDocument = gql`
    query socialTeamRegistrationCart($args: SocialTeamRegistrationCartArgs!, $code: ID!) {
  socialTeamRegistrationCart(args: $args) {
    cart {
      ...TeamCartFragment
    }
    errors {
      field
      message
    }
    checkoutSession {
      ... on Gr4vyEmbedCheckoutSession {
        id
        expiryDate
        embedToken
      }
      __typename
    }
  }
  discoverSocialTeamRegistration(registrationID: $code) {
    id
    products {
      ...ProductFragment
    }
    organisationTermsAndConditions {
      name
      type
      value
    }
  }
}
    ${TeamCartFragmentFragmentDoc}
${ProductFragmentFragmentDoc}`;

/**
 * __useSocialTeamRegistrationCartQuery__
 *
 * To run a query within a React component, call `useSocialTeamRegistrationCartQuery` and pass it any options that fit your needs.
 * When your component renders, `useSocialTeamRegistrationCartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSocialTeamRegistrationCartQuery({
 *   variables: {
 *      args: // value for 'args'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSocialTeamRegistrationCartQuery(baseOptions: Apollo.QueryHookOptions<SocialTeamRegistrationCartQuery, SocialTeamRegistrationCartQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SocialTeamRegistrationCartQuery, SocialTeamRegistrationCartQueryVariables>(SocialTeamRegistrationCartDocument, options);
      }
export function useSocialTeamRegistrationCartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SocialTeamRegistrationCartQuery, SocialTeamRegistrationCartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SocialTeamRegistrationCartQuery, SocialTeamRegistrationCartQueryVariables>(SocialTeamRegistrationCartDocument, options);
        }
export type SocialTeamRegistrationCartQueryHookResult = ReturnType<typeof useSocialTeamRegistrationCartQuery>;
export type SocialTeamRegistrationCartLazyQueryHookResult = ReturnType<typeof useSocialTeamRegistrationCartLazyQuery>;
export type SocialTeamRegistrationCartQueryResult = Apollo.QueryResult<SocialTeamRegistrationCartQuery, SocialTeamRegistrationCartQueryVariables>;
export const SupportedCountriesDocument = gql`
    query supportedCountries {
  configuration {
    supportedCountries {
      name
      alpha2Code
      mobileCountryCode
    }
  }
}
    `;

/**
 * __useSupportedCountriesQuery__
 *
 * To run a query within a React component, call `useSupportedCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedCountriesQuery(baseOptions?: Apollo.QueryHookOptions<SupportedCountriesQuery, SupportedCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedCountriesQuery, SupportedCountriesQueryVariables>(SupportedCountriesDocument, options);
      }
export function useSupportedCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedCountriesQuery, SupportedCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedCountriesQuery, SupportedCountriesQueryVariables>(SupportedCountriesDocument, options);
        }
export type SupportedCountriesQueryHookResult = ReturnType<typeof useSupportedCountriesQuery>;
export type SupportedCountriesLazyQueryHookResult = ReturnType<typeof useSupportedCountriesLazyQuery>;
export type SupportedCountriesQueryResult = Apollo.QueryResult<SupportedCountriesQuery, SupportedCountriesQueryVariables>;
export const GameSheetGenerateDocument = gql`
    mutation gameSheetGenerate($input: GameSheetGenerateInput!) {
  gameSheetGenerate(input: $input) {
    stateID
  }
}
    `;
export type GameSheetGenerateMutationFn = Apollo.MutationFunction<GameSheetGenerateMutation, GameSheetGenerateMutationVariables>;

/**
 * __useGameSheetGenerateMutation__
 *
 * To run a mutation, you first call `useGameSheetGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameSheetGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameSheetGenerateMutation, { data, loading, error }] = useGameSheetGenerateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGameSheetGenerateMutation(baseOptions?: Apollo.MutationHookOptions<GameSheetGenerateMutation, GameSheetGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameSheetGenerateMutation, GameSheetGenerateMutationVariables>(GameSheetGenerateDocument, options);
      }
export type GameSheetGenerateMutationHookResult = ReturnType<typeof useGameSheetGenerateMutation>;
export type GameSheetGenerateMutationResult = Apollo.MutationResult<GameSheetGenerateMutation>;
export type GameSheetGenerateMutationOptions = Apollo.BaseMutationOptions<GameSheetGenerateMutation, GameSheetGenerateMutationVariables>;
export const GameSheetDownloadDocument = gql`
    query gameSheetDownload($stateID: ID!) {
  gameSheetDownload(stateID: $stateID) {
    stateID
    document {
      url
    }
    status
  }
}
    `;

/**
 * __useGameSheetDownloadQuery__
 *
 * To run a query within a React component, call `useGameSheetDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameSheetDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameSheetDownloadQuery({
 *   variables: {
 *      stateID: // value for 'stateID'
 *   },
 * });
 */
export function useGameSheetDownloadQuery(baseOptions: Apollo.QueryHookOptions<GameSheetDownloadQuery, GameSheetDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameSheetDownloadQuery, GameSheetDownloadQueryVariables>(GameSheetDownloadDocument, options);
      }
export function useGameSheetDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameSheetDownloadQuery, GameSheetDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameSheetDownloadQuery, GameSheetDownloadQueryVariables>(GameSheetDownloadDocument, options);
        }
export type GameSheetDownloadQueryHookResult = ReturnType<typeof useGameSheetDownloadQuery>;
export type GameSheetDownloadLazyQueryHookResult = ReturnType<typeof useGameSheetDownloadLazyQuery>;
export type GameSheetDownloadQueryResult = Apollo.QueryResult<GameSheetDownloadQuery, GameSheetDownloadQueryVariables>;
export const GetLocalisationDocument = gql`
    query getLocalisation {
  tenantConfiguration {
    label
    localisation {
      country
      locale
      currency {
        code
        symbol
        symbolLocation
      }
    }
  }
}
    `;

/**
 * __useGetLocalisationQuery__
 *
 * To run a query within a React component, call `useGetLocalisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalisationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLocalisationQuery(baseOptions?: Apollo.QueryHookOptions<GetLocalisationQuery, GetLocalisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalisationQuery, GetLocalisationQueryVariables>(GetLocalisationDocument, options);
      }
export function useGetLocalisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalisationQuery, GetLocalisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalisationQuery, GetLocalisationQueryVariables>(GetLocalisationDocument, options);
        }
export type GetLocalisationQueryHookResult = ReturnType<typeof useGetLocalisationQuery>;
export type GetLocalisationLazyQueryHookResult = ReturnType<typeof useGetLocalisationLazyQuery>;
export type GetLocalisationQueryResult = Apollo.QueryResult<GetLocalisationQuery, GetLocalisationQueryVariables>;
export const PlayerNumberDisabledTenantConfigDocument = gql`
    query playerNumberDisabledTenantConfig {
  tenantConfiguration {
    label
    playerNumberDisabled
  }
}
    `;

/**
 * __usePlayerNumberDisabledTenantConfigQuery__
 *
 * To run a query within a React component, call `usePlayerNumberDisabledTenantConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlayerNumberDisabledTenantConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlayerNumberDisabledTenantConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlayerNumberDisabledTenantConfigQuery(baseOptions?: Apollo.QueryHookOptions<PlayerNumberDisabledTenantConfigQuery, PlayerNumberDisabledTenantConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlayerNumberDisabledTenantConfigQuery, PlayerNumberDisabledTenantConfigQueryVariables>(PlayerNumberDisabledTenantConfigDocument, options);
      }
export function usePlayerNumberDisabledTenantConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlayerNumberDisabledTenantConfigQuery, PlayerNumberDisabledTenantConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlayerNumberDisabledTenantConfigQuery, PlayerNumberDisabledTenantConfigQueryVariables>(PlayerNumberDisabledTenantConfigDocument, options);
        }
export type PlayerNumberDisabledTenantConfigQueryHookResult = ReturnType<typeof usePlayerNumberDisabledTenantConfigQuery>;
export type PlayerNumberDisabledTenantConfigLazyQueryHookResult = ReturnType<typeof usePlayerNumberDisabledTenantConfigLazyQuery>;
export type PlayerNumberDisabledTenantConfigQueryResult = Apollo.QueryResult<PlayerNumberDisabledTenantConfigQuery, PlayerNumberDisabledTenantConfigQueryVariables>;
export const MyProfileAndDependantsDocument = gql`
    query myProfileAndDependants {
  account {
    id
    profile {
      ...ProfileOverview
    }
  }
}
    ${ProfileOverviewFragmentDoc}`;

/**
 * __useMyProfileAndDependantsQuery__
 *
 * To run a query within a React component, call `useMyProfileAndDependantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyProfileAndDependantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyProfileAndDependantsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyProfileAndDependantsQuery(baseOptions?: Apollo.QueryHookOptions<MyProfileAndDependantsQuery, MyProfileAndDependantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyProfileAndDependantsQuery, MyProfileAndDependantsQueryVariables>(MyProfileAndDependantsDocument, options);
      }
export function useMyProfileAndDependantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyProfileAndDependantsQuery, MyProfileAndDependantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyProfileAndDependantsQuery, MyProfileAndDependantsQueryVariables>(MyProfileAndDependantsDocument, options);
        }
export type MyProfileAndDependantsQueryHookResult = ReturnType<typeof useMyProfileAndDependantsQuery>;
export type MyProfileAndDependantsLazyQueryHookResult = ReturnType<typeof useMyProfileAndDependantsLazyQuery>;
export type MyProfileAndDependantsQueryResult = Apollo.QueryResult<MyProfileAndDependantsQuery, MyProfileAndDependantsQueryVariables>;
export const ProfileTenantHistoryDocument = gql`
    query profileTenantHistory($id: ID!) {
  profileTenantHistory(id: $id) {
    myTeams {
      name
      value
    }
    coachingAccreditation {
      name
      value
    }
    registrationHistory {
      name
      value
    }
    memberships {
      name
      value
    }
    concussionIncidents {
      name
      value
    }
  }
}
    `;

/**
 * __useProfileTenantHistoryQuery__
 *
 * To run a query within a React component, call `useProfileTenantHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileTenantHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileTenantHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProfileTenantHistoryQuery(baseOptions: Apollo.QueryHookOptions<ProfileTenantHistoryQuery, ProfileTenantHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileTenantHistoryQuery, ProfileTenantHistoryQueryVariables>(ProfileTenantHistoryDocument, options);
      }
export function useProfileTenantHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileTenantHistoryQuery, ProfileTenantHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileTenantHistoryQuery, ProfileTenantHistoryQueryVariables>(ProfileTenantHistoryDocument, options);
        }
export type ProfileTenantHistoryQueryHookResult = ReturnType<typeof useProfileTenantHistoryQuery>;
export type ProfileTenantHistoryLazyQueryHookResult = ReturnType<typeof useProfileTenantHistoryLazyQuery>;
export type ProfileTenantHistoryQueryResult = Apollo.QueryResult<ProfileTenantHistoryQuery, ProfileTenantHistoryQueryVariables>;
export const ChangeEmailAccountDocument = gql`
    query changeEmailAccount {
  account {
    id
    profile {
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useChangeEmailAccountQuery__
 *
 * To run a query within a React component, call `useChangeEmailAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChangeEmailAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useChangeEmailAccountQuery(baseOptions?: Apollo.QueryHookOptions<ChangeEmailAccountQuery, ChangeEmailAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChangeEmailAccountQuery, ChangeEmailAccountQueryVariables>(ChangeEmailAccountDocument, options);
      }
export function useChangeEmailAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChangeEmailAccountQuery, ChangeEmailAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChangeEmailAccountQuery, ChangeEmailAccountQueryVariables>(ChangeEmailAccountDocument, options);
        }
export type ChangeEmailAccountQueryHookResult = ReturnType<typeof useChangeEmailAccountQuery>;
export type ChangeEmailAccountLazyQueryHookResult = ReturnType<typeof useChangeEmailAccountLazyQuery>;
export type ChangeEmailAccountQueryResult = Apollo.QueryResult<ChangeEmailAccountQuery, ChangeEmailAccountQueryVariables>;
export const ProfileEmailChangeDocument = gql`
    mutation profileEmailChange($request: ProfileEmailChangeInput!) {
  profileEmailChange(request: $request)
}
    `;
export type ProfileEmailChangeMutationFn = Apollo.MutationFunction<ProfileEmailChangeMutation, ProfileEmailChangeMutationVariables>;

/**
 * __useProfileEmailChangeMutation__
 *
 * To run a mutation, you first call `useProfileEmailChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileEmailChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileEmailChangeMutation, { data, loading, error }] = useProfileEmailChangeMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useProfileEmailChangeMutation(baseOptions?: Apollo.MutationHookOptions<ProfileEmailChangeMutation, ProfileEmailChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileEmailChangeMutation, ProfileEmailChangeMutationVariables>(ProfileEmailChangeDocument, options);
      }
export type ProfileEmailChangeMutationHookResult = ReturnType<typeof useProfileEmailChangeMutation>;
export type ProfileEmailChangeMutationResult = Apollo.MutationResult<ProfileEmailChangeMutation>;
export type ProfileEmailChangeMutationOptions = Apollo.BaseMutationOptions<ProfileEmailChangeMutation, ProfileEmailChangeMutationVariables>;
export const ProfileEmailVerifyDocument = gql`
    mutation profileEmailVerify($id: ID!, $code: String!) {
  profileEmailVerify(id: $id, code: $code) {
    id
    status
  }
}
    `;
export type ProfileEmailVerifyMutationFn = Apollo.MutationFunction<ProfileEmailVerifyMutation, ProfileEmailVerifyMutationVariables>;

/**
 * __useProfileEmailVerifyMutation__
 *
 * To run a mutation, you first call `useProfileEmailVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProfileEmailVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [profileEmailVerifyMutation, { data, loading, error }] = useProfileEmailVerifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useProfileEmailVerifyMutation(baseOptions?: Apollo.MutationHookOptions<ProfileEmailVerifyMutation, ProfileEmailVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProfileEmailVerifyMutation, ProfileEmailVerifyMutationVariables>(ProfileEmailVerifyDocument, options);
      }
export type ProfileEmailVerifyMutationHookResult = ReturnType<typeof useProfileEmailVerifyMutation>;
export type ProfileEmailVerifyMutationResult = Apollo.MutationResult<ProfileEmailVerifyMutation>;
export type ProfileEmailVerifyMutationOptions = Apollo.BaseMutationOptions<ProfileEmailVerifyMutation, ProfileEmailVerifyMutationVariables>;
export const OrganisationRegistrationsDocument = gql`
    query organisationRegistrations($code: ID!, $codeString: String!) {
  discoverOrganisation(code: $codeString) {
    id
    type
    name
    email
    contactNumber
    websiteUrl
    address {
      id
      line1
      suburb
      postcode
      state
      country
    }
    logo {
      sizes {
        url
        dimensions {
          width
          height
        }
      }
    }
    contacts {
      id
      firstName
      lastName
      position
      email
      phone
    }
    shopVisible
  }
  organisationRegistrations(code: $code) {
    id
    type
    registrationCode
    startDate {
      date
      time
      timezone
    }
    endDate {
      date
      time
      timezone
    }
    season {
      ... on ProgramSeason {
        id
        name
        startDate
        endDate
        program {
          id
          name
          description
          alias
        }
      }
      ... on DiscoverSeason {
        id
        name
        startDate
        endDate
        competition {
          id
          name
        }
      }
    }
    hostOrganisation {
      id
      name
      type
      logo {
        sizes {
          url
          dimensions {
            width
            height
          }
        }
      }
    }
    registrationUserTypes {
      name
      displayName
      value
    }
  }
  tenantConfiguration {
    label
    sport {
      name
    }
    ...TenantContactRolesConfiguration
  }
}
    ${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useOrganisationRegistrationsQuery__
 *
 * To run a query within a React component, call `useOrganisationRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationRegistrationsQuery({
 *   variables: {
 *      code: // value for 'code'
 *      codeString: // value for 'codeString'
 *   },
 * });
 */
export function useOrganisationRegistrationsQuery(baseOptions: Apollo.QueryHookOptions<OrganisationRegistrationsQuery, OrganisationRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationRegistrationsQuery, OrganisationRegistrationsQueryVariables>(OrganisationRegistrationsDocument, options);
      }
export function useOrganisationRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationRegistrationsQuery, OrganisationRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationRegistrationsQuery, OrganisationRegistrationsQueryVariables>(OrganisationRegistrationsDocument, options);
        }
export type OrganisationRegistrationsQueryHookResult = ReturnType<typeof useOrganisationRegistrationsQuery>;
export type OrganisationRegistrationsLazyQueryHookResult = ReturnType<typeof useOrganisationRegistrationsLazyQuery>;
export type OrganisationRegistrationsQueryResult = Apollo.QueryResult<OrganisationRegistrationsQuery, OrganisationRegistrationsQueryVariables>;
export const FindMyProfilesDocument = gql`
    query findMyProfiles {
  profile {
    id
    firstName
    lastName
    dateOfBirth
    gender {
      value
    }
    dependants {
      id
      firstName
      lastName
      dateOfBirth
      gender {
        value
      }
    }
  }
}
    `;

/**
 * __useFindMyProfilesQuery__
 *
 * To run a query within a React component, call `useFindMyProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFindMyProfilesQuery(baseOptions?: Apollo.QueryHookOptions<FindMyProfilesQuery, FindMyProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyProfilesQuery, FindMyProfilesQueryVariables>(FindMyProfilesDocument, options);
      }
export function useFindMyProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyProfilesQuery, FindMyProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyProfilesQuery, FindMyProfilesQueryVariables>(FindMyProfilesDocument, options);
        }
export type FindMyProfilesQueryHookResult = ReturnType<typeof useFindMyProfilesQuery>;
export type FindMyProfilesLazyQueryHookResult = ReturnType<typeof useFindMyProfilesLazyQuery>;
export type FindMyProfilesQueryResult = Apollo.QueryResult<FindMyProfilesQuery, FindMyProfilesQueryVariables>;
export const FindMyProfilesClaimProfilesDocument = gql`
    query findMyProfilesClaimProfiles($input: DuplicateProfileSearchInput!) {
  duplicateProfiles(searchParameters: $input) {
    id
    firstName
    lastName
    email
    mobileNumber
    lastRegisteredRole
    lastRegisteredSeason {
      id
      name
    }
    lastRegisteredOrganisation {
      id
      name
    }
    claimability
    isPrivate
    isMigrated
  }
}
    `;

/**
 * __useFindMyProfilesClaimProfilesQuery__
 *
 * To run a query within a React component, call `useFindMyProfilesClaimProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyProfilesClaimProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyProfilesClaimProfilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFindMyProfilesClaimProfilesQuery(baseOptions: Apollo.QueryHookOptions<FindMyProfilesClaimProfilesQuery, FindMyProfilesClaimProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyProfilesClaimProfilesQuery, FindMyProfilesClaimProfilesQueryVariables>(FindMyProfilesClaimProfilesDocument, options);
      }
export function useFindMyProfilesClaimProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyProfilesClaimProfilesQuery, FindMyProfilesClaimProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyProfilesClaimProfilesQuery, FindMyProfilesClaimProfilesQueryVariables>(FindMyProfilesClaimProfilesDocument, options);
        }
export type FindMyProfilesClaimProfilesQueryHookResult = ReturnType<typeof useFindMyProfilesClaimProfilesQuery>;
export type FindMyProfilesClaimProfilesLazyQueryHookResult = ReturnType<typeof useFindMyProfilesClaimProfilesLazyQuery>;
export type FindMyProfilesClaimProfilesQueryResult = Apollo.QueryResult<FindMyProfilesClaimProfilesQuery, FindMyProfilesClaimProfilesQueryVariables>;
export const GameCentreDiscoverGameDocument = gql`
    query gameCentreDiscoverGame($gameId: ID!) {
  discoverGame(gameID: $gameId) {
    id
    alias
    away {
      ... on ProvisionalTeam {
        name
      }
      ... on DiscoverTeam {
        id
        name
      }
    }
    home {
      ... on ProvisionalTeam {
        name
      }
      ... on DiscoverTeam {
        id
        name
      }
    }
    round {
      id
      name
      abbreviatedName
      grade {
        id
        name
        season {
          id
          name
          competition {
            id
            name
            organisation {
              ...OrganisationDetails
            }
          }
        }
      }
    }
  }
  tenantConfiguration {
    label
    ...TenantContactRolesConfiguration
  }
}
    ${OrganisationDetailsFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useGameCentreDiscoverGameQuery__
 *
 * To run a query within a React component, call `useGameCentreDiscoverGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameCentreDiscoverGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameCentreDiscoverGameQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useGameCentreDiscoverGameQuery(baseOptions: Apollo.QueryHookOptions<GameCentreDiscoverGameQuery, GameCentreDiscoverGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GameCentreDiscoverGameQuery, GameCentreDiscoverGameQueryVariables>(GameCentreDiscoverGameDocument, options);
      }
export function useGameCentreDiscoverGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameCentreDiscoverGameQuery, GameCentreDiscoverGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GameCentreDiscoverGameQuery, GameCentreDiscoverGameQueryVariables>(GameCentreDiscoverGameDocument, options);
        }
export type GameCentreDiscoverGameQueryHookResult = ReturnType<typeof useGameCentreDiscoverGameQuery>;
export type GameCentreDiscoverGameLazyQueryHookResult = ReturnType<typeof useGameCentreDiscoverGameLazyQuery>;
export type GameCentreDiscoverGameQueryResult = Apollo.QueryResult<GameCentreDiscoverGameQuery, GameCentreDiscoverGameQueryVariables>;
export const GameManageJwtGenerateDocument = gql`
    mutation gameManageJWTGenerate($token: String!) {
  gameManageJWTGenerate(token: $token) {
    jwt
    gameID
  }
}
    `;
export type GameManageJwtGenerateMutationFn = Apollo.MutationFunction<GameManageJwtGenerateMutation, GameManageJwtGenerateMutationVariables>;

/**
 * __useGameManageJwtGenerateMutation__
 *
 * To run a mutation, you first call `useGameManageJwtGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGameManageJwtGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [gameManageJwtGenerateMutation, { data, loading, error }] = useGameManageJwtGenerateMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useGameManageJwtGenerateMutation(baseOptions?: Apollo.MutationHookOptions<GameManageJwtGenerateMutation, GameManageJwtGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GameManageJwtGenerateMutation, GameManageJwtGenerateMutationVariables>(GameManageJwtGenerateDocument, options);
      }
export type GameManageJwtGenerateMutationHookResult = ReturnType<typeof useGameManageJwtGenerateMutation>;
export type GameManageJwtGenerateMutationResult = Apollo.MutationResult<GameManageJwtGenerateMutation>;
export type GameManageJwtGenerateMutationOptions = Apollo.BaseMutationOptions<GameManageJwtGenerateMutation, GameManageJwtGenerateMutationVariables>;
export const DiscoverGradeDocument = gql`
    query discoverGrade($gradeID: ID!) {
  discoverGrade(gradeID: $gradeID) {
    id
    name
    type
    season {
      id
      name
      competition {
        id
        name
        organisation {
          ...OrganisationDetails
        }
      }
    }
  }
  tenantConfiguration {
    label
    statistics {
      enabled
    }
    ...TenantContactRolesConfiguration
    gradeTypes {
      value
      isAllPlay
      features {
        hasRounds
        hasSeasonStats
        hasCareerStats
        hasGameStats
        hasFixture
        hasLadder
      }
    }
  }
}
    ${OrganisationDetailsFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useDiscoverGradeQuery__
 *
 * To run a query within a React component, call `useDiscoverGradeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverGradeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverGradeQuery({
 *   variables: {
 *      gradeID: // value for 'gradeID'
 *   },
 * });
 */
export function useDiscoverGradeQuery(baseOptions: Apollo.QueryHookOptions<DiscoverGradeQuery, DiscoverGradeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverGradeQuery, DiscoverGradeQueryVariables>(DiscoverGradeDocument, options);
      }
export function useDiscoverGradeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverGradeQuery, DiscoverGradeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverGradeQuery, DiscoverGradeQueryVariables>(DiscoverGradeDocument, options);
        }
export type DiscoverGradeQueryHookResult = ReturnType<typeof useDiscoverGradeQuery>;
export type DiscoverGradeLazyQueryHookResult = ReturnType<typeof useDiscoverGradeLazyQuery>;
export type DiscoverGradeQueryResult = Apollo.QueryResult<DiscoverGradeQuery, DiscoverGradeQueryVariables>;
export const GradeLadderDocument = gql`
    query gradeLadder($gradeID: ID!) {
  discoverGrade(gradeID: $gradeID) {
    id
    name
    season {
      id
      name
      competition {
        id
        type
        organisation {
          id
          name
        }
      }
    }
    ladderType
    ladder {
      pool {
        id
        name
      }
      generatedFrom {
        id
        name
      }
      standings {
        team {
          id
          name
          season {
            id
            name
            competition {
              id
              name
            }
          }
          organisation {
            id
            name
            type
          }
        }
        played
        won
        lost
        drawn
        byes
        pointsFor
        pointsAgainst
        pointsDifference
        forfeits
        disqualifications
        adjustments
        percentage
        alternatePercentage
        competitionPoints
        pointsAverage
        noResults
        ties
        quotient
        netRunRate
        runsFor
        oversFaced
        wicketsLost
        runsAgainst
        oversBowled
        wicketsTaken
        winOutright
        winFirstInnings
        lossOutright
        lossFirstInnings
        matchRatio
        bonusPoints
      }
      gameTypeValue
    }
    gameTypes {
      name
      value
      ladderFields {
        shortName
        key
        toolTip
        extendedToolTip
        type
        displayOrder
        dataType
        truncateTrailingZeros
        decimals
      }
      ladderRankingFields {
        fullName
        shortName
        key
        sortOrder
        toolTip
      }
      ladderType
    }
    overallLadder {
      ladderType
    }
    overallLadderFields {
      shortName
      key
      toolTip
      type
      displayOrder
      dataType
      truncateTrailingZeros
      decimals
    }
    overallLadderRankingFields {
      fullName
      shortName
      key
      sortOrder
      toolTip
    }
  }
}
    `;

/**
 * __useGradeLadderQuery__
 *
 * To run a query within a React component, call `useGradeLadderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradeLadderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradeLadderQuery({
 *   variables: {
 *      gradeID: // value for 'gradeID'
 *   },
 * });
 */
export function useGradeLadderQuery(baseOptions: Apollo.QueryHookOptions<GradeLadderQuery, GradeLadderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GradeLadderQuery, GradeLadderQueryVariables>(GradeLadderDocument, options);
      }
export function useGradeLadderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GradeLadderQuery, GradeLadderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GradeLadderQuery, GradeLadderQueryVariables>(GradeLadderDocument, options);
        }
export type GradeLadderQueryHookResult = ReturnType<typeof useGradeLadderQuery>;
export type GradeLadderLazyQueryHookResult = ReturnType<typeof useGradeLadderLazyQuery>;
export type GradeLadderQueryResult = Apollo.QueryResult<GradeLadderQuery, GradeLadderQueryVariables>;
export const GradeListDiscoverSeasonDocument = gql`
    query gradeListDiscoverSeason($id: String!) {
  discoverSeason(seasonID: $id) {
    id
    name
    competition {
      id
      name
      type
      organisation {
        ...OrganisationDetails
      }
    }
    status {
      name
      value
    }
    grades {
      id
      name
      day {
        name
        value
      }
      gender {
        name
        value
      }
      age {
        name
        value
      }
    }
  }
  tenantConfiguration {
    label
    competition {
      ageGroups {
        name
        value
      }
      genders {
        name
        value
      }
    }
    ...TenantContactRolesConfiguration
  }
}
    ${OrganisationDetailsFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useGradeListDiscoverSeasonQuery__
 *
 * To run a query within a React component, call `useGradeListDiscoverSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGradeListDiscoverSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGradeListDiscoverSeasonQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGradeListDiscoverSeasonQuery(baseOptions: Apollo.QueryHookOptions<GradeListDiscoverSeasonQuery, GradeListDiscoverSeasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GradeListDiscoverSeasonQuery, GradeListDiscoverSeasonQueryVariables>(GradeListDiscoverSeasonDocument, options);
      }
export function useGradeListDiscoverSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GradeListDiscoverSeasonQuery, GradeListDiscoverSeasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GradeListDiscoverSeasonQuery, GradeListDiscoverSeasonQueryVariables>(GradeListDiscoverSeasonDocument, options);
        }
export type GradeListDiscoverSeasonQueryHookResult = ReturnType<typeof useGradeListDiscoverSeasonQuery>;
export type GradeListDiscoverSeasonLazyQueryHookResult = ReturnType<typeof useGradeListDiscoverSeasonLazyQuery>;
export type GradeListDiscoverSeasonQueryResult = Apollo.QueryResult<GradeListDiscoverSeasonQuery, GradeListDiscoverSeasonQueryVariables>;
export const PublicGradeStatisticsDocument = gql`
    query publicGradeStatistics($gradeID: ID!, $filter: GradePlayerStatisticsFilter) {
  tenantConfiguration {
    statistics {
      enabled
      publicGradeStatisticsMeta {
        value
        name
        shortName
      }
    }
  }
  discoverGrade(gradeID: $gradeID) {
    id
    name
    season {
      id
      name
      competition {
        id
        organisation {
          id
          name
        }
      }
    }
  }
  gradePlayerStatistics(gradeID: $gradeID, filter: $filter) {
    meta {
      page
      totalPages
      totalRecords
    }
    results {
      ranking
      profile {
        id
        firstName
        lastName
      }
      team {
        name
      }
      statistics {
        count
        details {
          value
        }
      }
    }
  }
}
    `;

/**
 * __usePublicGradeStatisticsQuery__
 *
 * To run a query within a React component, call `usePublicGradeStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicGradeStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicGradeStatisticsQuery({
 *   variables: {
 *      gradeID: // value for 'gradeID'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePublicGradeStatisticsQuery(baseOptions: Apollo.QueryHookOptions<PublicGradeStatisticsQuery, PublicGradeStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicGradeStatisticsQuery, PublicGradeStatisticsQueryVariables>(PublicGradeStatisticsDocument, options);
      }
export function usePublicGradeStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicGradeStatisticsQuery, PublicGradeStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicGradeStatisticsQuery, PublicGradeStatisticsQueryVariables>(PublicGradeStatisticsDocument, options);
        }
export type PublicGradeStatisticsQueryHookResult = ReturnType<typeof usePublicGradeStatisticsQuery>;
export type PublicGradeStatisticsLazyQueryHookResult = ReturnType<typeof usePublicGradeStatisticsLazyQuery>;
export type PublicGradeStatisticsQueryResult = Apollo.QueryResult<PublicGradeStatisticsQuery, PublicGradeStatisticsQueryVariables>;
export const SubmitIncidentClearanceDocument = gql`
    mutation submitIncidentClearance($incidentID: ID!, $input: ConcussionClearanceInput!) {
  submitIncidentClearance(incidentID: $incidentID, input: $input) {
    id
  }
}
    `;
export type SubmitIncidentClearanceMutationFn = Apollo.MutationFunction<SubmitIncidentClearanceMutation, SubmitIncidentClearanceMutationVariables>;

/**
 * __useSubmitIncidentClearanceMutation__
 *
 * To run a mutation, you first call `useSubmitIncidentClearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitIncidentClearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitIncidentClearanceMutation, { data, loading, error }] = useSubmitIncidentClearanceMutation({
 *   variables: {
 *      incidentID: // value for 'incidentID'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitIncidentClearanceMutation(baseOptions?: Apollo.MutationHookOptions<SubmitIncidentClearanceMutation, SubmitIncidentClearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitIncidentClearanceMutation, SubmitIncidentClearanceMutationVariables>(SubmitIncidentClearanceDocument, options);
      }
export type SubmitIncidentClearanceMutationHookResult = ReturnType<typeof useSubmitIncidentClearanceMutation>;
export type SubmitIncidentClearanceMutationResult = Apollo.MutationResult<SubmitIncidentClearanceMutation>;
export type SubmitIncidentClearanceMutationOptions = Apollo.BaseMutationOptions<SubmitIncidentClearanceMutation, SubmitIncidentClearanceMutationVariables>;
export const RegistrationTypeDocument = gql`
    query registrationType($code: String!) {
  registrationSettings(code: $code) {
    ... on DiscoverRegistration {
      id
      type
    }
    ... on DiscoverSocialTeamRegistration {
      id
    }
  }
}
    `;

/**
 * __useRegistrationTypeQuery__
 *
 * To run a query within a React component, call `useRegistrationTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationTypeQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRegistrationTypeQuery(baseOptions: Apollo.QueryHookOptions<RegistrationTypeQuery, RegistrationTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationTypeQuery, RegistrationTypeQueryVariables>(RegistrationTypeDocument, options);
      }
export function useRegistrationTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationTypeQuery, RegistrationTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationTypeQuery, RegistrationTypeQueryVariables>(RegistrationTypeDocument, options);
        }
export type RegistrationTypeQueryHookResult = ReturnType<typeof useRegistrationTypeQuery>;
export type RegistrationTypeLazyQueryHookResult = ReturnType<typeof useRegistrationTypeLazyQuery>;
export type RegistrationTypeQueryResult = Apollo.QueryResult<RegistrationTypeQuery, RegistrationTypeQueryVariables>;
export const MyTeamsEnterVotesDocument = gql`
    query myTeamsEnterVotes($gameId: ID!, $teamId: ID!, $profileId: ID) {
  gameTeamAward(input: {gameID: $gameId, teamID: $teamId, profileID: $profileId}) {
    award {
      isOpen
      configuration {
        awardName
        highestVote
        totalVoters
      }
      voteSlips {
        voterName
        voterNumber
      }
    }
    players {
      id
      playerNumber
      firstName
      lastName
    }
  }
  discoverGame(gameID: $gameId) {
    id
    home {
      ... on DiscoverTeam {
        id
        name
      }
    }
    away {
      ... on DiscoverTeam {
        id
        name
      }
    }
    round {
      id
      name
    }
  }
}
    `;

/**
 * __useMyTeamsEnterVotesQuery__
 *
 * To run a query within a React component, call `useMyTeamsEnterVotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsEnterVotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsEnterVotesQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      teamId: // value for 'teamId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useMyTeamsEnterVotesQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsEnterVotesQuery, MyTeamsEnterVotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsEnterVotesQuery, MyTeamsEnterVotesQueryVariables>(MyTeamsEnterVotesDocument, options);
      }
export function useMyTeamsEnterVotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsEnterVotesQuery, MyTeamsEnterVotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsEnterVotesQuery, MyTeamsEnterVotesQueryVariables>(MyTeamsEnterVotesDocument, options);
        }
export type MyTeamsEnterVotesQueryHookResult = ReturnType<typeof useMyTeamsEnterVotesQuery>;
export type MyTeamsEnterVotesLazyQueryHookResult = ReturnType<typeof useMyTeamsEnterVotesLazyQuery>;
export type MyTeamsEnterVotesQueryResult = Apollo.QueryResult<MyTeamsEnterVotesQuery, MyTeamsEnterVotesQueryVariables>;
export const MyTeamsFixtureDocument = gql`
    query myTeamsFixture($teamID: ID!) {
  discoverTeamFixture(teamID: $teamID) {
    id
    name
    isStale
    provisionalDates
    grade {
      id
      name
      type
      season {
        id
        name
        competition {
          id
          name
          organisation {
            id
            name
          }
          type
        }
      }
      hideScores
    }
    fixture {
      ...RoundFixtureFragment
    }
  }
  tenantConfiguration {
    label
    gradeTypes {
      value
      isAllPlay
      features {
        hasRounds
        hasSeasonStats
        hasCareerStats
        hasGameStats
        hasFixture
        hasLadder
      }
    }
  }
}
    ${RoundFixtureFragmentFragmentDoc}`;

/**
 * __useMyTeamsFixtureQuery__
 *
 * To run a query within a React component, call `useMyTeamsFixtureQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsFixtureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsFixtureQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useMyTeamsFixtureQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsFixtureQuery, MyTeamsFixtureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsFixtureQuery, MyTeamsFixtureQueryVariables>(MyTeamsFixtureDocument, options);
      }
export function useMyTeamsFixtureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsFixtureQuery, MyTeamsFixtureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsFixtureQuery, MyTeamsFixtureQueryVariables>(MyTeamsFixtureDocument, options);
        }
export type MyTeamsFixtureQueryHookResult = ReturnType<typeof useMyTeamsFixtureQuery>;
export type MyTeamsFixtureLazyQueryHookResult = ReturnType<typeof useMyTeamsFixtureLazyQuery>;
export type MyTeamsFixtureQueryResult = Apollo.QueryResult<MyTeamsFixtureQuery, MyTeamsFixtureQueryVariables>;
export const MyTeamsGameManagementAccessDocument = gql`
    query myTeamsGameManagementAccess($gameId: ID!, $teamContextId: ID!, $profileId: ID) {
  gameTeamAward(input: {gameID: $gameId, teamID: $teamContextId, profileID: $profileId}) {
    award {
      isOpen
      configuration {
        awardName
      }
    }
  }
  myTeamsGame(input: {gameID: $gameId, profileID: $profileId, teamContextID: $teamContextId}) {
    id
    hasManagementAccess
    hasIncidentAccess
    dates
  }
  discoverGame(gameID: $gameId) {
    id
    home {
      ... on ProvisionalTeam {
        name
      }
      ... on DiscoverTeam {
        id
        name
      }
    }
    away {
      ... on ProvisionalTeam {
        name
      }
      ... on DiscoverTeam {
        id
        name
      }
    }
    round {
      id
      name
      abbreviatedName
      grade {
        id
        name
        season {
          id
          name
          competition {
            id
            name
            organisation {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyTeamsGameManagementAccessQuery__
 *
 * To run a query within a React component, call `useMyTeamsGameManagementAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsGameManagementAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsGameManagementAccessQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      teamContextId: // value for 'teamContextId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useMyTeamsGameManagementAccessQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsGameManagementAccessQuery, MyTeamsGameManagementAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsGameManagementAccessQuery, MyTeamsGameManagementAccessQueryVariables>(MyTeamsGameManagementAccessDocument, options);
      }
export function useMyTeamsGameManagementAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsGameManagementAccessQuery, MyTeamsGameManagementAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsGameManagementAccessQuery, MyTeamsGameManagementAccessQueryVariables>(MyTeamsGameManagementAccessDocument, options);
        }
export type MyTeamsGameManagementAccessQueryHookResult = ReturnType<typeof useMyTeamsGameManagementAccessQuery>;
export type MyTeamsGameManagementAccessLazyQueryHookResult = ReturnType<typeof useMyTeamsGameManagementAccessLazyQuery>;
export type MyTeamsGameManagementAccessQueryResult = Apollo.QueryResult<MyTeamsGameManagementAccessQuery, MyTeamsGameManagementAccessQueryVariables>;
export const MyTeamsGameIncidentDetailsDocument = gql`
    query myTeamsGameIncidentDetails($gameId: ID!, $teamContextId: ID!, $profileId: ID) {
  myTeamsGame(input: {gameID: $gameId, teamContextID: $teamContextId, profileID: $profileId}) {
    id
    dates
    ...IncidentGameFields
  }
  myTeamsTeam(input: {teamID: $teamContextId}) {
    id
    teamPlayers {
      participant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
    }
  }
}
    ${IncidentGameFieldsFragmentDoc}`;

/**
 * __useMyTeamsGameIncidentDetailsQuery__
 *
 * To run a query within a React component, call `useMyTeamsGameIncidentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsGameIncidentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsGameIncidentDetailsQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      teamContextId: // value for 'teamContextId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useMyTeamsGameIncidentDetailsQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsGameIncidentDetailsQuery, MyTeamsGameIncidentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsGameIncidentDetailsQuery, MyTeamsGameIncidentDetailsQueryVariables>(MyTeamsGameIncidentDetailsDocument, options);
      }
export function useMyTeamsGameIncidentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsGameIncidentDetailsQuery, MyTeamsGameIncidentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsGameIncidentDetailsQuery, MyTeamsGameIncidentDetailsQueryVariables>(MyTeamsGameIncidentDetailsDocument, options);
        }
export type MyTeamsGameIncidentDetailsQueryHookResult = ReturnType<typeof useMyTeamsGameIncidentDetailsQuery>;
export type MyTeamsGameIncidentDetailsLazyQueryHookResult = ReturnType<typeof useMyTeamsGameIncidentDetailsLazyQuery>;
export type MyTeamsGameIncidentDetailsQueryResult = Apollo.QueryResult<MyTeamsGameIncidentDetailsQuery, MyTeamsGameIncidentDetailsQueryVariables>;
export const CreateIncidentDocument = gql`
    mutation createIncident($input: IncidentCreateInput!) {
  incidentCreate(input: $input) {
    ...IncidentFields
  }
}
    ${IncidentFieldsFragmentDoc}`;
export type CreateIncidentMutationFn = Apollo.MutationFunction<CreateIncidentMutation, CreateIncidentMutationVariables>;

/**
 * __useCreateIncidentMutation__
 *
 * To run a mutation, you first call `useCreateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIncidentMutation, { data, loading, error }] = useCreateIncidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIncidentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIncidentMutation, CreateIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIncidentMutation, CreateIncidentMutationVariables>(CreateIncidentDocument, options);
      }
export type CreateIncidentMutationHookResult = ReturnType<typeof useCreateIncidentMutation>;
export type CreateIncidentMutationResult = Apollo.MutationResult<CreateIncidentMutation>;
export type CreateIncidentMutationOptions = Apollo.BaseMutationOptions<CreateIncidentMutation, CreateIncidentMutationVariables>;
export const GetIncidentDocument = gql`
    query getIncident($id: ID!) {
  incident(id: $id) {
    ...IncidentFields
  }
}
    ${IncidentFieldsFragmentDoc}`;

/**
 * __useGetIncidentQuery__
 *
 * To run a query within a React component, call `useGetIncidentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIncidentQuery(baseOptions: Apollo.QueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
      }
export function useGetIncidentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentQuery, GetIncidentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentQuery, GetIncidentQueryVariables>(GetIncidentDocument, options);
        }
export type GetIncidentQueryHookResult = ReturnType<typeof useGetIncidentQuery>;
export type GetIncidentLazyQueryHookResult = ReturnType<typeof useGetIncidentLazyQuery>;
export type GetIncidentQueryResult = Apollo.QueryResult<GetIncidentQuery, GetIncidentQueryVariables>;
export const GetIncidentRelatedGameDocument = gql`
    query getIncidentRelatedGame($gameId: ID!, $teamContextId: ID!, $profileId: ID) {
  myTeamsGame(input: {gameID: $gameId, teamContextID: $teamContextId, profileID: $profileId}) {
    ...IncidentGameFields
  }
}
    ${IncidentGameFieldsFragmentDoc}`;

/**
 * __useGetIncidentRelatedGameQuery__
 *
 * To run a query within a React component, call `useGetIncidentRelatedGameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIncidentRelatedGameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIncidentRelatedGameQuery({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      teamContextId: // value for 'teamContextId'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetIncidentRelatedGameQuery(baseOptions: Apollo.QueryHookOptions<GetIncidentRelatedGameQuery, GetIncidentRelatedGameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIncidentRelatedGameQuery, GetIncidentRelatedGameQueryVariables>(GetIncidentRelatedGameDocument, options);
      }
export function useGetIncidentRelatedGameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIncidentRelatedGameQuery, GetIncidentRelatedGameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIncidentRelatedGameQuery, GetIncidentRelatedGameQueryVariables>(GetIncidentRelatedGameDocument, options);
        }
export type GetIncidentRelatedGameQueryHookResult = ReturnType<typeof useGetIncidentRelatedGameQuery>;
export type GetIncidentRelatedGameLazyQueryHookResult = ReturnType<typeof useGetIncidentRelatedGameLazyQuery>;
export type GetIncidentRelatedGameQueryResult = Apollo.QueryResult<GetIncidentRelatedGameQuery, GetIncidentRelatedGameQueryVariables>;
export const UpdateIncidentDocument = gql`
    mutation updateIncident($id: ID!, $input: IncidentUpdateInput!) {
  incidentUpdate(id: $id, input: $input) {
    ...IncidentFields
  }
}
    ${IncidentFieldsFragmentDoc}`;
export type UpdateIncidentMutationFn = Apollo.MutationFunction<UpdateIncidentMutation, UpdateIncidentMutationVariables>;

/**
 * __useUpdateIncidentMutation__
 *
 * To run a mutation, you first call `useUpdateIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncidentMutation, { data, loading, error }] = useUpdateIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncidentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIncidentMutation, UpdateIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIncidentMutation, UpdateIncidentMutationVariables>(UpdateIncidentDocument, options);
      }
export type UpdateIncidentMutationHookResult = ReturnType<typeof useUpdateIncidentMutation>;
export type UpdateIncidentMutationResult = Apollo.MutationResult<UpdateIncidentMutation>;
export type UpdateIncidentMutationOptions = Apollo.BaseMutationOptions<UpdateIncidentMutation, UpdateIncidentMutationVariables>;
export const DeleteIncidentDocument = gql`
    mutation deleteIncident($id: ID!) {
  incidentDelete(id: $id) {
    __typename
  }
}
    `;
export type DeleteIncidentMutationFn = Apollo.MutationFunction<DeleteIncidentMutation, DeleteIncidentMutationVariables>;

/**
 * __useDeleteIncidentMutation__
 *
 * To run a mutation, you first call `useDeleteIncidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIncidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIncidentMutation, { data, loading, error }] = useDeleteIncidentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIncidentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIncidentMutation, DeleteIncidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIncidentMutation, DeleteIncidentMutationVariables>(DeleteIncidentDocument, options);
      }
export type DeleteIncidentMutationHookResult = ReturnType<typeof useDeleteIncidentMutation>;
export type DeleteIncidentMutationResult = Apollo.MutationResult<DeleteIncidentMutation>;
export type DeleteIncidentMutationOptions = Apollo.BaseMutationOptions<DeleteIncidentMutation, DeleteIncidentMutationVariables>;
export const ConfirmIncidentClearanceDocument = gql`
    mutation confirmIncidentClearance($incidentID: ID!, $profileID: ID) {
  confirmIncidentClearance(incidentID: $incidentID, profileID: $profileID) {
    id
  }
}
    `;
export type ConfirmIncidentClearanceMutationFn = Apollo.MutationFunction<ConfirmIncidentClearanceMutation, ConfirmIncidentClearanceMutationVariables>;

/**
 * __useConfirmIncidentClearanceMutation__
 *
 * To run a mutation, you first call `useConfirmIncidentClearanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmIncidentClearanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmIncidentClearanceMutation, { data, loading, error }] = useConfirmIncidentClearanceMutation({
 *   variables: {
 *      incidentID: // value for 'incidentID'
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function useConfirmIncidentClearanceMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmIncidentClearanceMutation, ConfirmIncidentClearanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmIncidentClearanceMutation, ConfirmIncidentClearanceMutationVariables>(ConfirmIncidentClearanceDocument, options);
      }
export type ConfirmIncidentClearanceMutationHookResult = ReturnType<typeof useConfirmIncidentClearanceMutation>;
export type ConfirmIncidentClearanceMutationResult = Apollo.MutationResult<ConfirmIncidentClearanceMutation>;
export type ConfirmIncidentClearanceMutationOptions = Apollo.BaseMutationOptions<ConfirmIncidentClearanceMutation, ConfirmIncidentClearanceMutationVariables>;
export const GetTeamIncidentsDocument = gql`
    query getTeamIncidents($teamID: ID!, $profileId: ID) {
  myTeamsTeam(input: {teamID: $teamID, profileID: $profileId}) {
    id
    teamPlayers {
      participant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
    }
    concussionIncidents {
      ...IncidentFields
    }
  }
}
    ${IncidentFieldsFragmentDoc}`;

/**
 * __useGetTeamIncidentsQuery__
 *
 * To run a query within a React component, call `useGetTeamIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamIncidentsQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      profileId: // value for 'profileId'
 *   },
 * });
 */
export function useGetTeamIncidentsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamIncidentsQuery, GetTeamIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamIncidentsQuery, GetTeamIncidentsQueryVariables>(GetTeamIncidentsDocument, options);
      }
export function useGetTeamIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamIncidentsQuery, GetTeamIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamIncidentsQuery, GetTeamIncidentsQueryVariables>(GetTeamIncidentsDocument, options);
        }
export type GetTeamIncidentsQueryHookResult = ReturnType<typeof useGetTeamIncidentsQuery>;
export type GetTeamIncidentsLazyQueryHookResult = ReturnType<typeof useGetTeamIncidentsLazyQuery>;
export type GetTeamIncidentsQueryResult = Apollo.QueryResult<GetTeamIncidentsQuery, GetTeamIncidentsQueryVariables>;
export const MyTeamsLadderDocument = gql`
    query myTeamsLadder($teamID: ID!) {
  discoverTeam(teamID: $teamID) {
    id
    name
    season {
      id
      name
      competition {
        id
        type
      }
    }
    grade {
      id
      name
      ladderType
      ladder(filter: {teamID: $teamID}) {
        pool {
          id
          name
        }
        generatedFrom {
          id
          name
        }
        standings {
          team {
            id
            name
            season {
              id
              name
              competition {
                id
                name
              }
            }
            organisation {
              id
              name
              type
            }
          }
          played
          won
          lost
          drawn
          byes
          pointsFor
          pointsAgainst
          pointsDifference
          forfeits
          disqualifications
          adjustments
          percentage
          alternatePercentage
          competitionPoints
          pointsAverage
          noResults
          ties
          quotient
          netRunRate
          runsFor
          oversFaced
          wicketsLost
          runsAgainst
          oversBowled
          wicketsTaken
          winOutright
          winFirstInnings
          lossOutright
          lossFirstInnings
          matchRatio
          bonusPoints
        }
        gameTypeValue
      }
      gameTypes {
        name
        value
        ladderFields {
          shortName
          key
          toolTip
          extendedToolTip
          type
          displayOrder
          dataType
          decimals
        }
        ladderRankingFields {
          fullName
          shortName
          key
          sortOrder
          toolTip
        }
      }
      overallLadder {
        ladderType
      }
      overallLadderFields {
        shortName
        key
        toolTip
        type
        displayOrder
        dataType
        decimals
      }
      overallLadderRankingFields {
        fullName
        shortName
        key
        sortOrder
        toolTip
      }
    }
    organisation {
      name
    }
  }
}
    `;

/**
 * __useMyTeamsLadderQuery__
 *
 * To run a query within a React component, call `useMyTeamsLadderQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsLadderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsLadderQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useMyTeamsLadderQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsLadderQuery, MyTeamsLadderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsLadderQuery, MyTeamsLadderQueryVariables>(MyTeamsLadderDocument, options);
      }
export function useMyTeamsLadderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsLadderQuery, MyTeamsLadderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsLadderQuery, MyTeamsLadderQueryVariables>(MyTeamsLadderDocument, options);
        }
export type MyTeamsLadderQueryHookResult = ReturnType<typeof useMyTeamsLadderQuery>;
export type MyTeamsLadderLazyQueryHookResult = ReturnType<typeof useMyTeamsLadderLazyQuery>;
export type MyTeamsLadderQueryResult = Apollo.QueryResult<MyTeamsLadderQuery, MyTeamsLadderQueryVariables>;
export const MyTeamsSquadDocument = gql`
    query myTeamsSquad($teamID: ID!, $profileID: ID) {
  discoverTeam(teamID: $teamID) {
    id
    season {
      id
      endDate
      status {
        value
      }
    }
  }
  myTeamsTeam(input: {teamID: $teamID, profileID: $profileID}) {
    id
    hasManagementAccess
    teamPlayers {
      participant {
        id
        profile {
          ...MyTeamsSquadProfileFragment
        }
        gamesPlayed
        totalStatistics {
          type {
            shortName
            value
          }
          count
        }
      }
      playerNumber
      captain {
        name
        value
        shortName
      }
    }
    coach {
      id
      profile {
        ...MyTeamsSquadProfileFragment
      }
    }
    assistantCoaches {
      id
      profile {
        ...MyTeamsSquadProfileFragment
      }
    }
    teamManagers {
      id
      profile {
        ...MyTeamsSquadProfileFragment
      }
    }
    organiser {
      ...MyTeamsSquadProfileFragment
    }
    registrationCode
  }
  tenantConfiguration {
    statistics {
      seasonStatisticsMeta {
        value
        isDisplayable
        inOffenceList
        offenceListPublicVisible
        shortName
        name
      }
    }
  }
}
    ${MyTeamsSquadProfileFragmentFragmentDoc}`;

/**
 * __useMyTeamsSquadQuery__
 *
 * To run a query within a React component, call `useMyTeamsSquadQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsSquadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsSquadQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function useMyTeamsSquadQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsSquadQuery, MyTeamsSquadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsSquadQuery, MyTeamsSquadQueryVariables>(MyTeamsSquadDocument, options);
      }
export function useMyTeamsSquadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsSquadQuery, MyTeamsSquadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsSquadQuery, MyTeamsSquadQueryVariables>(MyTeamsSquadDocument, options);
        }
export type MyTeamsSquadQueryHookResult = ReturnType<typeof useMyTeamsSquadQuery>;
export type MyTeamsSquadLazyQueryHookResult = ReturnType<typeof useMyTeamsSquadLazyQuery>;
export type MyTeamsSquadQueryResult = Apollo.QueryResult<MyTeamsSquadQuery, MyTeamsSquadQueryVariables>;
export const MyTeamsTeamDocument = gql`
    query myTeamsTeam($teamID: ID!, $profileID: ID) {
  discoverTeam(teamID: $teamID) {
    id
    name
    logo {
      sizes {
        url
        dimensions {
          width
          height
        }
      }
    }
    grade {
      id
      name
    }
    season {
      id
      name
      endDate
      competition {
        id
        name
      }
      status {
        value
      }
    }
    organisation {
      id
      name
      tenant {
        id
        name
      }
    }
  }
  myTeamsTeam(input: {teamID: $teamID, profileID: $profileID}) {
    id
    teamPlayers {
      participant {
        id
        profile {
          id
          firstName
          lastName
        }
      }
    }
    hasManagementAccess
    hasIncidentAccess
  }
}
    `;

/**
 * __useMyTeamsTeamQuery__
 *
 * To run a query within a React component, call `useMyTeamsTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyTeamsTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyTeamsTeamQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function useMyTeamsTeamQuery(baseOptions: Apollo.QueryHookOptions<MyTeamsTeamQuery, MyTeamsTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyTeamsTeamQuery, MyTeamsTeamQueryVariables>(MyTeamsTeamDocument, options);
      }
export function useMyTeamsTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyTeamsTeamQuery, MyTeamsTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyTeamsTeamQuery, MyTeamsTeamQueryVariables>(MyTeamsTeamDocument, options);
        }
export type MyTeamsTeamQueryHookResult = ReturnType<typeof useMyTeamsTeamQuery>;
export type MyTeamsTeamLazyQueryHookResult = ReturnType<typeof useMyTeamsTeamLazyQuery>;
export type MyTeamsTeamQueryResult = Apollo.QueryResult<MyTeamsTeamQuery, MyTeamsTeamQueryVariables>;
export const GetOrganisationNewsDocument = gql`
    query getOrganisationNews($orgCode: String!) {
  discoverOrganisation(code: $orgCode) {
    id
    name
  }
}
    `;

/**
 * __useGetOrganisationNewsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationNewsQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useGetOrganisationNewsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationNewsQuery, GetOrganisationNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationNewsQuery, GetOrganisationNewsQueryVariables>(GetOrganisationNewsDocument, options);
      }
export function useGetOrganisationNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationNewsQuery, GetOrganisationNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationNewsQuery, GetOrganisationNewsQueryVariables>(GetOrganisationNewsDocument, options);
        }
export type GetOrganisationNewsQueryHookResult = ReturnType<typeof useGetOrganisationNewsQuery>;
export type GetOrganisationNewsLazyQueryHookResult = ReturnType<typeof useGetOrganisationNewsLazyQuery>;
export type GetOrganisationNewsQueryResult = Apollo.QueryResult<GetOrganisationNewsQuery, GetOrganisationNewsQueryVariables>;
export const GetOrganisationNewsResultsDocument = gql`
    query getOrganisationNewsResults($input: DiscoverOrganisationPostsInput!) {
  discoverOrganisationPosts(input: $input) {
    results {
      id
      title
      image {
        heroImageUrl
        thumbnailUrl
      }
      publishedDateTime
      updatedDateTime
    }
    meta {
      page
      totalPages
      totalRecords
    }
  }
}
    `;

/**
 * __useGetOrganisationNewsResultsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationNewsResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationNewsResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationNewsResultsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrganisationNewsResultsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationNewsResultsQuery, GetOrganisationNewsResultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationNewsResultsQuery, GetOrganisationNewsResultsQueryVariables>(GetOrganisationNewsResultsDocument, options);
      }
export function useGetOrganisationNewsResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationNewsResultsQuery, GetOrganisationNewsResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationNewsResultsQuery, GetOrganisationNewsResultsQueryVariables>(GetOrganisationNewsResultsDocument, options);
        }
export type GetOrganisationNewsResultsQueryHookResult = ReturnType<typeof useGetOrganisationNewsResultsQuery>;
export type GetOrganisationNewsResultsLazyQueryHookResult = ReturnType<typeof useGetOrganisationNewsResultsLazyQuery>;
export type GetOrganisationNewsResultsQueryResult = Apollo.QueryResult<GetOrganisationNewsResultsQuery, GetOrganisationNewsResultsQueryVariables>;
export const GetNewsItemDocument = gql`
    query getNewsItem($postID: ID!, $includeProducts: Boolean = false) {
  discoverPost(postID: $postID) {
    id
    organisation {
      id
      name
      logo {
        sizes {
          url
          dimensions {
            height
            width
          }
        }
      }
      isTenantOrganisation
    }
    title
    body
    image {
      heroImageUrl
      caption
    }
    products @include(if: $includeProducts) {
      ...PostProduct
    }
    publishedDateTime
    updatedDateTime
  }
}
    ${PostProductFragmentDoc}`;

/**
 * __useGetNewsItemQuery__
 *
 * To run a query within a React component, call `useGetNewsItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsItemQuery({
 *   variables: {
 *      postID: // value for 'postID'
 *      includeProducts: // value for 'includeProducts'
 *   },
 * });
 */
export function useGetNewsItemQuery(baseOptions: Apollo.QueryHookOptions<GetNewsItemQuery, GetNewsItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsItemQuery, GetNewsItemQueryVariables>(GetNewsItemDocument, options);
      }
export function useGetNewsItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsItemQuery, GetNewsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsItemQuery, GetNewsItemQueryVariables>(GetNewsItemDocument, options);
        }
export type GetNewsItemQueryHookResult = ReturnType<typeof useGetNewsItemQuery>;
export type GetNewsItemLazyQueryHookResult = ReturnType<typeof useGetNewsItemLazyQuery>;
export type GetNewsItemQueryResult = Apollo.QueryResult<GetNewsItemQuery, GetNewsItemQueryVariables>;
export const EmailNotificationUnsubscribeDocument = gql`
    mutation emailNotificationUnsubscribe($input: EmailNotificationUnsubscribeInput!) {
  emailNotificationUnsubscribe(input: $input) {
    success
  }
}
    `;
export type EmailNotificationUnsubscribeMutationFn = Apollo.MutationFunction<EmailNotificationUnsubscribeMutation, EmailNotificationUnsubscribeMutationVariables>;

/**
 * __useEmailNotificationUnsubscribeMutation__
 *
 * To run a mutation, you first call `useEmailNotificationUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailNotificationUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailNotificationUnsubscribeMutation, { data, loading, error }] = useEmailNotificationUnsubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmailNotificationUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<EmailNotificationUnsubscribeMutation, EmailNotificationUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailNotificationUnsubscribeMutation, EmailNotificationUnsubscribeMutationVariables>(EmailNotificationUnsubscribeDocument, options);
      }
export type EmailNotificationUnsubscribeMutationHookResult = ReturnType<typeof useEmailNotificationUnsubscribeMutation>;
export type EmailNotificationUnsubscribeMutationResult = Apollo.MutationResult<EmailNotificationUnsubscribeMutation>;
export type EmailNotificationUnsubscribeMutationOptions = Apollo.BaseMutationOptions<EmailNotificationUnsubscribeMutation, EmailNotificationUnsubscribeMutationVariables>;
export const GetPaymentRequestProductDocument = gql`
    query getPaymentRequestProduct($productId: ID!) {
  paymentRequestProduct(id: $productId) {
    id
    name
    description
    productType
    settings {
      validFrom {
        date
      }
      validTo {
        date
      }
    }
    variants {
      id
      name
      amount {
        net
      }
      available
    }
  }
}
    `;

/**
 * __useGetPaymentRequestProductQuery__
 *
 * To run a query within a React component, call `useGetPaymentRequestProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentRequestProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentRequestProductQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetPaymentRequestProductQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentRequestProductQuery, GetPaymentRequestProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentRequestProductQuery, GetPaymentRequestProductQueryVariables>(GetPaymentRequestProductDocument, options);
      }
export function useGetPaymentRequestProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentRequestProductQuery, GetPaymentRequestProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentRequestProductQuery, GetPaymentRequestProductQueryVariables>(GetPaymentRequestProductDocument, options);
        }
export type GetPaymentRequestProductQueryHookResult = ReturnType<typeof useGetPaymentRequestProductQuery>;
export type GetPaymentRequestProductLazyQueryHookResult = ReturnType<typeof useGetPaymentRequestProductLazyQuery>;
export type GetPaymentRequestProductQueryResult = Apollo.QueryResult<GetPaymentRequestProductQuery, GetPaymentRequestProductQueryVariables>;
export const GetPostEmailUnsubscribeDocument = gql`
    query getPostEmailUnsubscribe($orgCode: String!) {
  discoverOrganisation(code: $orgCode) {
    id
    name
  }
}
    `;

/**
 * __useGetPostEmailUnsubscribeQuery__
 *
 * To run a query within a React component, call `useGetPostEmailUnsubscribeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPostEmailUnsubscribeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPostEmailUnsubscribeQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useGetPostEmailUnsubscribeQuery(baseOptions: Apollo.QueryHookOptions<GetPostEmailUnsubscribeQuery, GetPostEmailUnsubscribeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPostEmailUnsubscribeQuery, GetPostEmailUnsubscribeQueryVariables>(GetPostEmailUnsubscribeDocument, options);
      }
export function useGetPostEmailUnsubscribeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPostEmailUnsubscribeQuery, GetPostEmailUnsubscribeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPostEmailUnsubscribeQuery, GetPostEmailUnsubscribeQueryVariables>(GetPostEmailUnsubscribeDocument, options);
        }
export type GetPostEmailUnsubscribeQueryHookResult = ReturnType<typeof useGetPostEmailUnsubscribeQuery>;
export type GetPostEmailUnsubscribeLazyQueryHookResult = ReturnType<typeof useGetPostEmailUnsubscribeLazyQuery>;
export type GetPostEmailUnsubscribeQueryResult = Apollo.QueryResult<GetPostEmailUnsubscribeQuery, GetPostEmailUnsubscribeQueryVariables>;
export const PostEmailUnsubscribeDocument = gql`
    mutation postEmailUnsubscribe($input: PostEmailUnsubscribeInput!) {
  postEmailUnsubscribe(input: $input) {
    success
  }
}
    `;
export type PostEmailUnsubscribeMutationFn = Apollo.MutationFunction<PostEmailUnsubscribeMutation, PostEmailUnsubscribeMutationVariables>;

/**
 * __usePostEmailUnsubscribeMutation__
 *
 * To run a mutation, you first call `usePostEmailUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePostEmailUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [postEmailUnsubscribeMutation, { data, loading, error }] = usePostEmailUnsubscribeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePostEmailUnsubscribeMutation(baseOptions?: Apollo.MutationHookOptions<PostEmailUnsubscribeMutation, PostEmailUnsubscribeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PostEmailUnsubscribeMutation, PostEmailUnsubscribeMutationVariables>(PostEmailUnsubscribeDocument, options);
      }
export type PostEmailUnsubscribeMutationHookResult = ReturnType<typeof usePostEmailUnsubscribeMutation>;
export type PostEmailUnsubscribeMutationResult = Apollo.MutationResult<PostEmailUnsubscribeMutation>;
export type PostEmailUnsubscribeMutationOptions = Apollo.BaseMutationOptions<PostEmailUnsubscribeMutation, PostEmailUnsubscribeMutationVariables>;
export const ProfileHistoryDocument = gql`
    query profileHistory {
  account {
    id
    profile {
      ...HistoryFragment
      dependants {
        ...HistoryFragment
      }
    }
  }
}
    ${HistoryFragmentFragmentDoc}`;

/**
 * __useProfileHistoryQuery__
 *
 * To run a query within a React component, call `useProfileHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileHistoryQuery(baseOptions?: Apollo.QueryHookOptions<ProfileHistoryQuery, ProfileHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileHistoryQuery, ProfileHistoryQueryVariables>(ProfileHistoryDocument, options);
      }
export function useProfileHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileHistoryQuery, ProfileHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileHistoryQuery, ProfileHistoryQueryVariables>(ProfileHistoryDocument, options);
        }
export type ProfileHistoryQueryHookResult = ReturnType<typeof useProfileHistoryQuery>;
export type ProfileHistoryLazyQueryHookResult = ReturnType<typeof useProfileHistoryLazyQuery>;
export type ProfileHistoryQueryResult = Apollo.QueryResult<ProfileHistoryQuery, ProfileHistoryQueryVariables>;
export const GetProfileIncidentsDocument = gql`
    query getProfileIncidents($profileID: ID!, $includeDependant: Boolean!) {
  account {
    id
    profile {
      concussionIncidents {
        ...IncidentFields
      }
    }
  }
  dependantProfile(id: $profileID) @include(if: $includeDependant) {
    concussionIncidents {
      ...IncidentFields
    }
  }
}
    ${IncidentFieldsFragmentDoc}`;

/**
 * __useGetProfileIncidentsQuery__
 *
 * To run a query within a React component, call `useGetProfileIncidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileIncidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileIncidentsQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *      includeDependant: // value for 'includeDependant'
 *   },
 * });
 */
export function useGetProfileIncidentsQuery(baseOptions: Apollo.QueryHookOptions<GetProfileIncidentsQuery, GetProfileIncidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileIncidentsQuery, GetProfileIncidentsQueryVariables>(GetProfileIncidentsDocument, options);
      }
export function useGetProfileIncidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileIncidentsQuery, GetProfileIncidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileIncidentsQuery, GetProfileIncidentsQueryVariables>(GetProfileIncidentsDocument, options);
        }
export type GetProfileIncidentsQueryHookResult = ReturnType<typeof useGetProfileIncidentsQuery>;
export type GetProfileIncidentsLazyQueryHookResult = ReturnType<typeof useGetProfileIncidentsLazyQuery>;
export type GetProfileIncidentsQueryResult = Apollo.QueryResult<GetProfileIncidentsQuery, GetProfileIncidentsQueryVariables>;
export const InvoiceListDocument = gql`
    query invoiceList($filter: InvoicePaginatedFilter) {
  invoiceList(filter: $filter) {
    meta {
      page
      totalPages
      totalRecords
    }
    results {
      id
      createdAt
      total {
        currency {
          code
          symbol
        }
        net
        label
      }
      orderID
    }
  }
}
    `;

/**
 * __useInvoiceListQuery__
 *
 * To run a query within a React component, call `useInvoiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useInvoiceListQuery(baseOptions?: Apollo.QueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceListQuery, InvoiceListQueryVariables>(InvoiceListDocument, options);
      }
export function useInvoiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceListQuery, InvoiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceListQuery, InvoiceListQueryVariables>(InvoiceListDocument, options);
        }
export type InvoiceListQueryHookResult = ReturnType<typeof useInvoiceListQuery>;
export type InvoiceListLazyQueryHookResult = ReturnType<typeof useInvoiceListLazyQuery>;
export type InvoiceListQueryResult = Apollo.QueryResult<InvoiceListQuery, InvoiceListQueryVariables>;
export const InvoiceDownloadDocument = gql`
    mutation invoiceDownload($id: String!) {
  invoiceDownload(orderID: $id) {
    url
  }
}
    `;
export type InvoiceDownloadMutationFn = Apollo.MutationFunction<InvoiceDownloadMutation, InvoiceDownloadMutationVariables>;

/**
 * __useInvoiceDownloadMutation__
 *
 * To run a mutation, you first call `useInvoiceDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceDownloadMutation, { data, loading, error }] = useInvoiceDownloadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInvoiceDownloadMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceDownloadMutation, InvoiceDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceDownloadMutation, InvoiceDownloadMutationVariables>(InvoiceDownloadDocument, options);
      }
export type InvoiceDownloadMutationHookResult = ReturnType<typeof useInvoiceDownloadMutation>;
export type InvoiceDownloadMutationResult = Apollo.MutationResult<InvoiceDownloadMutation>;
export type InvoiceDownloadMutationOptions = Apollo.BaseMutationOptions<InvoiceDownloadMutation, InvoiceDownloadMutationVariables>;
export const ProfileMembershipsDocument = gql`
    query ProfileMemberships {
  account {
    id
    profile {
      ...ProfileMembershipsWithOrgFragment
      dependants {
        ...ProfileMembershipsWithOrgFragment
      }
    }
  }
}
    ${ProfileMembershipsWithOrgFragmentFragmentDoc}`;

/**
 * __useProfileMembershipsQuery__
 *
 * To run a query within a React component, call `useProfileMembershipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileMembershipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileMembershipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileMembershipsQuery(baseOptions?: Apollo.QueryHookOptions<ProfileMembershipsQuery, ProfileMembershipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileMembershipsQuery, ProfileMembershipsQueryVariables>(ProfileMembershipsDocument, options);
      }
export function useProfileMembershipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileMembershipsQuery, ProfileMembershipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileMembershipsQuery, ProfileMembershipsQueryVariables>(ProfileMembershipsDocument, options);
        }
export type ProfileMembershipsQueryHookResult = ReturnType<typeof useProfileMembershipsQuery>;
export type ProfileMembershipsLazyQueryHookResult = ReturnType<typeof useProfileMembershipsLazyQuery>;
export type ProfileMembershipsQueryResult = Apollo.QueryResult<ProfileMembershipsQuery, ProfileMembershipsQueryVariables>;
export const AccountMyTeamsListDocument = gql`
    query accountMyTeamsList {
  account {
    id
    profile {
      ...ProfileTeams
      dependants {
        ...ProfileTeams
      }
    }
  }
}
    ${ProfileTeamsFragmentDoc}`;

/**
 * __useAccountMyTeamsListQuery__
 *
 * To run a query within a React component, call `useAccountMyTeamsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMyTeamsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMyTeamsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountMyTeamsListQuery(baseOptions?: Apollo.QueryHookOptions<AccountMyTeamsListQuery, AccountMyTeamsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMyTeamsListQuery, AccountMyTeamsListQueryVariables>(AccountMyTeamsListDocument, options);
      }
export function useAccountMyTeamsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMyTeamsListQuery, AccountMyTeamsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMyTeamsListQuery, AccountMyTeamsListQueryVariables>(AccountMyTeamsListDocument, options);
        }
export type AccountMyTeamsListQueryHookResult = ReturnType<typeof useAccountMyTeamsListQuery>;
export type AccountMyTeamsListLazyQueryHookResult = ReturnType<typeof useAccountMyTeamsListLazyQuery>;
export type AccountMyTeamsListQueryResult = Apollo.QueryResult<AccountMyTeamsListQuery, AccountMyTeamsListQueryVariables>;
export const PublicProfileDocument = gql`
    query publicProfile($profileID: ID!) {
  publicProfile(profileID: $profileID) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __usePublicProfileQuery__
 *
 * To run a query within a React component, call `usePublicProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProfileQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function usePublicProfileQuery(baseOptions: Apollo.QueryHookOptions<PublicProfileQuery, PublicProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicProfileQuery, PublicProfileQueryVariables>(PublicProfileDocument, options);
      }
export function usePublicProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicProfileQuery, PublicProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicProfileQuery, PublicProfileQueryVariables>(PublicProfileDocument, options);
        }
export type PublicProfileQueryHookResult = ReturnType<typeof usePublicProfileQuery>;
export type PublicProfileLazyQueryHookResult = ReturnType<typeof usePublicProfileLazyQuery>;
export type PublicProfileQueryResult = Apollo.QueryResult<PublicProfileQuery, PublicProfileQueryVariables>;
export const PublicProfileTenantHistoryDocument = gql`
    query publicProfileTenantHistory($id: ID!) {
  profileTenantHistory(id: $id) {
    registrationHistory {
      name
      value
    }
  }
}
    `;

/**
 * __usePublicProfileTenantHistoryQuery__
 *
 * To run a query within a React component, call `usePublicProfileTenantHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProfileTenantHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProfileTenantHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePublicProfileTenantHistoryQuery(baseOptions: Apollo.QueryHookOptions<PublicProfileTenantHistoryQuery, PublicProfileTenantHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicProfileTenantHistoryQuery, PublicProfileTenantHistoryQueryVariables>(PublicProfileTenantHistoryDocument, options);
      }
export function usePublicProfileTenantHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicProfileTenantHistoryQuery, PublicProfileTenantHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicProfileTenantHistoryQuery, PublicProfileTenantHistoryQueryVariables>(PublicProfileTenantHistoryDocument, options);
        }
export type PublicProfileTenantHistoryQueryHookResult = ReturnType<typeof usePublicProfileTenantHistoryQuery>;
export type PublicProfileTenantHistoryLazyQueryHookResult = ReturnType<typeof usePublicProfileTenantHistoryLazyQuery>;
export type PublicProfileTenantHistoryQueryResult = Apollo.QueryResult<PublicProfileTenantHistoryQuery, PublicProfileTenantHistoryQueryVariables>;
export const ExternalStatisticsUrlDocument = gql`
    query externalStatisticsUrl {
  tenantConfiguration {
    label
    externalStatisticsUrls {
      url
      name
      value
    }
  }
}
    `;

/**
 * __useExternalStatisticsUrlQuery__
 *
 * To run a query within a React component, call `useExternalStatisticsUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalStatisticsUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalStatisticsUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useExternalStatisticsUrlQuery(baseOptions?: Apollo.QueryHookOptions<ExternalStatisticsUrlQuery, ExternalStatisticsUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalStatisticsUrlQuery, ExternalStatisticsUrlQueryVariables>(ExternalStatisticsUrlDocument, options);
      }
export function useExternalStatisticsUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalStatisticsUrlQuery, ExternalStatisticsUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalStatisticsUrlQuery, ExternalStatisticsUrlQueryVariables>(ExternalStatisticsUrlDocument, options);
        }
export type ExternalStatisticsUrlQueryHookResult = ReturnType<typeof useExternalStatisticsUrlQuery>;
export type ExternalStatisticsUrlLazyQueryHookResult = ReturnType<typeof useExternalStatisticsUrlLazyQuery>;
export type ExternalStatisticsUrlQueryResult = Apollo.QueryResult<ExternalStatisticsUrlQuery, ExternalStatisticsUrlQueryVariables>;
export const PublicProfileStatisticsDocument = gql`
    query publicProfileStatistics($profileID: ID!) {
  tenantConfiguration {
    label
    statistics {
      enabled
      careerStatisticsMeta {
        value
        name
        shortName
        isDisplayable
      }
      seasonStatisticsMeta {
        value
        name
        shortName
        isDisplayable
      }
    }
  }
  publicProfileStatistics(profileID: $profileID) {
    careerStatistics {
      totalStatistics {
        count
        details {
          value
        }
      }
      clubStatistics {
        id
        club {
          id
          name
        }
        statistics {
          count
          details {
            value
          }
        }
      }
    }
    seasonStatistics {
      name
      player {
        hasGamePermit
      }
      statistics {
        season {
          id
          name
          competition {
            id
            name
            organisation {
              id
              name
            }
          }
        }
        role
        club {
          id
          name
        }
        totalStatistics {
          count
          details {
            value
          }
        }
        teamStatistics {
          team {
            ... on DiscoverTeam {
              id
              name
            }
          }
          totalStatistics {
            count
            details {
              value
            }
          }
          gradeStatistics {
            grade {
              id
              name
            }
            totalStatistics {
              count
              details {
                value
              }
            }
            gameStatistics {
              game {
                id
                round {
                  name
                }
                home {
                  ... on DiscoverTeam {
                    id
                    name
                  }
                }
                away {
                  ... on DiscoverTeam {
                    id
                    name
                  }
                }
                date
                allocation {
                  court {
                    abbreviatedName
                    venue {
                      name
                    }
                  }
                }
              }
              statistics {
                count
                details {
                  value
                }
              }
            }
          }
        }
      }
    }
  }
  publicProfile(profileID: $profileID) {
    id
    firstName
    lastName
  }
}
    `;

/**
 * __usePublicProfileStatisticsQuery__
 *
 * To run a query within a React component, call `usePublicProfileStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicProfileStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicProfileStatisticsQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function usePublicProfileStatisticsQuery(baseOptions: Apollo.QueryHookOptions<PublicProfileStatisticsQuery, PublicProfileStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicProfileStatisticsQuery, PublicProfileStatisticsQueryVariables>(PublicProfileStatisticsDocument, options);
      }
export function usePublicProfileStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicProfileStatisticsQuery, PublicProfileStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicProfileStatisticsQuery, PublicProfileStatisticsQueryVariables>(PublicProfileStatisticsDocument, options);
        }
export type PublicProfileStatisticsQueryHookResult = ReturnType<typeof usePublicProfileStatisticsQuery>;
export type PublicProfileStatisticsLazyQueryHookResult = ReturnType<typeof usePublicProfileStatisticsLazyQuery>;
export type PublicProfileStatisticsQueryResult = Apollo.QueryResult<PublicProfileStatisticsQuery, PublicProfileStatisticsQueryVariables>;
export const ProfilesToRegisterDocument = gql`
    query profilesToRegister {
  account {
    id
    profile {
      id
      firstName
      lastName
      dependants {
        id
        firstName
        lastName
      }
      ...ExternalAccountsFragment
    }
  }
}
    ${ExternalAccountsFragmentFragmentDoc}`;

/**
 * __useProfilesToRegisterQuery__
 *
 * To run a query within a React component, call `useProfilesToRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfilesToRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfilesToRegisterQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfilesToRegisterQuery(baseOptions?: Apollo.QueryHookOptions<ProfilesToRegisterQuery, ProfilesToRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfilesToRegisterQuery, ProfilesToRegisterQueryVariables>(ProfilesToRegisterDocument, options);
      }
export function useProfilesToRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfilesToRegisterQuery, ProfilesToRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfilesToRegisterQuery, ProfilesToRegisterQueryVariables>(ProfilesToRegisterDocument, options);
        }
export type ProfilesToRegisterQueryHookResult = ReturnType<typeof useProfilesToRegisterQuery>;
export type ProfilesToRegisterLazyQueryHookResult = ReturnType<typeof useProfilesToRegisterLazyQuery>;
export type ProfilesToRegisterQueryResult = Apollo.QueryResult<ProfilesToRegisterQuery, ProfilesToRegisterQueryVariables>;
export const GetDuplicateProfilesDocument = gql`
    query getDuplicateProfiles($participantID: ID!, $registrationCode: String!) {
  tenantConfiguration {
    label
    claimProfilesIsMandatory
  }
  participant(id: $participantID) {
    id
    profile {
      id
      duplicateProfiles(registrationCode: $registrationCode) {
        id
        firstName
        lastName
        email
        mobileNumber
        lastRegisteredRole
        lastRegisteredSeason {
          id
          name
        }
        lastRegisteredOrganisation {
          id
          name
        }
        claimability
        isPrivate
        isMigrated
      }
    }
  }
}
    `;

/**
 * __useGetDuplicateProfilesQuery__
 *
 * To run a query within a React component, call `useGetDuplicateProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicateProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicateProfilesQuery({
 *   variables: {
 *      participantID: // value for 'participantID'
 *      registrationCode: // value for 'registrationCode'
 *   },
 * });
 */
export function useGetDuplicateProfilesQuery(baseOptions: Apollo.QueryHookOptions<GetDuplicateProfilesQuery, GetDuplicateProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuplicateProfilesQuery, GetDuplicateProfilesQueryVariables>(GetDuplicateProfilesDocument, options);
      }
export function useGetDuplicateProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuplicateProfilesQuery, GetDuplicateProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuplicateProfilesQuery, GetDuplicateProfilesQueryVariables>(GetDuplicateProfilesDocument, options);
        }
export type GetDuplicateProfilesQueryHookResult = ReturnType<typeof useGetDuplicateProfilesQuery>;
export type GetDuplicateProfilesLazyQueryHookResult = ReturnType<typeof useGetDuplicateProfilesLazyQuery>;
export type GetDuplicateProfilesQueryResult = Apollo.QueryResult<GetDuplicateProfilesQuery, GetDuplicateProfilesQueryVariables>;
export const GetParticipantTransferRequestsDocument = gql`
    query getParticipantTransferRequests($participantID: ID!) {
  participant(id: $participantID) {
    id
    type
    transferRequired {
      pendingTransferRequest {
        id
        destinationClub {
          name
        }
      }
      exceptionPeriod {
        id
      }
      hasRegistrationInSameSeason
      transferDeniedReason
    }
    profile {
      id
    }
    seasonRegistration {
      id
      season {
        ... on DiscoverSeason {
          id
          competition {
            id
            organisation {
              id
            }
          }
        }
      }
    }
    status
    clubChangeOptions
  }
  tenantConfiguration {
    transfers {
      transferSettingsOwner
    }
  }
}
    `;

/**
 * __useGetParticipantTransferRequestsQuery__
 *
 * To run a query within a React component, call `useGetParticipantTransferRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantTransferRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantTransferRequestsQuery({
 *   variables: {
 *      participantID: // value for 'participantID'
 *   },
 * });
 */
export function useGetParticipantTransferRequestsQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantTransferRequestsQuery, GetParticipantTransferRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantTransferRequestsQuery, GetParticipantTransferRequestsQueryVariables>(GetParticipantTransferRequestsDocument, options);
      }
export function useGetParticipantTransferRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantTransferRequestsQuery, GetParticipantTransferRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantTransferRequestsQuery, GetParticipantTransferRequestsQueryVariables>(GetParticipantTransferRequestsDocument, options);
        }
export type GetParticipantTransferRequestsQueryHookResult = ReturnType<typeof useGetParticipantTransferRequestsQuery>;
export type GetParticipantTransferRequestsLazyQueryHookResult = ReturnType<typeof useGetParticipantTransferRequestsLazyQuery>;
export type GetParticipantTransferRequestsQueryResult = Apollo.QueryResult<GetParticipantTransferRequestsQuery, GetParticipantTransferRequestsQueryVariables>;
export const LinkExternalAccountDocument = gql`
    mutation LinkExternalAccount($input: LinkExternalAccountInput!) {
  linkExternalAccount(input: $input) {
    tenantSlug
    externalAccountID
  }
}
    `;
export type LinkExternalAccountMutationFn = Apollo.MutationFunction<LinkExternalAccountMutation, LinkExternalAccountMutationVariables>;

/**
 * __useLinkExternalAccountMutation__
 *
 * To run a mutation, you first call `useLinkExternalAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkExternalAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkExternalAccountMutation, { data, loading, error }] = useLinkExternalAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkExternalAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkExternalAccountMutation, LinkExternalAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkExternalAccountMutation, LinkExternalAccountMutationVariables>(LinkExternalAccountDocument, options);
      }
export type LinkExternalAccountMutationHookResult = ReturnType<typeof useLinkExternalAccountMutation>;
export type LinkExternalAccountMutationResult = Apollo.MutationResult<LinkExternalAccountMutation>;
export type LinkExternalAccountMutationOptions = Apollo.BaseMutationOptions<LinkExternalAccountMutation, LinkExternalAccountMutationVariables>;
export const AccountLinkingConfigurationDocument = gql`
    query accountLinkingConfiguration {
  tenantConfiguration {
    ...ExternalAccountLinking
  }
}
    ${ExternalAccountLinkingFragmentDoc}`;

/**
 * __useAccountLinkingConfigurationQuery__
 *
 * To run a query within a React component, call `useAccountLinkingConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountLinkingConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountLinkingConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountLinkingConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<AccountLinkingConfigurationQuery, AccountLinkingConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountLinkingConfigurationQuery, AccountLinkingConfigurationQueryVariables>(AccountLinkingConfigurationDocument, options);
      }
export function useAccountLinkingConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountLinkingConfigurationQuery, AccountLinkingConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountLinkingConfigurationQuery, AccountLinkingConfigurationQueryVariables>(AccountLinkingConfigurationDocument, options);
        }
export type AccountLinkingConfigurationQueryHookResult = ReturnType<typeof useAccountLinkingConfigurationQuery>;
export type AccountLinkingConfigurationLazyQueryHookResult = ReturnType<typeof useAccountLinkingConfigurationLazyQuery>;
export type AccountLinkingConfigurationQueryResult = Apollo.QueryResult<AccountLinkingConfigurationQuery, AccountLinkingConfigurationQueryVariables>;
export const GetSportNameDocument = gql`
    query getSportName {
  tenantConfiguration {
    sport {
      name
    }
  }
}
    `;

/**
 * __useGetSportNameQuery__
 *
 * To run a query within a React component, call `useGetSportNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSportNameQuery(baseOptions?: Apollo.QueryHookOptions<GetSportNameQuery, GetSportNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportNameQuery, GetSportNameQueryVariables>(GetSportNameDocument, options);
      }
export function useGetSportNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportNameQuery, GetSportNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportNameQuery, GetSportNameQueryVariables>(GetSportNameDocument, options);
        }
export type GetSportNameQueryHookResult = ReturnType<typeof useGetSportNameQuery>;
export type GetSportNameLazyQueryHookResult = ReturnType<typeof useGetSportNameLazyQuery>;
export type GetSportNameQueryResult = Apollo.QueryResult<GetSportNameQuery, GetSportNameQueryVariables>;
export const UpdatePendingParticipantDocument = gql`
    mutation updatePendingParticipant($input: UpdatePendingParticipantInput!) {
  updatePendingParticipant(input: $input)
}
    `;
export type UpdatePendingParticipantMutationFn = Apollo.MutationFunction<UpdatePendingParticipantMutation, UpdatePendingParticipantMutationVariables>;

/**
 * __useUpdatePendingParticipantMutation__
 *
 * To run a mutation, you first call `useUpdatePendingParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePendingParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePendingParticipantMutation, { data, loading, error }] = useUpdatePendingParticipantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePendingParticipantMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePendingParticipantMutation, UpdatePendingParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePendingParticipantMutation, UpdatePendingParticipantMutationVariables>(UpdatePendingParticipantDocument, options);
      }
export type UpdatePendingParticipantMutationHookResult = ReturnType<typeof useUpdatePendingParticipantMutation>;
export type UpdatePendingParticipantMutationResult = Apollo.MutationResult<UpdatePendingParticipantMutation>;
export type UpdatePendingParticipantMutationOptions = Apollo.BaseMutationOptions<UpdatePendingParticipantMutation, UpdatePendingParticipantMutationVariables>;
export const RegistrationOverviewDocument = gql`
    query registrationOverview($code: String!) {
  registrationSettings(code: $code) {
    ... on DiscoverRegistration {
      id
      type
      season {
        ... on DiscoverSeason {
          id
          name
          startDate
          endDate
          competition {
            id
            name
            organisation {
              id
              name
            }
          }
          ageRestrictionRange {
            dobFromDate
            dobToDate
          }
          ageGroups {
            ageGroup {
              name
              value
            }
            equalToOrOlderThan {
              years
              months
              days
            }
            youngerThan {
              years
              months
              days
            }
            minDOB
            maxDOB
          }
        }
        ... on ProgramSeason {
          id
          name
          startDate
          endDate
          program {
            id
            name
            alias
          }
        }
      }
      registrationUserTypes {
        name
        displayName
        value
      }
      organisation {
        id
        name
      }
      pricingInfo
      additionalInfo
      registrationAgeRestriction {
        asAtDate
        range {
          min
          max
        }
      }
      groups {
        ...GroupLabel
      }
      ageGroupRestrictions {
        ageGroup {
          value
        }
        registrationInfo
      }
      daySessions {
        day
        startTime
        endTime
      }
      sessionCount
      gender
      playingSurface {
        id
        name
        venue {
          id
          name
        }
      }
    }
    ... on DiscoverSocialTeamRegistration {
      id
      season {
        ... on DiscoverSeason {
          id
          name
          startDate
          endDate
          competition {
            id
            name
            organisation {
              id
              name
            }
          }
        }
      }
      pricingInfo
      additionalInfo
    }
  }
}
    ${GroupLabelFragmentDoc}`;

/**
 * __useRegistrationOverviewQuery__
 *
 * To run a query within a React component, call `useRegistrationOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationOverviewQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRegistrationOverviewQuery(baseOptions: Apollo.QueryHookOptions<RegistrationOverviewQuery, RegistrationOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationOverviewQuery, RegistrationOverviewQueryVariables>(RegistrationOverviewDocument, options);
      }
export function useRegistrationOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationOverviewQuery, RegistrationOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationOverviewQuery, RegistrationOverviewQueryVariables>(RegistrationOverviewDocument, options);
        }
export type RegistrationOverviewQueryHookResult = ReturnType<typeof useRegistrationOverviewQuery>;
export type RegistrationOverviewLazyQueryHookResult = ReturnType<typeof useRegistrationOverviewLazyQuery>;
export type RegistrationOverviewQueryResult = Apollo.QueryResult<RegistrationOverviewQuery, RegistrationOverviewQueryVariables>;
export const ParticipantRegisterDocument = gql`
    mutation participantRegister($input: ParticipantRegisterInput!, $registrationCode: String) {
  participantRegister(input: $input) {
    id
    type
    profile {
      id
      firstName
      duplicateProfiles(registrationCode: $registrationCode) {
        id
      }
    }
    transferRequired {
      pendingTransferRequest {
        id
        destinationClub {
          id
          name
        }
        sourceAffiliation {
          club {
            id
            name
          }
        }
        createdAt
        season {
          id
          name
        }
        requestedBy
      }
      hasRegistrationInSameSeason
      exceptionPeriod {
        id
      }
      transferDeniedReason
    }
    seasonRegistration {
      id
      season {
        ... on DiscoverSeason {
          id
          competition {
            id
            organisation {
              id
            }
          }
        }
      }
    }
    status
    clubChangeOptions
  }
}
    `;
export type ParticipantRegisterMutationFn = Apollo.MutationFunction<ParticipantRegisterMutation, ParticipantRegisterMutationVariables>;

/**
 * __useParticipantRegisterMutation__
 *
 * To run a mutation, you first call `useParticipantRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipantRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participantRegisterMutation, { data, loading, error }] = useParticipantRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *      registrationCode: // value for 'registrationCode'
 *   },
 * });
 */
export function useParticipantRegisterMutation(baseOptions?: Apollo.MutationHookOptions<ParticipantRegisterMutation, ParticipantRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipantRegisterMutation, ParticipantRegisterMutationVariables>(ParticipantRegisterDocument, options);
      }
export type ParticipantRegisterMutationHookResult = ReturnType<typeof useParticipantRegisterMutation>;
export type ParticipantRegisterMutationResult = Apollo.MutationResult<ParticipantRegisterMutation>;
export type ParticipantRegisterMutationOptions = Apollo.BaseMutationOptions<ParticipantRegisterMutation, ParticipantRegisterMutationVariables>;
export const GetRegistrationTenantConfigurationDocument = gql`
    query getRegistrationTenantConfiguration($registrationId: String!, $role: CustomFieldApplicableRole) {
  tenantConfiguration {
    label
    seasonRegistration {
      coachingAccreditationConfig {
        selfSubmit
        accreditations {
          name
          value
        }
      }
      disabilities {
        name
        value
      }
    }
    discloseOptions {
      name
      value
    }
    sport {
      name
    }
  }
  configuration {
    supportedCountries {
      name
      alpha2Code
      mobileCountryCode
    }
  }
  discoverSeasonRegistration(registrationID: $registrationId) {
    id
    type
    questions {
      id
      question
    }
    customFields(role: $role) {
      ...TextCustomFieldDetails
      ...RecursiveDropdownCustomFieldsDetails
    }
    groups {
      ...GroupLabel
      userTypesMeta {
        name
        value
        registrationLimit {
          limitReached
        }
        fee {
          label
        }
      }
    }
    fieldEntries {
      childSafety {
        ...FieldSetFragment
      }
      profileQuestions {
        ...FieldSetFragment
      }
    }
  }
}
    ${TextCustomFieldDetailsFragmentDoc}
${RecursiveDropdownCustomFieldsDetailsFragmentDoc}
${GroupLabelFragmentDoc}
${FieldSetFragmentFragmentDoc}`;

/**
 * __useGetRegistrationTenantConfigurationQuery__
 *
 * To run a query within a React component, call `useGetRegistrationTenantConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationTenantConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationTenantConfigurationQuery({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGetRegistrationTenantConfigurationQuery(baseOptions: Apollo.QueryHookOptions<GetRegistrationTenantConfigurationQuery, GetRegistrationTenantConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistrationTenantConfigurationQuery, GetRegistrationTenantConfigurationQueryVariables>(GetRegistrationTenantConfigurationDocument, options);
      }
export function useGetRegistrationTenantConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistrationTenantConfigurationQuery, GetRegistrationTenantConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistrationTenantConfigurationQuery, GetRegistrationTenantConfigurationQueryVariables>(GetRegistrationTenantConfigurationDocument, options);
        }
export type GetRegistrationTenantConfigurationQueryHookResult = ReturnType<typeof useGetRegistrationTenantConfigurationQuery>;
export type GetRegistrationTenantConfigurationLazyQueryHookResult = ReturnType<typeof useGetRegistrationTenantConfigurationLazyQuery>;
export type GetRegistrationTenantConfigurationQueryResult = Apollo.QueryResult<GetRegistrationTenantConfigurationQuery, GetRegistrationTenantConfigurationQueryVariables>;
export const GetParticipantDetailsDocument = gql`
    query getParticipantDetails($participantId: ID!) {
  participant(id: $participantId) {
    id
    profile {
      id
      visible
    }
    school
    schoolData {
      schoolID
      name
      suburb
      state
      postcode
    }
    schoolYear
    playerNumber
    customFieldAnswers {
      ... on TextCustomFieldAnswer {
        question {
          id
        }
        answer
      }
      ... on DropdownCustomFieldAnswer {
        question {
          id
        }
        dropdownAnswer {
          id
        }
      }
    }
    preferredGroup {
      id
    }
  }
}
    `;

/**
 * __useGetParticipantDetailsQuery__
 *
 * To run a query within a React component, call `useGetParticipantDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantDetailsQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantDetailsQuery, GetParticipantDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantDetailsQuery, GetParticipantDetailsQueryVariables>(GetParticipantDetailsDocument, options);
      }
export function useGetParticipantDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantDetailsQuery, GetParticipantDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantDetailsQuery, GetParticipantDetailsQueryVariables>(GetParticipantDetailsDocument, options);
        }
export type GetParticipantDetailsQueryHookResult = ReturnType<typeof useGetParticipantDetailsQuery>;
export type GetParticipantDetailsLazyQueryHookResult = ReturnType<typeof useGetParticipantDetailsLazyQuery>;
export type GetParticipantDetailsQueryResult = Apollo.QueryResult<GetParticipantDetailsQuery, GetParticipantDetailsQueryVariables>;
export const GetProfileDocument = gql`
    query getProfile {
  account {
    id
    profile {
      id
      firstName
      lastName
      email
      gender {
        value
      }
      genderSelfDescribe
      dateOfBirth
      mobileNumber {
        countryAlphaCode
        countryCode {
          value
        }
        number
        displayNumber
      }
      preferredName
      countryOfBirth
      homeNumber
      indigenousDescent {
        value
      }
      address {
        id
        line1
        suburb
        postcode
        state
        country
      }
      emergencyContact {
        id
        firstName
        lastName
        email
        mobileNumber {
          countryAlphaCode
          countryCode {
            value
          }
          displayNumber
          number
        }
        relation
      }
      guardians {
        ... on Profile {
          id
          firstName
          lastName
          email
          mobileNumber {
            countryAlphaCode
            countryCode {
              value
            }
            displayNumber
            number
          }
          address {
            id
            line1
            suburb
            postcode
            state
            country
          }
        }
        ... on Guardian {
          id
          firstName
          lastName
          email
          mobileNumber {
            countryAlphaCode
            countryCode {
              value
            }
            displayNumber
            number
          }
          address {
            id
            line1
            suburb
            postcode
            state
            country
          }
        }
      }
      coachingAccreditation {
        id
        level {
          value
        }
      }
      childSafety {
        name
        label
        fields {
          name
          label
          value
          hidden
          ... on FieldInput {
            type
          }
          ... on FieldSelect {
            options {
              label
              value
            }
          }
        }
      }
      profileQuestions {
        name
        fields {
          name
          value
        }
      }
      guardianBornOverseas {
        value
      }
      guardian1CountryOfBirth
      guardian2CountryOfBirth
      hasDisability {
        value
      }
      disabilities {
        value
      }
      otherDisability
      disabilityHelp
      visible
    }
  }
}
    `;

/**
 * __useGetProfileQuery__
 *
 * To run a query within a React component, call `useGetProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfileQuery, GetProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfileQuery, GetProfileQueryVariables>(GetProfileDocument, options);
        }
export type GetProfileQueryHookResult = ReturnType<typeof useGetProfileQuery>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<GetProfileQuery, GetProfileQueryVariables>;
export const GetParentProfileDocument = gql`
    query getParentProfile {
  account {
    id
    profile {
      id
      firstName
      lastName
      email
      mobileNumber {
        countryAlphaCode
        countryCode {
          value
        }
        number
        displayNumber
      }
      address {
        id
        line1
        suburb
        postcode
        state
        country
      }
    }
  }
}
    `;

/**
 * __useGetParentProfileQuery__
 *
 * To run a query within a React component, call `useGetParentProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetParentProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetParentProfileQuery, GetParentProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentProfileQuery, GetParentProfileQueryVariables>(GetParentProfileDocument, options);
      }
export function useGetParentProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParentProfileQuery, GetParentProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentProfileQuery, GetParentProfileQueryVariables>(GetParentProfileDocument, options);
        }
export type GetParentProfileQueryHookResult = ReturnType<typeof useGetParentProfileQuery>;
export type GetParentProfileLazyQueryHookResult = ReturnType<typeof useGetParentProfileLazyQuery>;
export type GetParentProfileQueryResult = Apollo.QueryResult<GetParentProfileQuery, GetParentProfileQueryVariables>;
export const GetExistingDependantDocument = gql`
    query getExistingDependant($profileID: ID!) {
  dependantProfile(id: $profileID) {
    id
    firstName
    lastName
    gender {
      value
    }
    genderSelfDescribe
    dateOfBirth
    preferredName
    countryOfBirth
    homeNumber
    indigenousDescent {
      value
    }
    address {
      id
      line1
      suburb
      postcode
      state
      country
    }
    emergencyContact {
      id
      firstName
      lastName
      email
      mobileNumber {
        countryAlphaCode
        countryCode {
          value
        }
        number
        displayNumber
      }
      relation
    }
    guardians {
      ... on Profile {
        id
        firstName
        lastName
        email
        mobileNumber {
          countryAlphaCode
          countryCode {
            value
          }
          displayNumber
          number
        }
        address {
          id
          line1
          suburb
          postcode
          state
          country
        }
      }
      ... on Guardian {
        id
        firstName
        lastName
        email
        mobileNumber {
          countryAlphaCode
          countryCode {
            value
          }
          displayNumber
          number
        }
        address {
          id
          line1
          suburb
          postcode
          state
          country
        }
      }
    }
    coachingAccreditation {
      id
      level {
        value
      }
    }
    childSafety {
      name
      label
      fields {
        name
        label
        value
        hidden
        ... on FieldInput {
          type
        }
        ... on FieldSelect {
          options {
            label
            value
          }
        }
      }
    }
    profileQuestions {
      name
      fields {
        name
        value
      }
    }
    guardianBornOverseas {
      value
    }
    guardian1CountryOfBirth
    guardian2CountryOfBirth
    hasDisability {
      value
    }
    disabilities {
      value
    }
    otherDisability
    disabilityHelp
    visible
  }
}
    `;

/**
 * __useGetExistingDependantQuery__
 *
 * To run a query within a React component, call `useGetExistingDependantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExistingDependantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExistingDependantQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function useGetExistingDependantQuery(baseOptions: Apollo.QueryHookOptions<GetExistingDependantQuery, GetExistingDependantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExistingDependantQuery, GetExistingDependantQueryVariables>(GetExistingDependantDocument, options);
      }
export function useGetExistingDependantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExistingDependantQuery, GetExistingDependantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExistingDependantQuery, GetExistingDependantQueryVariables>(GetExistingDependantDocument, options);
        }
export type GetExistingDependantQueryHookResult = ReturnType<typeof useGetExistingDependantQuery>;
export type GetExistingDependantLazyQueryHookResult = ReturnType<typeof useGetExistingDependantLazyQuery>;
export type GetExistingDependantQueryResult = Apollo.QueryResult<GetExistingDependantQuery, GetExistingDependantQueryVariables>;
export const RegistrationAssertDocument = gql`
    query registrationAssert($input: RegistrationAssertInput!) {
  registrationAssert(input: $input) {
    hashKey
    timestampIso
  }
}
    `;

/**
 * __useRegistrationAssertQuery__
 *
 * To run a query within a React component, call `useRegistrationAssertQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationAssertQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationAssertQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationAssertQuery(baseOptions: Apollo.QueryHookOptions<RegistrationAssertQuery, RegistrationAssertQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationAssertQuery, RegistrationAssertQueryVariables>(RegistrationAssertDocument, options);
      }
export function useRegistrationAssertLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationAssertQuery, RegistrationAssertQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationAssertQuery, RegistrationAssertQueryVariables>(RegistrationAssertDocument, options);
        }
export type RegistrationAssertQueryHookResult = ReturnType<typeof useRegistrationAssertQuery>;
export type RegistrationAssertLazyQueryHookResult = ReturnType<typeof useRegistrationAssertLazyQuery>;
export type RegistrationAssertQueryResult = Apollo.QueryResult<RegistrationAssertQuery, RegistrationAssertQueryVariables>;
export const GetPaymentDetailsDocument = gql`
    query getPaymentDetails($code: String!) {
  registrationSettings(code: $code) {
    ... on DiscoverSocialTeamRegistration {
      id
      season {
        id
        name
        startDate
        endDate
        competition {
          id
          name
          organisation {
            id
            name
          }
          format {
            name
          }
        }
      }
    }
    ... on DiscoverRegistration {
      id
      type
      season {
        ... on DiscoverSeason {
          id
          name
          startDate
          endDate
          ageRestrictionRange {
            dobFromDate
            dobToDate
          }
          competition {
            id
            name
            organisation {
              id
              name
            }
            format {
              name
            }
          }
        }
        ... on ProgramSeason {
          id
          name
          startDate
          endDate
          program {
            id
            name
            format {
              name
            }
          }
        }
      }
    }
  }
  configuration {
    supportedCountries {
      name
      alpha2Code
      mobileCountryCode
    }
  }
  account {
    id
    profile {
      id
      address {
        id
        line1
        suburb
        postcode
        state
        country
      }
    }
  }
}
    `;

/**
 * __useGetPaymentDetailsQuery__
 *
 * To run a query within a React component, call `useGetPaymentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentDetailsQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetPaymentDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentDetailsQuery, GetPaymentDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentDetailsQuery, GetPaymentDetailsQueryVariables>(GetPaymentDetailsDocument, options);
      }
export function useGetPaymentDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentDetailsQuery, GetPaymentDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentDetailsQuery, GetPaymentDetailsQueryVariables>(GetPaymentDetailsDocument, options);
        }
export type GetPaymentDetailsQueryHookResult = ReturnType<typeof useGetPaymentDetailsQuery>;
export type GetPaymentDetailsLazyQueryHookResult = ReturnType<typeof useGetPaymentDetailsLazyQuery>;
export type GetPaymentDetailsQueryResult = Apollo.QueryResult<GetPaymentDetailsQuery, GetPaymentDetailsQueryVariables>;
export const OrderSubmitDocument = gql`
    mutation orderSubmit($input: OrderSubmitInput!) {
  orderSubmit(input: $input) {
    id
    amount {
      net
    }
    status
  }
}
    `;
export type OrderSubmitMutationFn = Apollo.MutationFunction<OrderSubmitMutation, OrderSubmitMutationVariables>;

/**
 * __useOrderSubmitMutation__
 *
 * To run a mutation, you first call `useOrderSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderSubmitMutation, { data, loading, error }] = useOrderSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderSubmitMutation(baseOptions?: Apollo.MutationHookOptions<OrderSubmitMutation, OrderSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderSubmitMutation, OrderSubmitMutationVariables>(OrderSubmitDocument, options);
      }
export type OrderSubmitMutationHookResult = ReturnType<typeof useOrderSubmitMutation>;
export type OrderSubmitMutationResult = Apollo.MutationResult<OrderSubmitMutation>;
export type OrderSubmitMutationOptions = Apollo.BaseMutationOptions<OrderSubmitMutation, OrderSubmitMutationVariables>;
export const GetParticipantExternalDocument = gql`
    query getParticipantExternal($participantID: ID!) {
  account {
    id
    profile {
      id
      mobileNumber {
        number
        countryCode {
          value
        }
      }
      email
      externalAccounts {
        tenantSlug
        externalAccountID
      }
    }
  }
  participant(id: $participantID) {
    id
    type
    profile {
      id
      gender {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useGetParticipantExternalQuery__
 *
 * To run a query within a React component, call `useGetParticipantExternalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantExternalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantExternalQuery({
 *   variables: {
 *      participantID: // value for 'participantID'
 *   },
 * });
 */
export function useGetParticipantExternalQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantExternalQuery, GetParticipantExternalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantExternalQuery, GetParticipantExternalQueryVariables>(GetParticipantExternalDocument, options);
      }
export function useGetParticipantExternalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantExternalQuery, GetParticipantExternalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantExternalQuery, GetParticipantExternalQueryVariables>(GetParticipantExternalDocument, options);
        }
export type GetParticipantExternalQueryHookResult = ReturnType<typeof useGetParticipantExternalQuery>;
export type GetParticipantExternalLazyQueryHookResult = ReturnType<typeof useGetParticipantExternalLazyQuery>;
export type GetParticipantExternalQueryResult = Apollo.QueryResult<GetParticipantExternalQuery, GetParticipantExternalQueryVariables>;
export const ProductsUpdateCartDocument = gql`
    mutation productsUpdateCart($input: SeasonRegistrationProductCartInput!) {
  productsUpdateCart(input: $input) {
    ...CartFragment
  }
}
    ${CartFragmentFragmentDoc}`;
export type ProductsUpdateCartMutationFn = Apollo.MutationFunction<ProductsUpdateCartMutation, ProductsUpdateCartMutationVariables>;

/**
 * __useProductsUpdateCartMutation__
 *
 * To run a mutation, you first call `useProductsUpdateCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductsUpdateCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productsUpdateCartMutation, { data, loading, error }] = useProductsUpdateCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductsUpdateCartMutation(baseOptions?: Apollo.MutationHookOptions<ProductsUpdateCartMutation, ProductsUpdateCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductsUpdateCartMutation, ProductsUpdateCartMutationVariables>(ProductsUpdateCartDocument, options);
      }
export type ProductsUpdateCartMutationHookResult = ReturnType<typeof useProductsUpdateCartMutation>;
export type ProductsUpdateCartMutationResult = Apollo.MutationResult<ProductsUpdateCartMutation>;
export type ProductsUpdateCartMutationOptions = Apollo.BaseMutationOptions<ProductsUpdateCartMutation, ProductsUpdateCartMutationVariables>;
export const ProductUpdateSocialTeamCartDocument = gql`
    mutation productUpdateSocialTeamCart($input: SocialTeamRegistrationProductCartInput!) {
  productUpdateSocialTeamCart(input: $input) {
    ...TeamCartFragment
  }
}
    ${TeamCartFragmentFragmentDoc}`;
export type ProductUpdateSocialTeamCartMutationFn = Apollo.MutationFunction<ProductUpdateSocialTeamCartMutation, ProductUpdateSocialTeamCartMutationVariables>;

/**
 * __useProductUpdateSocialTeamCartMutation__
 *
 * To run a mutation, you first call `useProductUpdateSocialTeamCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProductUpdateSocialTeamCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [productUpdateSocialTeamCartMutation, { data, loading, error }] = useProductUpdateSocialTeamCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductUpdateSocialTeamCartMutation(baseOptions?: Apollo.MutationHookOptions<ProductUpdateSocialTeamCartMutation, ProductUpdateSocialTeamCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProductUpdateSocialTeamCartMutation, ProductUpdateSocialTeamCartMutationVariables>(ProductUpdateSocialTeamCartDocument, options);
      }
export type ProductUpdateSocialTeamCartMutationHookResult = ReturnType<typeof useProductUpdateSocialTeamCartMutation>;
export type ProductUpdateSocialTeamCartMutationResult = Apollo.MutationResult<ProductUpdateSocialTeamCartMutation>;
export type ProductUpdateSocialTeamCartMutationOptions = Apollo.BaseMutationOptions<ProductUpdateSocialTeamCartMutation, ProductUpdateSocialTeamCartMutationVariables>;
export const GetProfilePhotoVerificationUploadUrlDocument = gql`
    query getProfilePhotoVerificationUploadURL($dependantProfileID: ID) {
  profilePhotoVerificationUploadURL(dependantProfileID: $dependantProfileID) {
    url
  }
}
    `;

/**
 * __useGetProfilePhotoVerificationUploadUrlQuery__
 *
 * To run a query within a React component, call `useGetProfilePhotoVerificationUploadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePhotoVerificationUploadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePhotoVerificationUploadUrlQuery({
 *   variables: {
 *      dependantProfileID: // value for 'dependantProfileID'
 *   },
 * });
 */
export function useGetProfilePhotoVerificationUploadUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetProfilePhotoVerificationUploadUrlQuery, GetProfilePhotoVerificationUploadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePhotoVerificationUploadUrlQuery, GetProfilePhotoVerificationUploadUrlQueryVariables>(GetProfilePhotoVerificationUploadUrlDocument, options);
      }
export function useGetProfilePhotoVerificationUploadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePhotoVerificationUploadUrlQuery, GetProfilePhotoVerificationUploadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePhotoVerificationUploadUrlQuery, GetProfilePhotoVerificationUploadUrlQueryVariables>(GetProfilePhotoVerificationUploadUrlDocument, options);
        }
export type GetProfilePhotoVerificationUploadUrlQueryHookResult = ReturnType<typeof useGetProfilePhotoVerificationUploadUrlQuery>;
export type GetProfilePhotoVerificationUploadUrlLazyQueryHookResult = ReturnType<typeof useGetProfilePhotoVerificationUploadUrlLazyQuery>;
export type GetProfilePhotoVerificationUploadUrlQueryResult = Apollo.QueryResult<GetProfilePhotoVerificationUploadUrlQuery, GetProfilePhotoVerificationUploadUrlQueryVariables>;
export const GetProfilePhotoVerificationUrlDocument = gql`
    query getProfilePhotoVerificationURL($profileID: ID) {
  profile(id: $profileID) {
    profilePhotoVerificationURL {
      url
    }
  }
}
    `;

/**
 * __useGetProfilePhotoVerificationUrlQuery__
 *
 * To run a query within a React component, call `useGetProfilePhotoVerificationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePhotoVerificationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePhotoVerificationUrlQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function useGetProfilePhotoVerificationUrlQuery(baseOptions?: Apollo.QueryHookOptions<GetProfilePhotoVerificationUrlQuery, GetProfilePhotoVerificationUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePhotoVerificationUrlQuery, GetProfilePhotoVerificationUrlQueryVariables>(GetProfilePhotoVerificationUrlDocument, options);
      }
export function useGetProfilePhotoVerificationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePhotoVerificationUrlQuery, GetProfilePhotoVerificationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePhotoVerificationUrlQuery, GetProfilePhotoVerificationUrlQueryVariables>(GetProfilePhotoVerificationUrlDocument, options);
        }
export type GetProfilePhotoVerificationUrlQueryHookResult = ReturnType<typeof useGetProfilePhotoVerificationUrlQuery>;
export type GetProfilePhotoVerificationUrlLazyQueryHookResult = ReturnType<typeof useGetProfilePhotoVerificationUrlLazyQuery>;
export type GetProfilePhotoVerificationUrlQueryResult = Apollo.QueryResult<GetProfilePhotoVerificationUrlQuery, GetProfilePhotoVerificationUrlQueryVariables>;
export const GetDependantProfilePhotoVerificationUrlDocument = gql`
    query getDependantProfilePhotoVerificationURL($profileID: ID!) {
  dependantProfile(id: $profileID) {
    profilePhotoVerificationURL {
      url
    }
  }
}
    `;

/**
 * __useGetDependantProfilePhotoVerificationUrlQuery__
 *
 * To run a query within a React component, call `useGetDependantProfilePhotoVerificationUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDependantProfilePhotoVerificationUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDependantProfilePhotoVerificationUrlQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *   },
 * });
 */
export function useGetDependantProfilePhotoVerificationUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDependantProfilePhotoVerificationUrlQuery, GetDependantProfilePhotoVerificationUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDependantProfilePhotoVerificationUrlQuery, GetDependantProfilePhotoVerificationUrlQueryVariables>(GetDependantProfilePhotoVerificationUrlDocument, options);
      }
export function useGetDependantProfilePhotoVerificationUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDependantProfilePhotoVerificationUrlQuery, GetDependantProfilePhotoVerificationUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDependantProfilePhotoVerificationUrlQuery, GetDependantProfilePhotoVerificationUrlQueryVariables>(GetDependantProfilePhotoVerificationUrlDocument, options);
        }
export type GetDependantProfilePhotoVerificationUrlQueryHookResult = ReturnType<typeof useGetDependantProfilePhotoVerificationUrlQuery>;
export type GetDependantProfilePhotoVerificationUrlLazyQueryHookResult = ReturnType<typeof useGetDependantProfilePhotoVerificationUrlLazyQuery>;
export type GetDependantProfilePhotoVerificationUrlQueryResult = Apollo.QueryResult<GetDependantProfilePhotoVerificationUrlQuery, GetDependantProfilePhotoVerificationUrlQueryVariables>;
export const GetProfilePhotoVerificationConfigDocument = gql`
    query getProfilePhotoVerificationConfig {
  tenantConfiguration {
    seasonRegistration {
      photoVerification {
        enabled
        requiredMinimumAge
        roles
      }
    }
  }
}
    `;

/**
 * __useGetProfilePhotoVerificationConfigQuery__
 *
 * To run a query within a React component, call `useGetProfilePhotoVerificationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProfilePhotoVerificationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfilePhotoVerificationConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProfilePhotoVerificationConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetProfilePhotoVerificationConfigQuery, GetProfilePhotoVerificationConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProfilePhotoVerificationConfigQuery, GetProfilePhotoVerificationConfigQueryVariables>(GetProfilePhotoVerificationConfigDocument, options);
      }
export function useGetProfilePhotoVerificationConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProfilePhotoVerificationConfigQuery, GetProfilePhotoVerificationConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProfilePhotoVerificationConfigQuery, GetProfilePhotoVerificationConfigQueryVariables>(GetProfilePhotoVerificationConfigDocument, options);
        }
export type GetProfilePhotoVerificationConfigQueryHookResult = ReturnType<typeof useGetProfilePhotoVerificationConfigQuery>;
export type GetProfilePhotoVerificationConfigLazyQueryHookResult = ReturnType<typeof useGetProfilePhotoVerificationConfigLazyQuery>;
export type GetProfilePhotoVerificationConfigQueryResult = Apollo.QueryResult<GetProfilePhotoVerificationConfigQuery, GetProfilePhotoVerificationConfigQueryVariables>;
export const GetRegistrationStatusDocument = gql`
    query GetRegistrationStatus($code: String!, $participantId: ID!) {
  participant(id: $participantId) {
    id
    profile {
      id
      registrationHistory {
        ... on Participant {
          id
          type
          seasonRegistration {
            id
            season {
              ... on DiscoverSeason {
                id
                competition {
                  id
                }
              }
            }
            organisation {
              id
              name
            }
          }
        }
      }
    }
    status
    clubChangeOptions
  }
  registrationSettings(code: $code) {
    ... on DiscoverRegistration {
      season {
        ... on DiscoverSeason {
          id
          name
          competition {
            id
            name
            organisation {
              id
              name
            }
          }
        }
      }
      organisation {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRegistrationStatusQuery__
 *
 * To run a query within a React component, call `useGetRegistrationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationStatusQuery({
 *   variables: {
 *      code: // value for 'code'
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetRegistrationStatusQuery(baseOptions: Apollo.QueryHookOptions<GetRegistrationStatusQuery, GetRegistrationStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistrationStatusQuery, GetRegistrationStatusQueryVariables>(GetRegistrationStatusDocument, options);
      }
export function useGetRegistrationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistrationStatusQuery, GetRegistrationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistrationStatusQuery, GetRegistrationStatusQueryVariables>(GetRegistrationStatusDocument, options);
        }
export type GetRegistrationStatusQueryHookResult = ReturnType<typeof useGetRegistrationStatusQuery>;
export type GetRegistrationStatusLazyQueryHookResult = ReturnType<typeof useGetRegistrationStatusLazyQuery>;
export type GetRegistrationStatusQueryResult = Apollo.QueryResult<GetRegistrationStatusQuery, GetRegistrationStatusQueryVariables>;
export const TransferRequestCreateDocument = gql`
    mutation TransferRequestCreate($participantID: ID!) {
  transferRequestCreate(participantID: $participantID) {
    id
  }
}
    `;
export type TransferRequestCreateMutationFn = Apollo.MutationFunction<TransferRequestCreateMutation, TransferRequestCreateMutationVariables>;

/**
 * __useTransferRequestCreateMutation__
 *
 * To run a mutation, you first call `useTransferRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferRequestCreateMutation, { data, loading, error }] = useTransferRequestCreateMutation({
 *   variables: {
 *      participantID: // value for 'participantID'
 *   },
 * });
 */
export function useTransferRequestCreateMutation(baseOptions?: Apollo.MutationHookOptions<TransferRequestCreateMutation, TransferRequestCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TransferRequestCreateMutation, TransferRequestCreateMutationVariables>(TransferRequestCreateDocument, options);
      }
export type TransferRequestCreateMutationHookResult = ReturnType<typeof useTransferRequestCreateMutation>;
export type TransferRequestCreateMutationResult = Apollo.MutationResult<TransferRequestCreateMutation>;
export type TransferRequestCreateMutationOptions = Apollo.BaseMutationOptions<TransferRequestCreateMutation, TransferRequestCreateMutationVariables>;
export const PermitRequestCreateDocument = gql`
    mutation PermitRequestCreate($participantID: ID!) {
  permitRequestCreate(participantID: $participantID) {
    id
  }
}
    `;
export type PermitRequestCreateMutationFn = Apollo.MutationFunction<PermitRequestCreateMutation, PermitRequestCreateMutationVariables>;

/**
 * __usePermitRequestCreateMutation__
 *
 * To run a mutation, you first call `usePermitRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePermitRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [permitRequestCreateMutation, { data, loading, error }] = usePermitRequestCreateMutation({
 *   variables: {
 *      participantID: // value for 'participantID'
 *   },
 * });
 */
export function usePermitRequestCreateMutation(baseOptions?: Apollo.MutationHookOptions<PermitRequestCreateMutation, PermitRequestCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PermitRequestCreateMutation, PermitRequestCreateMutationVariables>(PermitRequestCreateDocument, options);
      }
export type PermitRequestCreateMutationHookResult = ReturnType<typeof usePermitRequestCreateMutation>;
export type PermitRequestCreateMutationResult = Apollo.MutationResult<PermitRequestCreateMutation>;
export type PermitRequestCreateMutationOptions = Apollo.BaseMutationOptions<PermitRequestCreateMutation, PermitRequestCreateMutationVariables>;
export const RegistrationCheckDocument = gql`
    query RegistrationCheck($input: RegistrationCheckInput!) {
  registrationCheck(input: $input) {
    alreadyRegisteredToRole
    approvedParticipantID
    hasAffiliationChangedSinceParticipantCreation
    transferRequest {
      id
      status
      createdAt
      sourceAffiliation {
        id
        club {
          id
          name
        }
      }
      destinationClub {
        id
        name
      }
      season {
        id
        name
      }
      requestedBy
    }
    permitRequest {
      id
      status
    }
  }
  tenantConfiguration {
    transfers {
      transferSettingsOwner
    }
  }
}
    `;

/**
 * __useRegistrationCheckQuery__
 *
 * To run a query within a React component, call `useRegistrationCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrationCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrationCheckQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegistrationCheckQuery(baseOptions: Apollo.QueryHookOptions<RegistrationCheckQuery, RegistrationCheckQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrationCheckQuery, RegistrationCheckQueryVariables>(RegistrationCheckDocument, options);
      }
export function useRegistrationCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrationCheckQuery, RegistrationCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrationCheckQuery, RegistrationCheckQueryVariables>(RegistrationCheckDocument, options);
        }
export type RegistrationCheckQueryHookResult = ReturnType<typeof useRegistrationCheckQuery>;
export type RegistrationCheckLazyQueryHookResult = ReturnType<typeof useRegistrationCheckLazyQuery>;
export type RegistrationCheckQueryResult = Apollo.QueryResult<RegistrationCheckQuery, RegistrationCheckQueryVariables>;
export const GetPendingTransferRequestForPrimaryProfileDocument = gql`
    query getPendingTransferRequestForPrimaryProfile($filter: TransferRequestsFilter) {
  account {
    id
    profile {
      id
      transferRequests(filter: $filter) {
        id
      }
    }
  }
}
    `;

/**
 * __useGetPendingTransferRequestForPrimaryProfileQuery__
 *
 * To run a query within a React component, call `useGetPendingTransferRequestForPrimaryProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingTransferRequestForPrimaryProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingTransferRequestForPrimaryProfileQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPendingTransferRequestForPrimaryProfileQuery(baseOptions?: Apollo.QueryHookOptions<GetPendingTransferRequestForPrimaryProfileQuery, GetPendingTransferRequestForPrimaryProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingTransferRequestForPrimaryProfileQuery, GetPendingTransferRequestForPrimaryProfileQueryVariables>(GetPendingTransferRequestForPrimaryProfileDocument, options);
      }
export function useGetPendingTransferRequestForPrimaryProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingTransferRequestForPrimaryProfileQuery, GetPendingTransferRequestForPrimaryProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingTransferRequestForPrimaryProfileQuery, GetPendingTransferRequestForPrimaryProfileQueryVariables>(GetPendingTransferRequestForPrimaryProfileDocument, options);
        }
export type GetPendingTransferRequestForPrimaryProfileQueryHookResult = ReturnType<typeof useGetPendingTransferRequestForPrimaryProfileQuery>;
export type GetPendingTransferRequestForPrimaryProfileLazyQueryHookResult = ReturnType<typeof useGetPendingTransferRequestForPrimaryProfileLazyQuery>;
export type GetPendingTransferRequestForPrimaryProfileQueryResult = Apollo.QueryResult<GetPendingTransferRequestForPrimaryProfileQuery, GetPendingTransferRequestForPrimaryProfileQueryVariables>;
export const GetPendingTransferRequestForExistingDependantDocument = gql`
    query getPendingTransferRequestForExistingDependant($profileID: ID!, $filter: TransferRequestsFilter) {
  dependantProfile(id: $profileID) {
    id
    transferRequests(filter: $filter) {
      id
    }
  }
}
    `;

/**
 * __useGetPendingTransferRequestForExistingDependantQuery__
 *
 * To run a query within a React component, call `useGetPendingTransferRequestForExistingDependantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingTransferRequestForExistingDependantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingTransferRequestForExistingDependantQuery({
 *   variables: {
 *      profileID: // value for 'profileID'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPendingTransferRequestForExistingDependantQuery(baseOptions: Apollo.QueryHookOptions<GetPendingTransferRequestForExistingDependantQuery, GetPendingTransferRequestForExistingDependantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPendingTransferRequestForExistingDependantQuery, GetPendingTransferRequestForExistingDependantQueryVariables>(GetPendingTransferRequestForExistingDependantDocument, options);
      }
export function useGetPendingTransferRequestForExistingDependantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPendingTransferRequestForExistingDependantQuery, GetPendingTransferRequestForExistingDependantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPendingTransferRequestForExistingDependantQuery, GetPendingTransferRequestForExistingDependantQueryVariables>(GetPendingTransferRequestForExistingDependantDocument, options);
        }
export type GetPendingTransferRequestForExistingDependantQueryHookResult = ReturnType<typeof useGetPendingTransferRequestForExistingDependantQuery>;
export type GetPendingTransferRequestForExistingDependantLazyQueryHookResult = ReturnType<typeof useGetPendingTransferRequestForExistingDependantLazyQuery>;
export type GetPendingTransferRequestForExistingDependantQueryResult = Apollo.QueryResult<GetPendingTransferRequestForExistingDependantQuery, GetPendingTransferRequestForExistingDependantQueryVariables>;
export const DiscoverSeasonRegistrationDocument = gql`
    query discoverSeasonRegistration($registrationId: String!) {
  discoverSeasonRegistration(registrationID: $registrationId) {
    id
    registrationUserTypes {
      name
      displayName
      value
      registrationLimit {
        limitReached
      }
    }
  }
}
    `;

/**
 * __useDiscoverSeasonRegistrationQuery__
 *
 * To run a query within a React component, call `useDiscoverSeasonRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverSeasonRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverSeasonRegistrationQuery({
 *   variables: {
 *      registrationId: // value for 'registrationId'
 *   },
 * });
 */
export function useDiscoverSeasonRegistrationQuery(baseOptions: Apollo.QueryHookOptions<DiscoverSeasonRegistrationQuery, DiscoverSeasonRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverSeasonRegistrationQuery, DiscoverSeasonRegistrationQueryVariables>(DiscoverSeasonRegistrationDocument, options);
      }
export function useDiscoverSeasonRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverSeasonRegistrationQuery, DiscoverSeasonRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverSeasonRegistrationQuery, DiscoverSeasonRegistrationQueryVariables>(DiscoverSeasonRegistrationDocument, options);
        }
export type DiscoverSeasonRegistrationQueryHookResult = ReturnType<typeof useDiscoverSeasonRegistrationQuery>;
export type DiscoverSeasonRegistrationLazyQueryHookResult = ReturnType<typeof useDiscoverSeasonRegistrationLazyQuery>;
export type DiscoverSeasonRegistrationQueryResult = Apollo.QueryResult<DiscoverSeasonRegistrationQuery, DiscoverSeasonRegistrationQueryVariables>;
export const ProfileRegistrationHistoryDocument = gql`
    query profileRegistrationHistory {
  account {
    id
    profile {
      ...RegistrationHistoryFragment
      dependants {
        ...RegistrationHistoryFragment
      }
    }
  }
}
    ${RegistrationHistoryFragmentFragmentDoc}`;

/**
 * __useProfileRegistrationHistoryQuery__
 *
 * To run a query within a React component, call `useProfileRegistrationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileRegistrationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileRegistrationHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileRegistrationHistoryQuery(baseOptions?: Apollo.QueryHookOptions<ProfileRegistrationHistoryQuery, ProfileRegistrationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileRegistrationHistoryQuery, ProfileRegistrationHistoryQueryVariables>(ProfileRegistrationHistoryDocument, options);
      }
export function useProfileRegistrationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileRegistrationHistoryQuery, ProfileRegistrationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileRegistrationHistoryQuery, ProfileRegistrationHistoryQueryVariables>(ProfileRegistrationHistoryDocument, options);
        }
export type ProfileRegistrationHistoryQueryHookResult = ReturnType<typeof useProfileRegistrationHistoryQuery>;
export type ProfileRegistrationHistoryLazyQueryHookResult = ReturnType<typeof useProfileRegistrationHistoryLazyQuery>;
export type ProfileRegistrationHistoryQueryResult = Apollo.QueryResult<ProfileRegistrationHistoryQuery, ProfileRegistrationHistoryQueryVariables>;
export const GetRegistrationForShareDocument = gql`
    query getRegistrationForShare($code: String!, $teamId: ID!, $skipTeam: Boolean! = true) {
  registrationSettings(code: $code) {
    ... on DiscoverRegistration {
      id
      type
      season {
        ... on DiscoverSeason {
          ...DiscoverSeasonDetails
        }
        ... on ProgramSeason {
          ...ProgramSeasonDetails
        }
      }
      organisation {
        id
        name
      }
    }
    ... on DiscoverSocialTeamRegistration {
      id
      season {
        id
        name
        competition {
          id
          name
          organisation {
            id
            name
          }
        }
      }
    }
  }
  discoverTeam(teamID: $teamId) @skip(if: $skipTeam) {
    id
    name
    preferredGrade
  }
}
    ${DiscoverSeasonDetailsFragmentDoc}
${ProgramSeasonDetailsFragmentDoc}`;

/**
 * __useGetRegistrationForShareQuery__
 *
 * To run a query within a React component, call `useGetRegistrationForShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistrationForShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistrationForShareQuery({
 *   variables: {
 *      code: // value for 'code'
 *      teamId: // value for 'teamId'
 *      skipTeam: // value for 'skipTeam'
 *   },
 * });
 */
export function useGetRegistrationForShareQuery(baseOptions: Apollo.QueryHookOptions<GetRegistrationForShareQuery, GetRegistrationForShareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegistrationForShareQuery, GetRegistrationForShareQueryVariables>(GetRegistrationForShareDocument, options);
      }
export function useGetRegistrationForShareLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegistrationForShareQuery, GetRegistrationForShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegistrationForShareQuery, GetRegistrationForShareQueryVariables>(GetRegistrationForShareDocument, options);
        }
export type GetRegistrationForShareQueryHookResult = ReturnType<typeof useGetRegistrationForShareQuery>;
export type GetRegistrationForShareLazyQueryHookResult = ReturnType<typeof useGetRegistrationForShareLazyQuery>;
export type GetRegistrationForShareQueryResult = Apollo.QueryResult<GetRegistrationForShareQuery, GetRegistrationForShareQueryVariables>;
export const SocialTeamRegistrationSubmitDocument = gql`
    mutation socialTeamRegistrationSubmit($input: SocialTeamCreateInput!) {
  socialTeamRegistrationSubmit(input: $input) {
    id
    name
  }
}
    `;
export type SocialTeamRegistrationSubmitMutationFn = Apollo.MutationFunction<SocialTeamRegistrationSubmitMutation, SocialTeamRegistrationSubmitMutationVariables>;

/**
 * __useSocialTeamRegistrationSubmitMutation__
 *
 * To run a mutation, you first call `useSocialTeamRegistrationSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialTeamRegistrationSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialTeamRegistrationSubmitMutation, { data, loading, error }] = useSocialTeamRegistrationSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialTeamRegistrationSubmitMutation(baseOptions?: Apollo.MutationHookOptions<SocialTeamRegistrationSubmitMutation, SocialTeamRegistrationSubmitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SocialTeamRegistrationSubmitMutation, SocialTeamRegistrationSubmitMutationVariables>(SocialTeamRegistrationSubmitDocument, options);
      }
export type SocialTeamRegistrationSubmitMutationHookResult = ReturnType<typeof useSocialTeamRegistrationSubmitMutation>;
export type SocialTeamRegistrationSubmitMutationResult = Apollo.MutationResult<SocialTeamRegistrationSubmitMutation>;
export type SocialTeamRegistrationSubmitMutationOptions = Apollo.BaseMutationOptions<SocialTeamRegistrationSubmitMutation, SocialTeamRegistrationSubmitMutationVariables>;
export const GetSocialTeamGradesAndOrganisationDocument = gql`
    query getSocialTeamGradesAndOrganisation($code: ID!) {
  discoverSocialTeamRegistration(registrationID: $code) {
    id
    grades {
      id
      name
      day {
        value
      }
      gender {
        value
      }
    }
    season {
      id
      name
      competition {
        id
        name
        organisation {
          id
          name
        }
      }
    }
    customFields {
      ...TextCustomFieldDetails
      ...RecursiveDropdownCustomFieldsDetails
    }
  }
}
    ${TextCustomFieldDetailsFragmentDoc}
${RecursiveDropdownCustomFieldsDetailsFragmentDoc}`;

/**
 * __useGetSocialTeamGradesAndOrganisationQuery__
 *
 * To run a query within a React component, call `useGetSocialTeamGradesAndOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSocialTeamGradesAndOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSocialTeamGradesAndOrganisationQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetSocialTeamGradesAndOrganisationQuery(baseOptions: Apollo.QueryHookOptions<GetSocialTeamGradesAndOrganisationQuery, GetSocialTeamGradesAndOrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSocialTeamGradesAndOrganisationQuery, GetSocialTeamGradesAndOrganisationQueryVariables>(GetSocialTeamGradesAndOrganisationDocument, options);
      }
export function useGetSocialTeamGradesAndOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSocialTeamGradesAndOrganisationQuery, GetSocialTeamGradesAndOrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSocialTeamGradesAndOrganisationQuery, GetSocialTeamGradesAndOrganisationQueryVariables>(GetSocialTeamGradesAndOrganisationDocument, options);
        }
export type GetSocialTeamGradesAndOrganisationQueryHookResult = ReturnType<typeof useGetSocialTeamGradesAndOrganisationQuery>;
export type GetSocialTeamGradesAndOrganisationLazyQueryHookResult = ReturnType<typeof useGetSocialTeamGradesAndOrganisationLazyQuery>;
export type GetSocialTeamGradesAndOrganisationQueryResult = Apollo.QueryResult<GetSocialTeamGradesAndOrganisationQuery, GetSocialTeamGradesAndOrganisationQueryVariables>;
export const GetMySocialTeamsDocument = gql`
    query getMySocialTeams($organisationId: ID) {
  account {
    id
    profile {
      id
      socialTeams(organisationID: $organisationId) {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetMySocialTeamsQuery__
 *
 * To run a query within a React component, call `useGetMySocialTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMySocialTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMySocialTeamsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useGetMySocialTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetMySocialTeamsQuery, GetMySocialTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMySocialTeamsQuery, GetMySocialTeamsQueryVariables>(GetMySocialTeamsDocument, options);
      }
export function useGetMySocialTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMySocialTeamsQuery, GetMySocialTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMySocialTeamsQuery, GetMySocialTeamsQueryVariables>(GetMySocialTeamsDocument, options);
        }
export type GetMySocialTeamsQueryHookResult = ReturnType<typeof useGetMySocialTeamsQuery>;
export type GetMySocialTeamsLazyQueryHookResult = ReturnType<typeof useGetMySocialTeamsLazyQuery>;
export type GetMySocialTeamsQueryResult = Apollo.QueryResult<GetMySocialTeamsQuery, GetMySocialTeamsQueryVariables>;
export const DiscoverDiscountDocument = gql`
    query discoverDiscount($input: DiscoverDiscountInput!) {
  discoverDiscount(input: $input) {
    id
    enabled
  }
}
    `;

/**
 * __useDiscoverDiscountQuery__
 *
 * To run a query within a React component, call `useDiscoverDiscountQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverDiscountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverDiscountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDiscoverDiscountQuery(baseOptions: Apollo.QueryHookOptions<DiscoverDiscountQuery, DiscoverDiscountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverDiscountQuery, DiscoverDiscountQueryVariables>(DiscoverDiscountDocument, options);
      }
export function useDiscoverDiscountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverDiscountQuery, DiscoverDiscountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverDiscountQuery, DiscoverDiscountQueryVariables>(DiscoverDiscountDocument, options);
        }
export type DiscoverDiscountQueryHookResult = ReturnType<typeof useDiscoverDiscountQuery>;
export type DiscoverDiscountLazyQueryHookResult = ReturnType<typeof useDiscoverDiscountLazyQuery>;
export type DiscoverDiscountQueryResult = Apollo.QueryResult<DiscoverDiscountQuery, DiscoverDiscountQueryVariables>;
export const SeasonRegistrationsDocument = gql`
    query seasonRegistrations($seasonId: ID!) {
  seasonRegistrations(seasonID: $seasonId) {
    id
    type
    registrationCode
  }
}
    `;

/**
 * __useSeasonRegistrationsQuery__
 *
 * To run a query within a React component, call `useSeasonRegistrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeasonRegistrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeasonRegistrationsQuery({
 *   variables: {
 *      seasonId: // value for 'seasonId'
 *   },
 * });
 */
export function useSeasonRegistrationsQuery(baseOptions: Apollo.QueryHookOptions<SeasonRegistrationsQuery, SeasonRegistrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeasonRegistrationsQuery, SeasonRegistrationsQueryVariables>(SeasonRegistrationsDocument, options);
      }
export function useSeasonRegistrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeasonRegistrationsQuery, SeasonRegistrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeasonRegistrationsQuery, SeasonRegistrationsQueryVariables>(SeasonRegistrationsDocument, options);
        }
export type SeasonRegistrationsQueryHookResult = ReturnType<typeof useSeasonRegistrationsQuery>;
export type SeasonRegistrationsLazyQueryHookResult = ReturnType<typeof useSeasonRegistrationsLazyQuery>;
export type SeasonRegistrationsQueryResult = Apollo.QueryResult<SeasonRegistrationsQuery, SeasonRegistrationsQueryVariables>;
export const GetTeamAndSeasonRegDocument = gql`
    query getTeamAndSeasonReg($code: String!, $teamId: ID!) {
  discoverTeam(teamID: $teamId) {
    id
    name
    preferredGrade
  }
  registrationSettings(code: $code) {
    ... on DiscoverSocialTeamRegistration {
      id
      season {
        id
        name
        competition {
          id
          name
          organisation {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTeamAndSeasonRegQuery__
 *
 * To run a query within a React component, call `useGetTeamAndSeasonRegQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamAndSeasonRegQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamAndSeasonRegQuery({
 *   variables: {
 *      code: // value for 'code'
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamAndSeasonRegQuery(baseOptions: Apollo.QueryHookOptions<GetTeamAndSeasonRegQuery, GetTeamAndSeasonRegQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamAndSeasonRegQuery, GetTeamAndSeasonRegQueryVariables>(GetTeamAndSeasonRegDocument, options);
      }
export function useGetTeamAndSeasonRegLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamAndSeasonRegQuery, GetTeamAndSeasonRegQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamAndSeasonRegQuery, GetTeamAndSeasonRegQueryVariables>(GetTeamAndSeasonRegDocument, options);
        }
export type GetTeamAndSeasonRegQueryHookResult = ReturnType<typeof useGetTeamAndSeasonRegQuery>;
export type GetTeamAndSeasonRegLazyQueryHookResult = ReturnType<typeof useGetTeamAndSeasonRegLazyQuery>;
export type GetTeamAndSeasonRegQueryResult = Apollo.QueryResult<GetTeamAndSeasonRegQuery, GetTeamAndSeasonRegQueryVariables>;
export const GetParticipantDocument = gql`
    query getParticipant($participantId: ID!) {
  participant(id: $participantId) {
    id
    transferRequired {
      pendingTransferRequest {
        id
      }
      hasRegistrationInSameSeason
    }
  }
}
    `;

/**
 * __useGetParticipantQuery__
 *
 * To run a query within a React component, call `useGetParticipantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParticipantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParticipantQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useGetParticipantQuery(baseOptions: Apollo.QueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
      }
export function useGetParticipantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParticipantQuery, GetParticipantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParticipantQuery, GetParticipantQueryVariables>(GetParticipantDocument, options);
        }
export type GetParticipantQueryHookResult = ReturnType<typeof useGetParticipantQuery>;
export type GetParticipantLazyQueryHookResult = ReturnType<typeof useGetParticipantLazyQuery>;
export type GetParticipantQueryResult = Apollo.QueryResult<GetParticipantQuery, GetParticipantQueryVariables>;
export const RequestTransferDocument = gql`
    mutation requestTransfer($participantId: ID!) {
  transferRequestCreate(participantID: $participantId) {
    id
  }
}
    `;
export type RequestTransferMutationFn = Apollo.MutationFunction<RequestTransferMutation, RequestTransferMutationVariables>;

/**
 * __useRequestTransferMutation__
 *
 * To run a mutation, you first call `useRequestTransferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTransferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTransferMutation, { data, loading, error }] = useRequestTransferMutation({
 *   variables: {
 *      participantId: // value for 'participantId'
 *   },
 * });
 */
export function useRequestTransferMutation(baseOptions?: Apollo.MutationHookOptions<RequestTransferMutation, RequestTransferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestTransferMutation, RequestTransferMutationVariables>(RequestTransferDocument, options);
      }
export type RequestTransferMutationHookResult = ReturnType<typeof useRequestTransferMutation>;
export type RequestTransferMutationResult = Apollo.MutationResult<RequestTransferMutation>;
export type RequestTransferMutationOptions = Apollo.BaseMutationOptions<RequestTransferMutation, RequestTransferMutationVariables>;
export const GetCompetitionTypeDocument = gql`
    query getCompetitionType($gradeID: ID!) {
  discoverGrade(gradeID: $gradeID) {
    id
    name
    season {
      id
      name
      competition {
        id
        type
        organisation {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCompetitionTypeQuery__
 *
 * To run a query within a React component, call `useGetCompetitionTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompetitionTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompetitionTypeQuery({
 *   variables: {
 *      gradeID: // value for 'gradeID'
 *   },
 * });
 */
export function useGetCompetitionTypeQuery(baseOptions: Apollo.QueryHookOptions<GetCompetitionTypeQuery, GetCompetitionTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompetitionTypeQuery, GetCompetitionTypeQueryVariables>(GetCompetitionTypeDocument, options);
      }
export function useGetCompetitionTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompetitionTypeQuery, GetCompetitionTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompetitionTypeQuery, GetCompetitionTypeQueryVariables>(GetCompetitionTypeDocument, options);
        }
export type GetCompetitionTypeQueryHookResult = ReturnType<typeof useGetCompetitionTypeQuery>;
export type GetCompetitionTypeLazyQueryHookResult = ReturnType<typeof useGetCompetitionTypeLazyQuery>;
export type GetCompetitionTypeQueryResult = Apollo.QueryResult<GetCompetitionTypeQuery, GetCompetitionTypeQueryVariables>;
export const DiscoverCompetitionsDocument = gql`
    query discoverCompetitions($organisationID: ID!, $organisationCode: String!) {
  discoverCompetitions(organisationID: $organisationID) {
    id
    name
    seasons(organisationID: $organisationID) {
      id
      name
      startDate
      endDate
      status {
        name
        value
      }
    }
    organisation {
      id
      name
      logo {
        sizes {
          url
          dimensions {
            width
            height
          }
        }
      }
    }
  }
  discoverOrganisation(code: $organisationCode) {
    ...OrganisationDetails
  }
  tenantConfiguration {
    label
    sport {
      name
    }
    ...TenantContactRolesConfiguration
  }
}
    ${OrganisationDetailsFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useDiscoverCompetitionsQuery__
 *
 * To run a query within a React component, call `useDiscoverCompetitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverCompetitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverCompetitionsQuery({
 *   variables: {
 *      organisationID: // value for 'organisationID'
 *      organisationCode: // value for 'organisationCode'
 *   },
 * });
 */
export function useDiscoverCompetitionsQuery(baseOptions: Apollo.QueryHookOptions<DiscoverCompetitionsQuery, DiscoverCompetitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverCompetitionsQuery, DiscoverCompetitionsQueryVariables>(DiscoverCompetitionsDocument, options);
      }
export function useDiscoverCompetitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverCompetitionsQuery, DiscoverCompetitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverCompetitionsQuery, DiscoverCompetitionsQueryVariables>(DiscoverCompetitionsDocument, options);
        }
export type DiscoverCompetitionsQueryHookResult = ReturnType<typeof useDiscoverCompetitionsQuery>;
export type DiscoverCompetitionsLazyQueryHookResult = ReturnType<typeof useDiscoverCompetitionsLazyQuery>;
export type DiscoverCompetitionsQueryResult = Apollo.QueryResult<DiscoverCompetitionsQuery, DiscoverCompetitionsQueryVariables>;
export const GetOrganisationShopProductsDocument = gql`
    query getOrganisationShopProducts($orgCode: String!, $shopFilter: ShopProductsFilter) {
  shopProducts(organisationCode: $orgCode, filter: $shopFilter) {
    id
    name
    productType
    maxPrice {
      net
    }
    minPrice {
      net
    }
    images {
      sizes {
        url
        dimensions {
          width
        }
      }
    }
  }
}
    `;

/**
 * __useGetOrganisationShopProductsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationShopProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationShopProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationShopProductsQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *      shopFilter: // value for 'shopFilter'
 *   },
 * });
 */
export function useGetOrganisationShopProductsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationShopProductsQuery, GetOrganisationShopProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationShopProductsQuery, GetOrganisationShopProductsQueryVariables>(GetOrganisationShopProductsDocument, options);
      }
export function useGetOrganisationShopProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationShopProductsQuery, GetOrganisationShopProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationShopProductsQuery, GetOrganisationShopProductsQueryVariables>(GetOrganisationShopProductsDocument, options);
        }
export type GetOrganisationShopProductsQueryHookResult = ReturnType<typeof useGetOrganisationShopProductsQuery>;
export type GetOrganisationShopProductsLazyQueryHookResult = ReturnType<typeof useGetOrganisationShopProductsLazyQuery>;
export type GetOrganisationShopProductsQueryResult = Apollo.QueryResult<GetOrganisationShopProductsQuery, GetOrganisationShopProductsQueryVariables>;
export const GetTenantStripeKeyDocument = gql`
    query getTenantStripeKey {
  tenantConfiguration {
    stripePublicKey
  }
}
    `;

/**
 * __useGetTenantStripeKeyQuery__
 *
 * To run a query within a React component, call `useGetTenantStripeKeyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantStripeKeyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantStripeKeyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTenantStripeKeyQuery(baseOptions?: Apollo.QueryHookOptions<GetTenantStripeKeyQuery, GetTenantStripeKeyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantStripeKeyQuery, GetTenantStripeKeyQueryVariables>(GetTenantStripeKeyDocument, options);
      }
export function useGetTenantStripeKeyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantStripeKeyQuery, GetTenantStripeKeyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantStripeKeyQuery, GetTenantStripeKeyQueryVariables>(GetTenantStripeKeyDocument, options);
        }
export type GetTenantStripeKeyQueryHookResult = ReturnType<typeof useGetTenantStripeKeyQuery>;
export type GetTenantStripeKeyLazyQueryHookResult = ReturnType<typeof useGetTenantStripeKeyLazyQuery>;
export type GetTenantStripeKeyQueryResult = Apollo.QueryResult<GetTenantStripeKeyQuery, GetTenantStripeKeyQueryVariables>;
export const GetShopCheckoutConfigDocument = gql`
    query getShopCheckoutConfig {
  configuration {
    supportedCountries {
      name
      alpha2Code
      mobileCountryCode
    }
  }
}
    `;

/**
 * __useGetShopCheckoutConfigQuery__
 *
 * To run a query within a React component, call `useGetShopCheckoutConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopCheckoutConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopCheckoutConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShopCheckoutConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetShopCheckoutConfigQuery, GetShopCheckoutConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopCheckoutConfigQuery, GetShopCheckoutConfigQueryVariables>(GetShopCheckoutConfigDocument, options);
      }
export function useGetShopCheckoutConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopCheckoutConfigQuery, GetShopCheckoutConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopCheckoutConfigQuery, GetShopCheckoutConfigQueryVariables>(GetShopCheckoutConfigDocument, options);
        }
export type GetShopCheckoutConfigQueryHookResult = ReturnType<typeof useGetShopCheckoutConfigQuery>;
export type GetShopCheckoutConfigLazyQueryHookResult = ReturnType<typeof useGetShopCheckoutConfigLazyQuery>;
export type GetShopCheckoutConfigQueryResult = Apollo.QueryResult<GetShopCheckoutConfigQuery, GetShopCheckoutConfigQueryVariables>;
export const GetShopCheckoutSessionDocument = gql`
    query getShopCheckoutSession($shopCartInput: ShopCartArgs!) {
  shopCart(input: $shopCartInput) {
    checkoutSession {
      ... on Gr4vyEmbedCheckoutSession {
        id
        expiryDate
        embedToken
      }
      __typename
    }
  }
}
    `;

/**
 * __useGetShopCheckoutSessionQuery__
 *
 * To run a query within a React component, call `useGetShopCheckoutSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopCheckoutSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopCheckoutSessionQuery({
 *   variables: {
 *      shopCartInput: // value for 'shopCartInput'
 *   },
 * });
 */
export function useGetShopCheckoutSessionQuery(baseOptions: Apollo.QueryHookOptions<GetShopCheckoutSessionQuery, GetShopCheckoutSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopCheckoutSessionQuery, GetShopCheckoutSessionQueryVariables>(GetShopCheckoutSessionDocument, options);
      }
export function useGetShopCheckoutSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopCheckoutSessionQuery, GetShopCheckoutSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopCheckoutSessionQuery, GetShopCheckoutSessionQueryVariables>(GetShopCheckoutSessionDocument, options);
        }
export type GetShopCheckoutSessionQueryHookResult = ReturnType<typeof useGetShopCheckoutSessionQuery>;
export type GetShopCheckoutSessionLazyQueryHookResult = ReturnType<typeof useGetShopCheckoutSessionLazyQuery>;
export type GetShopCheckoutSessionQueryResult = Apollo.QueryResult<GetShopCheckoutSessionQuery, GetShopCheckoutSessionQueryVariables>;
export const GetShopProductDocument = gql`
    query getShopProduct($orgCode: String!, $productId: ID!) {
  discoverOrganisation(code: $orgCode) {
    id
    name
  }
  shopProduct(id: $productId, organisationCode: $orgCode) {
    id
    name
    description
    activeShop
    productType
    settings {
      validFrom {
        date
      }
      validTo {
        date
      }
    }
    variants {
      id
      name
      amount {
        net
      }
      available
      categoryPairs {
        id
        category {
          id
          name
        }
        option {
          id
          name
        }
      }
    }
    categories {
      id
      name
      options {
        id
        name
      }
    }
    customFields {
      id
      question
      type
      dropdownOptions {
        id
        label
      }
      option {
        category {
          id
        }
        option {
          id
        }
      }
    }
    images {
      sizes {
        url
        dimensions {
          width
        }
      }
    }
  }
  tenantConfiguration {
    label
  }
}
    `;

/**
 * __useGetShopProductQuery__
 *
 * To run a query within a React component, call `useGetShopProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShopProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopProductQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetShopProductQuery(baseOptions: Apollo.QueryHookOptions<GetShopProductQuery, GetShopProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShopProductQuery, GetShopProductQueryVariables>(GetShopProductDocument, options);
      }
export function useGetShopProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShopProductQuery, GetShopProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShopProductQuery, GetShopProductQueryVariables>(GetShopProductDocument, options);
        }
export type GetShopProductQueryHookResult = ReturnType<typeof useGetShopProductQuery>;
export type GetShopProductLazyQueryHookResult = ReturnType<typeof useGetShopProductLazyQuery>;
export type GetShopProductQueryResult = Apollo.QueryResult<GetShopProductQuery, GetShopProductQueryVariables>;
export const UpdateShopCartDocument = gql`
    mutation updateShopCart($input: ShopCartUpsertInput!) {
  shopCartUpsert(input: $input) {
    ...ShopCartFragment
  }
}
    ${ShopCartFragmentFragmentDoc}`;
export type UpdateShopCartMutationFn = Apollo.MutationFunction<UpdateShopCartMutation, UpdateShopCartMutationVariables>;

/**
 * __useUpdateShopCartMutation__
 *
 * To run a mutation, you first call `useUpdateShopCartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopCartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShopCartMutation, { data, loading, error }] = useUpdateShopCartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShopCartMutation(baseOptions?: Apollo.MutationHookOptions<UpdateShopCartMutation, UpdateShopCartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateShopCartMutation, UpdateShopCartMutationVariables>(UpdateShopCartDocument, options);
      }
export type UpdateShopCartMutationHookResult = ReturnType<typeof useUpdateShopCartMutation>;
export type UpdateShopCartMutationResult = Apollo.MutationResult<UpdateShopCartMutation>;
export type UpdateShopCartMutationOptions = Apollo.BaseMutationOptions<UpdateShopCartMutation, UpdateShopCartMutationVariables>;
export const GetOrganisationShopSettingsDocument = gql`
    query getOrganisationShopSettings($orgCode: String!) {
  discoverOrganisation(code: $orgCode) {
    id
    type
    name
    email
    contactNumber
    websiteUrl
    address {
      id
      line1
      suburb
      postcode
      state
      country
    }
    logo {
      sizes {
        url
        dimensions {
          width
          height
        }
      }
    }
    contacts {
      id
      firstName
      lastName
      position
      email
      phone
    }
    shopVisible
  }
  tenantConfiguration {
    label
    ...TenantContactRolesConfiguration
  }
}
    ${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useGetOrganisationShopSettingsQuery__
 *
 * To run a query within a React component, call `useGetOrganisationShopSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganisationShopSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganisationShopSettingsQuery({
 *   variables: {
 *      orgCode: // value for 'orgCode'
 *   },
 * });
 */
export function useGetOrganisationShopSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganisationShopSettingsQuery, GetOrganisationShopSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganisationShopSettingsQuery, GetOrganisationShopSettingsQueryVariables>(GetOrganisationShopSettingsDocument, options);
      }
export function useGetOrganisationShopSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganisationShopSettingsQuery, GetOrganisationShopSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganisationShopSettingsQuery, GetOrganisationShopSettingsQueryVariables>(GetOrganisationShopSettingsDocument, options);
        }
export type GetOrganisationShopSettingsQueryHookResult = ReturnType<typeof useGetOrganisationShopSettingsQuery>;
export type GetOrganisationShopSettingsLazyQueryHookResult = ReturnType<typeof useGetOrganisationShopSettingsLazyQuery>;
export type GetOrganisationShopSettingsQueryResult = Apollo.QueryResult<GetOrganisationShopSettingsQuery, GetOrganisationShopSettingsQueryVariables>;
export const SignUpDocument = gql`
    query signUp {
  configuration {
    supportedCountries {
      name
      alpha2Code
      mobileCountryCode
    }
  }
}
    `;

/**
 * __useSignUpQuery__
 *
 * To run a query within a React component, call `useSignUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignUpQuery(baseOptions?: Apollo.QueryHookOptions<SignUpQuery, SignUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignUpQuery, SignUpQueryVariables>(SignUpDocument, options);
      }
export function useSignUpLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignUpQuery, SignUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignUpQuery, SignUpQueryVariables>(SignUpDocument, options);
        }
export type SignUpQueryHookResult = ReturnType<typeof useSignUpQuery>;
export type SignUpLazyQueryHookResult = ReturnType<typeof useSignUpLazyQuery>;
export type SignUpQueryResult = Apollo.QueryResult<SignUpQuery, SignUpQueryVariables>;
export const AccountConfirmDocument = gql`
    mutation accountConfirm($input: AccountConfirmInput!) {
  accountConfirm(input: $input) {
    success
  }
}
    `;
export type AccountConfirmMutationFn = Apollo.MutationFunction<AccountConfirmMutation, AccountConfirmMutationVariables>;

/**
 * __useAccountConfirmMutation__
 *
 * To run a mutation, you first call `useAccountConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAccountConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [accountConfirmMutation, { data, loading, error }] = useAccountConfirmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAccountConfirmMutation(baseOptions?: Apollo.MutationHookOptions<AccountConfirmMutation, AccountConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AccountConfirmMutation, AccountConfirmMutationVariables>(AccountConfirmDocument, options);
      }
export type AccountConfirmMutationHookResult = ReturnType<typeof useAccountConfirmMutation>;
export type AccountConfirmMutationResult = Apollo.MutationResult<AccountConfirmMutation>;
export type AccountConfirmMutationOptions = Apollo.BaseMutationOptions<AccountConfirmMutation, AccountConfirmMutationVariables>;
export const DiscoverTeamDocument = gql`
    query discoverTeam($teamID: ID!) {
  discoverTeam(teamID: $teamID) {
    id
    name
    logo {
      sizes {
        url
        dimensions {
          width
          height
        }
      }
    }
    grade {
      id
      name
    }
    season {
      id
      name
      competition {
        id
        name
        organisation {
          id
          name
        }
      }
    }
    organisation {
      ...OrganisationDetails
    }
  }
  tenantConfiguration {
    label
    ...TenantContactRolesConfiguration
  }
}
    ${OrganisationDetailsFragmentDoc}
${TenantContactRolesConfigurationFragmentDoc}`;

/**
 * __useDiscoverTeamQuery__
 *
 * To run a query within a React component, call `useDiscoverTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverTeamQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useDiscoverTeamQuery(baseOptions: Apollo.QueryHookOptions<DiscoverTeamQuery, DiscoverTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverTeamQuery, DiscoverTeamQueryVariables>(DiscoverTeamDocument, options);
      }
export function useDiscoverTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverTeamQuery, DiscoverTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverTeamQuery, DiscoverTeamQueryVariables>(DiscoverTeamDocument, options);
        }
export type DiscoverTeamQueryHookResult = ReturnType<typeof useDiscoverTeamQuery>;
export type DiscoverTeamLazyQueryHookResult = ReturnType<typeof useDiscoverTeamLazyQuery>;
export type DiscoverTeamQueryResult = Apollo.QueryResult<DiscoverTeamQuery, DiscoverTeamQueryVariables>;
export const TeamFixtureDocument = gql`
    query teamFixture($teamID: ID!) {
  discoverTeam(teamID: $teamID) {
    id
    name
    season {
      id
      name
    }
    grade {
      id
      name
    }
    organisation {
      id
      name
    }
  }
  discoverTeamFixture(teamID: $teamID) {
    id
    name
    isStale
    provisionalDates
    grade {
      id
      name
      type
      season {
        id
        name
        competition {
          id
          name
          organisation {
            id
            name
          }
          type
        }
      }
      hideScores
    }
    fixture {
      ...RoundFixtureFragment
    }
  }
  tenantConfiguration {
    label
    gradeTypes {
      value
      isAllPlay
      features {
        hasRounds
        hasSeasonStats
        hasCareerStats
        hasGameStats
        hasFixture
        hasLadder
      }
    }
  }
}
    ${RoundFixtureFragmentFragmentDoc}`;

/**
 * __useTeamFixtureQuery__
 *
 * To run a query within a React component, call `useTeamFixtureQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamFixtureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamFixtureQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useTeamFixtureQuery(baseOptions: Apollo.QueryHookOptions<TeamFixtureQuery, TeamFixtureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamFixtureQuery, TeamFixtureQueryVariables>(TeamFixtureDocument, options);
      }
export function useTeamFixtureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamFixtureQuery, TeamFixtureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamFixtureQuery, TeamFixtureQueryVariables>(TeamFixtureDocument, options);
        }
export type TeamFixtureQueryHookResult = ReturnType<typeof useTeamFixtureQuery>;
export type TeamFixtureLazyQueryHookResult = ReturnType<typeof useTeamFixtureLazyQuery>;
export type TeamFixtureQueryResult = Apollo.QueryResult<TeamFixtureQuery, TeamFixtureQueryVariables>;
export const TeamLadderDocument = gql`
    query teamLadder($teamID: ID!) {
  discoverTeam(teamID: $teamID) {
    id
    name
    season {
      id
      name
      competition {
        id
        type
      }
    }
    organisation {
      id
      name
    }
    grade {
      id
      name
      ladderType
      ladder(filter: {teamID: $teamID}) {
        pool {
          id
          name
        }
        generatedFrom {
          id
          name
        }
        standings {
          team {
            id
            name
            season {
              id
              name
              competition {
                id
                name
              }
            }
            organisation {
              id
              name
              type
            }
          }
          played
          won
          lost
          drawn
          byes
          pointsFor
          pointsAgainst
          pointsDifference
          percentage
          alternatePercentage
          competitionPoints
          pointsAverage
          forfeits
          disqualifications
          adjustments
          competitionPoints
          pointsAverage
          noResults
          ties
          quotient
          netRunRate
          runsFor
          oversFaced
          wicketsLost
          runsAgainst
          oversBowled
          wicketsTaken
          winOutright
          winFirstInnings
          lossOutright
          lossFirstInnings
          matchRatio
          bonusPoints
        }
        gameTypeValue
      }
      gameTypes {
        name
        value
        ladderFields {
          shortName
          key
          toolTip
          extendedToolTip
          type
          displayOrder
          dataType
          decimals
        }
        ladderRankingFields {
          fullName
          shortName
          key
          sortOrder
          toolTip
        }
      }
      overallLadderFields {
        shortName
        key
        toolTip
        type
        displayOrder
        dataType
        decimals
      }
      overallLadderRankingFields {
        fullName
        shortName
        key
        sortOrder
        toolTip
      }
    }
  }
}
    `;

/**
 * __useTeamLadderQuery__
 *
 * To run a query within a React component, call `useTeamLadderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamLadderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamLadderQuery({
 *   variables: {
 *      teamID: // value for 'teamID'
 *   },
 * });
 */
export function useTeamLadderQuery(baseOptions: Apollo.QueryHookOptions<TeamLadderQuery, TeamLadderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamLadderQuery, TeamLadderQueryVariables>(TeamLadderDocument, options);
      }
export function useTeamLadderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamLadderQuery, TeamLadderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamLadderQuery, TeamLadderQueryVariables>(TeamLadderDocument, options);
        }
export type TeamLadderQueryHookResult = ReturnType<typeof useTeamLadderQuery>;
export type TeamLadderLazyQueryHookResult = ReturnType<typeof useTeamLadderLazyQuery>;
export type TeamLadderQueryResult = Apollo.QueryResult<TeamLadderQuery, TeamLadderQueryVariables>;
export const DiscoverOrganisationTeamsDocument = gql`
    query discoverOrganisationTeams($seasonCode: String!, $seasonId: ID!, $organisationCode: String!, $organisationId: ID!) {
  discoverSeason(seasonID: $seasonCode) {
    id
    name
    competition {
      id
      name
      organisation {
        id
        name
        logo {
          sizes {
            url
            dimensions {
              width
              height
            }
          }
        }
      }
    }
    status {
      name
      value
    }
    grades {
      id
      name
    }
  }
  tenantConfiguration {
    label
    competition {
      ageGroups {
        name
        value
      }
      genders {
        name
        value
      }
    }
    ...TenantContactRolesConfiguration
  }
  discoverTeams(filter: {seasonID: $seasonId, organisationID: $organisationId}) {
    id
    name
    gender {
      name
      value
    }
    ageGroup {
      name
      value
    }
    grade {
      id
      name
    }
  }
  discoverOrganisation(code: $organisationCode) {
    ...OrganisationDetails
  }
}
    ${TenantContactRolesConfigurationFragmentDoc}
${OrganisationDetailsFragmentDoc}`;

/**
 * __useDiscoverOrganisationTeamsQuery__
 *
 * To run a query within a React component, call `useDiscoverOrganisationTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiscoverOrganisationTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDiscoverOrganisationTeamsQuery({
 *   variables: {
 *      seasonCode: // value for 'seasonCode'
 *      seasonId: // value for 'seasonId'
 *      organisationCode: // value for 'organisationCode'
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useDiscoverOrganisationTeamsQuery(baseOptions: Apollo.QueryHookOptions<DiscoverOrganisationTeamsQuery, DiscoverOrganisationTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DiscoverOrganisationTeamsQuery, DiscoverOrganisationTeamsQueryVariables>(DiscoverOrganisationTeamsDocument, options);
      }
export function useDiscoverOrganisationTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DiscoverOrganisationTeamsQuery, DiscoverOrganisationTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DiscoverOrganisationTeamsQuery, DiscoverOrganisationTeamsQueryVariables>(DiscoverOrganisationTeamsDocument, options);
        }
export type DiscoverOrganisationTeamsQueryHookResult = ReturnType<typeof useDiscoverOrganisationTeamsQuery>;
export type DiscoverOrganisationTeamsLazyQueryHookResult = ReturnType<typeof useDiscoverOrganisationTeamsLazyQuery>;
export type DiscoverOrganisationTeamsQueryResult = Apollo.QueryResult<DiscoverOrganisationTeamsQuery, DiscoverOrganisationTeamsQueryVariables>;
export const TenantDocument = gql`
    query tenant {
  tenantConfiguration {
    label
    sport {
      name
    }
  }
}
    `;

/**
 * __useTenantQuery__
 *
 * To run a query within a React component, call `useTenantQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantQuery({
 *   variables: {
 *   },
 * });
 */
export function useTenantQuery(baseOptions?: Apollo.QueryHookOptions<TenantQuery, TenantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
      }
export function useTenantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantQuery, TenantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantQuery, TenantQueryVariables>(TenantDocument, options);
        }
export type TenantQueryHookResult = ReturnType<typeof useTenantQuery>;
export type TenantLazyQueryHookResult = ReturnType<typeof useTenantLazyQuery>;
export type TenantQueryResult = Apollo.QueryResult<TenantQuery, TenantQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "Field": [
      "FieldInput",
      "FieldSelect"
    ],
    "Node": [
      "CoachingAccreditation",
      "MyTeamsGame",
      "MyTeamsParticipant",
      "Permit",
      "DiscoverOrganisationContact",
      "DiscoverSeason",
      "Group",
      "Venue",
      "RegistrationQuestion",
      "ProgramSeason",
      "Program",
      "TenantOrganisation",
      "Affiliation",
      "EmergencyContact",
      "MyTeamsGamePermitFillInPlayer",
      "MyTeamsParticipantFillInPlayer",
      "MyTeamsRegularFillInPlayer",
      "MyTeamsFillInCoach",
      "MyTeamsFillInPlayer",
      "Participant",
      "TransferExceptionPeriod",
      "TransferRequest",
      "Guardian",
      "TeamOrigin",
      "Discount",
      "ParticipantFee",
      "TeamFee",
      "SocialTeamRegistration",
      "Order",
      "ExceptionDate",
      "FinalsTemplate",
      "OrganisationDeleteResult",
      "Slot",
      "Voucher"
    ],
    "CustomFields": [
      "DropdownCustomField",
      "TextCustomField"
    ],
    "CustomField": [
      "DropdownCustomField",
      "TextCustomField"
    ],
    "DiscoverPossibleTeam": [
      "DiscoverTeam",
      "ProvisionalTeam"
    ],
    "DiscoverPossibleParticipant": [
      "DiscoverAnonymousParticipant",
      "DiscoverParticipant"
    ],
    "DiscoverPossibleEmergencyPlayer": [
      "DiscoverAnonymousParticipant",
      "DiscoverGamePermitFillInPlayer",
      "DiscoverParticipant",
      "DiscoverParticipantFillInPlayer"
    ],
    "DiscoverPossiblePlayer": [
      "DiscoverAnonymousParticipant",
      "DiscoverGamePermitFillInPlayer",
      "DiscoverParticipant",
      "DiscoverParticipantFillInPlayer",
      "DiscoverRegularFillInPlayer"
    ],
    "CompetitionProgramSeason": [
      "DiscoverSeason",
      "ProgramSeason"
    ],
    "Contact": [
      "EmergencyContact",
      "Guardian"
    ],
    "MyTeamsPossibleGuardian": [
      "MyTeamsGuardian",
      "MyTeamsProfile"
    ],
    "MyTeamsPossibleTeam": [
      "MyTeamsTeam",
      "ProvisionalTeam"
    ],
    "MyTeamsPossibleEmergencyPlayer": [
      "MyTeamsGamePermitFillInPlayer",
      "MyTeamsParticipant",
      "MyTeamsParticipantFillInPlayer"
    ],
    "MyTeamsPossibleGamePlayer": [
      "MyTeamsGamePermitFillInPlayer",
      "MyTeamsParticipant",
      "MyTeamsParticipantFillInPlayer",
      "MyTeamsRegularFillInPlayer"
    ],
    "MyTeamsPossiblePreviousRoundPlayer": [
      "MyTeamsParticipant",
      "MyTeamsParticipantFillInPlayer"
    ],
    "MyTeamsPossibleBestPlayer": [
      "MyTeamsGamePermitFillInPlayer",
      "MyTeamsParticipant",
      "MyTeamsParticipantFillInPlayer"
    ],
    "MyTeamsPossibleCoach": [
      "MyTeamsFillInCoach",
      "MyTeamsParticipant"
    ],
    "MyTeamsPossiblePlayer": [
      "MyTeamsFillInPlayer",
      "MyTeamsParticipant"
    ],
    "Outcome": [
      "ConcussionOutcome",
      "SuspensionOutcome"
    ],
    "CustomFieldAnswer": [
      "DropdownCustomFieldAnswer",
      "TextCustomFieldAnswer"
    ],
    "PossibleGuardian": [
      "Guardian",
      "Profile"
    ],
    "RegistrationHistory": [
      "DiscoverTeam",
      "Participant"
    ],
    "ActivityItem": [
      "DiscoverMilestone",
      "DiscoverPost"
    ],
    "Bookmarkable": [
      "DiscoverGrade",
      "DiscoverOrganisation",
      "DiscoverProfile",
      "DiscoverTeam"
    ],
    "RegistrationSettings": [
      "DiscoverRegistration",
      "DiscoverSocialTeamRegistration"
    ],
    "CartFee": [
      "MembershipAdvancedFee",
      "MerchandiseFee",
      "ParticipantFee",
      "TeamFee"
    ],
    "CheckoutSession": [
      "Gr4vyCheckoutSession",
      "Gr4vyEmbedCheckoutSession",
      "StripeCheckoutSession"
    ],
    "UpcomingTeamEventItem": [
      "DiscoverGame",
      "DiscoverRound",
      "EmptyTeamEvent"
    ],
    "FieldAnswer": [
      "FieldInputAnswer",
      "FieldSelectAnswer"
    ],
    "PossibleCoach": [
      "FillInCoach",
      "Participant"
    ],
    "PossiblePlayer": [
      "FillInPlayer",
      "Participant"
    ],
    "SessionResult": [
      "SessionCreated",
      "SessionFailed"
    ]
  }
};
      export default result;
    